var _feGaussianBlur, _feComposite, _feComposite2, _feColorMatrix, _feGaussianBlur2, _feColorMatrix2, _feGaussianBlur3, _feGaussianBlur4, _feComposite3, _feComposite4, _feColorMatrix3, _feGaussianBlur5, _feColorMatrix4, _feGaussianBlur6, _feGaussianBlur7, _feComposite5, _feComposite6, _feColorMatrix5, _feGaussianBlur8, _feColorMatrix6, _feGaussianBlur9, _feGaussianBlur10, _feComposite7, _feComposite8, _feColorMatrix7, _feGaussianBlur11, _feColorMatrix8, _feGaussianBlur12, _feGaussianBlur13, _feComposite9, _feComposite10, _feColorMatrix9, _feGaussianBlur14, _feColorMatrix10, _feGaussianBlur15, _feGaussianBlur16, _feComposite11, _feComposite12, _feColorMatrix11, _feGaussianBlur17, _feColorMatrix12, _feGaussianBlur18, _feGaussianBlur19, _feComposite13, _feComposite14, _feColorMatrix13, _feGaussianBlur20, _feColorMatrix14, _feGaussianBlur21, _feGaussianBlur22, _feComposite15, _feComposite16, _feColorMatrix15, _feGaussianBlur23, _feColorMatrix16, _feGaussianBlur24, _feGaussianBlur25, _feComposite17, _feComposite18, _feColorMatrix17, _feGaussianBlur26, _feColorMatrix18, _feGaussianBlur27, _feColorMatrix19, _feColorMatrix20, _feComposite19, _feGaussianBlur28, _feComposite20, _feComposite21, _feColorMatrix21, _feGaussianBlur29, _feColorMatrix22, _feGaussianBlur30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "202.52841mm",
    height: "138.84335mm",
    viewBox: "0 0 202.52841 138.84335",
    id: "svg4163",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs4160"
  }, /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter1510",
    x: -0.049310091,
    y: -0.12516691,
    width: 1.0986202,
    height: 1.2503338
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "blur",
    id: "feGaussianBlur1504"
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "in",
    result: "composite1",
    id: "feComposite1506"
  })), _feComposite2 || (_feComposite2 = /*#__PURE__*/React.createElement("feComposite", {
    in: "composite1",
    in2: "composite1",
    operator: "in",
    result: "fbSourceGraphic",
    id: "feComposite1508"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1552"
  })), _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1554",
    stdDeviation: "0.73046 1.13748",
    result: "fbSourceGraphic",
    in: "fbSourceGraphic"
  })), _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1556"
  })), _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1558",
    stdDeviation: "0.73046 1.13748",
    result: "blur",
    in: "fbSourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter1510-3-2-8-6-8-2-9-6",
    x: -0.049310091,
    y: -0.12516691,
    width: 1.0986202,
    height: 1.2503338
  }, _feGaussianBlur4 || (_feGaussianBlur4 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "blur",
    id: "feGaussianBlur1504-1-0-5-8-0-9-4-0"
  })), _feComposite3 || (_feComposite3 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "in",
    result: "composite1",
    id: "feComposite1506-9-6-9-0-5-6-2-4"
  })), _feComposite4 || (_feComposite4 = /*#__PURE__*/React.createElement("feComposite", {
    in: "composite1",
    in2: "composite1",
    operator: "in",
    result: "fbSourceGraphic",
    id: "feComposite1508-4-8-7-2-6-1-2-1"
  })), _feColorMatrix3 || (_feColorMatrix3 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1552-7-9-5-1-6-0-6-0"
  })), _feGaussianBlur5 || (_feGaussianBlur5 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1554-8-2-38-0-4-4-4-4",
    stdDeviation: "0.73046 1.13748",
    result: "fbSourceGraphic",
    in: "fbSourceGraphic"
  })), _feColorMatrix4 || (_feColorMatrix4 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1556-4-6-8-5-0-2-1-8"
  })), _feGaussianBlur6 || (_feGaussianBlur6 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1558-5-6-3-1-0-2-2-7",
    stdDeviation: "0.73046 1.13748",
    result: "blur",
    in: "fbSourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter1510-3",
    x: -0.049310091,
    y: -0.12516691,
    width: 1.0986202,
    height: 1.2503338
  }, _feGaussianBlur7 || (_feGaussianBlur7 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "blur",
    id: "feGaussianBlur1504-1"
  })), _feComposite5 || (_feComposite5 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "in",
    result: "composite1",
    id: "feComposite1506-9"
  })), _feComposite6 || (_feComposite6 = /*#__PURE__*/React.createElement("feComposite", {
    in: "composite1",
    in2: "composite1",
    operator: "in",
    result: "fbSourceGraphic",
    id: "feComposite1508-4"
  })), _feColorMatrix5 || (_feColorMatrix5 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1552-7"
  })), _feGaussianBlur8 || (_feGaussianBlur8 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1554-8",
    stdDeviation: "0.73046 1.13748",
    result: "fbSourceGraphic",
    in: "fbSourceGraphic"
  })), _feColorMatrix6 || (_feColorMatrix6 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1556-4"
  })), _feGaussianBlur9 || (_feGaussianBlur9 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1558-5",
    stdDeviation: "0.73046 1.13748",
    result: "blur",
    in: "fbSourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter1510-3-2-8-6-8-2-9",
    x: -0.049310091,
    y: -0.12516691,
    width: 1.0986202,
    height: 1.2503338
  }, _feGaussianBlur10 || (_feGaussianBlur10 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "blur",
    id: "feGaussianBlur1504-1-0-5-8-0-9-4"
  })), _feComposite7 || (_feComposite7 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "in",
    result: "composite1",
    id: "feComposite1506-9-6-9-0-5-6-2"
  })), _feComposite8 || (_feComposite8 = /*#__PURE__*/React.createElement("feComposite", {
    in: "composite1",
    in2: "composite1",
    operator: "in",
    result: "fbSourceGraphic",
    id: "feComposite1508-4-8-7-2-6-1-2"
  })), _feColorMatrix7 || (_feColorMatrix7 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1552-7-9-5-1-6-0-6"
  })), _feGaussianBlur11 || (_feGaussianBlur11 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1554-8-2-38-0-4-4-4",
    stdDeviation: "0.73046 1.13748",
    result: "fbSourceGraphic",
    in: "fbSourceGraphic"
  })), _feColorMatrix8 || (_feColorMatrix8 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1556-4-6-8-5-0-2-1"
  })), _feGaussianBlur12 || (_feGaussianBlur12 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1558-5-6-3-1-0-2-2",
    stdDeviation: "0.73046 1.13748",
    result: "blur",
    in: "fbSourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter1510-3-2",
    x: -0.049310091,
    y: -0.12516691,
    width: 1.0986202,
    height: 1.2503338
  }, _feGaussianBlur13 || (_feGaussianBlur13 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "blur",
    id: "feGaussianBlur1504-1-0"
  })), _feComposite9 || (_feComposite9 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "in",
    result: "composite1",
    id: "feComposite1506-9-6"
  })), _feComposite10 || (_feComposite10 = /*#__PURE__*/React.createElement("feComposite", {
    in: "composite1",
    in2: "composite1",
    operator: "in",
    result: "fbSourceGraphic",
    id: "feComposite1508-4-8"
  })), _feColorMatrix9 || (_feColorMatrix9 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1552-7-9"
  })), _feGaussianBlur14 || (_feGaussianBlur14 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1554-8-2",
    stdDeviation: "0.73046 1.13748",
    result: "fbSourceGraphic",
    in: "fbSourceGraphic"
  })), _feColorMatrix10 || (_feColorMatrix10 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1556-4-6"
  })), _feGaussianBlur15 || (_feGaussianBlur15 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1558-5-6",
    stdDeviation: "0.73046 1.13748",
    result: "blur",
    in: "fbSourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter1510-3-2-8-6-8-2",
    x: -0.049310091,
    y: -0.12516691,
    width: 1.0986202,
    height: 1.2503338
  }, _feGaussianBlur16 || (_feGaussianBlur16 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "blur",
    id: "feGaussianBlur1504-1-0-5-8-0-9"
  })), _feComposite11 || (_feComposite11 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "in",
    result: "composite1",
    id: "feComposite1506-9-6-9-0-5-6"
  })), _feComposite12 || (_feComposite12 = /*#__PURE__*/React.createElement("feComposite", {
    in: "composite1",
    in2: "composite1",
    operator: "in",
    result: "fbSourceGraphic",
    id: "feComposite1508-4-8-7-2-6-1"
  })), _feColorMatrix11 || (_feColorMatrix11 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1552-7-9-5-1-6-0"
  })), _feGaussianBlur17 || (_feGaussianBlur17 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1554-8-2-38-0-4-4",
    stdDeviation: "0.73046 1.13748",
    result: "fbSourceGraphic",
    in: "fbSourceGraphic"
  })), _feColorMatrix12 || (_feColorMatrix12 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1556-4-6-8-5-0-2"
  })), _feGaussianBlur18 || (_feGaussianBlur18 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1558-5-6-3-1-0-2",
    stdDeviation: "0.73046 1.13748",
    result: "blur",
    in: "fbSourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter1510-3-2-4",
    x: -0.049310091,
    y: -0.12516691,
    width: 1.0986202,
    height: 1.2503338
  }, _feGaussianBlur19 || (_feGaussianBlur19 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "blur",
    id: "feGaussianBlur1504-1-0-8"
  })), _feComposite13 || (_feComposite13 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "in",
    result: "composite1",
    id: "feComposite1506-9-6-1"
  })), _feComposite14 || (_feComposite14 = /*#__PURE__*/React.createElement("feComposite", {
    in: "composite1",
    in2: "composite1",
    operator: "in",
    result: "fbSourceGraphic",
    id: "feComposite1508-4-8-2"
  })), _feColorMatrix13 || (_feColorMatrix13 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1552-7-9-9"
  })), _feGaussianBlur20 || (_feGaussianBlur20 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1554-8-2-3",
    stdDeviation: "0.73046 1.13748",
    result: "fbSourceGraphic",
    in: "fbSourceGraphic"
  })), _feColorMatrix14 || (_feColorMatrix14 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1556-4-6-9"
  })), _feGaussianBlur21 || (_feGaussianBlur21 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1558-5-6-0",
    stdDeviation: "0.73046 1.13748",
    result: "blur",
    in: "fbSourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter1510-3-2-8-6-8",
    x: -0.049310091,
    y: -0.12516691,
    width: 1.0986202,
    height: 1.2503338
  }, _feGaussianBlur22 || (_feGaussianBlur22 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "blur",
    id: "feGaussianBlur1504-1-0-5-8-0"
  })), _feComposite15 || (_feComposite15 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "in",
    result: "composite1",
    id: "feComposite1506-9-6-9-0-5"
  })), _feComposite16 || (_feComposite16 = /*#__PURE__*/React.createElement("feComposite", {
    in: "composite1",
    in2: "composite1",
    operator: "in",
    result: "fbSourceGraphic",
    id: "feComposite1508-4-8-7-2-6"
  })), _feColorMatrix15 || (_feColorMatrix15 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1552-7-9-5-1-6"
  })), _feGaussianBlur23 || (_feGaussianBlur23 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1554-8-2-38-0-4",
    stdDeviation: "0.73046 1.13748",
    result: "fbSourceGraphic",
    in: "fbSourceGraphic"
  })), _feColorMatrix16 || (_feColorMatrix16 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1556-4-6-8-5-0"
  })), _feGaussianBlur24 || (_feGaussianBlur24 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1558-5-6-3-1-0",
    stdDeviation: "0.73046 1.13748",
    result: "blur",
    in: "fbSourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter1510-3-2-8",
    x: -0.049310091,
    y: -0.12516691,
    width: 1.0986202,
    height: 1.2503338
  }, _feGaussianBlur25 || (_feGaussianBlur25 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "blur",
    id: "feGaussianBlur1504-1-0-5"
  })), _feComposite17 || (_feComposite17 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "in",
    result: "composite1",
    id: "feComposite1506-9-6-9"
  })), _feComposite18 || (_feComposite18 = /*#__PURE__*/React.createElement("feComposite", {
    in: "composite1",
    in2: "composite1",
    operator: "in",
    result: "fbSourceGraphic",
    id: "feComposite1508-4-8-7"
  })), _feColorMatrix17 || (_feColorMatrix17 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1552-7-9-5"
  })), _feGaussianBlur26 || (_feGaussianBlur26 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1554-8-2-38",
    stdDeviation: "0.73046 1.13748",
    result: "fbSourceGraphic",
    in: "fbSourceGraphic"
  })), _feColorMatrix18 || (_feColorMatrix18 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1556-4-6-8"
  })), _feGaussianBlur27 || (_feGaussianBlur27 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1558-5-6-3",
    stdDeviation: "0.73046 1.13748",
    result: "fbSourceGraphic",
    in: "fbSourceGraphic"
  })), _feColorMatrix19 || (_feColorMatrix19 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix5849"
  })), _feColorMatrix20 || (_feColorMatrix20 = /*#__PURE__*/React.createElement("feColorMatrix", {
    id: "feColorMatrix5851",
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 -1.36196 1.90688 -0.00144909 1.19736 0 ",
    in: "fbSourceGraphic",
    result: "colormatrix"
  })), _feComposite19 || (_feComposite19 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "fbSourceGraphic",
    id: "feComposite5853",
    in: "colormatrix",
    operator: "in",
    result: "composite1"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter1510-3-2-8-6",
    x: -0.049310091,
    y: -0.12516691,
    width: 1.0986202,
    height: 1.2503338
  }, _feGaussianBlur28 || (_feGaussianBlur28 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "blur",
    id: "feGaussianBlur1504-1-0-5-8"
  })), _feComposite20 || (_feComposite20 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "blur",
    operator: "in",
    result: "composite1",
    id: "feComposite1506-9-6-9-0"
  })), _feComposite21 || (_feComposite21 = /*#__PURE__*/React.createElement("feComposite", {
    in: "composite1",
    in2: "composite1",
    operator: "in",
    result: "fbSourceGraphic",
    id: "feComposite1508-4-8-7-2"
  })), _feColorMatrix21 || (_feColorMatrix21 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1552-7-9-5-1"
  })), _feGaussianBlur29 || (_feGaussianBlur29 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1554-8-2-38-0",
    stdDeviation: "0.73046 1.13748",
    result: "fbSourceGraphic",
    in: "fbSourceGraphic"
  })), _feColorMatrix22 || (_feColorMatrix22 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix1556-4-6-8-5"
  })), _feGaussianBlur30 || (_feGaussianBlur30 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur1558-5-6-3-1",
    stdDeviation: "0.73046 1.13748",
    result: "blur",
    in: "fbSourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-5.1957005,-42.42282)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5354",
    transform: "matrix(1.8173605,0,0,1.8173605,-4.1873264,64.262229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4306-0-3",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,110.05247,-11.008835)",
    style: {
      display: "inline",
      fill: "#666666",
      fillOpacity: 0.815819,
      filter: "url(#filter1510)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 71.092807,26.707917 c 0.662619,-0.268406 7.458348,-4.020158 12.034008,0 4.575019,4.020138 6.738979,6.587987 10.202976,6.298293 2.567848,-0.214837 3.216897,-2.158784 3.216897,-2.158784 0,0 0.649067,5.9028 -2.827201,7.388668 -7.132535,3.049154 -9.494562,-2.416216 -11.508188,-4.693731 -2.013627,-2.278155 -6.074422,-6.47767 -10.053283,-5.543444 -2.218789,0.52068 -1.065209,-1.291002 -1.065209,-1.291002",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-30-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,14.577765 c 0,0 3.701421,-1.119398 7.512538,-0.160027 3.811117,0.958751 7.991923,2.993026 10.25007,4.24403 3.021409,1.674261 4.39952,3.131087 4.39952,3.131087 0,0 -9.62165,-0.795505 -12.281107,-1.41617 -6.533798,-1.524586 -9.881021,-5.798938 -9.881021,-5.798938",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-4-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.030657,11.964122 c 0,0 0.255493,3.103982 0.827126,4.3292 0.571633,1.225199 1.878144,0 1.878144,0 0,0 -0.83746,-3.185295 -2.70527,-4.3292",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-44-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.830904,35.077904 c 0,0 1.027132,2.722681 3.291095,1.960077 2.263304,-0.761964 2.916249,-2.776889 4.223381,-1.224559 1.306511,1.551031 4.247267,6.846718 5.335703,7.13963 1.089076,0.292273 1.361341,-0.435509 1.905869,-0.469691 0.544548,-0.03475 2.558814,3.431735 2.558814,3.431735 0,0 -2.123304,1.522648 -5.227305,-0.111012 -2.929142,-1.541338 -5.934421,-5.662157 -5.934421,-5.662157 0,0 -6.370571,1.073586 -6.806702,0.781972 -0.43487,-0.292273 0.653566,-5.846032 0.653566,-5.846032",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-4-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.974429,33.934638 c 0,0 -9.96749,1.419407 -11.493996,1.652973 -0.418721,0.06383 -0.841977,0.405809 -1.263916,0.900025 0.370328,0.874879 0.825187,2.042669 1.140686,3.17626 0.200646,-0.257432 0.403231,-0.467771 0.607113,-0.592939 0.418081,-0.257414 4.753737,1.549751 10.307496,0.335507 1.396839,-0.305184 0.702617,-5.471826 0.702617,-5.471826",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-7-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.957683,41.587835 c -1.249724,1.697487 -2.245253,2.669131 -3.3891773,4.629849 -1.1426071,1.960077 -1.1426071,3.389817 -1.1426071,3.389817 l 3.2543164,-0.945838 c 0,0 0.17612,-1.57168 0.829065,-2.117507 0.652926,-0.546468 1.714898,-0.408406 2.450416,-1.86653 0.326454,-0.648409 1.312309,-3.618189 2.397507,-5.01373 -0.315499,-1.133591 -0.770358,-2.301381 -1.140686,-3.17626 -1.118119,1.305853 -2.234281,3.710474 -3.258834,5.100199",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.408427,29.259616 C 71.468951,24.126516 65.678408,24.635565 60.778215,24.853 46.417679,25.489155 41.765883,22.275476 37.950889,21.082539 c -2.343958,-0.73294 -9.873285,-4.420827 -12.496603,-5.050527 -5.261487,-1.263276 -9.953938,0.445185 -9.953938,0.445185 0,0 -5.123407,6.096368 -6.0924905,7.058977 -0.9690654,0.963268 -2.6304143,2.463968 -3.0465563,2.752364 -0.4148617,0.287755 -0.4916378,1.122617 0,1.846522 0.4735686,0.696161 1.523269,0.855511 1.523269,0.855511 0,0 -0.061999,0.900683 0.4916379,1.007142 0.5542219,0.105892 1.4207057,-0.201944 1.5929673,-1.25682 1.1000496,0.05102 4.9479266,-1.004564 6.3292746,-1.755555 1.761352,-0.956171 2.075571,-2.287829 2.075571,-2.287829 l 0.75099,-1.69233 c 0,0 4.246608,0.638734 6.424761,4.068549 2.178152,3.430455 5.117609,8.716467 5.117609,8.716467 l -2.318152,0.958751 c 0.314859,0.59228 0.581325,1.072287 0.772937,1.372954 1.163273,1.260039 2.484616,2.251051 3.914338,3.02011 l 2.504624,-2.003293 c 0,0 4.22854,0.754867 8.373225,0.691625 8.20612,-0.125827 10.73911,-1.947165 13.106953,-1.730389 2.939457,0.269046 5.069876,2.452355 5.071156,2.453654 1.249724,0.112293 2.694955,0.227749 4.402758,0.227749 0.787769,0 3.05559,0.03804 5.227287,-1.817498 2.171056,-1.855557 4.645997,-7.273175 2.68592,-9.704242",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-3-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.914353,39.830342 c -4.144685,0.06328 -8.373225,-0.691625 -8.373225,-0.691625 l -2.504624,2.003293 c 0.661321,0.355497 1.34329,0.668417 2.047187,0.931007 3.584647,0.920673 6.450565,0.879377 8.830662,0.879377 6.573155,6.58e-4 10.991385,-1.811024 13.495351,-2.440083 1.223919,-0.307105 2.70591,-0.1368 4.682758,0.04133 -0.0013,-0.0013 -2.131699,-2.184608 -5.071156,-2.453635 -2.367843,-0.216795 -4.900833,1.604562 -13.106953,1.730389",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-1-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.549772,27.073728 c -2.178153,-3.429815 -6.424761,-4.068549 -6.424761,-4.068549 l -0.75099,1.69233 c 0,0 3.080756,0.763262 4.742105,2.498168 0.974241,1.016799 3.692405,6.655089 5.233103,9.553269 l 2.318152,-0.958751 c 0,0 -2.939457,-5.286012 -5.117609,-8.716467",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-7-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.000736,38.276732 c -1.416828,0.285176 -2.658798,0.146493 -2.449118,-1.635544 0.199366,-1.686514 -13.590196,1.727811 -13.590196,1.727811 0,0 2.178152,2.227824 4.465323,4.584053 2.285891,2.356212 4.67632,2.799458 8.384838,1.925878 1.169729,-0.275502 2.747206,-0.981977 3.536273,-1.365858 0.656145,-2.779468 0.202585,-4.296939 -0.34712,-5.23634",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-5-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.256426,49.01522 c 1.791692,1.634904 5.330526,1.526506 5.330526,1.526506 0,0 0,-2.831718 -1.143265,-4.127896 -0.487121,-0.551643 -1.960077,0.87294 -2.613644,0 -0.653584,-0.872299 -1.960077,-6.550587 -2.613661,-8.044831 -0.653567,-1.494245 -1.392944,-0.905842 -2.831079,-0.459377 -0.451622,0.13936 -1.805866,0.386478 -2.263304,0.478744 0.57487,1.263258 0.878737,3.223336 0.734878,5.373744 0.7697,-0.374846 2.344598,-1.749099 2.344598,-1.749099 0,0 0.90778,5.040834 3.054951,7.002209",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-9-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.506117,16.148786 3.221415,4.182744 0.376145,-0.750991 -2.858164,-3.859508 -0.739396,0.427755",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-6-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.996994,16.460426 c 0,0 0.894868,1.900712 2.869795,1.582634 1.350368,-0.217435 2.869138,-1.749738 2.869138,-1.749738 l -0.522601,-1.449749 c 0,0 -3.209161,0.723265 -5.216332,1.616853",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-2-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.653947,11.326668 c 0,0 -0.19355,3.916935 0.567115,6.075079 0.760043,2.158144 2.883348,0 2.883348,0 0,0 -1.511034,-4.507917 -3.450463,-6.075079",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-1-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.151311,34.465633 c 0,0 -7.22802,3.471093 -11.148156,4.858897 -2.414296,0.855511 -2.876252,1.674901 -3.26529,2.688481 0.532276,0.33099 1.357464,1.121338 1.923939,2.930441 0.270326,-0.48712 0.510987,-0.818091 0.687766,-0.881334 1.403277,-0.501312 7.273193,-0.201286 11.643031,-2.048467 0.714212,-0.301288 2.976236,-1.496183 5.263426,-3.931749 1.50006,-1.597485 -5.104716,-3.616269 -5.104716,-3.616269",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-7-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,42.013011 c -0.112841,0.295492 -0.220013,0.605833 -0.367768,0.940041 -0.653566,1.480053 -3.662064,7.68288 -4.631787,9.241647 -0.969706,1.559408 -0.709695,4.297579 -0.709695,4.297579 l 3.114956,-1.353604 c 0,0 -0.624542,-1.876845 0.136068,-2.163302 0.760026,-0.287115 1.413592,-0.33227 2.067176,-2.351054 0.486463,-1.502639 1.528445,-4.263397 2.314916,-5.680866 -0.566457,-1.809103 -1.391663,-2.599451 -1.923939,-2.930441",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-8-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.339408,21.792873 c 0,0 -1.632965,3.974362 0.980697,6.097667 2.613644,2.123944 10.12748,2.394928 12.250784,2.09556 2.123304,-0.298729 1.743941,-4.045963 1.742003,-5.526016 -3.756928,-0.380661 -12.525006,-1.776202 -14.973484,-2.667211",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-5-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 46.294449,27.073728 c 0,0 -0.925849,5.608607 -1.251663,8.004176 -0.327112,2.395587 -1.128433,7.87449 -1.128433,7.87449 0,0 3.207223,6.58e-4 6.16217,-0.546467 -0.02524,-0.392916 0.410985,-1.51877 -0.678091,-2.027819 -1.089076,-0.508409 -2.551718,-1.178746 -2.364606,-2.967201 0.186454,-1.788456 1.329719,-10.337179 1.329719,-10.337179 h -2.069096",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-7-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.038642,21.792873 c -0.584526,-0.703238 -1.407154,0.871001 -3.571095,0.625841 -0.534214,-0.06072 -1.143266,-0.123815 -1.763949,-0.203883 -0.319998,1.175527 -0.757447,2.69042 -1.115522,3.58013 -0.507768,1.261996 -5.233743,0.709073 -5.233743,-0.934865 0,-1.388445 0.660023,-4.054998 1.000028,-5.336983 -0.460016,-0.508409 -1.125836,-0.320017 -1.258758,-0.02067 -0.239363,0.541968 -0.487761,1.725871 -0.612271,2.290408 -0.27808,1.259417 -1.242628,4.209208 1.388445,5.322151 2.246533,0.949715 4.655654,1.265855 5.472465,0.285816 0.816154,-0.980039 1.24197,-3.443367 1.24197,-3.443367 l 4.45243,0.358075 c 0,0 0.402608,-2.036853 0,-2.522675",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-4-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.588076,25.794961 c 0.358075,-0.88971 0.795524,-2.404603 1.115522,-3.58013 -1.158756,-0.149053 -2.362027,-0.358715 -3.218178,-0.735518 -1.020694,-0.449044 -1.680717,-1.291661 -2.001373,-1.796832 -0.03932,-0.06328 -0.08449,-0.110281 -0.129667,-0.159295 -0.340006,1.281986 -1.000047,3.948538 -1.000047,5.336983 0,1.64392 4.725993,2.196861 5.233762,0.934865",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.760256,20.517343 c 0,0 -0.04444,1.08198 0.47291,1.314247 0.774236,0.347121 1.471037,-0.800681 1.471037,-0.800681 l -1.943947,-0.513566",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-8-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.5968617,24.338793 c 0,0 0.1212543,0.217417 0.7103528,1.59295 0.2690457,0.629059 0.9310065,2.783344 0.9310065,2.783344 l 0.97874,-0.1026 c 0,0 -0.271624,-1.160694 -1.000686,-2.998822 -0.21226,-0.536153 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67875",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-5-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.45048,26.330474 c -0.410326,0 -0.7445344,0.334208 -0.7445344,0.744552 0,0.410327 0.3342084,0.744535 0.7445344,0.744535 0.410345,0 0.744553,-0.334208 0.744553,-0.744535 0,-0.410344 -0.334208,-0.744552 -0.744553,-0.744552 z m 0,1.887818 c -0.6303395,0 -1.1432655,-0.512926 -1.1432655,-1.143266 0,-0.630358 0.512926,-1.143283 1.1432655,-1.143283 0.630358,0 1.143266,0.512925 1.143266,1.143283 0,0.63034 -0.512908,1.143266 -1.143266,1.143266",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-9-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.880814,26.467895 c 0,0 3.696282,-1.885221 5.364727,-4.253704 1.25682,-1.783939 3.194969,-6.553806 3.194969,-6.553806 l 0.847775,-0.06127 c 0,0 -1.429082,4.270493 -3.656925,7.452551 -1.660709,2.37364 -5.4473,4.140149 -5.4473,4.140149 L 10.880814,26.46791",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-7-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.055033,27.509238 c 0,0 10.446197,-4.20727 14.56248,-5.611845 6.002821,-2.048466 7.514495,-2.37428 8.697758,-2.138776 0,0 0.780033,-0.10516 0.638734,-0.235504 -1.251023,-1.161975 -7.288665,0.878097 -10.433304,2.103314 -1.336175,0.520662 -13.349553,5.261487 -13.349553,5.261487 l -0.116134,0.621324",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-5-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.958597,11.00667 c 1.174887,0.311622 2.494291,1.006484 2.494291,1.006484 l 0.822609,-1.764589 -1.41553,-1.2406896 c 0,0 -2.045888,1.2884416 -1.90137,1.9987946",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-3-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.581887,9.426596 c -0.238723,1.502639 -1.501341,2.037493 -2.16396,2.222667 -0.386459,0.108452 -0.800022,-0.265169 -1.092295,-0.878737 -0.324533,-0.680671 -0.641953,-1.6297464 -0.265808,-2.8497881 0.448403,-1.4536072 0.919375,-1.6974875 2.000074,-1.525866 1.079383,0.17228 1.761352,1.5297432 1.521989,3.0317241",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-8-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 -0.346462,1.1123031 -0.256134,1.6013621 0.08907,0.488401 0.622604,0.765182 0.622604,0.765182 L 40.275497,9.5175642 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-8-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.353497,8.791739 c -0.06072,-0.2722644 -0.27744,-0.5716327 -0.489059,-0.5380912 -0.211619,0.0342 -0.526478,0.4929181 -0.526478,0.4929181 0,0 -0.486462,-0.2341873 -0.954215,-0.6819505 -0.469051,-0.447123 -1.331676,0.012802 -1.357481,-0.3574351 -0.0406,-0.5761501 -0.66518,-1.5252258 1.744581,-1.9968558 1.100689,-0.2154962 2.261384,0.1613067 2.56527,0.9451985 0.593561,1.5297432 0.101868,2.3523524 0.250976,2.9652811 C 38.764482,9.8466152 38.415423,9.0633634 38.353497,8.791739",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-3-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.473952,7.7639486 0.0018,0.3826004 c 0,0 1.571661,0.1819729 2.907196,-0.081934 0.782612,-0.154174 1.445231,-0.014631 2.245912,0.2638882 0.801303,0.2774219 1.319405,0.1232661 1.319405,0.1232661 0,0 -0.08193,-2.0729918 -0.898105,-2.8020541 C 38.232737,4.9200133 36.293308,5.2264776 35.619093,5.5535169 34.779695,5.959984 34.518404,7.725213 34.518404,7.725213 l -1.045201,0.038772",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-1-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.784397,7.2936171 c 0,0 -0.163319,1.4303805 0,2.258147 0.163135,0.8271269 1.365858,0.9587509 1.976848,0.1554543 0.326472,-0.4290538 0.800041,-1.5200502 0.800041,-1.5200502 L 38.927709,7.9219815 c 0,0 -0.16972,0.9039209 -0.712932,1.4220043 -0.662601,0.6309797 -1.044561,0.00732 -1.000046,-0.8497131 0.03219,-0.6213233 0.05944,-1.0419825 0.05944,-1.0419825 L 36.78447,7.2935439",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-8-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.069573,9.6737134 c 0,0 0.02067,0.6780916 0,1.0864786 -0.01993,0.407766 -0.111012,0.694223 -0.111012,0.694223 l 0.578088,-0.330972 c 0,0 0.346462,-1.014238 0.166428,-1.2826254 C 37.61145,9.7052981 37.0695,9.6736586 37.0695,9.6736586",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-9-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.828172,13.288684 c 0,0 1.686515,0.454859 2.678807,1.472956 1.265855,1.299415 0.985196,3.042057 0,4.492427 -1.471018,2.1646 -5.227306,4.142747 -5.227306,4.142747 l -3.022049,1.385865 c 0,0 -1.452949,-1.225217 -0.898105,-2.591075 0.321315,-0.792286 2.902057,-3.346583 4.818259,-5.878293 0.70002,-0.92391 1.650394,-3.024627 1.650394,-3.024627",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-6-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.949043,9.6614417 -0.310981,0.5871233 c 0,0 0.800662,3.083993 1.127775,3.982098 0.326472,0.898727 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.179413 2.777529,0.689705 0.898105,0.510329 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.443933 1.93877,-2.447198 1.740064,-1.070348 2.504625,-2.625256 2.504625,-2.625256 0,0 -3.269167,-0.945199 -4.249846,-1.27553 C 46.728002,11.684103 45.060197,10.904728 43.362069,10.076303 41.663942,9.249177 39.949043,9.6614417 39.949043,9.6614417",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-43-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.786289,19.516657 c 0,0 -1.633605,-0.245161 -2.1646,0 -0.530977,0.245179 -0.203865,0.694222 0,1.102628 0.204523,0.408406 0.612929,0.835521 1.06199,0.989073 0.449044,0.154174 1.891037,-0.726483 1.891037,-0.726483 l -0.788427,-1.365218",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-3-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.507839,15.346825 c -0.01097,-0.885834 -0.410984,-3.791749 -0.682609,-4.301456 -0.488401,-0.914876 -1.500042,-1.1845618 -2.187168,-0.796804 -0.687126,0.387758 -0.467113,2.029757 -0.193568,3.411106 0.08523,0.428395 0.48648,2.604608 0.663259,3.082054 l -4.713081,2.853006 c -0.134788,0.815514 0.217417,1.37877 0.773577,1.725872 0.432913,-0.154906 1.780702,-0.656803 2.905276,-1.301335 1.180684,-0.676811 2.300083,-1.280705 2.998823,-1.67748 0.347742,-0.197427 0.457438,-1.170369 0.435491,-2.994963",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-38-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.856361,24.930416 c 0,0 1.974269,6.043458 2.940756,7.15706 1.136809,1.310369 0.449701,-0.105892 0.449701,-0.105892 0,0 -1.947183,-3.430455 -2.615582,-6.649291 -0.142652,-0.164599 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.804675,23.396814 c 0,0 1.97555,2.291048 3.255597,3.871762 0.882614,1.091015 2.410419,3.478847 2.560094,3.707877 0.352918,0.537451 0.06383,1.373612 -0.361934,1.996856 -0.425835,0.623902 -0.896167,1.132951 -1.118119,1.566522 -0.220654,0.434193 0.130399,0.921972 0.130399,0.921972 0,0 1.508455,-0.392934 2.243955,-1.167151 0.734878,-0.774876 1.279407,-1.597485 1.439415,-1.526506 0.160575,0.07169 1.183281,-0.944559 1.183281,-0.944559 0,0 -0.736158,-1.238751 -1.317484,-2.029117 -0.581307,-0.790988 -2.120067,-3.78853 -2.723321,-5.011791 -0.603894,-1.223918 -0.625841,-1.782658 -2.088464,-2.273637 -0.591001,-0.198726 -0.525179,0.474849 -1.423925,0.474849 -1.080041,0 -1.779439,0.412923 -1.779439,0.412923",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-0-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.953906,31.300347 48.26742,31.87262 c 0,0 0.687126,0.746491 1.155519,1.30651 0.423256,0.505812 0.980057,1.39876 0.980057,1.39876 l 1.021956,-0.883255 c 0,0 -0.860028,-2.021381 -2.471046,-2.394288",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-4-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 1.041964,-1.0103613 2.226526,-0.8071186 1.184561,0.2032245 1.989119,0.9716441 2.383333,1.1794041 0.393556,0.2077418 1.047122,-0.1148532 1.047122,-0.1148532 0,0 -0.544529,1.0748658 -1.497464,1.0051858 C 42.40138,10.494366 41.564579,9.6162685 40.570989,9.6736951 39.196755,9.7530683 39.194816,9.3014279 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.815819,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-8-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4306-0",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,96.939229,-7.9641764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 71.092807,26.707917 c 0.662619,-0.268406 7.458348,-4.020158 12.034008,0 4.575019,4.020138 6.738979,6.587987 10.202976,6.298293 2.567848,-0.214837 3.216897,-2.158784 3.216897,-2.158784 0,0 0.649067,5.9028 -2.827201,7.388668 -7.132535,3.049154 -9.494562,-2.416216 -11.508188,-4.693731 -2.013627,-2.278155 -6.074422,-6.47767 -10.053283,-5.543444 -2.218789,0.52068 -1.065209,-1.291002 -1.065209,-1.291002",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,14.577765 c 0,0 3.701421,-1.119398 7.512538,-0.160027 3.811117,0.958751 7.991923,2.993026 10.25007,4.24403 3.021409,1.674261 4.39952,3.131087 4.39952,3.131087 0,0 -9.62165,-0.795505 -12.281107,-1.41617 -6.533798,-1.524586 -9.881021,-5.798938 -9.881021,-5.798938",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.030657,11.964122 c 0,0 0.255493,3.103982 0.827126,4.3292 0.571633,1.225199 1.878144,0 1.878144,0 0,0 -0.83746,-3.185295 -2.70527,-4.3292",
    style: {
      fill: "#6b2a26",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.830904,35.077904 c 0,0 1.027132,2.722681 3.291095,1.960077 2.263304,-0.761964 2.916249,-2.776889 4.223381,-1.224559 1.306511,1.551031 4.247267,6.846718 5.335703,7.13963 1.089076,0.292273 1.361341,-0.435509 1.905869,-0.469691 0.544548,-0.03475 2.558814,3.431735 2.558814,3.431735 0,0 -2.123304,1.522648 -5.227305,-0.111012 -2.929142,-1.541338 -5.934421,-5.662157 -5.934421,-5.662157 0,0 -6.370571,1.073586 -6.806702,0.781972 -0.43487,-0.292273 0.653566,-5.846032 0.653566,-5.846032",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.974429,33.934638 c 0,0 -9.96749,1.419407 -11.493996,1.652973 -0.418721,0.06383 -0.841977,0.405809 -1.263916,0.900025 0.370328,0.874879 0.825187,2.042669 1.140686,3.17626 0.200646,-0.257432 0.403231,-0.467771 0.607113,-0.592939 0.418081,-0.257414 4.753737,1.549751 10.307496,0.335507 1.396839,-0.305184 0.702617,-5.471826 0.702617,-5.471826",
    style: {
      fill: "#6b2a26",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.957683,41.587835 c -1.249724,1.697487 -2.245253,2.669131 -3.3891773,4.629849 -1.1426071,1.960077 -1.1426071,3.389817 -1.1426071,3.389817 l 3.2543164,-0.945838 c 0,0 0.17612,-1.57168 0.829065,-2.117507 0.652926,-0.546468 1.714898,-0.408406 2.450416,-1.86653 0.326454,-0.648409 1.312309,-3.618189 2.397507,-5.01373 -0.315499,-1.133591 -0.770358,-2.301381 -1.140686,-3.17626 -1.118119,1.305853 -2.234281,3.710474 -3.258834,5.100199",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.408427,29.259616 C 71.468951,24.126516 65.678408,24.635565 60.778215,24.853 46.417679,25.489155 41.765883,22.275476 37.950889,21.082539 c -2.343958,-0.73294 -9.873285,-4.420827 -12.496603,-5.050527 -5.261487,-1.263276 -9.953938,0.445185 -9.953938,0.445185 0,0 -5.123407,6.096368 -6.0924905,7.058977 -0.9690654,0.963268 -2.6304143,2.463968 -3.0465563,2.752364 -0.4148617,0.287755 -0.4916378,1.122617 0,1.846522 0.4735686,0.696161 1.523269,0.855511 1.523269,0.855511 0,0 -0.061999,0.900683 0.4916379,1.007142 0.5542219,0.105892 1.4207057,-0.201944 1.5929673,-1.25682 1.1000496,0.05102 4.9479266,-1.004564 6.3292746,-1.755555 1.761352,-0.956171 2.075571,-2.287829 2.075571,-2.287829 l 0.75099,-1.69233 c 0,0 4.246608,0.638734 6.424761,4.068549 2.178152,3.430455 5.117609,8.716467 5.117609,8.716467 l -2.318152,0.958751 c 0.314859,0.59228 0.581325,1.072287 0.772937,1.372954 1.163273,1.260039 2.484616,2.251051 3.914338,3.02011 l 2.504624,-2.003293 c 0,0 4.22854,0.754867 8.373225,0.691625 8.20612,-0.125827 10.73911,-1.947165 13.106953,-1.730389 2.939457,0.269046 5.069876,2.452355 5.071156,2.453654 1.249724,0.112293 2.694955,0.227749 4.402758,0.227749 0.787769,0 3.05559,0.03804 5.227287,-1.817498 2.171056,-1.855557 4.645997,-7.273175 2.68592,-9.704242",
    style: {
      fill: "#7e362f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 74.401862,29.258732 c -2.939476,-5.1331 -8.730019,-4.624051 -13.630212,-4.406616 -8.224596,10.921909 -18.165321,-3.442741 -22.804935,-3.663972 -6.591266,-1.365832 1.427146,11.725667 2.803387,11.525987 8.20612,-0.125827 11.366601,-8.501762 15.668077,0.398962 2.230709,2.509394 5.069876,2.452355 5.071156,2.453654 1.249724,0.112293 1.813394,-3.246382 3.521197,-3.246382 0.787769,0 2.183363,-0.125506 5.05244,0.985144 3.153148,1.307403 6.278962,-1.61571 4.31889,-4.046777",
    style: {
      fill: "#ffb380",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.914353,39.830342 c -4.144685,0.06328 -8.373225,-0.691625 -8.373225,-0.691625 l -2.504624,2.003293 c 0.661321,0.355497 1.34329,0.668417 2.047187,0.931007 3.584647,0.920673 6.450565,0.879377 8.830662,0.879377 6.573155,6.58e-4 10.991385,-1.811024 13.495351,-2.440083 1.223919,-0.307105 2.70591,-0.1368 4.682758,0.04133 -0.0013,-0.0013 -2.131699,-2.184608 -5.071156,-2.453635 -2.367843,-0.216795 -4.900833,1.604562 -13.106953,1.730389",
    style: {
      fill: "#702c29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.549772,27.073728 c -2.178153,-3.429815 -6.424761,-4.068549 -6.424761,-4.068549 l -0.75099,1.69233 c 0,0 3.080756,0.763262 4.742105,2.498168 0.974241,1.016799 3.692405,6.655089 5.233103,9.553269 l 2.318152,-0.958751 c 0,0 -2.939457,-5.286012 -5.117609,-8.716467",
    style: {
      fill: "#702c29",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.000736,38.276732 c -1.416828,0.285176 -2.658798,0.146493 -2.449118,-1.635544 0.199366,-1.686514 -13.590196,1.727811 -13.590196,1.727811 0,0 2.178152,2.227824 4.465323,4.584053 2.285891,2.356212 4.67632,2.799458 8.384838,1.925878 1.169729,-0.275502 2.747206,-0.981977 3.536273,-1.365858 0.656145,-2.779468 0.202585,-4.296939 -0.34712,-5.23634",
    style: {
      fill: "#7e362f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.256426,49.01522 c 1.791692,1.634904 5.330526,1.526506 5.330526,1.526506 0,0 0,-2.831718 -1.143265,-4.127896 -0.487121,-0.551643 -1.960077,0.87294 -2.613644,0 -0.653584,-0.872299 -1.960077,-6.550587 -2.613661,-8.044831 -0.653567,-1.494245 -1.392944,-0.905842 -2.831079,-0.459377 -0.451622,0.13936 -1.805866,0.386478 -2.263304,0.478744 0.57487,1.263258 0.878737,3.223336 0.734878,5.373744 0.7697,-0.374846 2.344598,-1.749099 2.344598,-1.749099 0,0 0.90778,5.040834 3.054951,7.002209",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.506117,16.148786 3.221415,4.182744 0.376145,-0.750991 -2.858164,-3.859508 -0.739396,0.427755",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.996994,16.460426 c 0,0 0.894868,1.900712 2.869795,1.582634 1.350368,-0.217435 2.869138,-1.749738 2.869138,-1.749738 l -0.522601,-1.449749 c 0,0 -3.209161,0.723265 -5.216332,1.616853",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.653947,11.326668 c 0,0 -0.19355,3.916935 0.567115,6.075079 0.760043,2.158144 2.883348,0 2.883348,0 0,0 -1.511034,-4.507917 -3.450463,-6.075079",
    style: {
      fill: "#7e362f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.151311,34.465633 c 0,0 -7.22802,3.471093 -11.148156,4.858897 -2.414296,0.855511 -2.876252,1.674901 -3.26529,2.688481 0.532276,0.33099 1.357464,1.121338 1.923939,2.930441 0.270326,-0.48712 0.510987,-0.818091 0.687766,-0.881334 1.403277,-0.501312 7.273193,-0.201286 11.643031,-2.048467 0.714212,-0.301288 2.976236,-1.496183 5.263426,-3.931749 1.50006,-1.597485 -5.104716,-3.616269 -5.104716,-3.616269",
    style: {
      fill: "#7e362f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,42.013011 c -0.112841,0.295492 -0.220013,0.605833 -0.367768,0.940041 -0.653566,1.480053 -3.662064,7.68288 -4.631787,9.241647 -0.969706,1.559408 -0.709695,4.297579 -0.709695,4.297579 l 3.114956,-1.353604 c 0,0 -0.624542,-1.876845 0.136068,-2.163302 0.760026,-0.287115 1.413592,-0.33227 2.067176,-2.351054 0.486463,-1.502639 1.528445,-4.263397 2.314916,-5.680866 -0.566457,-1.809103 -1.391663,-2.599451 -1.923939,-2.930441",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.339408,21.792873 c 0,0 -1.632965,3.974362 0.980697,6.097667 2.613644,2.123944 10.12748,2.394928 12.250784,2.09556 2.123304,-0.298729 1.743941,-4.045963 1.742003,-5.526016 -3.756928,-0.380661 -12.525006,-1.776202 -14.973484,-2.667211",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 46.294449,27.073728 c 0,0 -0.925849,5.608607 -1.251663,8.004176 -0.327112,2.395587 -1.128433,7.87449 -1.128433,7.87449 0,0 3.207223,6.58e-4 6.16217,-0.546467 -0.02524,-0.392916 0.410985,-1.51877 -0.678091,-2.027819 -1.089076,-0.508409 -2.551718,-1.178746 -2.364606,-2.967201 0.186454,-1.788456 1.329719,-10.337179 1.329719,-10.337179 h -2.069096",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.038642,21.792873 c -0.584526,-0.703238 -1.407154,0.871001 -3.571095,0.625841 -0.534214,-0.06072 -1.143266,-0.123815 -1.763949,-0.203883 -0.319998,1.175527 -0.757447,2.69042 -1.115522,3.58013 -0.507768,1.261996 -5.233743,0.709073 -5.233743,-0.934865 0,-1.388445 0.660023,-4.054998 1.000028,-5.336983 -0.460016,-0.508409 -1.125836,-0.320017 -1.258758,-0.02067 -0.239363,0.541968 -0.487761,1.725871 -0.612271,2.290408 -0.27808,1.259417 -1.242628,4.209208 1.388445,5.322151 2.246533,0.949715 4.655654,1.265855 5.472465,0.285816 0.816154,-0.980039 1.24197,-3.443367 1.24197,-3.443367 l 4.45243,0.358075 c 0,0 0.402608,-2.036853 0,-2.522675",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.588076,25.794961 c 0.358075,-0.88971 0.795524,-2.404603 1.115522,-3.58013 -1.158756,-0.149053 -2.362027,-0.358715 -3.218178,-0.735518 -1.020694,-0.449044 -1.680717,-1.291661 -2.001373,-1.796832 -0.03932,-0.06328 -0.08449,-0.110281 -0.129667,-0.159295 -0.340006,1.281986 -1.000047,3.948538 -1.000047,5.336983 0,1.64392 4.725993,2.196861 5.233762,0.934865",
    style: {
      fill: "#f0a7a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.760256,20.517343 c 0,0 -0.04444,1.08198 0.47291,1.314247 0.774236,0.347121 1.471037,-0.800681 1.471037,-0.800681 l -1.943947,-0.513566",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.5968617,24.338793 c 0,0 0.1212543,0.217417 0.7103528,1.59295 0.2690457,0.629059 0.9310065,2.783344 0.9310065,2.783344 l 0.97874,-0.1026 c 0,0 -0.271624,-1.160694 -1.000686,-2.998822 -0.21226,-0.536153 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67875",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.45048,26.330474 c -0.410326,0 -0.7445344,0.334208 -0.7445344,0.744552 0,0.410327 0.3342084,0.744535 0.7445344,0.744535 0.410345,0 0.744553,-0.334208 0.744553,-0.744535 0,-0.410344 -0.334208,-0.744552 -0.744553,-0.744552 z m 0,1.887818 c -0.6303395,0 -1.1432655,-0.512926 -1.1432655,-1.143266 0,-0.630358 0.512926,-1.143283 1.1432655,-1.143283 0.630358,0 1.143266,0.512925 1.143266,1.143283 0,0.63034 -0.512908,1.143266 -1.143266,1.143266",
    style: {
      fill: "#f4ab94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.880814,26.467895 c 0,0 3.696282,-1.885221 5.364727,-4.253704 1.25682,-1.783939 3.194969,-6.553806 3.194969,-6.553806 l 0.847775,-0.06127 c 0,0 -1.429082,4.270493 -3.656925,7.452551 -1.660709,2.37364 -5.4473,4.140149 -5.4473,4.140149 L 10.880814,26.46791",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.055033,27.509238 c 0,0 10.446197,-4.20727 14.56248,-5.611845 6.002821,-2.048466 7.514495,-2.37428 8.697758,-2.138776 0,0 0.780033,-0.10516 0.638734,-0.235504 -1.251023,-1.161975 -7.288665,0.878097 -10.433304,2.103314 -1.336175,0.520662 -13.349553,5.261487 -13.349553,5.261487 l -0.116134,0.621324",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.958597,11.00667 c 1.174887,0.311622 2.494291,1.006484 2.494291,1.006484 l 0.822609,-1.764589 -1.41553,-1.2406896 c 0,0 -2.045888,1.2884416 -1.90137,1.9987946",
    style: {
      fill: "#ee9d8f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.581887,9.426596 c -0.238723,1.502639 -1.501341,2.037493 -2.16396,2.222667 -0.386459,0.108452 -0.800022,-0.265169 -1.092295,-0.878737 -0.324533,-0.680671 -0.641953,-1.6297464 -0.265808,-2.8497881 0.448403,-1.4536072 0.919375,-1.6974875 2.000074,-1.525866 1.079383,0.17228 1.761352,1.5297432 1.521989,3.0317241",
    style: {
      fill: "#f9b2a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 -0.346462,1.1123031 -0.256134,1.6013621 0.08907,0.488401 0.622604,0.765182 0.622604,0.765182 L 40.275497,9.5175642 39.194816,9.3014279",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.353497,8.791739 c -0.06072,-0.2722644 -0.27744,-0.5716327 -0.489059,-0.5380912 -0.211619,0.0342 -0.526478,0.4929181 -0.526478,0.4929181 0,0 -0.486462,-0.2341873 -0.954215,-0.6819505 -0.469051,-0.447123 -1.331676,0.012802 -1.357481,-0.3574351 -0.0406,-0.5761501 -0.66518,-1.5252258 1.744581,-1.9968558 1.100689,-0.2154962 2.261384,0.1613067 2.56527,0.9451985 0.593561,1.5297432 0.101868,2.3523524 0.250976,2.9652811 C 38.764482,9.8466152 38.415423,9.0633634 38.353497,8.791739",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.473952,7.7639486 0.0018,0.3826004 c 0,0 1.571661,0.1819729 2.907196,-0.081934 0.782612,-0.154174 1.445231,-0.014631 2.245912,0.2638882 0.801303,0.2774219 1.319405,0.1232661 1.319405,0.1232661 0,0 -0.08193,-2.0729918 -0.898105,-2.8020541 C 38.232737,4.9200133 36.293308,5.2264776 35.619093,5.5535169 34.779695,5.959984 34.518404,7.725213 34.518404,7.725213 l -1.045201,0.038772",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.784397,7.2936171 c 0,0 -0.163319,1.4303805 0,2.258147 0.163135,0.8271269 1.365858,0.9587509 1.976848,0.1554543 0.326472,-0.4290538 0.800041,-1.5200502 0.800041,-1.5200502 L 38.927709,7.9219815 c 0,0 -0.16972,0.9039209 -0.712932,1.4220043 -0.662601,0.6309797 -1.044561,0.00732 -1.000046,-0.8497131 0.03219,-0.6213233 0.05944,-1.0419825 0.05944,-1.0419825 L 36.78447,7.2935439",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.069573,9.6737134 c 0,0 0.02067,0.6780916 0,1.0864786 -0.01993,0.407766 -0.111012,0.694223 -0.111012,0.694223 l 0.578088,-0.330972 c 0,0 0.346462,-1.014238 0.166428,-1.2826254 C 37.61145,9.7052981 37.0695,9.6736586 37.0695,9.6736586",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.828172,13.288684 c 0,0 1.686515,0.454859 2.678807,1.472956 1.265855,1.299415 0.985196,3.042057 0,4.492427 -1.471018,2.1646 -5.227306,4.142747 -5.227306,4.142747 l -3.022049,1.385865 c 0,0 -1.452949,-1.225217 -0.898105,-2.591075 0.321315,-0.792286 2.902057,-3.346583 4.818259,-5.878293 0.70002,-0.92391 1.650394,-3.024627 1.650394,-3.024627",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.949043,9.6614417 -0.310981,0.5871233 c 0,0 0.800662,3.083993 1.127775,3.982098 0.326472,0.898727 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.179413 2.777529,0.689705 0.898105,0.510329 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.443933 1.93877,-2.447198 1.740064,-1.070348 2.504625,-2.625256 2.504625,-2.625256 0,0 -3.269167,-0.945199 -4.249846,-1.27553 C 46.728002,11.684103 45.060197,10.904728 43.362069,10.076303 41.663942,9.249177 39.949043,9.6614417 39.949043,9.6614417",
    style: {
      fill: "#e6474f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.786289,19.516657 c 0,0 -1.633605,-0.245161 -2.1646,0 -0.530977,0.245179 -0.203865,0.694222 0,1.102628 0.204523,0.408406 0.612929,0.835521 1.06199,0.989073 0.449044,0.154174 1.891037,-0.726483 1.891037,-0.726483 l -0.788427,-1.365218",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.507839,15.346825 c -0.01097,-0.885834 -0.410984,-3.791749 -0.682609,-4.301456 -0.488401,-0.914876 -1.500042,-1.1845618 -2.187168,-0.796804 -0.687126,0.387758 -0.467113,2.029757 -0.193568,3.411106 0.08523,0.428395 0.48648,2.604608 0.663259,3.082054 l -4.713081,2.853006 c -0.134788,0.815514 0.217417,1.37877 0.773577,1.725872 0.432913,-0.154906 1.780702,-0.656803 2.905276,-1.301335 1.180684,-0.676811 2.300083,-1.280705 2.998823,-1.67748 0.347742,-0.197427 0.457438,-1.170369 0.435491,-2.994963",
    style: {
      fill: "#d73a45",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.856361,24.930416 c 0,0 1.974269,6.043458 2.940756,7.15706 1.136809,1.310369 0.449701,-0.105892 0.449701,-0.105892 0,0 -1.947183,-3.430455 -2.615582,-6.649291 -0.142652,-0.164599 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#89434a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.804675,23.396814 c 0,0 1.97555,2.291048 3.255597,3.871762 0.882614,1.091015 2.410419,3.478847 2.560094,3.707877 0.352918,0.537451 0.06383,1.373612 -0.361934,1.996856 -0.425835,0.623902 -0.896167,1.132951 -1.118119,1.566522 -0.220654,0.434193 0.130399,0.921972 0.130399,0.921972 0,0 1.508455,-0.392934 2.243955,-1.167151 0.734878,-0.774876 1.279407,-1.597485 1.439415,-1.526506 0.160575,0.07169 1.183281,-0.944559 1.183281,-0.944559 0,0 -0.736158,-1.238751 -1.317484,-2.029117 -0.581307,-0.790988 -2.120067,-3.78853 -2.723321,-5.011791 -0.603894,-1.223918 -0.625841,-1.782658 -2.088464,-2.273637 -0.591001,-0.198726 -0.525179,0.474849 -1.423925,0.474849 -1.080041,0 -1.779439,0.412923 -1.779439,0.412923",
    style: {
      fill: "#553133",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.953906,31.300347 48.26742,31.87262 c 0,0 0.687126,0.746491 1.155519,1.30651 0.423256,0.505812 0.980057,1.39876 0.980057,1.39876 l 1.021956,-0.883255 c 0,0 -0.860028,-2.021381 -2.471046,-2.394288",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 1.041964,-1.0103613 2.226526,-0.8071186 1.184561,0.2032245 1.989119,0.9716441 2.383333,1.1794041 0.393556,0.2077418 1.047122,-0.1148532 1.047122,-0.1148532 0,0 -0.544529,1.0748658 -1.497464,1.0051858 C 42.40138,10.494366 41.564579,9.6162685 40.570989,9.6736951 39.196755,9.7530683 39.194816,9.3014279 39.194816,9.3014279",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 74.288351,34.377942 c 1.275619,-0.879734 5.087568,-1.495066 7.231489,1.626816 0.97512,2.952388 -5.516854,0.424355 -6.905194,0.414311 -1.135225,1.181878 -3.390752,0.407461 -4.694684,-0.844108 -0.801708,-0.520042 -1.001186,-2.647638 0.50361,-2.257593",
    style: {
      fill: "#ffb380",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-7-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 61.829131,37.663142 c -0.488021,-0.520062 -0.05623,-1.15226 3.441967,0.07996 3.029601,1.26208 -1.062514,0.701512 -1.439572,0.824558 0.808816,0.645488 -0.515384,0.498301 -2.035504,0.04516 -0.70045,-0.164388 -2.750434,-1.120154 -1.985834,-1.079926",
    style: {
      fill: "#aa4400",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0293924
    },
    id: "path756-7-67-5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5229",
    transform: "matrix(1.8281232,0,0,1.8281232,-206.60483,21.363987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4306-0-3-0-4-1-1-4-2-8-0",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,216.87993,-8.4774225)",
    style: {
      display: "inline",
      fill: "#666666",
      fillOpacity: 0.84489,
      filter: "url(#filter1510-3-2-8-6-8-2-9-6)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 71.092807,26.707917 c 0.662619,-0.268406 7.458348,-4.020158 12.034008,0 4.575019,4.020138 6.738979,6.587987 10.202976,6.298293 2.567848,-0.214837 3.216897,-2.158784 3.216897,-2.158784 0,0 0.649067,5.9028 -2.827201,7.388668 -7.132535,3.049154 -9.494562,-2.416216 -11.508188,-4.693731 -2.013627,-2.278155 -6.074422,-6.47767 -10.053283,-5.543444 -2.218789,0.52068 -1.065209,-1.291002 -1.065209,-1.291002",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-30-6-3-9-89-0-6-0-8-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,14.577765 c 0,0 3.701421,-1.119398 7.512538,-0.160027 3.811117,0.958751 7.991923,2.993026 10.25007,4.24403 3.021409,1.674261 4.39952,3.131087 4.39952,3.131087 0,0 -9.62165,-0.795505 -12.281107,-1.41617 -6.533798,-1.524586 -9.881021,-5.798938 -9.881021,-5.798938",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-4-7-6-5-6-8-2-5-9-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.030657,11.964122 c 0,0 0.255493,3.103982 0.827126,4.3292 0.571633,1.225199 1.878144,0 1.878144,0 0,0 -0.83746,-3.185295 -2.70527,-4.3292",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-44-5-1-0-4-5-6-5-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.830904,35.077904 c 0,0 1.027132,2.722681 3.291095,1.960077 2.263304,-0.761964 2.916249,-2.776889 4.223381,-1.224559 1.306511,1.551031 4.247267,6.846718 5.335703,7.13963 1.089076,0.292273 1.361341,-0.435509 1.905869,-0.469691 0.544548,-0.03475 2.558814,3.431735 2.558814,3.431735 0,0 -2.123304,1.522648 -5.227305,-0.111012 -2.929142,-1.541338 -5.934421,-5.662157 -5.934421,-5.662157 0,0 -6.370571,1.073586 -6.806702,0.781972 -0.43487,-0.292273 0.653566,-5.846032 0.653566,-5.846032",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-4-3-0-4-3-0-7-2-8-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.974429,33.934638 c 0,0 -9.96749,1.419407 -11.493996,1.652973 -0.418721,0.06383 -0.841977,0.405809 -1.263916,0.900025 0.370328,0.874879 0.825187,2.042669 1.140686,3.17626 0.200646,-0.257432 0.403231,-0.467771 0.607113,-0.592939 0.418081,-0.257414 4.753737,1.549751 10.307496,0.335507 1.396839,-0.305184 0.702617,-5.471826 0.702617,-5.471826",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-7-5-6-8-3-6-5-9-8-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.957683,41.587835 c -1.249724,1.697487 -2.245253,2.669131 -3.3891773,4.629849 -1.1426071,1.960077 -1.1426071,3.389817 -1.1426071,3.389817 l 3.2543164,-0.945838 c 0,0 0.17612,-1.57168 0.829065,-2.117507 0.652926,-0.546468 1.714898,-0.408406 2.450416,-1.86653 0.326454,-0.648409 1.312309,-3.618189 2.397507,-5.01373 -0.315499,-1.133591 -0.770358,-2.301381 -1.140686,-3.17626 -1.118119,1.305853 -2.234281,3.710474 -3.258834,5.100199",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-6-6-3-7-38-4-6-0-8-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.408427,29.259616 C 71.468951,24.126516 65.678408,24.635565 60.778215,24.853 46.417679,25.489155 41.765883,22.275476 37.950889,21.082539 c -2.343958,-0.73294 -9.873285,-4.420827 -12.496603,-5.050527 -5.261487,-1.263276 -9.953938,0.445185 -9.953938,0.445185 0,0 -5.123407,6.096368 -6.0924905,7.058977 -0.9690654,0.963268 -2.6304143,2.463968 -3.0465563,2.752364 -0.4148617,0.287755 -0.4916378,1.122617 0,1.846522 0.4735686,0.696161 1.523269,0.855511 1.523269,0.855511 0,0 -0.061999,0.900683 0.4916379,1.007142 0.5542219,0.105892 1.4207057,-0.201944 1.5929673,-1.25682 1.1000496,0.05102 4.9479266,-1.004564 6.3292746,-1.755555 1.761352,-0.956171 2.075571,-2.287829 2.075571,-2.287829 l 0.75099,-1.69233 c 0,0 4.246608,0.638734 6.424761,4.068549 2.178152,3.430455 5.117609,8.716467 5.117609,8.716467 l -2.318152,0.958751 c 0.314859,0.59228 0.581325,1.072287 0.772937,1.372954 1.163273,1.260039 2.484616,2.251051 3.914338,3.02011 l 2.504624,-2.003293 c 0,0 4.22854,0.754867 8.373225,0.691625 8.20612,-0.125827 10.73911,-1.947165 13.106953,-1.730389 2.939457,0.269046 5.069876,2.452355 5.071156,2.453654 1.249724,0.112293 2.694955,0.227749 4.402758,0.227749 0.787769,0 3.05559,0.03804 5.227287,-1.817498 2.171056,-1.855557 4.645997,-7.273175 2.68592,-9.704242",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-3-2-2-1-6-6-9-2-6-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.914353,39.830342 c -4.144685,0.06328 -8.373225,-0.691625 -8.373225,-0.691625 l -2.504624,2.003293 c 0.661321,0.355497 1.34329,0.668417 2.047187,0.931007 3.584647,0.920673 6.450565,0.879377 8.830662,0.879377 6.573155,6.58e-4 10.991385,-1.811024 13.495351,-2.440083 1.223919,-0.307105 2.70591,-0.1368 4.682758,0.04133 -0.0013,-0.0013 -2.131699,-2.184608 -5.071156,-2.453635 -2.367843,-0.216795 -4.900833,1.604562 -13.106953,1.730389",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-1-9-0-7-0-2-8-8-8-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.549772,27.073728 c -2.178153,-3.429815 -6.424761,-4.068549 -6.424761,-4.068549 l -0.75099,1.69233 c 0,0 3.080756,0.763262 4.742105,2.498168 0.974241,1.016799 3.692405,6.655089 5.233103,9.553269 l 2.318152,-0.958751 c 0,0 -2.939457,-5.286012 -5.117609,-8.716467",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-7-1-6-2-4-5-7-3-3-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.000736,38.276732 c -1.416828,0.285176 -2.658798,0.146493 -2.449118,-1.635544 0.199366,-1.686514 -13.590196,1.727811 -13.590196,1.727811 0,0 2.178152,2.227824 4.465323,4.584053 2.285891,2.356212 4.67632,2.799458 8.384838,1.925878 1.169729,-0.275502 2.747206,-0.981977 3.536273,-1.365858 0.656145,-2.779468 0.202585,-4.296939 -0.34712,-5.23634",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-5-2-1-7-8-8-2-8-8-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.256426,49.01522 c 1.791692,1.634904 5.330526,1.526506 5.330526,1.526506 0,0 0,-2.831718 -1.143265,-4.127896 -0.487121,-0.551643 -1.960077,0.87294 -2.613644,0 -0.653584,-0.872299 -1.960077,-6.550587 -2.613661,-8.044831 -0.653567,-1.494245 -1.392944,-0.905842 -2.831079,-0.459377 -0.451622,0.13936 -1.805866,0.386478 -2.263304,0.478744 0.57487,1.263258 0.878737,3.223336 0.734878,5.373744 0.7697,-0.374846 2.344598,-1.749099 2.344598,-1.749099 0,0 0.90778,5.040834 3.054951,7.002209",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-9-7-5-2-8-6-8-0-3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.506117,16.148786 3.221415,4.182744 0.376145,-0.750991 -2.858164,-3.859508 -0.739396,0.427755",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-6-0-5-2-8-2-2-4-3-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.996994,16.460426 c 0,0 0.894868,1.900712 2.869795,1.582634 1.350368,-0.217435 2.869138,-1.749738 2.869138,-1.749738 l -0.522601,-1.449749 c 0,0 -3.209161,0.723265 -5.216332,1.616853",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-2-9-4-6-97-8-9-0-3-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.653947,11.326668 c 0,0 -0.19355,3.916935 0.567115,6.075079 0.760043,2.158144 2.883348,0 2.883348,0 0,0 -1.511034,-4.507917 -3.450463,-6.075079",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-1-3-7-1-7-4-9-9-8-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.151311,34.465633 c 0,0 -7.22802,3.471093 -11.148156,4.858897 -2.414296,0.855511 -2.876252,1.674901 -3.26529,2.688481 0.532276,0.33099 1.357464,1.121338 1.923939,2.930441 0.270326,-0.48712 0.510987,-0.818091 0.687766,-0.881334 1.403277,-0.501312 7.273193,-0.201286 11.643031,-2.048467 0.714212,-0.301288 2.976236,-1.496183 5.263426,-3.931749 1.50006,-1.597485 -5.104716,-3.616269 -5.104716,-3.616269",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-7-6-6-0-6-7-6-1-0-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,42.013011 c -0.112841,0.295492 -0.220013,0.605833 -0.367768,0.940041 -0.653566,1.480053 -3.662064,7.68288 -4.631787,9.241647 -0.969706,1.559408 -0.709695,4.297579 -0.709695,4.297579 l 3.114956,-1.353604 c 0,0 -0.624542,-1.876845 0.136068,-2.163302 0.760026,-0.287115 1.413592,-0.33227 2.067176,-2.351054 0.486463,-1.502639 1.528445,-4.263397 2.314916,-5.680866 -0.566457,-1.809103 -1.391663,-2.599451 -1.923939,-2.930441",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-8-0-5-6-4-2-0-9-4-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.339408,21.792873 c 0,0 -1.632965,3.974362 0.980697,6.097667 2.613644,2.123944 10.12748,2.394928 12.250784,2.09556 2.123304,-0.298729 1.743941,-4.045963 1.742003,-5.526016 -3.756928,-0.380661 -12.525006,-1.776202 -14.973484,-2.667211",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-5-6-6-1-3-4-2-6-7-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 46.294449,27.073728 c 0,0 -0.925849,5.608607 -1.251663,8.004176 -0.327112,2.395587 -1.128433,7.87449 -1.128433,7.87449 0,0 3.207223,6.58e-4 6.16217,-0.546467 -0.02524,-0.392916 0.410985,-1.51877 -0.678091,-2.027819 -1.089076,-0.508409 -2.551718,-1.178746 -2.364606,-2.967201 0.186454,-1.788456 1.329719,-10.337179 1.329719,-10.337179 h -2.069096",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-7-2-9-5-03-0-7-2-6-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.038642,21.792873 c -0.584526,-0.703238 -1.407154,0.871001 -3.571095,0.625841 -0.534214,-0.06072 -1.143266,-0.123815 -1.763949,-0.203883 -0.319998,1.175527 -0.757447,2.69042 -1.115522,3.58013 -0.507768,1.261996 -5.233743,0.709073 -5.233743,-0.934865 0,-1.388445 0.660023,-4.054998 1.000028,-5.336983 -0.460016,-0.508409 -1.125836,-0.320017 -1.258758,-0.02067 -0.239363,0.541968 -0.487761,1.725871 -0.612271,2.290408 -0.27808,1.259417 -1.242628,4.209208 1.388445,5.322151 2.246533,0.949715 4.655654,1.265855 5.472465,0.285816 0.816154,-0.980039 1.24197,-3.443367 1.24197,-3.443367 l 4.45243,0.358075 c 0,0 0.402608,-2.036853 0,-2.522675",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-4-6-3-9-0-6-6-5-8-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.588076,25.794961 c 0.358075,-0.88971 0.795524,-2.404603 1.115522,-3.58013 -1.158756,-0.149053 -2.362027,-0.358715 -3.218178,-0.735518 -1.020694,-0.449044 -1.680717,-1.291661 -2.001373,-1.796832 -0.03932,-0.06328 -0.08449,-0.110281 -0.129667,-0.159295 -0.340006,1.281986 -1.000047,3.948538 -1.000047,5.336983 0,1.64392 4.725993,2.196861 5.233762,0.934865",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-1-1-7-4-9-2-1-4-9-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.760256,20.517343 c 0,0 -0.04444,1.08198 0.47291,1.314247 0.774236,0.347121 1.471037,-0.800681 1.471037,-0.800681 l -1.943947,-0.513566",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-8-8-4-9-2-9-3-4-0-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.5968617,24.338793 c 0,0 0.1212543,0.217417 0.7103528,1.59295 0.2690457,0.629059 0.9310065,2.783344 0.9310065,2.783344 l 0.97874,-0.1026 c 0,0 -0.271624,-1.160694 -1.000686,-2.998822 -0.21226,-0.536153 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67875",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-5-7-5-0-5-9-2-9-6-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.45048,26.330474 c -0.410326,0 -0.7445344,0.334208 -0.7445344,0.744552 0,0.410327 0.3342084,0.744535 0.7445344,0.744535 0.410345,0 0.744553,-0.334208 0.744553,-0.744535 0,-0.410344 -0.334208,-0.744552 -0.744553,-0.744552 z m 0,1.887818 c -0.6303395,0 -1.1432655,-0.512926 -1.1432655,-1.143266 0,-0.630358 0.512926,-1.143283 1.1432655,-1.143283 0.630358,0 1.143266,0.512925 1.143266,1.143283 0,0.63034 -0.512908,1.143266 -1.143266,1.143266",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-9-9-2-9-40-0-1-9-8-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.880814,26.467895 c 0,0 3.696282,-1.885221 5.364727,-4.253704 1.25682,-1.783939 3.194969,-6.553806 3.194969,-6.553806 l 0.847775,-0.06127 c 0,0 -1.429082,4.270493 -3.656925,7.452551 -1.660709,2.37364 -5.4473,4.140149 -5.4473,4.140149 L 10.880814,26.46791",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-7-2-5-1-5-8-5-3-7-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.055033,27.509238 c 0,0 10.446197,-4.20727 14.56248,-5.611845 6.002821,-2.048466 7.514495,-2.37428 8.697758,-2.138776 0,0 0.780033,-0.10516 0.638734,-0.235504 -1.251023,-1.161975 -7.288665,0.878097 -10.433304,2.103314 -1.336175,0.520662 -13.349553,5.261487 -13.349553,5.261487 l -0.116134,0.621324",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-5-0-4-7-9-1-9-6-9-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.958597,11.00667 c 1.174887,0.311622 2.494291,1.006484 2.494291,1.006484 l 0.822609,-1.764589 -1.41553,-1.2406896 c 0,0 -2.045888,1.2884416 -1.90137,1.9987946",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-3-2-7-7-4-3-9-0-0-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.581887,9.426596 c -0.238723,1.502639 -1.501341,2.037493 -2.16396,2.222667 -0.386459,0.108452 -0.800022,-0.265169 -1.092295,-0.878737 -0.324533,-0.680671 -0.641953,-1.6297464 -0.265808,-2.8497881 0.448403,-1.4536072 0.919375,-1.6974875 2.000074,-1.525866 1.079383,0.17228 1.761352,1.5297432 1.521989,3.0317241",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-8-3-4-1-6-1-1-5-3-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 -0.346462,1.1123031 -0.256134,1.6013621 0.08907,0.488401 0.622604,0.765182 0.622604,0.765182 L 40.275497,9.5175642 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-8-7-4-1-9-1-4-0-3-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.353497,8.791739 c -0.06072,-0.2722644 -0.27744,-0.5716327 -0.489059,-0.5380912 -0.211619,0.0342 -0.526478,0.4929181 -0.526478,0.4929181 0,0 -0.486462,-0.2341873 -0.954215,-0.6819505 -0.469051,-0.447123 -1.331676,0.012802 -1.357481,-0.3574351 -0.0406,-0.5761501 -0.66518,-1.5252258 1.744581,-1.9968558 1.100689,-0.2154962 2.261384,0.1613067 2.56527,0.9451985 0.593561,1.5297432 0.101868,2.3523524 0.250976,2.9652811 C 38.764482,9.8466152 38.415423,9.0633634 38.353497,8.791739",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-3-5-3-5-2-0-9-2-3-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.473952,7.7639486 0.0018,0.3826004 c 0,0 1.571661,0.1819729 2.907196,-0.081934 0.782612,-0.154174 1.445231,-0.014631 2.245912,0.2638882 0.801303,0.2774219 1.319405,0.1232661 1.319405,0.1232661 0,0 -0.08193,-2.0729918 -0.898105,-2.8020541 C 38.232737,4.9200133 36.293308,5.2264776 35.619093,5.5535169 34.779695,5.959984 34.518404,7.725213 34.518404,7.725213 l -1.045201,0.038772",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-1-9-0-9-2-3-1-9-7-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.784397,7.2936171 c 0,0 -0.163319,1.4303805 0,2.258147 0.163135,0.8271269 1.365858,0.9587509 1.976848,0.1554543 0.326472,-0.4290538 0.800041,-1.5200502 0.800041,-1.5200502 L 38.927709,7.9219815 c 0,0 -0.16972,0.9039209 -0.712932,1.4220043 -0.662601,0.6309797 -1.044561,0.00732 -1.000046,-0.8497131 0.03219,-0.6213233 0.05944,-1.0419825 0.05944,-1.0419825 L 36.78447,7.2935439",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-8-2-7-7-4-4-0-4-3-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.069573,9.6737134 c 0,0 0.02067,0.6780916 0,1.0864786 -0.01993,0.407766 -0.111012,0.694223 -0.111012,0.694223 l 0.578088,-0.330972 c 0,0 0.346462,-1.014238 0.166428,-1.2826254 C 37.61145,9.7052981 37.0695,9.6736586 37.0695,9.6736586",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-9-2-8-7-7-0-7-3-2-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.828172,13.288684 c 0,0 1.686515,0.454859 2.678807,1.472956 1.265855,1.299415 0.985196,3.042057 0,4.492427 -1.471018,2.1646 -5.227306,4.142747 -5.227306,4.142747 l -3.022049,1.385865 c 0,0 -1.452949,-1.225217 -0.898105,-2.591075 0.321315,-0.792286 2.902057,-3.346583 4.818259,-5.878293 0.70002,-0.92391 1.650394,-3.024627 1.650394,-3.024627",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-6-8-6-6-7-3-5-5-6-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.949043,9.6614417 -0.310981,0.5871233 c 0,0 0.800662,3.083993 1.127775,3.982098 0.326472,0.898727 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.179413 2.777529,0.689705 0.898105,0.510329 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.443933 1.93877,-2.447198 1.740064,-1.070348 2.504625,-2.625256 2.504625,-2.625256 0,0 -3.269167,-0.945199 -4.249846,-1.27553 C 46.728002,11.684103 45.060197,10.904728 43.362069,10.076303 41.663942,9.249177 39.949043,9.6614417 39.949043,9.6614417",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-43-9-8-7-5-9-8-1-5-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.786289,19.516657 c 0,0 -1.633605,-0.245161 -2.1646,0 -0.530977,0.245179 -0.203865,0.694222 0,1.102628 0.204523,0.408406 0.612929,0.835521 1.06199,0.989073 0.449044,0.154174 1.891037,-0.726483 1.891037,-0.726483 l -0.788427,-1.365218",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-3-7-8-3-4-1-7-7-2-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.507839,15.346825 c -0.01097,-0.885834 -0.410984,-3.791749 -0.682609,-4.301456 -0.488401,-0.914876 -1.500042,-1.1845618 -2.187168,-0.796804 -0.687126,0.387758 -0.467113,2.029757 -0.193568,3.411106 0.08523,0.428395 0.48648,2.604608 0.663259,3.082054 l -4.713081,2.853006 c -0.134788,0.815514 0.217417,1.37877 0.773577,1.725872 0.432913,-0.154906 1.780702,-0.656803 2.905276,-1.301335 1.180684,-0.676811 2.300083,-1.280705 2.998823,-1.67748 0.347742,-0.197427 0.457438,-1.170369 0.435491,-2.994963",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-38-3-4-6-81-9-0-4-6-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.856361,24.930416 c 0,0 1.974269,6.043458 2.940756,7.15706 1.136809,1.310369 0.449701,-0.105892 0.449701,-0.105892 0,0 -1.947183,-3.430455 -2.615582,-6.649291 -0.142652,-0.164599 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-6-6-3-5-2-6-4-3-5-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.804675,23.396814 c 0,0 1.97555,2.291048 3.255597,3.871762 0.882614,1.091015 2.410419,3.478847 2.560094,3.707877 0.352918,0.537451 0.06383,1.373612 -0.361934,1.996856 -0.425835,0.623902 -0.896167,1.132951 -1.118119,1.566522 -0.220654,0.434193 0.130399,0.921972 0.130399,0.921972 0,0 1.508455,-0.392934 2.243955,-1.167151 0.734878,-0.774876 1.279407,-1.597485 1.439415,-1.526506 0.160575,0.07169 1.183281,-0.944559 1.183281,-0.944559 0,0 -0.736158,-1.238751 -1.317484,-2.029117 -0.581307,-0.790988 -2.120067,-3.78853 -2.723321,-5.011791 -0.603894,-1.223918 -0.625841,-1.782658 -2.088464,-2.273637 -0.591001,-0.198726 -0.525179,0.474849 -1.423925,0.474849 -1.080041,0 -1.779439,0.412923 -1.779439,0.412923",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-0-1-1-6-8-9-8-1-8-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.953906,31.300347 48.26742,31.87262 c 0,0 0.687126,0.746491 1.155519,1.30651 0.423256,0.505812 0.980057,1.39876 0.980057,1.39876 l 1.021956,-0.883255 c 0,0 -0.860028,-2.021381 -2.471046,-2.394288",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-4-2-4-3-9-3-0-4-7-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 1.041964,-1.0103613 2.226526,-0.8071186 1.184561,0.2032245 1.989119,0.9716441 2.383333,1.1794041 0.393556,0.2077418 1.047122,-0.1148532 1.047122,-0.1148532 0,0 -0.544529,1.0748658 -1.497464,1.0051858 C 42.40138,10.494366 41.564579,9.6162685 40.570989,9.6736951 39.196755,9.7530683 39.194816,9.3014279 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.84489,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-8-9-9-9-3-3-4-6-9-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4306",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,205.30711,-7.9658441)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 71.092807,26.707917 c 0.662619,-0.268406 7.458348,-4.020158 12.034008,0 4.575019,4.020138 6.738979,6.587987 10.202976,6.298293 2.567848,-0.214837 3.216897,-2.158784 3.216897,-2.158784 0,0 0.649067,5.9028 -2.827201,7.388668 -7.132535,3.049154 -9.494562,-2.416216 -11.508188,-4.693731 -2.013627,-2.278155 -6.074422,-6.47767 -10.053283,-5.543444 -2.218789,0.52068 -1.065209,-1.291002 -1.065209,-1.291002",
    style: {
      fill: "#1c1f24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,14.577765 c 0,0 3.701421,-1.119398 7.512538,-0.160027 3.811117,0.958751 7.991923,2.993026 10.25007,4.24403 3.021409,1.674261 4.39952,3.131087 4.39952,3.131087 0,0 -9.62165,-0.795505 -12.281107,-1.41617 -6.533798,-1.524586 -9.881021,-5.798938 -9.881021,-5.798938",
    style: {
      fill: "#1c1f24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.030657,11.964122 c 0,0 0.255493,3.103982 0.827126,4.3292 0.571633,1.225199 1.878144,0 1.878144,0 0,0 -0.83746,-3.185295 -2.70527,-4.3292",
    style: {
      fill: "#535d6c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.830904,35.077904 c 0,0 1.027132,2.722681 3.291095,1.960077 2.263304,-0.761964 2.916249,-2.776889 4.223381,-1.224559 1.306511,1.551031 4.247267,6.846718 5.335703,7.13963 1.089076,0.292273 1.361341,-0.435509 1.905869,-0.469691 0.544548,-0.03475 2.558814,3.431735 2.558814,3.431735 0,0 -2.123304,1.522648 -5.227305,-0.111012 -2.929142,-1.541338 -5.934421,-5.662157 -5.934421,-5.662157 0,0 -6.370571,1.073586 -6.806702,0.781972 -0.43487,-0.292273 0.653566,-5.846032 0.653566,-5.846032",
    style: {
      fill: "#1c1f24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.974429,33.934638 c 0,0 -9.96749,1.419407 -11.493996,1.652973 -0.418721,0.06383 -0.841977,0.405809 -1.263916,0.900025 0.370328,0.874879 0.825187,2.042669 1.140686,3.17626 0.200646,-0.257432 0.403231,-0.467771 0.607113,-0.592939 0.418081,-0.257414 4.753737,1.549751 10.307496,0.335507 1.396839,-0.305184 0.702617,-5.471826 0.702617,-5.471826",
    style: {
      fill: "#535d6c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.957683,41.587835 c -1.249724,1.697487 -2.245253,2.669131 -3.3891773,4.629849 -1.1426071,1.960077 -1.1426071,3.389817 -1.1426071,3.389817 l 3.2543164,-0.945838 c 0,0 0.17612,-1.57168 0.829065,-2.117507 0.652926,-0.546468 1.714898,-0.408406 2.450416,-1.86653 0.326454,-0.648409 1.312309,-3.618189 2.397507,-5.01373 -0.315499,-1.133591 -0.770358,-2.301381 -1.140686,-3.17626 -1.118119,1.305853 -2.234281,3.710474 -3.258834,5.100199",
    style: {
      fill: "#1c1f24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.408427,29.259616 C 71.468951,24.126516 65.678408,24.635565 60.778215,24.853 46.417679,25.489155 41.765883,22.275476 37.950889,21.082539 c -2.343958,-0.73294 -9.873285,-4.420827 -12.496603,-5.050527 -5.261487,-1.263276 -9.953938,0.445185 -9.953938,0.445185 0,0 -5.123407,6.096368 -6.0924905,7.058977 -0.9690654,0.963268 -2.6304143,2.463968 -3.0465563,2.752364 -0.4148617,0.287755 -0.4916378,1.122617 0,1.846522 0.4735686,0.696161 1.523269,0.855511 1.523269,0.855511 0,0 -0.061999,0.900683 0.4916379,1.007142 0.5542219,0.105892 1.4207057,-0.201944 1.5929673,-1.25682 1.1000496,0.05102 4.9479266,-1.004564 6.3292746,-1.755555 1.761352,-0.956171 2.075571,-2.287829 2.075571,-2.287829 l 0.75099,-1.69233 c 0,0 4.246608,0.638734 6.424761,4.068549 2.178152,3.430455 5.117609,8.716467 5.117609,8.716467 l -2.318152,0.958751 c 0.314859,0.59228 0.581325,1.072287 0.772937,1.372954 1.163273,1.260039 2.484616,2.251051 3.914338,3.02011 l 2.504624,-2.003293 c 0,0 4.22854,0.754867 8.373225,0.691625 8.20612,-0.125827 10.73911,-1.947165 13.106953,-1.730389 2.939457,0.269046 5.069876,2.452355 5.071156,2.453654 1.249724,0.112293 2.694955,0.227749 4.402758,0.227749 0.787769,0 3.05559,0.03804 5.227287,-1.817498 2.171056,-1.855557 4.645997,-7.273175 2.68592,-9.704242",
    style: {
      fill: "#b7bec8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 61.018188,29.73391 c -2.939476,-5.1331 -12.344279,-0.113497 -15.043271,-1.878649 -9.67194,-7.305865 -16.781308,3.036929 -14.503213,8.667417 7.908201,2.630137 9.314689,1.170613 12.072992,0.591434 6.978154,-3.167982 6.634015,-6.246907 8.695395,-4.997679 2.795451,1.809452 1.580667,3.126194 3.483435,3.841565 2.627241,-0.236048 4.589101,-1.631064 5.294662,-6.224088",
    style: {
      fill: "#666666",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.914353,39.830342 c -4.144685,0.06328 -8.373225,-0.691625 -8.373225,-0.691625 l -2.504624,2.003293 c 0.661321,0.355497 1.34329,0.668417 2.047187,0.931007 3.584647,0.920673 6.450565,0.879377 8.830662,0.879377 6.573155,6.58e-4 10.991385,-1.811024 13.495351,-2.440083 1.223919,-0.307105 2.70591,-0.1368 4.682758,0.04133 -0.0013,-0.0013 -2.131699,-2.184608 -5.071156,-2.453635 -2.367843,-0.216795 -4.900833,1.604562 -13.106953,1.730389",
    style: {
      fill: "#535d6c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.549772,27.073728 c -2.178153,-3.429815 -6.424761,-4.068549 -6.424761,-4.068549 l -0.75099,1.69233 c 0,0 3.080756,0.763262 4.742105,2.498168 0.974241,1.016799 3.692405,6.655089 5.233103,9.553269 l 2.318152,-0.958751 c 0,0 -2.939457,-5.286012 -5.117609,-8.716467",
    style: {
      fill: "#535d6c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.000736,38.276732 c -1.416828,0.285176 -2.658798,0.146493 -2.449118,-1.635544 0.199366,-1.686514 -13.590196,1.727811 -13.590196,1.727811 0,0 2.178152,2.227824 4.465323,4.584053 2.285891,2.356212 4.67632,2.799458 8.384838,1.925878 1.169729,-0.275502 2.747206,-0.981977 3.536273,-1.365858 0.656145,-2.779468 0.202585,-4.296939 -0.34712,-5.23634",
    style: {
      fill: "#b7bec8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.256426,49.01522 c 1.791692,1.634904 5.330526,1.526506 5.330526,1.526506 0,0 0,-2.831718 -1.143265,-4.127896 -0.487121,-0.551643 -1.960077,0.87294 -2.613644,0 -0.653584,-0.872299 -1.960077,-6.550587 -2.613661,-8.044831 -0.653567,-1.494245 -1.392944,-0.905842 -2.831079,-0.459377 -0.451622,0.13936 -1.805866,0.386478 -2.263304,0.478744 0.57487,1.263258 0.878737,3.223336 0.734878,5.373744 0.7697,-0.374846 2.344598,-1.749099 2.344598,-1.749099 0,0 0.90778,5.040834 3.054951,7.002209",
    style: {
      fill: "#373e48",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#373e48",
      strokeWidth: 0.0645186
    },
    id: "path748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.506117,16.148786 3.221415,4.182744 0.376145,-0.750991 -2.858164,-3.859508 -0.739396,0.427755",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.996994,16.460426 c 0,0 0.894868,1.900712 2.869795,1.582634 1.350368,-0.217435 2.869138,-1.749738 2.869138,-1.749738 l -0.522601,-1.449749 c 0,0 -3.209161,0.723265 -5.216332,1.616853",
    style: {
      fill: "#1c1f24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.653947,11.326668 c 0,0 -0.19355,3.916935 0.567115,6.075079 0.760043,2.158144 2.883348,0 2.883348,0 0,0 -1.511034,-4.507917 -3.450463,-6.075079",
    style: {
      fill: "#b7bec8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.151311,34.465633 c 0,0 -7.22802,3.471093 -11.148156,4.858897 -2.414296,0.855511 -2.876252,1.674901 -3.26529,2.688481 0.532276,0.33099 1.357464,1.121338 1.923939,2.930441 0.270326,-0.48712 0.510987,-0.818091 0.687766,-0.881334 1.403277,-0.501312 7.273193,-0.201286 11.643031,-2.048467 0.714212,-0.301288 2.976236,-1.496183 5.263426,-3.931749 1.50006,-1.597485 -5.104716,-3.616269 -5.104716,-3.616269",
    style: {
      fill: "#b7bec8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,42.013011 c -0.112841,0.295492 -0.220013,0.605833 -0.367768,0.940041 -0.653566,1.480053 -3.662064,7.68288 -4.631787,9.241647 -0.969706,1.559408 -0.709695,4.297579 -0.709695,4.297579 l 3.114956,-1.353604 c 0,0 -0.624542,-1.876845 0.136068,-2.163302 0.760026,-0.287115 1.413592,-0.33227 2.067176,-2.351054 0.486463,-1.502639 1.528445,-4.263397 2.314916,-5.680866 -0.566457,-1.809103 -1.391663,-2.599451 -1.923939,-2.930441",
    style: {
      fill: "#373e48",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#373e48",
      strokeWidth: 0.0645186
    },
    id: "path758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.339408,21.792873 c 0,0 -1.632965,3.974362 0.980697,6.097667 2.613644,2.123944 10.12748,2.394928 12.250784,2.09556 2.123304,-0.298729 1.743941,-4.045963 1.742003,-5.526016 -3.756928,-0.380661 -12.525006,-1.776202 -14.973484,-2.667211",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 46.294449,27.073728 c 0,0 -0.925849,5.608607 -1.251663,8.004176 -0.327112,2.395587 -1.128433,7.87449 -1.128433,7.87449 0,0 3.207223,6.58e-4 6.16217,-0.546467 -0.02524,-0.392916 0.410985,-1.51877 -0.678091,-2.027819 -1.089076,-0.508409 -2.551718,-1.178746 -2.364606,-2.967201 0.186454,-1.788456 1.329719,-10.337179 1.329719,-10.337179 h -2.069096",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.038642,21.792873 c -0.584526,-0.703238 -1.407154,0.871001 -3.571095,0.625841 -0.534214,-0.06072 -1.143266,-0.123815 -1.763949,-0.203883 -0.319998,1.175527 -0.757447,2.69042 -1.115522,3.58013 -0.507768,1.261996 -5.233743,0.709073 -5.233743,-0.934865 0,-1.388445 0.660023,-4.054998 1.000028,-5.336983 -0.460016,-0.508409 -1.125836,-0.320017 -1.258758,-0.02067 -0.239363,0.541968 -0.487761,1.725871 -0.612271,2.290408 -0.27808,1.259417 -1.242628,4.209208 1.388445,5.322151 2.246533,0.949715 4.655654,1.265855 5.472465,0.285816 0.816154,-0.980039 1.24197,-3.443367 1.24197,-3.443367 l 4.45243,0.358075 c 0,0 0.402608,-2.036853 0,-2.522675",
    style: {
      fill: "#3771c8",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.588076,25.794961 c 0.358075,-0.88971 0.795524,-2.404603 1.115522,-3.58013 -1.158756,-0.149053 -2.362027,-0.358715 -3.218178,-0.735518 -1.020694,-0.449044 -1.680717,-1.291661 -2.001373,-1.796832 -0.03932,-0.06328 -0.08449,-0.110281 -0.129667,-0.159295 -0.340006,1.281986 -1.000047,3.948538 -1.000047,5.336983 0,1.64392 4.725993,2.196861 5.233762,0.934865",
    style: {
      fill: "#2c5aa0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.760256,20.517343 c 0,0 -0.04444,1.08198 0.47291,1.314247 0.774236,0.347121 1.471037,-0.800681 1.471037,-0.800681 l -1.943947,-0.513566",
    style: {
      fill: "#1c1f24",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.5968617,24.338793 c 0,0 0.1212543,0.217417 0.7103528,1.59295 0.2690457,0.629059 0.9310065,2.783344 0.9310065,2.783344 l 0.97874,-0.1026 c 0,0 -0.271624,-1.160694 -1.000686,-2.998822 -0.21226,-0.536153 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67875",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.45048,26.330474 c -0.410326,0 -0.7445344,0.334208 -0.7445344,0.744552 0,0.410327 0.3342084,0.744535 0.7445344,0.744535 0.410345,0 0.744553,-0.334208 0.744553,-0.744535 0,-0.410344 -0.334208,-0.744552 -0.744553,-0.744552 z m 0,1.887818 c -0.6303395,0 -1.1432655,-0.512926 -1.1432655,-1.143266 0,-0.630358 0.512926,-1.143283 1.1432655,-1.143283 0.630358,0 1.143266,0.512925 1.143266,1.143283 0,0.63034 -0.512908,1.143266 -1.143266,1.143266",
    style: {
      fill: "#f4ab94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.880814,26.467895 c 0,0 3.696282,-1.885221 5.364727,-4.253704 1.25682,-1.783939 3.194969,-6.553806 3.194969,-6.553806 l 0.847775,-0.06127 c 0,0 -1.429082,4.270493 -3.656925,7.452551 -1.660709,2.37364 -5.4473,4.140149 -5.4473,4.140149 L 10.880814,26.46791",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.055033,27.509238 c 0,0 10.446197,-4.20727 14.56248,-5.611845 6.002821,-2.048466 7.514495,-2.37428 8.697758,-2.138776 0,0 0.780033,-0.10516 0.638734,-0.235504 -1.251023,-1.161975 -7.288665,0.878097 -10.433304,2.103314 -1.336175,0.520662 -13.349553,5.261487 -13.349553,5.261487 l -0.116134,0.621324",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.958597,11.00667 c 1.174887,0.311622 2.494291,1.006484 2.494291,1.006484 l 0.822609,-1.764589 -1.41553,-1.2406896 c 0,0 -2.045888,1.2884416 -1.90137,1.9987946",
    style: {
      fill: "#ee9d8f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.581887,9.426596 c -0.238723,1.502639 -1.501341,2.037493 -2.16396,2.222667 -0.386459,0.108452 -0.800022,-0.265169 -1.092295,-0.878737 -0.324533,-0.680671 -0.641953,-1.6297464 -0.265808,-2.8497881 0.448403,-1.4536072 0.919375,-1.6974875 2.000074,-1.525866 1.079383,0.17228 1.761352,1.5297432 1.521989,3.0317241",
    style: {
      fill: "#f9b2a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 -0.346462,1.1123031 -0.256134,1.6013621 0.08907,0.488401 0.622604,0.765182 0.622604,0.765182 L 40.275497,9.5175642 39.194816,9.3014279",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.353497,8.791739 c -0.06072,-0.2722644 -0.27744,-0.5716327 -0.489059,-0.5380912 -0.211619,0.0342 -0.526478,0.4929181 -0.526478,0.4929181 0,0 -0.486462,-0.2341873 -0.954215,-0.6819505 -0.469051,-0.447123 -1.331676,0.012802 -1.357481,-0.3574351 -0.0406,-0.5761501 -0.66518,-1.5252258 1.744581,-1.9968558 1.100689,-0.2154962 2.261384,0.1613067 2.56527,0.9451985 0.593561,1.5297432 0.101868,2.3523524 0.250976,2.9652811 C 38.764482,9.8466152 38.415423,9.0633634 38.353497,8.791739",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.473952,7.7639486 0.0018,0.3826004 c 0,0 1.571661,0.1819729 2.907196,-0.081934 0.782612,-0.154174 1.445231,-0.014631 2.245912,0.2638882 0.801303,0.2774219 1.319405,0.1232661 1.319405,0.1232661 0,0 -0.08193,-2.0729918 -0.898105,-2.8020541 C 38.232737,4.9200133 36.293308,5.2264776 35.619093,5.5535169 34.779695,5.959984 34.518404,7.725213 34.518404,7.725213 l -1.045201,0.038772",
    style: {
      fill: "#002b11",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.784397,7.2936171 c 0,0 -0.163319,1.4303805 0,2.258147 0.163135,0.8271269 1.365858,0.9587509 1.976848,0.1554543 0.326472,-0.4290538 0.800041,-1.5200502 0.800041,-1.5200502 L 38.927709,7.9219815 c 0,0 -0.16972,0.9039209 -0.712932,1.4220043 -0.662601,0.6309797 -1.044561,0.00732 -1.000046,-0.8497131 0.03219,-0.6213233 0.05944,-1.0419825 0.05944,-1.0419825 L 36.78447,7.2935439",
    style: {
      fill: "#002b11",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.069573,9.6737134 c 0,0 0.02067,0.6780916 0,1.0864786 -0.01993,0.407766 -0.111012,0.694223 -0.111012,0.694223 l 0.578088,-0.330972 c 0,0 0.346462,-1.014238 0.166428,-1.2826254 C 37.61145,9.7052981 37.0695,9.6736586 37.0695,9.6736586",
    style: {
      fill: "#002b11",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.828172,13.288684 c 0,0 1.686515,0.454859 2.678807,1.472956 1.265855,1.299415 0.985196,3.042057 0,4.492427 -1.471018,2.1646 -5.227306,4.142747 -5.227306,4.142747 l -3.022049,1.385865 c 0,0 -1.452949,-1.225217 -0.898105,-2.591075 0.321315,-0.792286 2.902057,-3.346583 4.818259,-5.878293 0.70002,-0.92391 1.650394,-3.024627 1.650394,-3.024627",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.949043,9.6614417 -0.310981,0.5871233 c 0,0 0.800662,3.083993 1.127775,3.982098 0.326472,0.898727 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.179413 2.777529,0.689705 0.898105,0.510329 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.443933 1.93877,-2.447198 1.740064,-1.070348 2.504625,-2.625256 2.504625,-2.625256 0,0 -3.269167,-0.945199 -4.249846,-1.27553 C 46.728002,11.684103 45.060197,10.904728 43.362069,10.076303 41.663942,9.249177 39.949043,9.6614417 39.949043,9.6614417",
    style: {
      fill: "#ff80b2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.786289,19.516657 c 0,0 -1.633605,-0.245161 -2.1646,0 -0.530977,0.245179 -0.203865,0.694222 0,1.102628 0.204523,0.408406 0.612929,0.835521 1.06199,0.989073 0.449044,0.154174 1.891037,-0.726483 1.891037,-0.726483 l -0.788427,-1.365218",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.507839,15.346825 c -0.01097,-0.885834 -0.410984,-3.791749 -0.682609,-4.301456 -0.488401,-0.914876 -1.500042,-1.1845618 -2.187168,-0.796804 -0.687126,0.387758 -0.467113,2.029757 -0.193568,3.411106 0.08523,0.428395 0.48648,2.604608 0.663259,3.082054 l -4.713081,2.853006 c -0.134788,0.815514 0.217417,1.37877 0.773577,1.725872 0.432913,-0.154906 1.780702,-0.656803 2.905276,-1.301335 1.180684,-0.676811 2.300083,-1.280705 2.998823,-1.67748 0.347742,-0.197427 0.457438,-1.170369 0.435491,-2.994963",
    style: {
      fill: "#ff2a7f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.856361,24.930416 c 0,0 1.974269,6.043458 2.940756,7.15706 1.136809,1.310369 0.449701,-0.105892 0.449701,-0.105892 0,0 -1.947183,-3.430455 -2.615582,-6.649291 -0.142652,-0.164599 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#89434a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.804675,23.396814 c 0,0 1.97555,2.291048 3.255597,3.871762 0.882614,1.091015 2.410419,3.478847 2.560094,3.707877 0.352918,0.537451 0.06383,1.373612 -0.361934,1.996856 -0.425835,0.623902 -0.896167,1.132951 -1.118119,1.566522 -0.220654,0.434193 0.130399,0.921972 0.130399,0.921972 0,0 1.508455,-0.392934 2.243955,-1.167151 0.734878,-0.774876 1.279407,-1.597485 1.439415,-1.526506 0.160575,0.07169 1.183281,-0.944559 1.183281,-0.944559 0,0 -0.736158,-1.238751 -1.317484,-2.029117 -0.581307,-0.790988 -2.120067,-3.78853 -2.723321,-5.011791 -0.603894,-1.223918 -0.625841,-1.782658 -2.088464,-2.273637 -0.591001,-0.198726 -0.525179,0.474849 -1.423925,0.474849 -1.080041,0 -1.779439,0.412923 -1.779439,0.412923",
    style: {
      fill: "#553133",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.953906,31.300347 48.26742,31.87262 c 0,0 0.687126,0.746491 1.155519,1.30651 0.423256,0.505812 0.980057,1.39876 0.980057,1.39876 l 1.021956,-0.883255 c 0,0 -0.860028,-2.021381 -2.471046,-2.394288",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 1.041964,-1.0103613 2.226526,-0.8071186 1.184561,0.2032245 1.989119,0.9716441 2.383333,1.1794041 0.393556,0.2077418 1.047122,-0.1148532 1.047122,-0.1148532 0,0 -0.544529,1.0748658 -1.497464,1.0051858 C 42.40138,10.494366 41.564579,9.6162685 40.570989,9.6736951 39.196755,9.7530683 39.194816,9.3014279 39.194816,9.3014279",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer3",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5479",
    transform: "matrix(1.8168503,0,0,1.8168503,-2.5278203,20.345401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6053",
    transform: "translate(-3.5827025,-58.640772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4306-0-3-0",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,109.31868,48.723188)",
    style: {
      display: "inline",
      fill: "#666666",
      fillOpacity: 0.846224,
      filter: "url(#filter1510-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 71.092807,26.707917 c 0.662619,-0.268406 7.458348,-4.020158 12.034008,0 4.575019,4.020138 6.738979,6.587987 10.202976,6.298293 2.567848,-0.214837 3.216897,-2.158784 3.216897,-2.158784 0,0 0.649067,5.9028 -2.827201,7.388668 -7.132535,3.049154 -9.494562,-2.416216 -11.508188,-4.693731 -2.013627,-2.278155 -6.074422,-6.47767 -10.053283,-5.543444 -2.218789,0.52068 -1.065209,-1.291002 -1.065209,-1.291002",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-30-6-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,14.577765 c 0,0 3.701421,-1.119398 7.512538,-0.160027 3.811117,0.958751 7.991923,2.993026 10.25007,4.24403 3.021409,1.674261 4.39952,3.131087 4.39952,3.131087 0,0 -9.62165,-0.795505 -12.281107,-1.41617 -6.533798,-1.524586 -9.881021,-5.798938 -9.881021,-5.798938",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-4-7-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.030657,11.964122 c 0,0 0.255493,3.103982 0.827126,4.3292 0.571633,1.225199 1.878144,0 1.878144,0 0,0 -0.83746,-3.185295 -2.70527,-4.3292",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-44-5-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.830904,35.077904 c 0,0 1.027132,2.722681 3.291095,1.960077 2.263304,-0.761964 2.916249,-2.776889 4.223381,-1.224559 1.306511,1.551031 4.247267,6.846718 5.335703,7.13963 1.089076,0.292273 1.361341,-0.435509 1.905869,-0.469691 0.544548,-0.03475 2.558814,3.431735 2.558814,3.431735 0,0 -2.123304,1.522648 -5.227305,-0.111012 -2.929142,-1.541338 -5.934421,-5.662157 -5.934421,-5.662157 0,0 -6.370571,1.073586 -6.806702,0.781972 -0.43487,-0.292273 0.653566,-5.846032 0.653566,-5.846032",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-4-3-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.974429,33.934638 c 0,0 -9.96749,1.419407 -11.493996,1.652973 -0.418721,0.06383 -0.841977,0.405809 -1.263916,0.900025 0.370328,0.874879 0.825187,2.042669 1.140686,3.17626 0.200646,-0.257432 0.403231,-0.467771 0.607113,-0.592939 0.418081,-0.257414 4.753737,1.549751 10.307496,0.335507 1.396839,-0.305184 0.702617,-5.471826 0.702617,-5.471826",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-7-5-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.957683,41.587835 c -1.249724,1.697487 -2.245253,2.669131 -3.3891773,4.629849 -1.1426071,1.960077 -1.1426071,3.389817 -1.1426071,3.389817 l 3.2543164,-0.945838 c 0,0 0.17612,-1.57168 0.829065,-2.117507 0.652926,-0.546468 1.714898,-0.408406 2.450416,-1.86653 0.326454,-0.648409 1.312309,-3.618189 2.397507,-5.01373 -0.315499,-1.133591 -0.770358,-2.301381 -1.140686,-3.17626 -1.118119,1.305853 -2.234281,3.710474 -3.258834,5.100199",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-6-6-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.408427,29.259616 C 71.468951,24.126516 65.678408,24.635565 60.778215,24.853 46.417679,25.489155 41.765883,22.275476 37.950889,21.082539 c -2.343958,-0.73294 -9.873285,-4.420827 -12.496603,-5.050527 -5.261487,-1.263276 -9.953938,0.445185 -9.953938,0.445185 0,0 -5.123407,6.096368 -6.0924905,7.058977 -0.9690654,0.963268 -2.6304143,2.463968 -3.0465563,2.752364 -0.4148617,0.287755 -0.4916378,1.122617 0,1.846522 0.4735686,0.696161 1.523269,0.855511 1.523269,0.855511 0,0 -0.061999,0.900683 0.4916379,1.007142 0.5542219,0.105892 1.4207057,-0.201944 1.5929673,-1.25682 1.1000496,0.05102 4.9479266,-1.004564 6.3292746,-1.755555 1.761352,-0.956171 2.075571,-2.287829 2.075571,-2.287829 l 0.75099,-1.69233 c 0,0 4.246608,0.638734 6.424761,4.068549 2.178152,3.430455 5.117609,8.716467 5.117609,8.716467 l -2.318152,0.958751 c 0.314859,0.59228 0.581325,1.072287 0.772937,1.372954 1.163273,1.260039 2.484616,2.251051 3.914338,3.02011 l 2.504624,-2.003293 c 0,0 4.22854,0.754867 8.373225,0.691625 8.20612,-0.125827 10.73911,-1.947165 13.106953,-1.730389 2.939457,0.269046 5.069876,2.452355 5.071156,2.453654 1.249724,0.112293 2.694955,0.227749 4.402758,0.227749 0.787769,0 3.05559,0.03804 5.227287,-1.817498 2.171056,-1.855557 4.645997,-7.273175 2.68592,-9.704242",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-3-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.914353,39.830342 c -4.144685,0.06328 -8.373225,-0.691625 -8.373225,-0.691625 l -2.504624,2.003293 c 0.661321,0.355497 1.34329,0.668417 2.047187,0.931007 3.584647,0.920673 6.450565,0.879377 8.830662,0.879377 6.573155,6.58e-4 10.991385,-1.811024 13.495351,-2.440083 1.223919,-0.307105 2.70591,-0.1368 4.682758,0.04133 -0.0013,-0.0013 -2.131699,-2.184608 -5.071156,-2.453635 -2.367843,-0.216795 -4.900833,1.604562 -13.106953,1.730389",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-1-9-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.549772,27.073728 c -2.178153,-3.429815 -6.424761,-4.068549 -6.424761,-4.068549 l -0.75099,1.69233 c 0,0 3.080756,0.763262 4.742105,2.498168 0.974241,1.016799 3.692405,6.655089 5.233103,9.553269 l 2.318152,-0.958751 c 0,0 -2.939457,-5.286012 -5.117609,-8.716467",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-7-1-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.000736,38.276732 c -1.416828,0.285176 -2.658798,0.146493 -2.449118,-1.635544 0.199366,-1.686514 -13.590196,1.727811 -13.590196,1.727811 0,0 2.178152,2.227824 4.465323,4.584053 2.285891,2.356212 4.67632,2.799458 8.384838,1.925878 1.169729,-0.275502 2.747206,-0.981977 3.536273,-1.365858 0.656145,-2.779468 0.202585,-4.296939 -0.34712,-5.23634",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-5-2-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.256426,49.01522 c 1.791692,1.634904 5.330526,1.526506 5.330526,1.526506 0,0 0,-2.831718 -1.143265,-4.127896 -0.487121,-0.551643 -1.960077,0.87294 -2.613644,0 -0.653584,-0.872299 -1.960077,-6.550587 -2.613661,-8.044831 -0.653567,-1.494245 -1.392944,-0.905842 -2.831079,-0.459377 -0.451622,0.13936 -1.805866,0.386478 -2.263304,0.478744 0.57487,1.263258 0.878737,3.223336 0.734878,5.373744 0.7697,-0.374846 2.344598,-1.749099 2.344598,-1.749099 0,0 0.90778,5.040834 3.054951,7.002209",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-9-7-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.506117,16.148786 3.221415,4.182744 0.376145,-0.750991 -2.858164,-3.859508 -0.739396,0.427755",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-6-0-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.996994,16.460426 c 0,0 0.894868,1.900712 2.869795,1.582634 1.350368,-0.217435 2.869138,-1.749738 2.869138,-1.749738 l -0.522601,-1.449749 c 0,0 -3.209161,0.723265 -5.216332,1.616853",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-2-9-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.653947,11.326668 c 0,0 -0.19355,3.916935 0.567115,6.075079 0.760043,2.158144 2.883348,0 2.883348,0 0,0 -1.511034,-4.507917 -3.450463,-6.075079",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-1-3-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.151311,34.465633 c 0,0 -7.22802,3.471093 -11.148156,4.858897 -2.414296,0.855511 -2.876252,1.674901 -3.26529,2.688481 0.532276,0.33099 1.357464,1.121338 1.923939,2.930441 0.270326,-0.48712 0.510987,-0.818091 0.687766,-0.881334 1.403277,-0.501312 7.273193,-0.201286 11.643031,-2.048467 0.714212,-0.301288 2.976236,-1.496183 5.263426,-3.931749 1.50006,-1.597485 -5.104716,-3.616269 -5.104716,-3.616269",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-7-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,42.013011 c -0.112841,0.295492 -0.220013,0.605833 -0.367768,0.940041 -0.653566,1.480053 -3.662064,7.68288 -4.631787,9.241647 -0.969706,1.559408 -0.709695,4.297579 -0.709695,4.297579 l 3.114956,-1.353604 c 0,0 -0.624542,-1.876845 0.136068,-2.163302 0.760026,-0.287115 1.413592,-0.33227 2.067176,-2.351054 0.486463,-1.502639 1.528445,-4.263397 2.314916,-5.680866 -0.566457,-1.809103 -1.391663,-2.599451 -1.923939,-2.930441",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-8-0-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.339408,21.792873 c 0,0 -1.632965,3.974362 0.980697,6.097667 2.613644,2.123944 10.12748,2.394928 12.250784,2.09556 2.123304,-0.298729 1.743941,-4.045963 1.742003,-5.526016 -3.756928,-0.380661 -12.525006,-1.776202 -14.973484,-2.667211",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-5-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 46.294449,27.073728 c 0,0 -0.925849,5.608607 -1.251663,8.004176 -0.327112,2.395587 -1.128433,7.87449 -1.128433,7.87449 0,0 3.207223,6.58e-4 6.16217,-0.546467 -0.02524,-0.392916 0.410985,-1.51877 -0.678091,-2.027819 -1.089076,-0.508409 -2.551718,-1.178746 -2.364606,-2.967201 0.186454,-1.788456 1.329719,-10.337179 1.329719,-10.337179 h -2.069096",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-7-2-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.038642,21.792873 c -0.584526,-0.703238 -1.407154,0.871001 -3.571095,0.625841 -0.534214,-0.06072 -1.143266,-0.123815 -1.763949,-0.203883 -0.319998,1.175527 -0.757447,2.69042 -1.115522,3.58013 -0.507768,1.261996 -5.233743,0.709073 -5.233743,-0.934865 0,-1.388445 0.660023,-4.054998 1.000028,-5.336983 -0.460016,-0.508409 -1.125836,-0.320017 -1.258758,-0.02067 -0.239363,0.541968 -0.487761,1.725871 -0.612271,2.290408 -0.27808,1.259417 -1.242628,4.209208 1.388445,5.322151 2.246533,0.949715 4.655654,1.265855 5.472465,0.285816 0.816154,-0.980039 1.24197,-3.443367 1.24197,-3.443367 l 4.45243,0.358075 c 0,0 0.402608,-2.036853 0,-2.522675",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-4-6-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.588076,25.794961 c 0.358075,-0.88971 0.795524,-2.404603 1.115522,-3.58013 -1.158756,-0.149053 -2.362027,-0.358715 -3.218178,-0.735518 -1.020694,-0.449044 -1.680717,-1.291661 -2.001373,-1.796832 -0.03932,-0.06328 -0.08449,-0.110281 -0.129667,-0.159295 -0.340006,1.281986 -1.000047,3.948538 -1.000047,5.336983 0,1.64392 4.725993,2.196861 5.233762,0.934865",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-1-1-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.760256,20.517343 c 0,0 -0.04444,1.08198 0.47291,1.314247 0.774236,0.347121 1.471037,-0.800681 1.471037,-0.800681 l -1.943947,-0.513566",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-8-8-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.5968617,24.338793 c 0,0 0.1212543,0.217417 0.7103528,1.59295 0.2690457,0.629059 0.9310065,2.783344 0.9310065,2.783344 l 0.97874,-0.1026 c 0,0 -0.271624,-1.160694 -1.000686,-2.998822 -0.21226,-0.536153 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67875",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-5-7-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.45048,26.330474 c -0.410326,0 -0.7445344,0.334208 -0.7445344,0.744552 0,0.410327 0.3342084,0.744535 0.7445344,0.744535 0.410345,0 0.744553,-0.334208 0.744553,-0.744535 0,-0.410344 -0.334208,-0.744552 -0.744553,-0.744552 z m 0,1.887818 c -0.6303395,0 -1.1432655,-0.512926 -1.1432655,-1.143266 0,-0.630358 0.512926,-1.143283 1.1432655,-1.143283 0.630358,0 1.143266,0.512925 1.143266,1.143283 0,0.63034 -0.512908,1.143266 -1.143266,1.143266",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-9-9-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.880814,26.467895 c 0,0 3.696282,-1.885221 5.364727,-4.253704 1.25682,-1.783939 3.194969,-6.553806 3.194969,-6.553806 l 0.847775,-0.06127 c 0,0 -1.429082,4.270493 -3.656925,7.452551 -1.660709,2.37364 -5.4473,4.140149 -5.4473,4.140149 L 10.880814,26.46791",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-7-2-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.055033,27.509238 c 0,0 10.446197,-4.20727 14.56248,-5.611845 6.002821,-2.048466 7.514495,-2.37428 8.697758,-2.138776 0,0 0.780033,-0.10516 0.638734,-0.235504 -1.251023,-1.161975 -7.288665,0.878097 -10.433304,2.103314 -1.336175,0.520662 -13.349553,5.261487 -13.349553,5.261487 l -0.116134,0.621324",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-5-0-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.958597,11.00667 c 1.174887,0.311622 2.494291,1.006484 2.494291,1.006484 l 0.822609,-1.764589 -1.41553,-1.2406896 c 0,0 -2.045888,1.2884416 -1.90137,1.9987946",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-3-2-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.581887,9.426596 c -0.238723,1.502639 -1.501341,2.037493 -2.16396,2.222667 -0.386459,0.108452 -0.800022,-0.265169 -1.092295,-0.878737 -0.324533,-0.680671 -0.641953,-1.6297464 -0.265808,-2.8497881 0.448403,-1.4536072 0.919375,-1.6974875 2.000074,-1.525866 1.079383,0.17228 1.761352,1.5297432 1.521989,3.0317241",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-8-3-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 -0.346462,1.1123031 -0.256134,1.6013621 0.08907,0.488401 0.622604,0.765182 0.622604,0.765182 L 40.275497,9.5175642 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-8-7-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.353497,8.791739 c -0.06072,-0.2722644 -0.27744,-0.5716327 -0.489059,-0.5380912 -0.211619,0.0342 -0.526478,0.4929181 -0.526478,0.4929181 0,0 -0.486462,-0.2341873 -0.954215,-0.6819505 -0.469051,-0.447123 -1.331676,0.012802 -1.357481,-0.3574351 -0.0406,-0.5761501 -0.66518,-1.5252258 1.744581,-1.9968558 1.100689,-0.2154962 2.261384,0.1613067 2.56527,0.9451985 0.593561,1.5297432 0.101868,2.3523524 0.250976,2.9652811 C 38.764482,9.8466152 38.415423,9.0633634 38.353497,8.791739",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-3-5-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.473952,7.7639486 0.0018,0.3826004 c 0,0 1.571661,0.1819729 2.907196,-0.081934 0.782612,-0.154174 1.445231,-0.014631 2.245912,0.2638882 0.801303,0.2774219 1.319405,0.1232661 1.319405,0.1232661 0,0 -0.08193,-2.0729918 -0.898105,-2.8020541 C 38.232737,4.9200133 36.293308,5.2264776 35.619093,5.5535169 34.779695,5.959984 34.518404,7.725213 34.518404,7.725213 l -1.045201,0.038772",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-1-9-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.784397,7.2936171 c 0,0 -0.163319,1.4303805 0,2.258147 0.163135,0.8271269 1.365858,0.9587509 1.976848,0.1554543 0.326472,-0.4290538 0.800041,-1.5200502 0.800041,-1.5200502 L 38.927709,7.9219815 c 0,0 -0.16972,0.9039209 -0.712932,1.4220043 -0.662601,0.6309797 -1.044561,0.00732 -1.000046,-0.8497131 0.03219,-0.6213233 0.05944,-1.0419825 0.05944,-1.0419825 L 36.78447,7.2935439",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-8-2-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.069573,9.6737134 c 0,0 0.02067,0.6780916 0,1.0864786 -0.01993,0.407766 -0.111012,0.694223 -0.111012,0.694223 l 0.578088,-0.330972 c 0,0 0.346462,-1.014238 0.166428,-1.2826254 C 37.61145,9.7052981 37.0695,9.6736586 37.0695,9.6736586",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-9-2-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.828172,13.288684 c 0,0 1.686515,0.454859 2.678807,1.472956 1.265855,1.299415 0.985196,3.042057 0,4.492427 -1.471018,2.1646 -5.227306,4.142747 -5.227306,4.142747 l -3.022049,1.385865 c 0,0 -1.452949,-1.225217 -0.898105,-2.591075 0.321315,-0.792286 2.902057,-3.346583 4.818259,-5.878293 0.70002,-0.92391 1.650394,-3.024627 1.650394,-3.024627",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-6-8-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.949043,9.6614417 -0.310981,0.5871233 c 0,0 0.800662,3.083993 1.127775,3.982098 0.326472,0.898727 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.179413 2.777529,0.689705 0.898105,0.510329 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.443933 1.93877,-2.447198 1.740064,-1.070348 2.504625,-2.625256 2.504625,-2.625256 0,0 -3.269167,-0.945199 -4.249846,-1.27553 C 46.728002,11.684103 45.060197,10.904728 43.362069,10.076303 41.663942,9.249177 39.949043,9.6614417 39.949043,9.6614417",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-43-9-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.786289,19.516657 c 0,0 -1.633605,-0.245161 -2.1646,0 -0.530977,0.245179 -0.203865,0.694222 0,1.102628 0.204523,0.408406 0.612929,0.835521 1.06199,0.989073 0.449044,0.154174 1.891037,-0.726483 1.891037,-0.726483 l -0.788427,-1.365218",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-3-7-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.507839,15.346825 c -0.01097,-0.885834 -0.410984,-3.791749 -0.682609,-4.301456 -0.488401,-0.914876 -1.500042,-1.1845618 -2.187168,-0.796804 -0.687126,0.387758 -0.467113,2.029757 -0.193568,3.411106 0.08523,0.428395 0.48648,2.604608 0.663259,3.082054 l -4.713081,2.853006 c -0.134788,0.815514 0.217417,1.37877 0.773577,1.725872 0.432913,-0.154906 1.780702,-0.656803 2.905276,-1.301335 1.180684,-0.676811 2.300083,-1.280705 2.998823,-1.67748 0.347742,-0.197427 0.457438,-1.170369 0.435491,-2.994963",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-38-3-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.856361,24.930416 c 0,0 1.974269,6.043458 2.940756,7.15706 1.136809,1.310369 0.449701,-0.105892 0.449701,-0.105892 0,0 -1.947183,-3.430455 -2.615582,-6.649291 -0.142652,-0.164599 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-6-6-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.804675,23.396814 c 0,0 1.97555,2.291048 3.255597,3.871762 0.882614,1.091015 2.410419,3.478847 2.560094,3.707877 0.352918,0.537451 0.06383,1.373612 -0.361934,1.996856 -0.425835,0.623902 -0.896167,1.132951 -1.118119,1.566522 -0.220654,0.434193 0.130399,0.921972 0.130399,0.921972 0,0 1.508455,-0.392934 2.243955,-1.167151 0.734878,-0.774876 1.279407,-1.597485 1.439415,-1.526506 0.160575,0.07169 1.183281,-0.944559 1.183281,-0.944559 0,0 -0.736158,-1.238751 -1.317484,-2.029117 -0.581307,-0.790988 -2.120067,-3.78853 -2.723321,-5.011791 -0.603894,-1.223918 -0.625841,-1.782658 -2.088464,-2.273637 -0.591001,-0.198726 -0.525179,0.474849 -1.423925,0.474849 -1.080041,0 -1.779439,0.412923 -1.779439,0.412923",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-0-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.953906,31.300347 48.26742,31.87262 c 0,0 0.687126,0.746491 1.155519,1.30651 0.423256,0.505812 0.980057,1.39876 0.980057,1.39876 l 1.021956,-0.883255 c 0,0 -0.860028,-2.021381 -2.471046,-2.394288",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-4-2-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 1.041964,-1.0103613 2.226526,-0.8071186 1.184561,0.2032245 1.989119,0.9716441 2.383333,1.1794041 0.393556,0.2077418 1.047122,-0.1148532 1.047122,-0.1148532 0,0 -0.544529,1.0748658 -1.497464,1.0051858 C 42.40138,10.494366 41.564579,9.6162685 40.570989,9.6736951 39.196755,9.7530683 39.194816,9.3014279 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.846224,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-8-9-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4348-0",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,91.422729,-4.7029849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 73.041712,84.135963 c 0.66262,-0.2684 7.45835,-4.02015 12.03401,0 4.57502,4.02014 6.73898,6.58799 10.20298,6.2983 2.56784,-0.21484 3.21689,-2.15879 3.21689,-2.15879 0,0 0.64907,5.9028 -2.8272,7.38867 -7.13253,3.04916 -9.49456,-2.41621 -11.50819,-4.69373 -2.01362,-2.27815 -6.07442,-6.47767 -10.05328,-5.54344 -2.21879,0.52068 -1.06521,-1.29101 -1.06521,-1.29101",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-3-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19.686773,72.005816 c 0,0 3.701421,-1.119398 7.512538,-0.160027 3.811117,0.958751 7.991923,2.993026 10.25007,4.24403 3.021409,1.674261 4.39952,3.131087 4.39952,3.131087 0,0 -9.62165,-0.795505 -12.281107,-1.41617 -6.533798,-1.524586 -9.881021,-5.798938 -9.881021,-5.798938",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-6-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.979565,69.392173 c 0,0 0.255493,3.103982 0.827126,4.3292 0.571633,1.225199 1.878144,0 1.878144,0 0,0 -0.83746,-3.185295 -2.70527,-4.3292",
    style: {
      fill: "#550000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-7-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 73.779812,92.505953 c 0,0 1.02713,2.72268 3.2911,1.96008 2.2633,-0.76197 2.91624,-2.77689 4.22338,-1.22456 1.30651,1.55103 4.24726,6.846717 5.3357,7.139627 1.08907,0.29227 1.36134,-0.435507 1.90587,-0.469687 0.54455,-0.0347 2.55881,3.431727 2.55881,3.431727 0,0 -2.1233,1.52265 -5.2273,-0.11101 -2.92915,-1.54134 -5.93442,-5.662157 -5.93442,-5.662157 0,0 -6.37058,1.07359 -6.80671,0.78198 -0.43487,-0.29228 0.65357,-5.84603 0.65357,-5.84603",
    style: {
      fill: "#280b0b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-5-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 30.923337,91.362693 c 0,0 -9.96749,1.4194 -11.493996,1.65297 -0.418721,0.0638 -0.841977,0.40581 -1.263916,0.90002 0.370328,0.87488 0.825187,2.04267 1.140686,3.17626 0.200646,-0.25743 0.403231,-0.46777 0.607113,-0.59293 0.418081,-0.25742 4.753737,1.54975 10.307496,0.3355 1.396839,-0.30518 0.702617,-5.47182 0.702617,-5.47182",
    style: {
      fill: "#550000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-3-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.906591,99.015883 c -1.249724,1.697487 -2.245253,2.669127 -3.389177,4.629847 -1.142607,1.96008 -1.142607,3.38982 -1.142607,3.38982 l 3.254316,-0.94584 c 0,0 0.17612,-1.57168 0.829065,-2.11751 0.652926,-0.54646 1.714898,-0.4084 2.450416,-1.86653 0.326454,-0.64841 1.312309,-3.618187 2.397507,-5.013727 -0.315499,-1.13359 -0.770358,-2.30138 -1.140686,-3.17626 -1.118119,1.30586 -2.234281,3.71048 -3.258834,5.1002",
    style: {
      fill: "#280b0b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-5-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.357332,86.687663 c -2.93947,-5.1331 -8.73002,-4.62405 -13.63021,-4.40661 -14.360535,0.63615 -19.012331,-2.577526 -22.827325,-3.770463 -2.343958,-0.73294 -9.873285,-4.420827 -12.496603,-5.050527 -5.261487,-1.263276 -9.953938,0.445185 -9.953938,0.445185 0,0 -5.123407,6.096365 -6.092491,7.058975 -0.969065,0.96327 -2.6304135,2.46397 -3.0465555,2.75237 -0.414862,0.28775 -0.491638,1.12261 0,1.84652 0.473569,0.69616 1.523269,0.85551 1.523269,0.85551 0,0 -0.062,0.90068 0.4916375,1.00714 0.554222,0.10589 1.420706,-0.20194 1.592967,-1.25682 1.10005,0.051 4.947927,-1.00456 6.329275,-1.75555 1.761352,-0.95618 2.075571,-2.28783 2.075571,-2.28783 l 0.75099,-1.69233 c 0,0 4.246608,0.63873 6.424761,4.06855 2.178152,3.43045 5.117609,8.71646 5.117609,8.71646 l -2.318152,0.95875 c 0.314859,0.59228 0.581325,1.07229 0.772937,1.37296 1.163273,1.26004 2.484616,2.25105 3.914338,3.02011 l 2.504624,-2.0033 c 0,0 4.22854,0.75487 8.373225,0.69163 8.206121,-0.12583 10.739111,-1.94717 13.106951,-1.73039 2.93946,0.26905 5.06988,2.45236 5.07116,2.45365 1.24972,0.1123 2.69495,0.22775 4.40276,0.22775 0.78777,0 3.05559,0.038 5.22728,-1.81749 2.17106,-1.85556 4.646,-7.27318 2.68592,-9.70425",
    style: {
      fill: "#800000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-6-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.863261,97.258393 c -4.144685,0.0633 -8.373225,-0.69163 -8.373225,-0.69163 l -2.504624,2.0033 c 0.661321,0.35549 1.34329,0.66841 2.047187,0.93101 3.584647,0.920667 6.450565,0.879367 8.830662,0.879367 6.573155,6.6e-4 10.991381,-1.811017 13.495351,-2.440077 1.22392,-0.30711 2.70591,-0.1368 4.68276,0.0413 -10e-4,-10e-4 -2.1317,-2.18461 -5.07116,-2.45364 -2.36784,-0.21679 -4.90083,1.60457 -13.106951,1.73039",
    style: {
      fill: "#550000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27.49868,84.501783 c -2.178153,-3.42982 -6.424761,-4.06855 -6.424761,-4.06855 l -0.75099,1.69233 c 0,0 3.080756,0.76326 4.742105,2.49816 0.974241,1.0168 3.692405,6.65509 5.233103,9.55327 l 2.318152,-0.95875 c 0,0 -2.939457,-5.28601 -5.117609,-8.71646",
    style: {
      fill: "#550000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-9-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 77.949642,95.704783 c -1.41683,0.28518 -2.6588,0.14649 -2.44912,-1.63554 0.19937,-1.68652 -13.59019,1.72781 -13.59019,1.72781 0,0 2.17815,2.22782 4.46532,4.584047 2.28589,2.35621 4.67632,2.79946 8.38484,1.92588 1.16973,-0.2755 2.74721,-0.98198 3.53627,-1.36586 0.65615,-2.779467 0.20259,-4.296937 -0.34712,-5.236337",
    style: {
      fill: "#800000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-1-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 83.205332,106.44327 c 1.79169,1.6349 5.33053,1.5265 5.33053,1.5265 0,0 0,-2.83171 -1.14327,-4.12789 -0.48712,-0.55165 -1.96007,0.87294 -2.61364,0 -0.65358,-0.8723 -1.96008,-6.550587 -2.61366,-8.044827 -0.65357,-1.49425 -1.39295,-0.90585 -2.83108,-0.45938 -0.45162,0.13936 -1.80587,0.38648 -2.2633,0.47874 0.57487,1.26326 0.87873,3.22334 0.73487,5.373747 0.7697,-0.37485 2.3446,-1.749097 2.3446,-1.749097 0,0 0.90778,5.040827 3.05495,7.002207",
    style: {
      fill: "#501616",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-2-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.455025,73.576837 3.221415,4.182744 0.376145,-0.750991 -2.858164,-3.859508 -0.739396,0.427755",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-7-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13.945902,73.888477 c 0,0 0.894868,1.900712 2.869795,1.582634 1.350368,-0.217435 2.869138,-1.749738 2.869138,-1.749738 l -0.522601,-1.449749 c 0,0 -3.209161,0.723265 -5.216332,1.616853",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-0-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18.602855,68.754719 c 0,0 -0.19355,3.916935 0.567115,6.075079 0.760043,2.158144 2.883348,0 2.883348,0 0,0 -1.511034,-4.507917 -3.450463,-6.075079",
    style: {
      fill: "#800000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-9-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34.100219,91.893683 c 0,0 -7.22802,3.47109 -11.148156,4.8589 -2.414296,0.85551 -2.876252,1.6749 -3.26529,2.68848 0.532276,0.33099 1.357464,1.121337 1.923939,2.930437 0.270326,-0.48712 0.510987,-0.81809 0.687766,-0.88133 1.403277,-0.50132 7.273193,-0.20129 11.643031,-2.048467 0.714212,-0.30129 2.976236,-1.49618 5.263426,-3.93175 1.50006,-1.59749 -5.104716,-3.61627 -5.104716,-3.61627",
    style: {
      fill: "#800000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-3-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19.686773,99.441063 c -0.112841,0.29549 -0.220013,0.605827 -0.367768,0.940037 -0.653566,1.48005 -3.662064,7.68288 -4.631787,9.24165 -0.969706,1.5594 -0.709695,4.29758 -0.709695,4.29758 l 3.114956,-1.35361 c 0,0 -0.624542,-1.87684 0.136068,-2.1633 0.760026,-0.28712 1.413592,-0.33227 2.067176,-2.35105 0.486463,-1.50264 1.528445,-4.2634 2.314916,-5.68087 -0.566457,-1.8091 -1.391663,-2.599447 -1.923939,-2.930437",
    style: {
      fill: "#501616",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-6-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.288316,79.220924 c 0,0 -1.632965,3.974359 0.980697,6.097669 2.613644,2.12394 10.127479,2.39493 12.250779,2.09556 2.12331,-0.29873 1.74395,-4.04596 1.74201,-5.52602 -3.75693,-0.38066 -12.525008,-1.7762 -14.973486,-2.667209",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-0-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.243357,84.501783 c 0,0 -0.925849,5.6086 -1.251663,8.00417 -0.327112,2.39559 -1.128433,7.874487 -1.128433,7.874487 0,0 3.207223,6.6e-4 6.16217,-0.546457 -0.02524,-0.39292 0.410985,-1.51878 -0.678091,-2.02782 -1.089076,-0.50841 -2.551718,-1.17875 -2.364606,-2.96721 0.186454,-1.78845 1.329719,-10.33717 1.329719,-10.33717 h -2.069096",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-6-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 56.987552,79.220924 c -0.58453,-0.703238 -1.40716,0.870999 -3.5711,0.625839 -0.534211,-0.06072 -1.143263,-0.123813 -1.763946,-0.203881 -0.319998,1.175531 -0.757447,2.690421 -1.115522,3.580131 -0.507768,1.26199 -5.233743,0.70907 -5.233743,-0.93487 0,-1.38844 0.660023,-4.054994 1.000028,-5.336979 -0.460016,-0.508409 -1.125836,-0.320017 -1.258758,-0.02067 -0.239363,0.541968 -0.487761,1.725871 -0.612271,2.290408 -0.27808,1.259421 -1.242628,4.209211 1.388445,5.322151 2.246533,0.94971 4.655654,1.26586 5.472465,0.28582 0.816154,-0.98004 1.24197,-3.44337 1.24197,-3.44337 l 4.452432,0.35807 c 0,0 0.40261,-2.036849 0,-2.522671",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-2-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.536984,83.223013 c 0.358075,-0.88971 0.795524,-2.4046 1.115522,-3.580131 -1.158756,-0.149053 -2.362027,-0.358715 -3.218178,-0.735518 -1.020694,-0.449044 -1.680717,-1.291661 -2.001373,-1.796832 -0.03932,-0.06328 -0.08449,-0.110281 -0.129667,-0.159295 -0.340006,1.281986 -1.000047,3.948536 -1.000047,5.336986 0,1.64392 4.725993,2.19686 5.233762,0.93486",
    style: {
      fill: "#f0a7a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-6-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.709164,77.945394 c 0,0 -0.04444,1.08198 0.47291,1.314247 0.774236,0.347121 1.471037,-0.800681 1.471037,-0.800681 l -1.943947,-0.513566",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-1-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.54577,81.766843 c 0,0 0.121254,0.21742 0.710353,1.59295 0.269045,0.62906 0.931006,2.78334 0.931006,2.78334 l 0.97874,-0.1026 c 0,0 -0.271624,-1.16069 -1.000686,-2.99882 -0.21226,-0.53615 -0.90906,-1.95364 -0.90906,-1.95364 l -0.710353,0.67875",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-8-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.399388,83.758523 c -0.410326,0 -0.744534,0.33421 -0.744534,0.74455 0,0.41033 0.334208,0.74454 0.744534,0.74454 0.410345,0 0.744553,-0.33421 0.744553,-0.74454 0,-0.41034 -0.334208,-0.74455 -0.744553,-0.74455 z m 0,1.88782 c -0.630339,0 -1.143265,-0.51293 -1.143265,-1.14327 0,-0.63035 0.512926,-1.14328 1.143265,-1.14328 0.630358,0 1.143266,0.51293 1.143266,1.14328 0,0.63034 -0.512908,1.14327 -1.143266,1.14327",
    style: {
      fill: "#f4ab94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-7-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.829722,83.895943 c 0,0 3.696282,-1.88522 5.364727,-4.253701 1.25682,-1.783939 3.194969,-6.553806 3.194969,-6.553806 l 0.847775,-0.06127 c 0,0 -1.429082,4.270493 -3.656925,7.452547 -1.660709,2.37364 -5.4473,4.14015 -5.4473,4.14015 l -0.303246,-0.7239",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-9-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13.003941,84.937293 c 0,0 10.446197,-4.20727 14.56248,-5.611849 6.002821,-2.048466 7.514495,-2.37428 8.697758,-2.138776 0,0 0.780033,-0.10516 0.638734,-0.235504 -1.251023,-1.161975 -7.288665,0.878097 -10.433304,2.103314 -1.336175,0.520662 -13.349553,5.261485 -13.349553,5.261485 l -0.116134,0.62133",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-2-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.907505,68.434721 c 1.174887,0.311622 2.494291,1.006484 2.494291,1.006484 l 0.822609,-1.764589 -1.41553,-1.24069 c 0,0 -2.045888,1.288442 -1.90137,1.998795",
    style: {
      fill: "#ee9d8f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-0-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.530795,66.854647 c -0.238723,1.502639 -1.501341,2.037493 -2.16396,2.222667 -0.386459,0.108452 -0.800022,-0.265169 -1.092295,-0.878737 -0.324533,-0.680671 -0.641953,-1.629746 -0.265808,-2.849788 0.448403,-1.453607 0.919375,-1.697488 2.000074,-1.525866 1.079383,0.17228 1.761352,1.529743 1.521989,3.031724",
    style: {
      fill: "#f9b2a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-2-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.143724,66.729479 c 0,0 -0.346462,1.112303 -0.256134,1.601362 0.08907,0.488401 0.622604,0.765182 0.622604,0.765182 l 0.714211,-2.150408 -1.080681,-0.216136",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-3-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.302405,66.21979 c -0.06072,-0.272264 -0.27744,-0.571633 -0.489059,-0.538091 -0.211619,0.0342 -0.526478,0.492918 -0.526478,0.492918 0,0 -0.486462,-0.234187 -0.954215,-0.681951 -0.469051,-0.447123 -1.331676,0.0128 -1.357481,-0.357435 -0.0406,-0.57615 -0.66518,-1.525226 1.744581,-1.996856 1.100689,-0.215496 2.261384,0.161307 2.56527,0.945199 0.593561,1.529743 0.101868,2.352352 0.250976,2.965281 -0.822609,0.225811 -1.171668,-0.557441 -1.233594,-0.829065",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-7-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.42286,65.192 0.0018,0.3826 c 0,0 1.571661,0.181973 2.907196,-0.08193 0.782612,-0.154174 1.445231,-0.01463 2.245912,0.263888 0.801303,0.277422 1.319405,0.123266 1.319405,0.123266 0,0 -0.08193,-2.072992 -0.898105,-2.802054 -0.817423,-0.729702 -2.756852,-0.423237 -3.431067,-0.0962 -0.839398,0.406467 -1.100689,2.171696 -1.100689,2.171696 l -1.045201,0.03877",
    style: {
      fill: "#005500",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-5-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.733305,64.721668 c 0,0 -0.163319,1.430381 0,2.258147 0.163135,0.827127 1.365858,0.958751 1.976848,0.155454 0.326472,-0.429053 0.800041,-1.52005 0.800041,-1.52005 l -0.633577,-0.265187 c 0,0 -0.16972,0.903921 -0.712932,1.422005 -0.662601,0.630979 -1.044561,0.0073 -1.000046,-0.849713 0.03219,-0.621324 0.05944,-1.041983 0.05944,-1.041983 l -0.489701,-0.158746",
    style: {
      fill: "#005500",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-9-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.018481,67.101764 c 0,0 0.02067,0.678092 0,1.086479 -0.01993,0.407766 -0.111012,0.694223 -0.111012,0.694223 l 0.578088,-0.330972 c 0,0 0.346462,-1.014238 0.166428,-1.282625 -0.09163,-0.13552 -0.633577,-0.167159 -0.633577,-0.167159",
    style: {
      fill: "#005500",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-2-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 52.77708,70.716735 c 0,0 1.686512,0.454859 2.678812,1.472956 1.26585,1.299415 0.98519,3.042057 0,4.492427 -1.47102,2.1646 -5.227311,4.142745 -5.227311,4.142745 l -3.022049,1.38587 c 0,0 -1.452949,-1.22522 -0.898105,-2.591078 0.321315,-0.792286 2.902057,-3.346583 4.818259,-5.878293 0.70002,-0.92391 1.650394,-3.024627 1.650394,-3.024627",
    style: {
      fill: "#afdde9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-2-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.897951,67.089493 -0.310981,0.587123 c 0,0 0.800662,3.083993 1.127775,3.982098 0.326472,0.898727 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.179413 2.777529,0.689705 0.898105,0.510329 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.443933 1.93877,-2.447198 1.740064,-1.070348 2.504623,-2.625256 2.504623,-2.625256 0,0 -3.269165,-0.945199 -4.249844,-1.27553 -0.979398,-0.329051 -2.647203,-1.108426 -4.345331,-1.936851 -1.698127,-0.827126 -3.413026,-0.414861 -3.413026,-0.414861",
    style: {
      fill: "#0044aa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-8-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.735197,76.944708 c 0,0 -1.633605,-0.245161 -2.1646,0 -0.530977,0.245179 -0.203865,0.694222 0,1.102628 0.204523,0.408406 0.612929,0.835521 1.06199,0.989073 0.449044,0.154174 1.891037,-0.726483 1.891037,-0.726483 l -0.788427,-1.365218",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-9-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 44.456747,72.774876 c -0.01097,-0.885834 -0.410984,-3.791749 -0.682609,-4.301456 -0.488401,-0.914876 -1.500042,-1.184562 -2.187168,-0.796804 -0.687126,0.387758 -0.467113,2.029757 -0.193568,3.411106 0.08523,0.428395 0.48648,2.604608 0.663259,3.082054 l -4.713081,2.853006 c -0.134788,0.815514 0.217417,1.37877 0.773577,1.725872 0.432913,-0.154906 1.780702,-0.656803 2.905276,-1.301335 1.180684,-0.676811 2.300083,-1.280705 2.998823,-1.67748 0.347742,-0.197427 0.457438,-1.170369 0.435491,-2.994963",
    style: {
      fill: "#002255",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-7-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 47.805269,82.358463 c 0,0 1.974269,6.04346 2.940756,7.15706 1.136809,1.31037 0.449701,-0.10589 0.449701,-0.10589 0,0 -1.947183,-3.43045 -2.615582,-6.64929 -0.142652,-0.1646 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#89434a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-3-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.753583,80.824863 c 0,0 1.97555,2.29105 3.255597,3.87176 0.882614,1.09102 2.410419,3.47885 2.560094,3.70788 0.352918,0.53745 0.06383,1.37361 -0.361934,1.99686 -0.425835,0.6239 -0.896167,1.13295 -1.118119,1.56652 -0.220654,0.43419 0.130399,0.92197 0.130399,0.92197 0,0 1.508455,-0.39293 2.243955,-1.16715 0.734877,-0.77488 1.279407,-1.59749 1.439417,-1.52651 0.16057,0.0717 1.18328,-0.94456 1.18328,-0.94456 0,0 -0.73616,-1.23875 -1.31748,-2.02911 -0.581312,-0.79099 -2.120072,-3.78853 -2.723326,-5.01179 -0.603894,-1.22392 -0.625841,-1.78266 -2.088464,-2.27364 -0.591001,-0.198726 -0.525179,0.47485 -1.423925,0.47485 -1.080041,0 -1.779439,0.41292 -1.779439,0.41292",
    style: {
      fill: "#553133",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-6-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.902814,88.728393 -0.686486,0.57228 c 0,0 0.687126,0.74649 1.155519,1.30651 0.423256,0.50581 0.980057,1.39876 0.980057,1.39876 l 1.021958,-0.88326 c 0,0 -0.86003,-2.02138 -2.471048,-2.39429",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-1-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.143724,66.729479 c 0,0 1.041964,-1.010361 2.226526,-0.807119 1.184561,0.203225 1.989119,0.971644 2.383333,1.179404 0.393556,0.207742 1.047122,-0.114853 1.047122,-0.114853 0,0 -0.544529,1.074866 -1.497464,1.005186 -0.952953,-0.06968 -1.789754,-0.947778 -2.783344,-0.890351 -1.374234,0.07937 -1.376173,-0.372267 -1.376173,-0.372267",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-2-9"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "layer4",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5043",
    transform: "matrix(1.8215069,0,0,1.8215069,-206.56733,-90.401129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4306-0-3-0-4-1-1-4-2-8",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,217.71316,50.952979)",
    style: {
      display: "inline",
      fill: "#666666",
      fillOpacity: 0.852309,
      filter: "url(#filter1510-3-2-8-6-8-2-9)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 71.092807,26.707917 c 0.662619,-0.268406 7.458348,-4.020158 12.034008,0 4.575019,4.020138 6.738979,6.587987 10.202976,6.298293 2.567848,-0.214837 3.216897,-2.158784 3.216897,-2.158784 0,0 0.649067,5.9028 -2.827201,7.388668 -7.132535,3.049154 -9.494562,-2.416216 -11.508188,-4.693731 -2.013627,-2.278155 -6.074422,-6.47767 -10.053283,-5.543444 -2.218789,0.52068 -1.065209,-1.291002 -1.065209,-1.291002",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-30-6-3-9-89-0-6-0-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,14.577765 c 0,0 3.701421,-1.119398 7.512538,-0.160027 3.811117,0.958751 7.991923,2.993026 10.25007,4.24403 3.021409,1.674261 4.39952,3.131087 4.39952,3.131087 0,0 -9.62165,-0.795505 -12.281107,-1.41617 -6.533798,-1.524586 -9.881021,-5.798938 -9.881021,-5.798938",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-4-7-6-5-6-8-2-5-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.030657,11.964122 c 0,0 0.255493,3.103982 0.827126,4.3292 0.571633,1.225199 1.878144,0 1.878144,0 0,0 -0.83746,-3.185295 -2.70527,-4.3292",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-44-5-1-0-4-5-6-5-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.830904,35.077904 c 0,0 1.027132,2.722681 3.291095,1.960077 2.263304,-0.761964 2.916249,-2.776889 4.223381,-1.224559 1.306511,1.551031 4.247267,6.846718 5.335703,7.13963 1.089076,0.292273 1.361341,-0.435509 1.905869,-0.469691 0.544548,-0.03475 2.558814,3.431735 2.558814,3.431735 0,0 -2.123304,1.522648 -5.227305,-0.111012 -2.929142,-1.541338 -5.934421,-5.662157 -5.934421,-5.662157 0,0 -6.370571,1.073586 -6.806702,0.781972 -0.43487,-0.292273 0.653566,-5.846032 0.653566,-5.846032",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-4-3-0-4-3-0-7-2-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.974429,33.934638 c 0,0 -9.96749,1.419407 -11.493996,1.652973 -0.418721,0.06383 -0.841977,0.405809 -1.263916,0.900025 0.370328,0.874879 0.825187,2.042669 1.140686,3.17626 0.200646,-0.257432 0.403231,-0.467771 0.607113,-0.592939 0.418081,-0.257414 4.753737,1.549751 10.307496,0.335507 1.396839,-0.305184 0.702617,-5.471826 0.702617,-5.471826",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-7-5-6-8-3-6-5-9-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.957683,41.587835 c -1.249724,1.697487 -2.245253,2.669131 -3.3891773,4.629849 -1.1426071,1.960077 -1.1426071,3.389817 -1.1426071,3.389817 l 3.2543164,-0.945838 c 0,0 0.17612,-1.57168 0.829065,-2.117507 0.652926,-0.546468 1.714898,-0.408406 2.450416,-1.86653 0.326454,-0.648409 1.312309,-3.618189 2.397507,-5.01373 -0.315499,-1.133591 -0.770358,-2.301381 -1.140686,-3.17626 -1.118119,1.305853 -2.234281,3.710474 -3.258834,5.100199",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-6-6-3-7-38-4-6-0-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.408427,29.259616 C 71.468951,24.126516 65.678408,24.635565 60.778215,24.853 46.417679,25.489155 41.765883,22.275476 37.950889,21.082539 c -2.343958,-0.73294 -9.873285,-4.420827 -12.496603,-5.050527 -5.261487,-1.263276 -9.953938,0.445185 -9.953938,0.445185 0,0 -5.123407,6.096368 -6.0924905,7.058977 -0.9690654,0.963268 -2.6304143,2.463968 -3.0465563,2.752364 -0.4148617,0.287755 -0.4916378,1.122617 0,1.846522 0.4735686,0.696161 1.523269,0.855511 1.523269,0.855511 0,0 -0.061999,0.900683 0.4916379,1.007142 0.5542219,0.105892 1.4207057,-0.201944 1.5929673,-1.25682 1.1000496,0.05102 4.9479266,-1.004564 6.3292746,-1.755555 1.761352,-0.956171 2.075571,-2.287829 2.075571,-2.287829 l 0.75099,-1.69233 c 0,0 4.246608,0.638734 6.424761,4.068549 2.178152,3.430455 5.117609,8.716467 5.117609,8.716467 l -2.318152,0.958751 c 0.314859,0.59228 0.581325,1.072287 0.772937,1.372954 1.163273,1.260039 2.484616,2.251051 3.914338,3.02011 l 2.504624,-2.003293 c 0,0 4.22854,0.754867 8.373225,0.691625 8.20612,-0.125827 10.73911,-1.947165 13.106953,-1.730389 2.939457,0.269046 5.069876,2.452355 5.071156,2.453654 1.249724,0.112293 2.694955,0.227749 4.402758,0.227749 0.787769,0 3.05559,0.03804 5.227287,-1.817498 2.171056,-1.855557 4.645997,-7.273175 2.68592,-9.704242",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-3-2-2-1-6-6-9-2-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.914353,39.830342 c -4.144685,0.06328 -8.373225,-0.691625 -8.373225,-0.691625 l -2.504624,2.003293 c 0.661321,0.355497 1.34329,0.668417 2.047187,0.931007 3.584647,0.920673 6.450565,0.879377 8.830662,0.879377 6.573155,6.58e-4 10.991385,-1.811024 13.495351,-2.440083 1.223919,-0.307105 2.70591,-0.1368 4.682758,0.04133 -0.0013,-0.0013 -2.131699,-2.184608 -5.071156,-2.453635 -2.367843,-0.216795 -4.900833,1.604562 -13.106953,1.730389",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-1-9-0-7-0-2-8-8-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.549772,27.073728 c -2.178153,-3.429815 -6.424761,-4.068549 -6.424761,-4.068549 l -0.75099,1.69233 c 0,0 3.080756,0.763262 4.742105,2.498168 0.974241,1.016799 3.692405,6.655089 5.233103,9.553269 l 2.318152,-0.958751 c 0,0 -2.939457,-5.286012 -5.117609,-8.716467",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-7-1-6-2-4-5-7-3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.000736,38.276732 c -1.416828,0.285176 -2.658798,0.146493 -2.449118,-1.635544 0.199366,-1.686514 -13.590196,1.727811 -13.590196,1.727811 0,0 2.178152,2.227824 4.465323,4.584053 2.285891,2.356212 4.67632,2.799458 8.384838,1.925878 1.169729,-0.275502 2.747206,-0.981977 3.536273,-1.365858 0.656145,-2.779468 0.202585,-4.296939 -0.34712,-5.23634",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-5-2-1-7-8-8-2-8-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.256426,49.01522 c 1.791692,1.634904 5.330526,1.526506 5.330526,1.526506 0,0 0,-2.831718 -1.143265,-4.127896 -0.487121,-0.551643 -1.960077,0.87294 -2.613644,0 -0.653584,-0.872299 -1.960077,-6.550587 -2.613661,-8.044831 -0.653567,-1.494245 -1.392944,-0.905842 -2.831079,-0.459377 -0.451622,0.13936 -1.805866,0.386478 -2.263304,0.478744 0.57487,1.263258 0.878737,3.223336 0.734878,5.373744 0.7697,-0.374846 2.344598,-1.749099 2.344598,-1.749099 0,0 0.90778,5.040834 3.054951,7.002209",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-9-7-5-2-8-6-8-0-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.506117,16.148786 3.221415,4.182744 0.376145,-0.750991 -2.858164,-3.859508 -0.739396,0.427755",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-6-0-5-2-8-2-2-4-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.996994,16.460426 c 0,0 0.894868,1.900712 2.869795,1.582634 1.350368,-0.217435 2.869138,-1.749738 2.869138,-1.749738 l -0.522601,-1.449749 c 0,0 -3.209161,0.723265 -5.216332,1.616853",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-2-9-4-6-97-8-9-0-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.653947,11.326668 c 0,0 -0.19355,3.916935 0.567115,6.075079 0.760043,2.158144 2.883348,0 2.883348,0 0,0 -1.511034,-4.507917 -3.450463,-6.075079",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-1-3-7-1-7-4-9-9-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.151311,34.465633 c 0,0 -7.22802,3.471093 -11.148156,4.858897 -2.414296,0.855511 -2.876252,1.674901 -3.26529,2.688481 0.532276,0.33099 1.357464,1.121338 1.923939,2.930441 0.270326,-0.48712 0.510987,-0.818091 0.687766,-0.881334 1.403277,-0.501312 7.273193,-0.201286 11.643031,-2.048467 0.714212,-0.301288 2.976236,-1.496183 5.263426,-3.931749 1.50006,-1.597485 -5.104716,-3.616269 -5.104716,-3.616269",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-7-6-6-0-6-7-6-1-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,42.013011 c -0.112841,0.295492 -0.220013,0.605833 -0.367768,0.940041 -0.653566,1.480053 -3.662064,7.68288 -4.631787,9.241647 -0.969706,1.559408 -0.709695,4.297579 -0.709695,4.297579 l 3.114956,-1.353604 c 0,0 -0.624542,-1.876845 0.136068,-2.163302 0.760026,-0.287115 1.413592,-0.33227 2.067176,-2.351054 0.486463,-1.502639 1.528445,-4.263397 2.314916,-5.680866 -0.566457,-1.809103 -1.391663,-2.599451 -1.923939,-2.930441",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-8-0-5-6-4-2-0-9-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.339408,21.792873 c 0,0 -1.632965,3.974362 0.980697,6.097667 2.613644,2.123944 10.12748,2.394928 12.250784,2.09556 2.123304,-0.298729 1.743941,-4.045963 1.742003,-5.526016 -3.756928,-0.380661 -12.525006,-1.776202 -14.973484,-2.667211",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-5-6-6-1-3-4-2-6-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 46.294449,27.073728 c 0,0 -0.925849,5.608607 -1.251663,8.004176 -0.327112,2.395587 -1.128433,7.87449 -1.128433,7.87449 0,0 3.207223,6.58e-4 6.16217,-0.546467 -0.02524,-0.392916 0.410985,-1.51877 -0.678091,-2.027819 -1.089076,-0.508409 -2.551718,-1.178746 -2.364606,-2.967201 0.186454,-1.788456 1.329719,-10.337179 1.329719,-10.337179 h -2.069096",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-7-2-9-5-03-0-7-2-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.038642,21.792873 c -0.584526,-0.703238 -1.407154,0.871001 -3.571095,0.625841 -0.534214,-0.06072 -1.143266,-0.123815 -1.763949,-0.203883 -0.319998,1.175527 -0.757447,2.69042 -1.115522,3.58013 -0.507768,1.261996 -5.233743,0.709073 -5.233743,-0.934865 0,-1.388445 0.660023,-4.054998 1.000028,-5.336983 -0.460016,-0.508409 -1.125836,-0.320017 -1.258758,-0.02067 -0.239363,0.541968 -0.487761,1.725871 -0.612271,2.290408 -0.27808,1.259417 -1.242628,4.209208 1.388445,5.322151 2.246533,0.949715 4.655654,1.265855 5.472465,0.285816 0.816154,-0.980039 1.24197,-3.443367 1.24197,-3.443367 l 4.45243,0.358075 c 0,0 0.402608,-2.036853 0,-2.522675",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-4-6-3-9-0-6-6-5-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.588076,25.794961 c 0.358075,-0.88971 0.795524,-2.404603 1.115522,-3.58013 -1.158756,-0.149053 -2.362027,-0.358715 -3.218178,-0.735518 -1.020694,-0.449044 -1.680717,-1.291661 -2.001373,-1.796832 -0.03932,-0.06328 -0.08449,-0.110281 -0.129667,-0.159295 -0.340006,1.281986 -1.000047,3.948538 -1.000047,5.336983 0,1.64392 4.725993,2.196861 5.233762,0.934865",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-1-1-7-4-9-2-1-4-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.760256,20.517343 c 0,0 -0.04444,1.08198 0.47291,1.314247 0.774236,0.347121 1.471037,-0.800681 1.471037,-0.800681 l -1.943947,-0.513566",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-8-8-4-9-2-9-3-4-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.5968617,24.338793 c 0,0 0.1212543,0.217417 0.7103528,1.59295 0.2690457,0.629059 0.9310065,2.783344 0.9310065,2.783344 l 0.97874,-0.1026 c 0,0 -0.271624,-1.160694 -1.000686,-2.998822 -0.21226,-0.536153 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67875",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-5-7-5-0-5-9-2-9-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.45048,26.330474 c -0.410326,0 -0.7445344,0.334208 -0.7445344,0.744552 0,0.410327 0.3342084,0.744535 0.7445344,0.744535 0.410345,0 0.744553,-0.334208 0.744553,-0.744535 0,-0.410344 -0.334208,-0.744552 -0.744553,-0.744552 z m 0,1.887818 c -0.6303395,0 -1.1432655,-0.512926 -1.1432655,-1.143266 0,-0.630358 0.512926,-1.143283 1.1432655,-1.143283 0.630358,0 1.143266,0.512925 1.143266,1.143283 0,0.63034 -0.512908,1.143266 -1.143266,1.143266",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-9-9-2-9-40-0-1-9-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.880814,26.467895 c 0,0 3.696282,-1.885221 5.364727,-4.253704 1.25682,-1.783939 3.194969,-6.553806 3.194969,-6.553806 l 0.847775,-0.06127 c 0,0 -1.429082,4.270493 -3.656925,7.452551 -1.660709,2.37364 -5.4473,4.140149 -5.4473,4.140149 L 10.880814,26.46791",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-7-2-5-1-5-8-5-3-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.055033,27.509238 c 0,0 10.446197,-4.20727 14.56248,-5.611845 6.002821,-2.048466 7.514495,-2.37428 8.697758,-2.138776 0,0 0.780033,-0.10516 0.638734,-0.235504 -1.251023,-1.161975 -7.288665,0.878097 -10.433304,2.103314 -1.336175,0.520662 -13.349553,5.261487 -13.349553,5.261487 l -0.116134,0.621324",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-5-0-4-7-9-1-9-6-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.958597,11.00667 c 1.174887,0.311622 2.494291,1.006484 2.494291,1.006484 l 0.822609,-1.764589 -1.41553,-1.2406896 c 0,0 -2.045888,1.2884416 -1.90137,1.9987946",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-3-2-7-7-4-3-9-0-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.581887,9.426596 c -0.238723,1.502639 -1.501341,2.037493 -2.16396,2.222667 -0.386459,0.108452 -0.800022,-0.265169 -1.092295,-0.878737 -0.324533,-0.680671 -0.641953,-1.6297464 -0.265808,-2.8497881 0.448403,-1.4536072 0.919375,-1.6974875 2.000074,-1.525866 1.079383,0.17228 1.761352,1.5297432 1.521989,3.0317241",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-8-3-4-1-6-1-1-5-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 -0.346462,1.1123031 -0.256134,1.6013621 0.08907,0.488401 0.622604,0.765182 0.622604,0.765182 L 40.275497,9.5175642 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-8-7-4-1-9-1-4-0-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.353497,8.791739 c -0.06072,-0.2722644 -0.27744,-0.5716327 -0.489059,-0.5380912 -0.211619,0.0342 -0.526478,0.4929181 -0.526478,0.4929181 0,0 -0.486462,-0.2341873 -0.954215,-0.6819505 -0.469051,-0.447123 -1.331676,0.012802 -1.357481,-0.3574351 -0.0406,-0.5761501 -0.66518,-1.5252258 1.744581,-1.9968558 1.100689,-0.2154962 2.261384,0.1613067 2.56527,0.9451985 0.593561,1.5297432 0.101868,2.3523524 0.250976,2.9652811 C 38.764482,9.8466152 38.415423,9.0633634 38.353497,8.791739",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-3-5-3-5-2-0-9-2-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.473952,7.7639486 0.0018,0.3826004 c 0,0 1.571661,0.1819729 2.907196,-0.081934 0.782612,-0.154174 1.445231,-0.014631 2.245912,0.2638882 0.801303,0.2774219 1.319405,0.1232661 1.319405,0.1232661 0,0 -0.08193,-2.0729918 -0.898105,-2.8020541 C 38.232737,4.9200133 36.293308,5.2264776 35.619093,5.5535169 34.779695,5.959984 34.518404,7.725213 34.518404,7.725213 l -1.045201,0.038772",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-1-9-0-9-2-3-1-9-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.784397,7.2936171 c 0,0 -0.163319,1.4303805 0,2.258147 0.163135,0.8271269 1.365858,0.9587509 1.976848,0.1554543 0.326472,-0.4290538 0.800041,-1.5200502 0.800041,-1.5200502 L 38.927709,7.9219815 c 0,0 -0.16972,0.9039209 -0.712932,1.4220043 -0.662601,0.6309797 -1.044561,0.00732 -1.000046,-0.8497131 0.03219,-0.6213233 0.05944,-1.0419825 0.05944,-1.0419825 L 36.78447,7.2935439",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-8-2-7-7-4-4-0-4-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.069573,9.6737134 c 0,0 0.02067,0.6780916 0,1.0864786 -0.01993,0.407766 -0.111012,0.694223 -0.111012,0.694223 l 0.578088,-0.330972 c 0,0 0.346462,-1.014238 0.166428,-1.2826254 C 37.61145,9.7052981 37.0695,9.6736586 37.0695,9.6736586",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-9-2-8-7-7-0-7-3-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.828172,13.288684 c 0,0 1.686515,0.454859 2.678807,1.472956 1.265855,1.299415 0.985196,3.042057 0,4.492427 -1.471018,2.1646 -5.227306,4.142747 -5.227306,4.142747 l -3.022049,1.385865 c 0,0 -1.452949,-1.225217 -0.898105,-2.591075 0.321315,-0.792286 2.902057,-3.346583 4.818259,-5.878293 0.70002,-0.92391 1.650394,-3.024627 1.650394,-3.024627",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-6-8-6-6-7-3-5-5-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.949043,9.6614417 -0.310981,0.5871233 c 0,0 0.800662,3.083993 1.127775,3.982098 0.326472,0.898727 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.179413 2.777529,0.689705 0.898105,0.510329 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.443933 1.93877,-2.447198 1.740064,-1.070348 2.504625,-2.625256 2.504625,-2.625256 0,0 -3.269167,-0.945199 -4.249846,-1.27553 C 46.728002,11.684103 45.060197,10.904728 43.362069,10.076303 41.663942,9.249177 39.949043,9.6614417 39.949043,9.6614417",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-43-9-8-7-5-9-8-1-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.786289,19.516657 c 0,0 -1.633605,-0.245161 -2.1646,0 -0.530977,0.245179 -0.203865,0.694222 0,1.102628 0.204523,0.408406 0.612929,0.835521 1.06199,0.989073 0.449044,0.154174 1.891037,-0.726483 1.891037,-0.726483 l -0.788427,-1.365218",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-3-7-8-3-4-1-7-7-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.507839,15.346825 c -0.01097,-0.885834 -0.410984,-3.791749 -0.682609,-4.301456 -0.488401,-0.914876 -1.500042,-1.1845618 -2.187168,-0.796804 -0.687126,0.387758 -0.467113,2.029757 -0.193568,3.411106 0.08523,0.428395 0.48648,2.604608 0.663259,3.082054 l -4.713081,2.853006 c -0.134788,0.815514 0.217417,1.37877 0.773577,1.725872 0.432913,-0.154906 1.780702,-0.656803 2.905276,-1.301335 1.180684,-0.676811 2.300083,-1.280705 2.998823,-1.67748 0.347742,-0.197427 0.457438,-1.170369 0.435491,-2.994963",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-38-3-4-6-81-9-0-4-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.856361,24.930416 c 0,0 1.974269,6.043458 2.940756,7.15706 1.136809,1.310369 0.449701,-0.105892 0.449701,-0.105892 0,0 -1.947183,-3.430455 -2.615582,-6.649291 -0.142652,-0.164599 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-6-6-3-5-2-6-4-3-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.804675,23.396814 c 0,0 1.97555,2.291048 3.255597,3.871762 0.882614,1.091015 2.410419,3.478847 2.560094,3.707877 0.352918,0.537451 0.06383,1.373612 -0.361934,1.996856 -0.425835,0.623902 -0.896167,1.132951 -1.118119,1.566522 -0.220654,0.434193 0.130399,0.921972 0.130399,0.921972 0,0 1.508455,-0.392934 2.243955,-1.167151 0.734878,-0.774876 1.279407,-1.597485 1.439415,-1.526506 0.160575,0.07169 1.183281,-0.944559 1.183281,-0.944559 0,0 -0.736158,-1.238751 -1.317484,-2.029117 -0.581307,-0.790988 -2.120067,-3.78853 -2.723321,-5.011791 -0.603894,-1.223918 -0.625841,-1.782658 -2.088464,-2.273637 -0.591001,-0.198726 -0.525179,0.474849 -1.423925,0.474849 -1.080041,0 -1.779439,0.412923 -1.779439,0.412923",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-0-1-1-6-8-9-8-1-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.953906,31.300347 48.26742,31.87262 c 0,0 0.687126,0.746491 1.155519,1.30651 0.423256,0.505812 0.980057,1.39876 0.980057,1.39876 l 1.021956,-0.883255 c 0,0 -0.860028,-2.021381 -2.471046,-2.394288",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-4-2-4-3-9-3-0-4-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 1.041964,-1.0103613 2.226526,-0.8071186 1.184561,0.2032245 1.989119,0.9716441 2.383333,1.1794041 0.393556,0.2077418 1.047122,-0.1148532 1.047122,-0.1148532 0,0 -0.544529,1.0748658 -1.497464,1.0051858 C 42.40138,10.494366 41.564579,9.6162685 40.570989,9.6736951 39.196755,9.7530683 39.194816,9.3014279 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.852309,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-8-9-9-9-3-3-4-6-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4348",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,199.8215,-4.1666863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 73.041712,84.135963 c 0.66262,-0.2684 7.45835,-4.02015 12.03401,0 4.57502,4.02014 6.73898,6.58799 10.20298,6.2983 2.56784,-0.21484 3.21689,-2.15879 3.21689,-2.15879 0,0 0.64907,5.9028 -2.8272,7.38867 -7.13253,3.04916 -9.49456,-2.41621 -11.50819,-4.69373 -2.01362,-2.27815 -6.07442,-6.47767 -10.05328,-5.54344 -2.21879,0.52068 -1.06521,-1.29101 -1.06521,-1.29101",
    style: {
      fill: "#343300",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19.686773,72.005816 c 0,0 3.701421,-1.119398 7.512538,-0.160027 3.811117,0.958751 7.991923,2.993026 10.25007,4.24403 3.021409,1.674261 4.39952,3.131087 4.39952,3.131087 0,0 -9.62165,-0.795505 -12.281107,-1.41617 -6.533798,-1.524586 -9.881021,-5.798938 -9.881021,-5.798938",
    style: {
      fill: "#343300",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.979565,69.392173 c 0,0 0.255493,3.103982 0.827126,4.3292 0.571633,1.225199 1.878144,0 1.878144,0 0,0 -0.83746,-3.185295 -2.70527,-4.3292",
    style: {
      fill: "#95911d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 73.779812,92.505953 c 0,0 1.02713,2.72268 3.2911,1.96008 2.2633,-0.76197 2.91624,-2.77689 4.22338,-1.22456 1.30651,1.55103 4.24726,6.846717 5.3357,7.139627 1.08907,0.29227 1.36134,-0.435507 1.90587,-0.469687 0.54455,-0.0347 2.55881,3.431727 2.55881,3.431727 0,0 -2.1233,1.52265 -5.2273,-0.11101 -2.92915,-1.54134 -5.93442,-5.662157 -5.93442,-5.662157 0,0 -6.37058,1.07359 -6.80671,0.78198 -0.43487,-0.29228 0.65357,-5.84603 0.65357,-5.84603",
    style: {
      fill: "#343300",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 30.923337,91.362693 c 0,0 -9.96749,1.4194 -11.493996,1.65297 -0.418721,0.0638 -0.841977,0.40581 -1.263916,0.90002 0.370328,0.87488 0.825187,2.04267 1.140686,3.17626 0.200646,-0.25743 0.403231,-0.46777 0.607113,-0.59293 0.418081,-0.25742 4.753737,1.54975 10.307496,0.3355 1.396839,-0.30518 0.702617,-5.47182 0.702617,-5.47182",
    style: {
      fill: "#95911d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.906591,99.015883 c -1.249724,1.697487 -2.245253,2.669127 -3.389177,4.629847 -1.142607,1.96008 -1.142607,3.38982 -1.142607,3.38982 l 3.254316,-0.94584 c 0,0 0.17612,-1.57168 0.829065,-2.11751 0.652926,-0.54646 1.714898,-0.4084 2.450416,-1.86653 0.326454,-0.64841 1.312309,-3.618187 2.397507,-5.013727 -0.315499,-1.13359 -0.770358,-2.30138 -1.140686,-3.17626 -1.118119,1.30586 -2.234281,3.71048 -3.258834,5.1002",
    style: {
      fill: "#343300",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.357332,86.687663 c -2.93947,-5.1331 -8.73002,-4.62405 -13.63021,-4.40661 -14.360535,0.63615 -19.012331,-2.577526 -22.827325,-3.770463 -2.343958,-0.73294 -9.873285,-4.420827 -12.496603,-5.050527 -5.261487,-1.263276 -9.953938,0.445185 -9.953938,0.445185 0,0 -5.123407,6.096365 -6.092491,7.058975 -0.969065,0.96327 -2.6304135,2.46397 -3.0465555,2.75237 -0.414862,0.28775 -0.491638,1.12261 0,1.84652 0.473569,0.69616 1.523269,0.85551 1.523269,0.85551 0,0 -0.062,0.90068 0.4916375,1.00714 0.554222,0.10589 1.420706,-0.20194 1.592967,-1.25682 1.10005,0.051 4.947927,-1.00456 6.329275,-1.75555 1.761352,-0.95618 2.075571,-2.28783 2.075571,-2.28783 l 0.75099,-1.69233 c 0,0 4.246608,0.63873 6.424761,4.06855 2.178152,3.43045 5.117609,8.71646 5.117609,8.71646 l -2.318152,0.95875 c 0.314859,0.59228 0.581325,1.07229 0.772937,1.37296 1.163273,1.26004 2.484616,2.25105 3.914338,3.02011 l 2.504624,-2.0033 c 0,0 4.22854,0.75487 8.373225,0.69163 8.206121,-0.12583 10.739111,-1.94717 13.106951,-1.73039 2.93946,0.26905 5.06988,2.45236 5.07116,2.45365 1.24972,0.1123 2.69495,0.22775 4.40276,0.22775 0.78777,0 3.05559,0.038 5.22728,-1.81749 2.17106,-1.85556 4.646,-7.27318 2.68592,-9.70425",
    style: {
      fill: "#dad540",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.863261,97.258393 c -4.144685,0.0633 -8.373225,-0.69163 -8.373225,-0.69163 l -2.504624,2.0033 c 0.661321,0.35549 1.34329,0.66841 2.047187,0.93101 3.584647,0.920667 6.450565,0.879367 8.830662,0.879367 6.573155,6.6e-4 10.991381,-1.811017 13.495351,-2.440077 1.22392,-0.30711 2.70591,-0.1368 4.68276,0.0413 -10e-4,-10e-4 -2.1317,-2.18461 -5.07116,-2.45364 -2.36784,-0.21679 -4.90083,1.60457 -13.106951,1.73039",
    style: {
      fill: "#95911d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 27.49868,84.501783 c -2.178153,-3.42982 -6.424761,-4.06855 -6.424761,-4.06855 l -0.75099,1.69233 c 0,0 3.080756,0.76326 4.742105,2.49816 0.974241,1.0168 3.692405,6.65509 5.233103,9.55327 l 2.318152,-0.95875 c 0,0 -2.939457,-5.28601 -5.117609,-8.71646",
    style: {
      fill: "#95911d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 77.949642,95.704783 c -1.41683,0.28518 -2.6588,0.14649 -2.44912,-1.63554 0.19937,-1.68652 -13.59019,1.72781 -13.59019,1.72781 0,0 2.17815,2.22782 4.46532,4.584047 2.28589,2.35621 4.67632,2.79946 8.38484,1.92588 1.16973,-0.2755 2.74721,-0.98198 3.53627,-1.36586 0.65615,-2.779467 0.20259,-4.296937 -0.34712,-5.236337",
    style: {
      fill: "#dad540",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 83.205332,106.44327 c 1.79169,1.6349 5.33053,1.5265 5.33053,1.5265 0,0 0,-2.83171 -1.14327,-4.12789 -0.48712,-0.55165 -1.96007,0.87294 -2.61364,0 -0.65358,-0.8723 -1.96008,-6.550587 -2.61366,-8.044827 -0.65357,-1.49425 -1.39295,-0.90585 -2.83108,-0.45938 -0.45162,0.13936 -1.80587,0.38648 -2.2633,0.47874 0.57487,1.26326 0.87873,3.22334 0.73487,5.373747 0.7697,-0.37485 2.3446,-1.749097 2.3446,-1.749097 0,0 0.90778,5.040827 3.05495,7.002207",
    style: {
      fill: "#95911d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.455025,73.576837 3.221415,4.182744 0.376145,-0.750991 -2.858164,-3.859508 -0.739396,0.427755",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13.945902,73.888477 c 0,0 0.894868,1.900712 2.869795,1.582634 1.350368,-0.217435 2.869138,-1.749738 2.869138,-1.749738 l -0.522601,-1.449749 c 0,0 -3.209161,0.723265 -5.216332,1.616853",
    style: {
      fill: "#343300",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 18.602855,68.754719 c 0,0 -0.19355,3.916935 0.567115,6.075079 0.760043,2.158144 2.883348,0 2.883348,0 0,0 -1.511034,-4.507917 -3.450463,-6.075079",
    style: {
      fill: "#dad540",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34.100219,91.893683 c 0,0 -7.22802,3.47109 -11.148156,4.8589 -2.414296,0.85551 -2.876252,1.6749 -3.26529,2.68848 0.532276,0.33099 1.357464,1.121337 1.923939,2.930437 0.270326,-0.48712 0.510987,-0.81809 0.687766,-0.88133 1.403277,-0.50132 7.273193,-0.20129 11.643031,-2.048467 0.714212,-0.30129 2.976236,-1.49618 5.263426,-3.93175 1.50006,-1.59749 -5.104716,-3.61627 -5.104716,-3.61627",
    style: {
      fill: "#dad540",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 19.686773,99.441063 c -0.112841,0.29549 -0.220013,0.605827 -0.367768,0.940037 -0.653566,1.48005 -3.662064,7.68288 -4.631787,9.24165 -0.969706,1.5594 -0.709695,4.29758 -0.709695,4.29758 l 3.114956,-1.35361 c 0,0 -0.624542,-1.87684 0.136068,-2.1633 0.760026,-0.28712 1.413592,-0.33227 2.067176,-2.35105 0.486463,-1.50264 1.528445,-4.2634 2.314916,-5.68087 -0.566457,-1.8091 -1.391663,-2.599447 -1.923939,-2.930437",
    style: {
      fill: "#95911d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.288316,79.220924 c 0,0 -1.632965,3.974359 0.980697,6.097669 2.613644,2.12394 10.127479,2.39493 12.250779,2.09556 2.12331,-0.29873 1.74395,-4.04596 1.74201,-5.52602 -3.75693,-0.38066 -12.525008,-1.7762 -14.973486,-2.667209",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.243357,84.501783 c 0,0 -0.925849,5.6086 -1.251663,8.00417 -0.327112,2.39559 -1.128433,7.874487 -1.128433,7.874487 0,0 3.207223,6.6e-4 6.16217,-0.546457 -0.02524,-0.39292 0.410985,-1.51878 -0.678091,-2.02782 -1.089076,-0.50841 -2.551718,-1.17875 -2.364606,-2.96721 0.186454,-1.78845 1.329719,-10.33717 1.329719,-10.33717 h -2.069096",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 56.987552,79.220924 c -0.58453,-0.703238 -1.40716,0.870999 -3.5711,0.625839 -0.534211,-0.06072 -1.143263,-0.123813 -1.763946,-0.203881 -0.319998,1.175531 -0.757447,2.690421 -1.115522,3.580131 -0.507768,1.26199 -5.233743,0.70907 -5.233743,-0.93487 0,-1.38844 0.660023,-4.054994 1.000028,-5.336979 -0.460016,-0.508409 -1.125836,-0.320017 -1.258758,-0.02067 -0.239363,0.541968 -0.487761,1.725871 -0.612271,2.290408 -0.27808,1.259421 -1.242628,4.209211 1.388445,5.322151 2.246533,0.94971 4.655654,1.26586 5.472465,0.28582 0.816154,-0.98004 1.24197,-3.44337 1.24197,-3.44337 l 4.452432,0.35807 c 0,0 0.40261,-2.036849 0,-2.522671",
    style: {
      fill: "#87de87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.536984,83.223013 c 0.358075,-0.88971 0.795524,-2.4046 1.115522,-3.580131 -1.158756,-0.149053 -2.362027,-0.358715 -3.218178,-0.735518 -1.020694,-0.449044 -1.680717,-1.291661 -2.001373,-1.796832 -0.03932,-0.06328 -0.08449,-0.110281 -0.129667,-0.159295 -0.340006,1.281986 -1.000047,3.948536 -1.000047,5.336986 0,1.64392 4.725993,2.19686 5.233762,0.93486",
    style: {
      fill: "#2ca02c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.709164,77.945394 c 0,0 -0.04444,1.08198 0.47291,1.314247 0.774236,0.347121 1.471037,-0.800681 1.471037,-0.800681 l -1.943947,-0.513566",
    style: {
      fill: "#343300",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.54577,81.766843 c 0,0 0.121254,0.21742 0.710353,1.59295 0.269045,0.62906 0.931006,2.78334 0.931006,2.78334 l 0.97874,-0.1026 c 0,0 -0.271624,-1.16069 -1.000686,-2.99882 -0.21226,-0.53615 -0.90906,-1.95364 -0.90906,-1.95364 l -0.710353,0.67875",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.399388,83.758523 c -0.410326,0 -0.744534,0.33421 -0.744534,0.74455 0,0.41033 0.334208,0.74454 0.744534,0.74454 0.410345,0 0.744553,-0.33421 0.744553,-0.74454 0,-0.41034 -0.334208,-0.74455 -0.744553,-0.74455 z m 0,1.88782 c -0.630339,0 -1.143265,-0.51293 -1.143265,-1.14327 0,-0.63035 0.512926,-1.14328 1.143265,-1.14328 0.630358,0 1.143266,0.51293 1.143266,1.14328 0,0.63034 -0.512908,1.14327 -1.143266,1.14327",
    style: {
      fill: "#f4ab94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.829722,83.895943 c 0,0 3.696282,-1.88522 5.364727,-4.253701 1.25682,-1.783939 3.194969,-6.553806 3.194969,-6.553806 l 0.847775,-0.06127 c 0,0 -1.429082,4.270493 -3.656925,7.452547 -1.660709,2.37364 -5.4473,4.14015 -5.4473,4.14015 l -0.303246,-0.7239",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13.003941,84.937293 c 0,0 10.446197,-4.20727 14.56248,-5.611849 6.002821,-2.048466 7.514495,-2.37428 8.697758,-2.138776 0,0 0.780033,-0.10516 0.638734,-0.235504 -1.251023,-1.161975 -7.288665,0.878097 -10.433304,2.103314 -1.336175,0.520662 -13.349553,5.261485 -13.349553,5.261485 l -0.116134,0.62133",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.907505,68.434721 c 1.174887,0.311622 2.494291,1.006484 2.494291,1.006484 l 0.822609,-1.764589 -1.41553,-1.24069 c 0,0 -2.045888,1.288442 -1.90137,1.998795",
    style: {
      fill: "#ee9d8f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.530795,66.854647 c -0.238723,1.502639 -1.501341,2.037493 -2.16396,2.222667 -0.386459,0.108452 -0.800022,-0.265169 -1.092295,-0.878737 -0.324533,-0.680671 -0.641953,-1.629746 -0.265808,-2.849788 0.448403,-1.453607 0.919375,-1.697488 2.000074,-1.525866 1.079383,0.17228 1.761352,1.529743 1.521989,3.031724",
    style: {
      fill: "#f9b2a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.143724,66.729479 c 0,0 -0.346462,1.112303 -0.256134,1.601362 0.08907,0.488401 0.622604,0.765182 0.622604,0.765182 l 0.714211,-2.150408 -1.080681,-0.216136",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.302405,66.21979 c -0.06072,-0.272264 -0.27744,-0.571633 -0.489059,-0.538091 -0.211619,0.0342 -0.526478,0.492918 -0.526478,0.492918 0,0 -0.486462,-0.234187 -0.954215,-0.681951 -0.469051,-0.447123 -1.331676,0.0128 -1.357481,-0.357435 -0.0406,-0.57615 -0.66518,-1.525226 1.744581,-1.996856 1.100689,-0.215496 2.261384,0.161307 2.56527,0.945199 0.593561,1.529743 0.101868,2.352352 0.250976,2.965281 -0.822609,0.225811 -1.171668,-0.557441 -1.233594,-0.829065",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.42286,65.192 0.0018,0.3826 c 0,0 1.571661,0.181973 2.907196,-0.08193 0.782612,-0.154174 1.445231,-0.01463 2.245912,0.263888 0.801303,0.277422 1.319405,0.123266 1.319405,0.123266 0,0 -0.08193,-2.072992 -0.898105,-2.802054 -0.817423,-0.729702 -2.756852,-0.423237 -3.431067,-0.0962 -0.839398,0.406467 -1.100689,2.171696 -1.100689,2.171696 l -1.045201,0.03877",
    style: {
      fill: "#800066",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.733305,64.721668 c 0,0 -0.163319,1.430381 0,2.258147 0.163135,0.827127 1.365858,0.958751 1.976848,0.155454 0.326472,-0.429053 0.800041,-1.52005 0.800041,-1.52005 l -0.633577,-0.265187 c 0,0 -0.16972,0.903921 -0.712932,1.422005 -0.662601,0.630979 -1.044561,0.0073 -1.000046,-0.849713 0.03219,-0.621324 0.05944,-1.041983 0.05944,-1.041983 l -0.489701,-0.158746",
    style: {
      fill: "#550044",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.018481,67.101764 c 0,0 0.02067,0.678092 0,1.086479 -0.01993,0.407766 -0.111012,0.694223 -0.111012,0.694223 l 0.578088,-0.330972 c 0,0 0.346462,-1.014238 0.166428,-1.282625 -0.09163,-0.13552 -0.633577,-0.167159 -0.633577,-0.167159",
    style: {
      fill: "#550044",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 52.77708,70.716735 c 0,0 1.686512,0.454859 2.678812,1.472956 1.26585,1.299415 0.98519,3.042057 0,4.492427 -1.47102,2.1646 -5.227311,4.142745 -5.227311,4.142745 l -3.022049,1.38587 c 0,0 -1.452949,-1.22522 -0.898105,-2.591078 0.321315,-0.792286 2.902057,-3.346583 4.818259,-5.878293 0.70002,-0.92391 1.650394,-3.024627 1.650394,-3.024627",
    style: {
      fill: "#d5ffe6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.897951,67.089493 -0.310981,0.587123 c 0,0 0.800662,3.083993 1.127775,3.982098 0.326472,0.898727 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.179413 2.777529,0.689705 0.898105,0.510329 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.443933 1.93877,-2.447198 1.740064,-1.070348 2.504623,-2.625256 2.504623,-2.625256 0,0 -3.269165,-0.945199 -4.249844,-1.27553 -0.979398,-0.329051 -2.647203,-1.108426 -4.345331,-1.936851 -1.698127,-0.827126 -3.413026,-0.414861 -3.413026,-0.414861",
    style: {
      fill: "#217844",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.735197,76.944708 c 0,0 -1.633605,-0.245161 -2.1646,0 -0.530977,0.245179 -0.203865,0.694222 0,1.102628 0.204523,0.408406 0.612929,0.835521 1.06199,0.989073 0.449044,0.154174 1.891037,-0.726483 1.891037,-0.726483 l -0.788427,-1.365218",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 44.456747,72.774876 c -0.01097,-0.885834 -0.410984,-3.791749 -0.682609,-4.301456 -0.488401,-0.914876 -1.500042,-1.184562 -2.187168,-0.796804 -0.687126,0.387758 -0.467113,2.029757 -0.193568,3.411106 0.08523,0.428395 0.48648,2.604608 0.663259,3.082054 l -4.713081,2.853006 c -0.134788,0.815514 0.217417,1.37877 0.773577,1.725872 0.432913,-0.154906 1.780702,-0.656803 2.905276,-1.301335 1.180684,-0.676811 2.300083,-1.280705 2.998823,-1.67748 0.347742,-0.197427 0.457438,-1.170369 0.435491,-2.994963",
    style: {
      fill: "#005522",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 47.805269,82.358463 c 0,0 1.974269,6.04346 2.940756,7.15706 1.136809,1.31037 0.449701,-0.10589 0.449701,-0.10589 0,0 -1.947183,-3.43045 -2.615582,-6.64929 -0.142652,-0.1646 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#89434a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.753583,80.824863 c 0,0 1.97555,2.29105 3.255597,3.87176 0.882614,1.09102 2.410419,3.47885 2.560094,3.70788 0.352918,0.53745 0.06383,1.37361 -0.361934,1.99686 -0.425835,0.6239 -0.896167,1.13295 -1.118119,1.56652 -0.220654,0.43419 0.130399,0.92197 0.130399,0.92197 0,0 1.508455,-0.39293 2.243955,-1.16715 0.734877,-0.77488 1.279407,-1.59749 1.439417,-1.52651 0.16057,0.0717 1.18328,-0.94456 1.18328,-0.94456 0,0 -0.73616,-1.23875 -1.31748,-2.02911 -0.581312,-0.79099 -2.120072,-3.78853 -2.723326,-5.01179 -0.603894,-1.22392 -0.625841,-1.78266 -2.088464,-2.27364 -0.591001,-0.198726 -0.525179,0.47485 -1.423925,0.47485 -1.080041,0 -1.779439,0.41292 -1.779439,0.41292",
    style: {
      fill: "#553133",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.902814,88.728393 -0.686486,0.57228 c 0,0 0.687126,0.74649 1.155519,1.30651 0.423256,0.50581 0.980057,1.39876 0.980057,1.39876 l 1.021958,-0.88326 c 0,0 -0.86003,-2.02138 -2.471048,-2.39429",
    style: {
      fill: "#00aa44",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.143724,66.729479 c 0,0 1.041964,-1.010361 2.226526,-0.807119 1.184561,0.203225 1.989119,0.971644 2.383333,1.179404 0.393556,0.207742 1.047122,-0.114853 1.047122,-0.114853 0,0 -0.544529,1.074866 -1.497464,1.005186 -0.952953,-0.06968 -1.789754,-0.947778 -2.783344,-0.890351 -1.374234,0.07937 -1.376173,-0.372267 -1.376173,-0.372267",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer5",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5604",
    transform: "matrix(1.7901361,0,0,1.7901361,-9.1158277,-201.48746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4306-0-3-0-4",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,111.48802,113.95847)",
    style: {
      display: "inline",
      fill: "#666666",
      fillOpacity: 0.818636,
      filter: "url(#filter1510-3-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 71.092807,26.707917 c 0.662619,-0.268406 7.458348,-4.020158 12.034008,0 4.575019,4.020138 6.738979,6.587987 10.202976,6.298293 2.567848,-0.214837 3.216897,-2.158784 3.216897,-2.158784 0,0 0.649067,5.9028 -2.827201,7.388668 -7.132535,3.049154 -9.494562,-2.416216 -11.508188,-4.693731 -2.013627,-2.278155 -6.074422,-6.47767 -10.053283,-5.543444 -2.218789,0.52068 -1.065209,-1.291002 -1.065209,-1.291002",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-30-6-3-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,14.577765 c 0,0 3.701421,-1.119398 7.512538,-0.160027 3.811117,0.958751 7.991923,2.993026 10.25007,4.24403 3.021409,1.674261 4.39952,3.131087 4.39952,3.131087 0,0 -9.62165,-0.795505 -12.281107,-1.41617 -6.533798,-1.524586 -9.881021,-5.798938 -9.881021,-5.798938",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-4-7-6-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.030657,11.964122 c 0,0 0.255493,3.103982 0.827126,4.3292 0.571633,1.225199 1.878144,0 1.878144,0 0,0 -0.83746,-3.185295 -2.70527,-4.3292",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-44-5-1-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.830904,35.077904 c 0,0 1.027132,2.722681 3.291095,1.960077 2.263304,-0.761964 2.916249,-2.776889 4.223381,-1.224559 1.306511,1.551031 4.247267,6.846718 5.335703,7.13963 1.089076,0.292273 1.361341,-0.435509 1.905869,-0.469691 0.544548,-0.03475 2.558814,3.431735 2.558814,3.431735 0,0 -2.123304,1.522648 -5.227305,-0.111012 -2.929142,-1.541338 -5.934421,-5.662157 -5.934421,-5.662157 0,0 -6.370571,1.073586 -6.806702,0.781972 -0.43487,-0.292273 0.653566,-5.846032 0.653566,-5.846032",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-4-3-0-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.974429,33.934638 c 0,0 -9.96749,1.419407 -11.493996,1.652973 -0.418721,0.06383 -0.841977,0.405809 -1.263916,0.900025 0.370328,0.874879 0.825187,2.042669 1.140686,3.17626 0.200646,-0.257432 0.403231,-0.467771 0.607113,-0.592939 0.418081,-0.257414 4.753737,1.549751 10.307496,0.335507 1.396839,-0.305184 0.702617,-5.471826 0.702617,-5.471826",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-7-5-6-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.957683,41.587835 c -1.249724,1.697487 -2.245253,2.669131 -3.3891773,4.629849 -1.1426071,1.960077 -1.1426071,3.389817 -1.1426071,3.389817 l 3.2543164,-0.945838 c 0,0 0.17612,-1.57168 0.829065,-2.117507 0.652926,-0.546468 1.714898,-0.408406 2.450416,-1.86653 0.326454,-0.648409 1.312309,-3.618189 2.397507,-5.01373 -0.315499,-1.133591 -0.770358,-2.301381 -1.140686,-3.17626 -1.118119,1.305853 -2.234281,3.710474 -3.258834,5.100199",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-6-6-3-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.408427,29.259616 C 71.468951,24.126516 65.678408,24.635565 60.778215,24.853 46.417679,25.489155 41.765883,22.275476 37.950889,21.082539 c -2.343958,-0.73294 -9.873285,-4.420827 -12.496603,-5.050527 -5.261487,-1.263276 -9.953938,0.445185 -9.953938,0.445185 0,0 -5.123407,6.096368 -6.0924905,7.058977 -0.9690654,0.963268 -2.6304143,2.463968 -3.0465563,2.752364 -0.4148617,0.287755 -0.4916378,1.122617 0,1.846522 0.4735686,0.696161 1.523269,0.855511 1.523269,0.855511 0,0 -0.061999,0.900683 0.4916379,1.007142 0.5542219,0.105892 1.4207057,-0.201944 1.5929673,-1.25682 1.1000496,0.05102 4.9479266,-1.004564 6.3292746,-1.755555 1.761352,-0.956171 2.075571,-2.287829 2.075571,-2.287829 l 0.75099,-1.69233 c 0,0 4.246608,0.638734 6.424761,4.068549 2.178152,3.430455 5.117609,8.716467 5.117609,8.716467 l -2.318152,0.958751 c 0.314859,0.59228 0.581325,1.072287 0.772937,1.372954 1.163273,1.260039 2.484616,2.251051 3.914338,3.02011 l 2.504624,-2.003293 c 0,0 4.22854,0.754867 8.373225,0.691625 8.20612,-0.125827 10.73911,-1.947165 13.106953,-1.730389 2.939457,0.269046 5.069876,2.452355 5.071156,2.453654 1.249724,0.112293 2.694955,0.227749 4.402758,0.227749 0.787769,0 3.05559,0.03804 5.227287,-1.817498 2.171056,-1.855557 4.645997,-7.273175 2.68592,-9.704242",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-3-2-2-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.914353,39.830342 c -4.144685,0.06328 -8.373225,-0.691625 -8.373225,-0.691625 l -2.504624,2.003293 c 0.661321,0.355497 1.34329,0.668417 2.047187,0.931007 3.584647,0.920673 6.450565,0.879377 8.830662,0.879377 6.573155,6.58e-4 10.991385,-1.811024 13.495351,-2.440083 1.223919,-0.307105 2.70591,-0.1368 4.682758,0.04133 -0.0013,-0.0013 -2.131699,-2.184608 -5.071156,-2.453635 -2.367843,-0.216795 -4.900833,1.604562 -13.106953,1.730389",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-1-9-0-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.549772,27.073728 c -2.178153,-3.429815 -6.424761,-4.068549 -6.424761,-4.068549 l -0.75099,1.69233 c 0,0 3.080756,0.763262 4.742105,2.498168 0.974241,1.016799 3.692405,6.655089 5.233103,9.553269 l 2.318152,-0.958751 c 0,0 -2.939457,-5.286012 -5.117609,-8.716467",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-7-1-6-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.000736,38.276732 c -1.416828,0.285176 -2.658798,0.146493 -2.449118,-1.635544 0.199366,-1.686514 -13.590196,1.727811 -13.590196,1.727811 0,0 2.178152,2.227824 4.465323,4.584053 2.285891,2.356212 4.67632,2.799458 8.384838,1.925878 1.169729,-0.275502 2.747206,-0.981977 3.536273,-1.365858 0.656145,-2.779468 0.202585,-4.296939 -0.34712,-5.23634",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-5-2-1-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.256426,49.01522 c 1.791692,1.634904 5.330526,1.526506 5.330526,1.526506 0,0 0,-2.831718 -1.143265,-4.127896 -0.487121,-0.551643 -1.960077,0.87294 -2.613644,0 -0.653584,-0.872299 -1.960077,-6.550587 -2.613661,-8.044831 -0.653567,-1.494245 -1.392944,-0.905842 -2.831079,-0.459377 -0.451622,0.13936 -1.805866,0.386478 -2.263304,0.478744 0.57487,1.263258 0.878737,3.223336 0.734878,5.373744 0.7697,-0.374846 2.344598,-1.749099 2.344598,-1.749099 0,0 0.90778,5.040834 3.054951,7.002209",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-9-7-5-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.506117,16.148786 3.221415,4.182744 0.376145,-0.750991 -2.858164,-3.859508 -0.739396,0.427755",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-6-0-5-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.996994,16.460426 c 0,0 0.894868,1.900712 2.869795,1.582634 1.350368,-0.217435 2.869138,-1.749738 2.869138,-1.749738 l -0.522601,-1.449749 c 0,0 -3.209161,0.723265 -5.216332,1.616853",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-2-9-4-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.653947,11.326668 c 0,0 -0.19355,3.916935 0.567115,6.075079 0.760043,2.158144 2.883348,0 2.883348,0 0,0 -1.511034,-4.507917 -3.450463,-6.075079",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-1-3-7-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.151311,34.465633 c 0,0 -7.22802,3.471093 -11.148156,4.858897 -2.414296,0.855511 -2.876252,1.674901 -3.26529,2.688481 0.532276,0.33099 1.357464,1.121338 1.923939,2.930441 0.270326,-0.48712 0.510987,-0.818091 0.687766,-0.881334 1.403277,-0.501312 7.273193,-0.201286 11.643031,-2.048467 0.714212,-0.301288 2.976236,-1.496183 5.263426,-3.931749 1.50006,-1.597485 -5.104716,-3.616269 -5.104716,-3.616269",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-7-6-6-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,42.013011 c -0.112841,0.295492 -0.220013,0.605833 -0.367768,0.940041 -0.653566,1.480053 -3.662064,7.68288 -4.631787,9.241647 -0.969706,1.559408 -0.709695,4.297579 -0.709695,4.297579 l 3.114956,-1.353604 c 0,0 -0.624542,-1.876845 0.136068,-2.163302 0.760026,-0.287115 1.413592,-0.33227 2.067176,-2.351054 0.486463,-1.502639 1.528445,-4.263397 2.314916,-5.680866 -0.566457,-1.809103 -1.391663,-2.599451 -1.923939,-2.930441",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-8-0-5-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.339408,21.792873 c 0,0 -1.632965,3.974362 0.980697,6.097667 2.613644,2.123944 10.12748,2.394928 12.250784,2.09556 2.123304,-0.298729 1.743941,-4.045963 1.742003,-5.526016 -3.756928,-0.380661 -12.525006,-1.776202 -14.973484,-2.667211",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-5-6-6-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 46.294449,27.073728 c 0,0 -0.925849,5.608607 -1.251663,8.004176 -0.327112,2.395587 -1.128433,7.87449 -1.128433,7.87449 0,0 3.207223,6.58e-4 6.16217,-0.546467 -0.02524,-0.392916 0.410985,-1.51877 -0.678091,-2.027819 -1.089076,-0.508409 -2.551718,-1.178746 -2.364606,-2.967201 0.186454,-1.788456 1.329719,-10.337179 1.329719,-10.337179 h -2.069096",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-7-2-9-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.038642,21.792873 c -0.584526,-0.703238 -1.407154,0.871001 -3.571095,0.625841 -0.534214,-0.06072 -1.143266,-0.123815 -1.763949,-0.203883 -0.319998,1.175527 -0.757447,2.69042 -1.115522,3.58013 -0.507768,1.261996 -5.233743,0.709073 -5.233743,-0.934865 0,-1.388445 0.660023,-4.054998 1.000028,-5.336983 -0.460016,-0.508409 -1.125836,-0.320017 -1.258758,-0.02067 -0.239363,0.541968 -0.487761,1.725871 -0.612271,2.290408 -0.27808,1.259417 -1.242628,4.209208 1.388445,5.322151 2.246533,0.949715 4.655654,1.265855 5.472465,0.285816 0.816154,-0.980039 1.24197,-3.443367 1.24197,-3.443367 l 4.45243,0.358075 c 0,0 0.402608,-2.036853 0,-2.522675",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-4-6-3-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.588076,25.794961 c 0.358075,-0.88971 0.795524,-2.404603 1.115522,-3.58013 -1.158756,-0.149053 -2.362027,-0.358715 -3.218178,-0.735518 -1.020694,-0.449044 -1.680717,-1.291661 -2.001373,-1.796832 -0.03932,-0.06328 -0.08449,-0.110281 -0.129667,-0.159295 -0.340006,1.281986 -1.000047,3.948538 -1.000047,5.336983 0,1.64392 4.725993,2.196861 5.233762,0.934865",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-1-1-7-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.760256,20.517343 c 0,0 -0.04444,1.08198 0.47291,1.314247 0.774236,0.347121 1.471037,-0.800681 1.471037,-0.800681 l -1.943947,-0.513566",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-8-8-4-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.5968617,24.338793 c 0,0 0.1212543,0.217417 0.7103528,1.59295 0.2690457,0.629059 0.9310065,2.783344 0.9310065,2.783344 l 0.97874,-0.1026 c 0,0 -0.271624,-1.160694 -1.000686,-2.998822 -0.21226,-0.536153 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67875",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-5-7-5-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.45048,26.330474 c -0.410326,0 -0.7445344,0.334208 -0.7445344,0.744552 0,0.410327 0.3342084,0.744535 0.7445344,0.744535 0.410345,0 0.744553,-0.334208 0.744553,-0.744535 0,-0.410344 -0.334208,-0.744552 -0.744553,-0.744552 z m 0,1.887818 c -0.6303395,0 -1.1432655,-0.512926 -1.1432655,-1.143266 0,-0.630358 0.512926,-1.143283 1.1432655,-1.143283 0.630358,0 1.143266,0.512925 1.143266,1.143283 0,0.63034 -0.512908,1.143266 -1.143266,1.143266",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-9-9-2-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.880814,26.467895 c 0,0 3.696282,-1.885221 5.364727,-4.253704 1.25682,-1.783939 3.194969,-6.553806 3.194969,-6.553806 l 0.847775,-0.06127 c 0,0 -1.429082,4.270493 -3.656925,7.452551 -1.660709,2.37364 -5.4473,4.140149 -5.4473,4.140149 L 10.880814,26.46791",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-7-2-5-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.055033,27.509238 c 0,0 10.446197,-4.20727 14.56248,-5.611845 6.002821,-2.048466 7.514495,-2.37428 8.697758,-2.138776 0,0 0.780033,-0.10516 0.638734,-0.235504 -1.251023,-1.161975 -7.288665,0.878097 -10.433304,2.103314 -1.336175,0.520662 -13.349553,5.261487 -13.349553,5.261487 l -0.116134,0.621324",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-5-0-4-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.958597,11.00667 c 1.174887,0.311622 2.494291,1.006484 2.494291,1.006484 l 0.822609,-1.764589 -1.41553,-1.2406896 c 0,0 -2.045888,1.2884416 -1.90137,1.9987946",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-3-2-7-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.581887,9.426596 c -0.238723,1.502639 -1.501341,2.037493 -2.16396,2.222667 -0.386459,0.108452 -0.800022,-0.265169 -1.092295,-0.878737 -0.324533,-0.680671 -0.641953,-1.6297464 -0.265808,-2.8497881 0.448403,-1.4536072 0.919375,-1.6974875 2.000074,-1.525866 1.079383,0.17228 1.761352,1.5297432 1.521989,3.0317241",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-8-3-4-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 -0.346462,1.1123031 -0.256134,1.6013621 0.08907,0.488401 0.622604,0.765182 0.622604,0.765182 L 40.275497,9.5175642 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-8-7-4-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.353497,8.791739 c -0.06072,-0.2722644 -0.27744,-0.5716327 -0.489059,-0.5380912 -0.211619,0.0342 -0.526478,0.4929181 -0.526478,0.4929181 0,0 -0.486462,-0.2341873 -0.954215,-0.6819505 -0.469051,-0.447123 -1.331676,0.012802 -1.357481,-0.3574351 -0.0406,-0.5761501 -0.66518,-1.5252258 1.744581,-1.9968558 1.100689,-0.2154962 2.261384,0.1613067 2.56527,0.9451985 0.593561,1.5297432 0.101868,2.3523524 0.250976,2.9652811 C 38.764482,9.8466152 38.415423,9.0633634 38.353497,8.791739",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-3-5-3-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.473952,7.7639486 0.0018,0.3826004 c 0,0 1.571661,0.1819729 2.907196,-0.081934 0.782612,-0.154174 1.445231,-0.014631 2.245912,0.2638882 0.801303,0.2774219 1.319405,0.1232661 1.319405,0.1232661 0,0 -0.08193,-2.0729918 -0.898105,-2.8020541 C 38.232737,4.9200133 36.293308,5.2264776 35.619093,5.5535169 34.779695,5.959984 34.518404,7.725213 34.518404,7.725213 l -1.045201,0.038772",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-1-9-0-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.784397,7.2936171 c 0,0 -0.163319,1.4303805 0,2.258147 0.163135,0.8271269 1.365858,0.9587509 1.976848,0.1554543 0.326472,-0.4290538 0.800041,-1.5200502 0.800041,-1.5200502 L 38.927709,7.9219815 c 0,0 -0.16972,0.9039209 -0.712932,1.4220043 -0.662601,0.6309797 -1.044561,0.00732 -1.000046,-0.8497131 0.03219,-0.6213233 0.05944,-1.0419825 0.05944,-1.0419825 L 36.78447,7.2935439",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-8-2-7-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.069573,9.6737134 c 0,0 0.02067,0.6780916 0,1.0864786 -0.01993,0.407766 -0.111012,0.694223 -0.111012,0.694223 l 0.578088,-0.330972 c 0,0 0.346462,-1.014238 0.166428,-1.2826254 C 37.61145,9.7052981 37.0695,9.6736586 37.0695,9.6736586",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-9-2-8-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.828172,13.288684 c 0,0 1.686515,0.454859 2.678807,1.472956 1.265855,1.299415 0.985196,3.042057 0,4.492427 -1.471018,2.1646 -5.227306,4.142747 -5.227306,4.142747 l -3.022049,1.385865 c 0,0 -1.452949,-1.225217 -0.898105,-2.591075 0.321315,-0.792286 2.902057,-3.346583 4.818259,-5.878293 0.70002,-0.92391 1.650394,-3.024627 1.650394,-3.024627",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-6-8-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.949043,9.6614417 -0.310981,0.5871233 c 0,0 0.800662,3.083993 1.127775,3.982098 0.326472,0.898727 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.179413 2.777529,0.689705 0.898105,0.510329 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.443933 1.93877,-2.447198 1.740064,-1.070348 2.504625,-2.625256 2.504625,-2.625256 0,0 -3.269167,-0.945199 -4.249846,-1.27553 C 46.728002,11.684103 45.060197,10.904728 43.362069,10.076303 41.663942,9.249177 39.949043,9.6614417 39.949043,9.6614417",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-43-9-8-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.786289,19.516657 c 0,0 -1.633605,-0.245161 -2.1646,0 -0.530977,0.245179 -0.203865,0.694222 0,1.102628 0.204523,0.408406 0.612929,0.835521 1.06199,0.989073 0.449044,0.154174 1.891037,-0.726483 1.891037,-0.726483 l -0.788427,-1.365218",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-3-7-8-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.507839,15.346825 c -0.01097,-0.885834 -0.410984,-3.791749 -0.682609,-4.301456 -0.488401,-0.914876 -1.500042,-1.1845618 -2.187168,-0.796804 -0.687126,0.387758 -0.467113,2.029757 -0.193568,3.411106 0.08523,0.428395 0.48648,2.604608 0.663259,3.082054 l -4.713081,2.853006 c -0.134788,0.815514 0.217417,1.37877 0.773577,1.725872 0.432913,-0.154906 1.780702,-0.656803 2.905276,-1.301335 1.180684,-0.676811 2.300083,-1.280705 2.998823,-1.67748 0.347742,-0.197427 0.457438,-1.170369 0.435491,-2.994963",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-38-3-4-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.856361,24.930416 c 0,0 1.974269,6.043458 2.940756,7.15706 1.136809,1.310369 0.449701,-0.105892 0.449701,-0.105892 0,0 -1.947183,-3.430455 -2.615582,-6.649291 -0.142652,-0.164599 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-6-6-3-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.804675,23.396814 c 0,0 1.97555,2.291048 3.255597,3.871762 0.882614,1.091015 2.410419,3.478847 2.560094,3.707877 0.352918,0.537451 0.06383,1.373612 -0.361934,1.996856 -0.425835,0.623902 -0.896167,1.132951 -1.118119,1.566522 -0.220654,0.434193 0.130399,0.921972 0.130399,0.921972 0,0 1.508455,-0.392934 2.243955,-1.167151 0.734878,-0.774876 1.279407,-1.597485 1.439415,-1.526506 0.160575,0.07169 1.183281,-0.944559 1.183281,-0.944559 0,0 -0.736158,-1.238751 -1.317484,-2.029117 -0.581307,-0.790988 -2.120067,-3.78853 -2.723321,-5.011791 -0.603894,-1.223918 -0.625841,-1.782658 -2.088464,-2.273637 -0.591001,-0.198726 -0.525179,0.474849 -1.423925,0.474849 -1.080041,0 -1.779439,0.412923 -1.779439,0.412923",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-0-1-1-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.953906,31.300347 48.26742,31.87262 c 0,0 0.687126,0.746491 1.155519,1.30651 0.423256,0.505812 0.980057,1.39876 0.980057,1.39876 l 1.021956,-0.883255 c 0,0 -0.860028,-2.021381 -2.471046,-2.394288",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-4-2-4-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 1.041964,-1.0103613 2.226526,-0.8071186 1.184561,0.2032245 1.989119,0.9716441 2.383333,1.1794041 0.393556,0.2077418 1.047122,-0.1148532 1.047122,-0.1148532 0,0 -0.544529,1.0748658 -1.497464,1.0051858 C 42.40138,10.494366 41.564579,9.6162685 40.570989,9.6736951 39.196755,9.7530683 39.194816,9.3014279 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.818636,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-8-9-9-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4697-8",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,81.210376,1.9253293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 70.345281,143.13231 c 0.662619,-0.26841 7.458348,-4.02016 12.034008,0 4.575019,4.02013 6.738979,6.58798 10.202976,6.29829 2.567848,-0.21484 3.216897,-2.15878 3.216897,-2.15878 0,0 0.649067,5.9028 -2.827201,7.38866 -7.132535,3.04916 -9.494562,-2.41621 -11.508188,-4.69373 -2.013627,-2.27815 -6.074422,-6.47767 -10.053283,-5.54344 -2.218789,0.52068 -1.065209,-1.291 -1.065209,-1.291",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-31-89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.990339,131.00216 c 0,0 3.701421,-1.1194 7.512538,-0.16003 3.811117,0.95875 7.991923,2.99302 10.25007,4.24403 3.021409,1.67426 4.39952,3.13108 4.39952,3.13108 0,0 -9.62165,-0.7955 -12.281107,-1.41617 -6.533798,-1.52458 -9.881021,-5.79893 -9.881021,-5.79893",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-9-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.283131,128.38851 c 0,0 0.255493,3.10398 0.827126,4.3292 0.571633,1.2252 1.878144,0 1.878144,0 0,0 -0.83746,-3.18529 -2.70527,-4.3292",
    style: {
      fill: "#552200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-4-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.083378,151.50229 c 0,0 1.027132,2.72268 3.291095,1.96008 2.263304,-0.76196 2.916249,-2.77689 4.223381,-1.22456 1.306511,1.55103 4.247267,6.84672 5.335703,7.13963 1.089076,0.29227 1.361341,-0.43551 1.905869,-0.46969 0.544548,-0.0348 2.558814,3.43174 2.558814,3.43174 0,0 -2.123304,1.52264 -5.227305,-0.11102 -2.929142,-1.54133 -5.934421,-5.66215 -5.934421,-5.66215 0,0 -6.370571,1.07358 -6.806702,0.78197 -0.43487,-0.29227 0.653566,-5.84603 0.653566,-5.84603",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-7-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.226903,150.35903 c 0,0 -9.96749,1.4194 -11.493996,1.65297 -0.418721,0.0638 -0.841977,0.40581 -1.263916,0.90003 0.370328,0.87487 0.825187,2.04267 1.140686,3.17626 0.200646,-0.25744 0.403231,-0.46778 0.607113,-0.59294 0.418081,-0.25742 4.753737,1.54975 10.307496,0.3355 1.396839,-0.30518 0.702617,-5.47182 0.702617,-5.47182",
    style: {
      fill: "#552200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-8-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.210157,158.01222 c -1.249724,1.69749 -2.2452532,2.66914 -3.3891775,4.62985 -1.1426071,1.96008 -1.1426071,3.38982 -1.1426071,3.38982 l 3.2543166,-0.94584 c 0,0 0.17612,-1.57168 0.829065,-2.1175 0.652926,-0.54647 1.714898,-0.40841 2.450416,-1.86653 0.326454,-0.64841 1.312309,-3.61819 2.397507,-5.01373 -0.315499,-1.13359 -0.770358,-2.30139 -1.140686,-3.17626 -1.118119,1.30585 -2.234281,3.71047 -3.258834,5.10019",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-4-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 73.660901,145.68401 c -2.939476,-5.1331 -8.730019,-4.62406 -13.630212,-4.40662 -14.360536,0.63615 -19.012332,-2.57752 -22.827326,-3.77046 -2.343958,-0.73294 -9.873285,-4.42083 -12.496603,-5.05053 -5.261487,-1.26327 -9.953938,0.44519 -9.953938,0.44519 0,0 -5.1234072,6.09636 -6.0924907,7.05897 -0.9690654,0.96327 -2.6304143,2.46397 -3.0465563,2.75237 -0.4148617,0.28775 -0.4916378,1.12261 0,1.84652 0.4735686,0.69616 1.523269,0.85551 1.523269,0.85551 0,0 -0.061999,0.90068 0.4916379,1.00714 0.5542219,0.10589 1.4207057,-0.20194 1.5929673,-1.25682 1.1000498,0.051 4.9479268,-1.00456 6.3292748,-1.75555 1.761352,-0.95617 2.075571,-2.28783 2.075571,-2.28783 l 0.75099,-1.69233 c 0,0 4.246608,0.63873 6.424761,4.06855 2.178152,3.43045 5.117609,8.71646 5.117609,8.71646 l -2.318152,0.95876 c 0.314859,0.59228 0.581325,1.07228 0.772937,1.37295 1.163273,1.26004 2.484616,2.25105 3.914338,3.02011 l 2.504624,-2.00329 c 0,0 4.22854,0.75486 8.373225,0.69162 8.20612,-0.12583 10.73911,-1.94716 13.106953,-1.73039 2.939457,0.26905 5.069876,2.45236 5.071156,2.45366 1.249724,0.11229 2.694955,0.22775 4.402758,0.22775 0.787769,0 3.05559,0.038 5.227287,-1.8175 2.171056,-1.85556 4.645997,-7.27318 2.68592,-9.70424",
    style: {
      fill: "#803300",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-5-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.166827,156.25473 c -4.144685,0.0633 -8.373225,-0.69162 -8.373225,-0.69162 l -2.504624,2.00329 c 0.661321,0.3555 1.34329,0.66842 2.047187,0.93101 3.584647,0.92067 6.450565,0.87937 8.830662,0.87937 6.573155,6.6e-4 10.991385,-1.81102 13.495351,-2.44008 1.223919,-0.3071 2.70591,-0.1368 4.682758,0.0413 -0.0013,-0.001 -2.131699,-2.18461 -5.071156,-2.45363 -2.367843,-0.2168 -4.900833,1.60456 -13.106953,1.73038",
    style: {
      fill: "#552200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-0-09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.802246,143.49812 c -2.178153,-3.42982 -6.424761,-4.06855 -6.424761,-4.06855 l -0.75099,1.69233 c 0,0 3.080756,0.76326 4.742105,2.49817 0.974241,1.0168 3.692405,6.65509 5.233103,9.55327 l 2.318152,-0.95876 c 0,0 -2.939457,-5.28601 -5.117609,-8.71646",
    style: {
      fill: "#552200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-3-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 75.25321,154.70112 c -1.416828,0.28518 -2.658798,0.1465 -2.449118,-1.63554 0.199366,-1.68652 -13.590196,1.72781 -13.590196,1.72781 0,0 2.178152,2.22782 4.465323,4.58405 2.285891,2.35621 4.67632,2.79946 8.384838,1.92588 1.169729,-0.2755 2.747206,-0.98198 3.536273,-1.36586 0.656145,-2.77947 0.202585,-4.29694 -0.34712,-5.23634",
    style: {
      fill: "#803300",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-6-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 80.5089,165.43961 c 1.791692,1.6349 5.330526,1.52651 5.330526,1.52651 0,0 0,-2.83172 -1.143265,-4.1279 -0.487121,-0.55164 -1.960077,0.87294 -2.613644,0 -0.653584,-0.8723 -1.960077,-6.55059 -2.613661,-8.04483 -0.653567,-1.49425 -1.392944,-0.90584 -2.831079,-0.45938 -0.451622,0.13936 -1.805866,0.38648 -2.263304,0.47875 0.57487,1.26325 0.878737,3.22333 0.734878,5.37374 0.7697,-0.37485 2.344598,-1.7491 2.344598,-1.7491 0,0 0.90778,5.04083 3.054951,7.00221",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-1-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13.758591,132.57318 3.221415,4.18274 0.376145,-0.75099 -2.858164,-3.85951 -0.739396,0.42776",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-0-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.249468,132.88482 c 0,0 0.894868,1.90071 2.869795,1.58263 1.350368,-0.21744 2.869138,-1.74974 2.869138,-1.74974 L 16.4658,131.26796 c 0,0 -3.209161,0.72327 -5.216332,1.61686",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-6-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.906421,127.75106 c 0,0 -0.19355,3.91693 0.567115,6.07508 0.760043,2.15814 2.883348,0 2.883348,0 0,0 -1.511034,-4.50792 -3.450463,-6.07508",
    style: {
      fill: "#803300",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-3-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.403785,150.89002 c 0,0 -7.22802,3.4711 -11.148156,4.8589 -2.414296,0.85551 -2.876252,1.6749 -3.26529,2.68848 0.532276,0.33099 1.357464,1.12134 1.923939,2.93044 0.270326,-0.48712 0.510987,-0.81809 0.687766,-0.88133 1.403277,-0.50131 7.273193,-0.20129 11.643031,-2.04847 0.714212,-0.30129 2.976236,-1.49618 5.263426,-3.93175 1.50006,-1.59748 -5.104716,-3.61627 -5.104716,-3.61627",
    style: {
      fill: "#803300",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-2-46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.990339,158.4374 c -0.112841,0.29549 -0.220013,0.60583 -0.367768,0.94004 -0.653566,1.48005 -3.662064,7.68288 -4.631787,9.24165 -0.969706,1.55941 -0.709695,4.29758 -0.709695,4.29758 l 3.114956,-1.35361 c 0,0 -0.624542,-1.87684 0.136068,-2.1633 0.760026,-0.28711 1.413592,-0.33227 2.067176,-2.35105 0.486463,-1.50264 1.528445,-4.2634 2.314916,-5.68087 -0.566457,-1.8091 -1.391663,-2.59945 -1.923939,-2.93044",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-0-92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.591882,138.21726 c 0,0 -1.632965,3.97436 0.980697,6.09767 2.613644,2.12394 10.12748,2.39493 12.250784,2.09556 2.123304,-0.29873 1.743941,-4.04596 1.742003,-5.52602 -3.756928,-0.38066 -12.525006,-1.7762 -14.973484,-2.66721",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-6-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.546923,143.49812 c 0,0 -0.925849,5.6086 -1.251663,8.00417 -0.327112,2.39559 -1.128433,7.87449 -1.128433,7.87449 0,0 3.207223,6.6e-4 6.16217,-0.54646 -0.02524,-0.39292 0.410985,-1.51877 -0.678091,-2.02782 -1.089076,-0.50841 -2.551718,-1.17875 -2.364606,-2.9672 0.186454,-1.78846 1.329719,-10.33718 1.329719,-10.33718 h -2.069096",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-1-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 54.291116,138.21726 c -0.584526,-0.70324 -1.407154,0.871 -3.571095,0.62584 -0.534214,-0.0607 -1.143266,-0.12381 -1.763949,-0.20388 -0.319998,1.17553 -0.757447,2.69042 -1.115522,3.58013 -0.507768,1.262 -5.233743,0.70907 -5.233743,-0.93486 0,-1.38845 0.660023,-4.055 1.000028,-5.33699 -0.460016,-0.50841 -1.125836,-0.32001 -1.258758,-0.0207 -0.239363,0.54197 -0.487761,1.72587 -0.612271,2.29041 -0.27808,1.25942 -1.242628,4.20921 1.388445,5.32215 2.246533,0.94972 4.655654,1.26586 5.472465,0.28582 0.816154,-0.98004 1.24197,-3.44337 1.24197,-3.44337 l 4.45243,0.35808 c 0,0 0.402608,-2.03686 0,-2.52268",
    style: {
      fill: "#6c5353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-5-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 47.84055,142.21935 c 0.358075,-0.88971 0.795524,-2.4046 1.115522,-3.58013 -1.158756,-0.14905 -2.362027,-0.35871 -3.218178,-0.73552 -1.020694,-0.44904 -1.680717,-1.29166 -2.001373,-1.79683 -0.03932,-0.0633 -0.08449,-0.11028 -0.129667,-0.15929 -0.340006,1.28198 -1.000047,3.94853 -1.000047,5.33698 0,1.64392 4.725993,2.19686 5.233762,0.93486",
    style: {
      fill: "#483737",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-5-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.01273,136.94173 c 0,0 -0.04444,1.08198 0.47291,1.31425 0.774236,0.34712 1.471037,-0.80068 1.471037,-0.80068 l -1.943947,-0.51357",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-4-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7.8493355,140.76318 c 0,0 0.1212543,0.21742 0.7103528,1.59295 0.2690457,0.62906 0.9310065,2.78335 0.9310065,2.78335 l 0.9787402,-0.1026 c 0,0 -0.271624,-1.1607 -1.0006862,-2.99883 -0.21226,-0.53615 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67876",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-7-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9.7029538,142.75486 c -0.410326,0 -0.7445344,0.33421 -0.7445344,0.74456 0,0.41032 0.3342084,0.74453 0.7445344,0.74453 0.4103452,0 0.7445532,-0.33421 0.7445532,-0.74453 0,-0.41035 -0.334208,-0.74456 -0.7445532,-0.74456 z m 0,1.88782 c -0.6303395,0 -1.1432655,-0.51292 -1.1432655,-1.14326 0,-0.63036 0.512926,-1.14329 1.1432655,-1.14329 0.6303582,0 1.1432662,0.51293 1.1432662,1.14329 0,0.63034 -0.512908,1.14326 -1.1432662,1.14326",
    style: {
      fill: "#f4ab94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-6-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.133288,142.89229 c 0,0 3.696282,-1.88523 5.364727,-4.25371 1.25682,-1.78394 3.194969,-6.55381 3.194969,-6.55381 l 0.847775,-0.0613 c 0,0 -1.429082,4.2705 -3.656925,7.45256 -1.660709,2.37364 -5.4473,4.14014 -5.4473,4.14014 l -0.303246,-0.7239",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-5-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.307507,143.93363 c 0,0 10.446197,-4.20727 14.56248,-5.61185 6.002821,-2.04846 7.514495,-2.37428 8.697758,-2.13877 0,0 0.780033,-0.10516 0.638734,-0.23551 -1.251023,-1.16197 -7.288665,0.8781 -10.433304,2.10332 -1.336175,0.52066 -13.349553,5.26148 -13.349553,5.26148 l -0.116134,0.62133",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-6-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.211071,127.43106 c 1.174887,0.31162 2.494291,1.00648 2.494291,1.00648 l 0.822609,-1.76458 -1.41553,-1.24069 c 0,0 -2.045888,1.28844 -1.90137,1.99879",
    style: {
      fill: "#ee9d8f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-9-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.834361,125.85099 c -0.238723,1.50264 -1.501341,2.03749 -2.16396,2.22266 -0.386459,0.10845 -0.800022,-0.26517 -1.092295,-0.87873 -0.324533,-0.68067 -0.641953,-1.62975 -0.265808,-2.84979 0.448403,-1.45361 0.919375,-1.69749 2.000074,-1.52587 1.079383,0.17228 1.761352,1.52975 1.521989,3.03173",
    style: {
      fill: "#f9b2a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-3-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.44729,125.72582 c 0,0 -0.346462,1.1123 -0.256134,1.60136 0.08907,0.4884 0.622604,0.76518 0.622604,0.76518 l 0.714211,-2.15041 -1.080681,-0.21613",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-7-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.605971,125.21613 c -0.06072,-0.27227 -0.27744,-0.57163 -0.489059,-0.53809 -0.211619,0.0342 -0.526478,0.49292 -0.526478,0.49292 0,0 -0.486462,-0.23419 -0.954215,-0.68195 -0.469051,-0.44713 -1.331676,0.0128 -1.357481,-0.35744 -0.0406,-0.57615 -0.66518,-1.52523 1.744581,-1.99686 1.100689,-0.21549 2.261384,0.16131 2.56527,0.9452 0.593561,1.52975 0.101868,2.35236 0.250976,2.96528 -0.822609,0.22582 -1.171668,-0.55744 -1.233594,-0.82906",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-4-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.726426,124.18834 0.0018,0.3826 c 0,0 1.571661,0.18197 2.907196,-0.0819 0.782612,-0.15418 1.445231,-0.0146 2.245912,0.26388 0.801303,0.27743 1.319405,0.12327 1.319405,0.12327 0,0 -0.08193,-2.07299 -0.898105,-2.80205 -0.817423,-0.72971 -2.756852,-0.42324 -3.431067,-0.0962 -0.839398,0.40646 -1.100689,2.17169 -1.100689,2.17169 l -1.045201,0.0388",
    style: {
      fill: "#800000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-52-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.036871,123.71801 c 0,0 -0.163319,1.43038 0,2.25814 0.163135,0.82713 1.365858,0.95876 1.976848,0.15546 0.326472,-0.42906 0.800041,-1.52005 0.800041,-1.52005 l -0.633577,-0.26519 c 0,0 -0.16972,0.90392 -0.712932,1.42201 -0.662601,0.63098 -1.044561,0.007 -1.000046,-0.84972 0.03219,-0.62132 0.05944,-1.04198 0.05944,-1.04198 l -0.489701,-0.15875",
    style: {
      fill: "#800000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-5-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.322047,126.0981 c 0,0 0.02067,0.6781 0,1.08648 -0.01993,0.40777 -0.111012,0.69423 -0.111012,0.69423 l 0.578088,-0.33098 c 0,0 0.346462,-1.01423 0.166428,-1.28262 -0.09163,-0.13552 -0.633577,-0.16716 -0.633577,-0.16716",
    style: {
      fill: "#800000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-4-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.080646,129.71307 c 0,0 1.686515,0.45486 2.678807,1.47296 1.265855,1.29941 0.985196,3.04206 0,4.49243 -1.471018,2.1646 -5.227306,4.14274 -5.227306,4.14274 l -3.022049,1.38587 c 0,0 -1.452949,-1.22522 -0.898105,-2.59108 0.321315,-0.79228 2.902057,-3.34658 4.818259,-5.87829 0.70002,-0.92391 1.650394,-3.02463 1.650394,-3.02463",
    style: {
      fill: "#cdde87",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-7-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.201517,126.08583 -0.310981,0.58713 c 0,0 0.800662,3.08399 1.127775,3.98209 0.326472,0.89873 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.17942 2.777529,0.68971 0.898105,0.51033 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.44394 1.93877,-2.4472 1.740064,-1.07035 2.504625,-2.62526 2.504625,-2.62526 0,0 -3.269167,-0.9452 -4.249846,-1.27553 -0.979398,-0.32905 -2.647203,-1.10842 -4.345331,-1.93685 -1.698127,-0.82712 -3.413026,-0.41486 -3.413026,-0.41486",
    style: {
      fill: "#338000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-4-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.038763,135.94105 c 0,0 -1.633605,-0.24516 -2.1646,0 -0.530977,0.24518 -0.203865,0.69422 0,1.10262 0.204523,0.40841 0.612929,0.83553 1.06199,0.98908 0.449044,0.15417 1.891037,-0.72649 1.891037,-0.72649 l -0.788427,-1.36521",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-4-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.760313,131.77121 c -0.01097,-0.88583 -0.410984,-3.79174 -0.682609,-4.30145 -0.488401,-0.91488 -1.500042,-1.18456 -2.187168,-0.7968 -0.687126,0.38775 -0.467113,2.02975 -0.193568,3.4111 0.08523,0.4284 0.48648,2.60461 0.663259,3.08205 l -4.713081,2.85301 c -0.134788,0.81551 0.217417,1.37877 0.773577,1.72587 0.432913,-0.1549 1.780702,-0.6568 2.905276,-1.30133 1.180684,-0.67681 2.300083,-1.28071 2.998823,-1.67748 0.347742,-0.19743 0.457438,-1.17037 0.435491,-2.99497",
    style: {
      fill: "#225500",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-3-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.108835,141.35481 c 0,0 1.974269,6.04345 2.940756,7.15706 1.136809,1.31036 0.449701,-0.1059 0.449701,-0.1059 0,0 -1.947183,-3.43045 -2.615582,-6.64929 -0.142652,-0.1646 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#916f6f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-0-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.057149,139.8212 c 0,0 1.97555,2.29105 3.255597,3.87177 0.882614,1.09101 2.410419,3.47884 2.560094,3.70787 0.352918,0.53745 0.06383,1.37361 -0.361934,1.99686 -0.425835,0.6239 -0.896167,1.13295 -1.118119,1.56652 -0.220654,0.43419 0.130399,0.92197 0.130399,0.92197 0,0 1.508455,-0.39293 2.243955,-1.16715 0.734878,-0.77487 1.279407,-1.59748 1.439415,-1.5265 0.160575,0.0717 1.183281,-0.94456 1.183281,-0.94456 0,0 -0.736158,-1.23875 -1.317484,-2.02912 -0.581307,-0.79099 -2.120067,-3.78853 -2.723321,-5.01179 -0.603894,-1.22392 -0.625841,-1.78266 -2.088464,-2.27364 -0.591001,-0.19872 -0.525179,0.47485 -1.423925,0.47485 -1.080041,0 -1.779439,0.41292 -1.779439,0.41292",
    style: {
      fill: "#553133",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-7-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.20638,147.72474 -0.686486,0.57227 c 0,0 0.687126,0.74649 1.155519,1.30651 0.423256,0.50581 0.980057,1.39876 0.980057,1.39876 l 1.021956,-0.88325 c 0,0 -0.860028,-2.02139 -2.471046,-2.39429",
    style: {
      fill: "#6c5353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-8-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.44729,125.72582 c 0,0 1.041964,-1.01036 2.226526,-0.80712 1.184561,0.20322 1.989119,0.97164 2.383333,1.1794 0.393556,0.20775 1.047122,-0.11485 1.047122,-0.11485 0,0 -0.544529,1.07487 -1.497464,1.00519 -0.952953,-0.0697 -1.789754,-0.94778 -2.783344,-0.89035 -1.374234,0.0794 -1.376173,-0.37227 -1.376173,-0.37227",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-6-5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer6",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4918",
    transform: "matrix(1.8137974,0,0,1.8137974,-205.25467,-190.6761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4306-0-3-0-4-1-1-4-2",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,216.1721,106.58366)",
    style: {
      display: "inline",
      fill: "#666666",
      fillOpacity: 0.859168,
      filter: "url(#filter1510-3-2-8-6-8-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 71.092807,26.707917 c 0.662619,-0.268406 7.458348,-4.020158 12.034008,0 4.575019,4.020138 6.738979,6.587987 10.202976,6.298293 2.567848,-0.214837 3.216897,-2.158784 3.216897,-2.158784 0,0 0.649067,5.9028 -2.827201,7.388668 -7.132535,3.049154 -9.494562,-2.416216 -11.508188,-4.693731 -2.013627,-2.278155 -6.074422,-6.47767 -10.053283,-5.543444 -2.218789,0.52068 -1.065209,-1.291002 -1.065209,-1.291002",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-30-6-3-9-89-0-6-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,14.577765 c 0,0 3.701421,-1.119398 7.512538,-0.160027 3.811117,0.958751 7.991923,2.993026 10.25007,4.24403 3.021409,1.674261 4.39952,3.131087 4.39952,3.131087 0,0 -9.62165,-0.795505 -12.281107,-1.41617 -6.533798,-1.524586 -9.881021,-5.798938 -9.881021,-5.798938",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-4-7-6-5-6-8-2-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.030657,11.964122 c 0,0 0.255493,3.103982 0.827126,4.3292 0.571633,1.225199 1.878144,0 1.878144,0 0,0 -0.83746,-3.185295 -2.70527,-4.3292",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-44-5-1-0-4-5-6-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.830904,35.077904 c 0,0 1.027132,2.722681 3.291095,1.960077 2.263304,-0.761964 2.916249,-2.776889 4.223381,-1.224559 1.306511,1.551031 4.247267,6.846718 5.335703,7.13963 1.089076,0.292273 1.361341,-0.435509 1.905869,-0.469691 0.544548,-0.03475 2.558814,3.431735 2.558814,3.431735 0,0 -2.123304,1.522648 -5.227305,-0.111012 -2.929142,-1.541338 -5.934421,-5.662157 -5.934421,-5.662157 0,0 -6.370571,1.073586 -6.806702,0.781972 -0.43487,-0.292273 0.653566,-5.846032 0.653566,-5.846032",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-4-3-0-4-3-0-7-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.974429,33.934638 c 0,0 -9.96749,1.419407 -11.493996,1.652973 -0.418721,0.06383 -0.841977,0.405809 -1.263916,0.900025 0.370328,0.874879 0.825187,2.042669 1.140686,3.17626 0.200646,-0.257432 0.403231,-0.467771 0.607113,-0.592939 0.418081,-0.257414 4.753737,1.549751 10.307496,0.335507 1.396839,-0.305184 0.702617,-5.471826 0.702617,-5.471826",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-7-5-6-8-3-6-5-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.957683,41.587835 c -1.249724,1.697487 -2.245253,2.669131 -3.3891773,4.629849 -1.1426071,1.960077 -1.1426071,3.389817 -1.1426071,3.389817 l 3.2543164,-0.945838 c 0,0 0.17612,-1.57168 0.829065,-2.117507 0.652926,-0.546468 1.714898,-0.408406 2.450416,-1.86653 0.326454,-0.648409 1.312309,-3.618189 2.397507,-5.01373 -0.315499,-1.133591 -0.770358,-2.301381 -1.140686,-3.17626 -1.118119,1.305853 -2.234281,3.710474 -3.258834,5.100199",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-6-6-3-7-38-4-6-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.408427,29.259616 C 71.468951,24.126516 65.678408,24.635565 60.778215,24.853 46.417679,25.489155 41.765883,22.275476 37.950889,21.082539 c -2.343958,-0.73294 -9.873285,-4.420827 -12.496603,-5.050527 -5.261487,-1.263276 -9.953938,0.445185 -9.953938,0.445185 0,0 -5.123407,6.096368 -6.0924905,7.058977 -0.9690654,0.963268 -2.6304143,2.463968 -3.0465563,2.752364 -0.4148617,0.287755 -0.4916378,1.122617 0,1.846522 0.4735686,0.696161 1.523269,0.855511 1.523269,0.855511 0,0 -0.061999,0.900683 0.4916379,1.007142 0.5542219,0.105892 1.4207057,-0.201944 1.5929673,-1.25682 1.1000496,0.05102 4.9479266,-1.004564 6.3292746,-1.755555 1.761352,-0.956171 2.075571,-2.287829 2.075571,-2.287829 l 0.75099,-1.69233 c 0,0 4.246608,0.638734 6.424761,4.068549 2.178152,3.430455 5.117609,8.716467 5.117609,8.716467 l -2.318152,0.958751 c 0.314859,0.59228 0.581325,1.072287 0.772937,1.372954 1.163273,1.260039 2.484616,2.251051 3.914338,3.02011 l 2.504624,-2.003293 c 0,0 4.22854,0.754867 8.373225,0.691625 8.20612,-0.125827 10.73911,-1.947165 13.106953,-1.730389 2.939457,0.269046 5.069876,2.452355 5.071156,2.453654 1.249724,0.112293 2.694955,0.227749 4.402758,0.227749 0.787769,0 3.05559,0.03804 5.227287,-1.817498 2.171056,-1.855557 4.645997,-7.273175 2.68592,-9.704242",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-3-2-2-1-6-6-9-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.914353,39.830342 c -4.144685,0.06328 -8.373225,-0.691625 -8.373225,-0.691625 l -2.504624,2.003293 c 0.661321,0.355497 1.34329,0.668417 2.047187,0.931007 3.584647,0.920673 6.450565,0.879377 8.830662,0.879377 6.573155,6.58e-4 10.991385,-1.811024 13.495351,-2.440083 1.223919,-0.307105 2.70591,-0.1368 4.682758,0.04133 -0.0013,-0.0013 -2.131699,-2.184608 -5.071156,-2.453635 -2.367843,-0.216795 -4.900833,1.604562 -13.106953,1.730389",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-1-9-0-7-0-2-8-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.549772,27.073728 c -2.178153,-3.429815 -6.424761,-4.068549 -6.424761,-4.068549 l -0.75099,1.69233 c 0,0 3.080756,0.763262 4.742105,2.498168 0.974241,1.016799 3.692405,6.655089 5.233103,9.553269 l 2.318152,-0.958751 c 0,0 -2.939457,-5.286012 -5.117609,-8.716467",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-7-1-6-2-4-5-7-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.000736,38.276732 c -1.416828,0.285176 -2.658798,0.146493 -2.449118,-1.635544 0.199366,-1.686514 -13.590196,1.727811 -13.590196,1.727811 0,0 2.178152,2.227824 4.465323,4.584053 2.285891,2.356212 4.67632,2.799458 8.384838,1.925878 1.169729,-0.275502 2.747206,-0.981977 3.536273,-1.365858 0.656145,-2.779468 0.202585,-4.296939 -0.34712,-5.23634",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-5-2-1-7-8-8-2-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.256426,49.01522 c 1.791692,1.634904 5.330526,1.526506 5.330526,1.526506 0,0 0,-2.831718 -1.143265,-4.127896 -0.487121,-0.551643 -1.960077,0.87294 -2.613644,0 -0.653584,-0.872299 -1.960077,-6.550587 -2.613661,-8.044831 -0.653567,-1.494245 -1.392944,-0.905842 -2.831079,-0.459377 -0.451622,0.13936 -1.805866,0.386478 -2.263304,0.478744 0.57487,1.263258 0.878737,3.223336 0.734878,5.373744 0.7697,-0.374846 2.344598,-1.749099 2.344598,-1.749099 0,0 0.90778,5.040834 3.054951,7.002209",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-9-7-5-2-8-6-8-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.506117,16.148786 3.221415,4.182744 0.376145,-0.750991 -2.858164,-3.859508 -0.739396,0.427755",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-6-0-5-2-8-2-2-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.996994,16.460426 c 0,0 0.894868,1.900712 2.869795,1.582634 1.350368,-0.217435 2.869138,-1.749738 2.869138,-1.749738 l -0.522601,-1.449749 c 0,0 -3.209161,0.723265 -5.216332,1.616853",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-2-9-4-6-97-8-9-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.653947,11.326668 c 0,0 -0.19355,3.916935 0.567115,6.075079 0.760043,2.158144 2.883348,0 2.883348,0 0,0 -1.511034,-4.507917 -3.450463,-6.075079",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-1-3-7-1-7-4-9-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.151311,34.465633 c 0,0 -7.22802,3.471093 -11.148156,4.858897 -2.414296,0.855511 -2.876252,1.674901 -3.26529,2.688481 0.532276,0.33099 1.357464,1.121338 1.923939,2.930441 0.270326,-0.48712 0.510987,-0.818091 0.687766,-0.881334 1.403277,-0.501312 7.273193,-0.201286 11.643031,-2.048467 0.714212,-0.301288 2.976236,-1.496183 5.263426,-3.931749 1.50006,-1.597485 -5.104716,-3.616269 -5.104716,-3.616269",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-7-6-6-0-6-7-6-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,42.013011 c -0.112841,0.295492 -0.220013,0.605833 -0.367768,0.940041 -0.653566,1.480053 -3.662064,7.68288 -4.631787,9.241647 -0.969706,1.559408 -0.709695,4.297579 -0.709695,4.297579 l 3.114956,-1.353604 c 0,0 -0.624542,-1.876845 0.136068,-2.163302 0.760026,-0.287115 1.413592,-0.33227 2.067176,-2.351054 0.486463,-1.502639 1.528445,-4.263397 2.314916,-5.680866 -0.566457,-1.809103 -1.391663,-2.599451 -1.923939,-2.930441",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-8-0-5-6-4-2-0-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.339408,21.792873 c 0,0 -1.632965,3.974362 0.980697,6.097667 2.613644,2.123944 10.12748,2.394928 12.250784,2.09556 2.123304,-0.298729 1.743941,-4.045963 1.742003,-5.526016 -3.756928,-0.380661 -12.525006,-1.776202 -14.973484,-2.667211",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-5-6-6-1-3-4-2-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 46.294449,27.073728 c 0,0 -0.925849,5.608607 -1.251663,8.004176 -0.327112,2.395587 -1.128433,7.87449 -1.128433,7.87449 0,0 3.207223,6.58e-4 6.16217,-0.546467 -0.02524,-0.392916 0.410985,-1.51877 -0.678091,-2.027819 -1.089076,-0.508409 -2.551718,-1.178746 -2.364606,-2.967201 0.186454,-1.788456 1.329719,-10.337179 1.329719,-10.337179 h -2.069096",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-7-2-9-5-03-0-7-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.038642,21.792873 c -0.584526,-0.703238 -1.407154,0.871001 -3.571095,0.625841 -0.534214,-0.06072 -1.143266,-0.123815 -1.763949,-0.203883 -0.319998,1.175527 -0.757447,2.69042 -1.115522,3.58013 -0.507768,1.261996 -5.233743,0.709073 -5.233743,-0.934865 0,-1.388445 0.660023,-4.054998 1.000028,-5.336983 -0.460016,-0.508409 -1.125836,-0.320017 -1.258758,-0.02067 -0.239363,0.541968 -0.487761,1.725871 -0.612271,2.290408 -0.27808,1.259417 -1.242628,4.209208 1.388445,5.322151 2.246533,0.949715 4.655654,1.265855 5.472465,0.285816 0.816154,-0.980039 1.24197,-3.443367 1.24197,-3.443367 l 4.45243,0.358075 c 0,0 0.402608,-2.036853 0,-2.522675",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-4-6-3-9-0-6-6-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.588076,25.794961 c 0.358075,-0.88971 0.795524,-2.404603 1.115522,-3.58013 -1.158756,-0.149053 -2.362027,-0.358715 -3.218178,-0.735518 -1.020694,-0.449044 -1.680717,-1.291661 -2.001373,-1.796832 -0.03932,-0.06328 -0.08449,-0.110281 -0.129667,-0.159295 -0.340006,1.281986 -1.000047,3.948538 -1.000047,5.336983 0,1.64392 4.725993,2.196861 5.233762,0.934865",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-1-1-7-4-9-2-1-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.760256,20.517343 c 0,0 -0.04444,1.08198 0.47291,1.314247 0.774236,0.347121 1.471037,-0.800681 1.471037,-0.800681 l -1.943947,-0.513566",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-8-8-4-9-2-9-3-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.5968617,24.338793 c 0,0 0.1212543,0.217417 0.7103528,1.59295 0.2690457,0.629059 0.9310065,2.783344 0.9310065,2.783344 l 0.97874,-0.1026 c 0,0 -0.271624,-1.160694 -1.000686,-2.998822 -0.21226,-0.536153 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67875",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-5-7-5-0-5-9-2-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.45048,26.330474 c -0.410326,0 -0.7445344,0.334208 -0.7445344,0.744552 0,0.410327 0.3342084,0.744535 0.7445344,0.744535 0.410345,0 0.744553,-0.334208 0.744553,-0.744535 0,-0.410344 -0.334208,-0.744552 -0.744553,-0.744552 z m 0,1.887818 c -0.6303395,0 -1.1432655,-0.512926 -1.1432655,-1.143266 0,-0.630358 0.512926,-1.143283 1.1432655,-1.143283 0.630358,0 1.143266,0.512925 1.143266,1.143283 0,0.63034 -0.512908,1.143266 -1.143266,1.143266",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-9-9-2-9-40-0-1-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.880814,26.467895 c 0,0 3.696282,-1.885221 5.364727,-4.253704 1.25682,-1.783939 3.194969,-6.553806 3.194969,-6.553806 l 0.847775,-0.06127 c 0,0 -1.429082,4.270493 -3.656925,7.452551 -1.660709,2.37364 -5.4473,4.140149 -5.4473,4.140149 L 10.880814,26.46791",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-7-2-5-1-5-8-5-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.055033,27.509238 c 0,0 10.446197,-4.20727 14.56248,-5.611845 6.002821,-2.048466 7.514495,-2.37428 8.697758,-2.138776 0,0 0.780033,-0.10516 0.638734,-0.235504 -1.251023,-1.161975 -7.288665,0.878097 -10.433304,2.103314 -1.336175,0.520662 -13.349553,5.261487 -13.349553,5.261487 l -0.116134,0.621324",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-5-0-4-7-9-1-9-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.958597,11.00667 c 1.174887,0.311622 2.494291,1.006484 2.494291,1.006484 l 0.822609,-1.764589 -1.41553,-1.2406896 c 0,0 -2.045888,1.2884416 -1.90137,1.9987946",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-3-2-7-7-4-3-9-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.581887,9.426596 c -0.238723,1.502639 -1.501341,2.037493 -2.16396,2.222667 -0.386459,0.108452 -0.800022,-0.265169 -1.092295,-0.878737 -0.324533,-0.680671 -0.641953,-1.6297464 -0.265808,-2.8497881 0.448403,-1.4536072 0.919375,-1.6974875 2.000074,-1.525866 1.079383,0.17228 1.761352,1.5297432 1.521989,3.0317241",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-8-3-4-1-6-1-1-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 -0.346462,1.1123031 -0.256134,1.6013621 0.08907,0.488401 0.622604,0.765182 0.622604,0.765182 L 40.275497,9.5175642 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-8-7-4-1-9-1-4-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.353497,8.791739 c -0.06072,-0.2722644 -0.27744,-0.5716327 -0.489059,-0.5380912 -0.211619,0.0342 -0.526478,0.4929181 -0.526478,0.4929181 0,0 -0.486462,-0.2341873 -0.954215,-0.6819505 -0.469051,-0.447123 -1.331676,0.012802 -1.357481,-0.3574351 -0.0406,-0.5761501 -0.66518,-1.5252258 1.744581,-1.9968558 1.100689,-0.2154962 2.261384,0.1613067 2.56527,0.9451985 0.593561,1.5297432 0.101868,2.3523524 0.250976,2.9652811 C 38.764482,9.8466152 38.415423,9.0633634 38.353497,8.791739",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-3-5-3-5-2-0-9-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.473952,7.7639486 0.0018,0.3826004 c 0,0 1.571661,0.1819729 2.907196,-0.081934 0.782612,-0.154174 1.445231,-0.014631 2.245912,0.2638882 0.801303,0.2774219 1.319405,0.1232661 1.319405,0.1232661 0,0 -0.08193,-2.0729918 -0.898105,-2.8020541 C 38.232737,4.9200133 36.293308,5.2264776 35.619093,5.5535169 34.779695,5.959984 34.518404,7.725213 34.518404,7.725213 l -1.045201,0.038772",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-1-9-0-9-2-3-1-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.784397,7.2936171 c 0,0 -0.163319,1.4303805 0,2.258147 0.163135,0.8271269 1.365858,0.9587509 1.976848,0.1554543 0.326472,-0.4290538 0.800041,-1.5200502 0.800041,-1.5200502 L 38.927709,7.9219815 c 0,0 -0.16972,0.9039209 -0.712932,1.4220043 -0.662601,0.6309797 -1.044561,0.00732 -1.000046,-0.8497131 0.03219,-0.6213233 0.05944,-1.0419825 0.05944,-1.0419825 L 36.78447,7.2935439",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-8-2-7-7-4-4-0-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.069573,9.6737134 c 0,0 0.02067,0.6780916 0,1.0864786 -0.01993,0.407766 -0.111012,0.694223 -0.111012,0.694223 l 0.578088,-0.330972 c 0,0 0.346462,-1.014238 0.166428,-1.2826254 C 37.61145,9.7052981 37.0695,9.6736586 37.0695,9.6736586",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-9-2-8-7-7-0-7-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.828172,13.288684 c 0,0 1.686515,0.454859 2.678807,1.472956 1.265855,1.299415 0.985196,3.042057 0,4.492427 -1.471018,2.1646 -5.227306,4.142747 -5.227306,4.142747 l -3.022049,1.385865 c 0,0 -1.452949,-1.225217 -0.898105,-2.591075 0.321315,-0.792286 2.902057,-3.346583 4.818259,-5.878293 0.70002,-0.92391 1.650394,-3.024627 1.650394,-3.024627",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-6-8-6-6-7-3-5-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.949043,9.6614417 -0.310981,0.5871233 c 0,0 0.800662,3.083993 1.127775,3.982098 0.326472,0.898727 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.179413 2.777529,0.689705 0.898105,0.510329 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.443933 1.93877,-2.447198 1.740064,-1.070348 2.504625,-2.625256 2.504625,-2.625256 0,0 -3.269167,-0.945199 -4.249846,-1.27553 C 46.728002,11.684103 45.060197,10.904728 43.362069,10.076303 41.663942,9.249177 39.949043,9.6614417 39.949043,9.6614417",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-43-9-8-7-5-9-8-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.786289,19.516657 c 0,0 -1.633605,-0.245161 -2.1646,0 -0.530977,0.245179 -0.203865,0.694222 0,1.102628 0.204523,0.408406 0.612929,0.835521 1.06199,0.989073 0.449044,0.154174 1.891037,-0.726483 1.891037,-0.726483 l -0.788427,-1.365218",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-3-7-8-3-4-1-7-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.507839,15.346825 c -0.01097,-0.885834 -0.410984,-3.791749 -0.682609,-4.301456 -0.488401,-0.914876 -1.500042,-1.1845618 -2.187168,-0.796804 -0.687126,0.387758 -0.467113,2.029757 -0.193568,3.411106 0.08523,0.428395 0.48648,2.604608 0.663259,3.082054 l -4.713081,2.853006 c -0.134788,0.815514 0.217417,1.37877 0.773577,1.725872 0.432913,-0.154906 1.780702,-0.656803 2.905276,-1.301335 1.180684,-0.676811 2.300083,-1.280705 2.998823,-1.67748 0.347742,-0.197427 0.457438,-1.170369 0.435491,-2.994963",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-38-3-4-6-81-9-0-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.856361,24.930416 c 0,0 1.974269,6.043458 2.940756,7.15706 1.136809,1.310369 0.449701,-0.105892 0.449701,-0.105892 0,0 -1.947183,-3.430455 -2.615582,-6.649291 -0.142652,-0.164599 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-6-6-3-5-2-6-4-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.804675,23.396814 c 0,0 1.97555,2.291048 3.255597,3.871762 0.882614,1.091015 2.410419,3.478847 2.560094,3.707877 0.352918,0.537451 0.06383,1.373612 -0.361934,1.996856 -0.425835,0.623902 -0.896167,1.132951 -1.118119,1.566522 -0.220654,0.434193 0.130399,0.921972 0.130399,0.921972 0,0 1.508455,-0.392934 2.243955,-1.167151 0.734878,-0.774876 1.279407,-1.597485 1.439415,-1.526506 0.160575,0.07169 1.183281,-0.944559 1.183281,-0.944559 0,0 -0.736158,-1.238751 -1.317484,-2.029117 -0.581307,-0.790988 -2.120067,-3.78853 -2.723321,-5.011791 -0.603894,-1.223918 -0.625841,-1.782658 -2.088464,-2.273637 -0.591001,-0.198726 -0.525179,0.474849 -1.423925,0.474849 -1.080041,0 -1.779439,0.412923 -1.779439,0.412923",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-0-1-1-6-8-9-8-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.953906,31.300347 48.26742,31.87262 c 0,0 0.687126,0.746491 1.155519,1.30651 0.423256,0.505812 0.980057,1.39876 0.980057,1.39876 l 1.021956,-0.883255 c 0,0 -0.860028,-2.021381 -2.471046,-2.394288",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-4-2-4-3-9-3-0-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 1.041964,-1.0103613 2.226526,-0.8071186 1.184561,0.2032245 1.989119,0.9716441 2.383333,1.1794041 0.393556,0.2077418 1.047122,-0.1148532 1.047122,-0.1148532 0,0 -0.544529,1.0748658 -1.497464,1.0051858 C 42.40138,10.494366 41.564579,9.6162685 40.570989,9.6736951 39.196755,9.7530683 39.194816,9.3014279 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.859168,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-8-9-9-9-3-3-4-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4697",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,189.5068,-8.5052817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 70.345281,143.13231 c 0.662619,-0.26841 7.458348,-4.02016 12.034008,0 4.575019,4.02013 6.738979,6.58798 10.202976,6.29829 2.567848,-0.21484 3.216897,-2.15878 3.216897,-2.15878 0,0 0.649067,5.9028 -2.827201,7.38866 -7.132535,3.04916 -9.494562,-2.41621 -11.508188,-4.69373 -2.013627,-2.27815 -6.074422,-6.47767 -10.053283,-5.54344 -2.218789,0.52068 -1.065209,-1.291 -1.065209,-1.291",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.990339,131.00216 c 0,0 3.701421,-1.1194 7.512538,-0.16003 3.811117,0.95875 7.991923,2.99302 10.25007,4.24403 3.021409,1.67426 4.39952,3.13108 4.39952,3.13108 0,0 -9.62165,-0.7955 -12.281107,-1.41617 -6.533798,-1.52458 -9.881021,-5.79893 -9.881021,-5.79893",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.283131,128.38851 c 0,0 0.255493,3.10398 0.827126,4.3292 0.571633,1.2252 1.878144,0 1.878144,0 0,0 -0.83746,-3.18529 -2.70527,-4.3292",
    style: {
      fill: "#5e3a22",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.083378,151.50229 c 0,0 1.027132,2.72268 3.291095,1.96008 2.263304,-0.76196 2.916249,-2.77689 4.223381,-1.22456 1.306511,1.55103 4.247267,6.84672 5.335703,7.13963 1.089076,0.29227 1.361341,-0.43551 1.905869,-0.46969 0.544548,-0.0348 2.558814,3.43174 2.558814,3.43174 0,0 -2.123304,1.52264 -5.227305,-0.11102 -2.929142,-1.54133 -5.934421,-5.66215 -5.934421,-5.66215 0,0 -6.370571,1.07358 -6.806702,0.78197 -0.43487,-0.29227 0.653566,-5.84603 0.653566,-5.84603",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.226903,150.35903 c 0,0 -9.96749,1.4194 -11.493996,1.65297 -0.418721,0.0638 -0.841977,0.40581 -1.263916,0.90003 0.370328,0.87487 0.825187,2.04267 1.140686,3.17626 0.200646,-0.25744 0.403231,-0.46778 0.607113,-0.59294 0.418081,-0.25742 4.753737,1.54975 10.307496,0.3355 1.396839,-0.30518 0.702617,-5.47182 0.702617,-5.47182",
    style: {
      fill: "#5e3a22",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.210157,158.01222 c -1.249724,1.69749 -2.2452532,2.66914 -3.3891775,4.62985 -1.1426071,1.96008 -1.1426071,3.38982 -1.1426071,3.38982 l 3.2543166,-0.94584 c 0,0 0.17612,-1.57168 0.829065,-2.1175 0.652926,-0.54647 1.714898,-0.40841 2.450416,-1.86653 0.326454,-0.64841 1.312309,-3.61819 2.397507,-5.01373 -0.315499,-1.13359 -0.770358,-2.30139 -1.140686,-3.17626 -1.118119,1.30585 -2.234281,3.71047 -3.258834,5.10019",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 73.660901,145.68401 c -2.939476,-5.1331 -8.730019,-4.62406 -13.630212,-4.40662 -14.360536,0.63615 -19.012332,-2.57752 -22.827326,-3.77046 -2.343958,-0.73294 -9.873285,-4.42083 -12.496603,-5.05053 -5.261487,-1.26327 -9.953938,0.44519 -9.953938,0.44519 0,0 -5.1234072,6.09636 -6.0924907,7.05897 -0.9690654,0.96327 -2.6304143,2.46397 -3.0465563,2.75237 -0.4148617,0.28775 -0.4916378,1.12261 0,1.84652 0.4735686,0.69616 1.523269,0.85551 1.523269,0.85551 0,0 -0.061999,0.90068 0.4916379,1.00714 0.5542219,0.10589 1.4207057,-0.20194 1.5929673,-1.25682 1.1000498,0.051 4.9479268,-1.00456 6.3292748,-1.75555 1.761352,-0.95617 2.075571,-2.28783 2.075571,-2.28783 l 0.75099,-1.69233 c 0,0 4.246608,0.63873 6.424761,4.06855 2.178152,3.43045 5.117609,8.71646 5.117609,8.71646 l -2.318152,0.95876 c 0.314859,0.59228 0.581325,1.07228 0.772937,1.37295 1.163273,1.26004 2.484616,2.25105 3.914338,3.02011 l 2.504624,-2.00329 c 0,0 4.22854,0.75486 8.373225,0.69162 8.20612,-0.12583 10.73911,-1.94716 13.106953,-1.73039 2.939457,0.26905 5.069876,2.45236 5.071156,2.45366 1.249724,0.11229 2.694955,0.22775 4.402758,0.22775 0.787769,0 3.05559,0.038 5.227287,-1.8175 2.171056,-1.85556 4.645997,-7.27318 2.68592,-9.70424",
    style: {
      fill: "#995d34",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.166827,156.25473 c -4.144685,0.0633 -8.373225,-0.69162 -8.373225,-0.69162 l -2.504624,2.00329 c 0.661321,0.3555 1.34329,0.66842 2.047187,0.93101 3.584647,0.92067 6.450565,0.87937 8.830662,0.87937 6.573155,6.6e-4 10.991385,-1.81102 13.495351,-2.44008 1.223919,-0.3071 2.70591,-0.1368 4.682758,0.0413 -0.0013,-0.001 -2.131699,-2.18461 -5.071156,-2.45363 -2.367843,-0.2168 -4.900833,1.60456 -13.106953,1.73038",
    style: {
      fill: "#5e3a22",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.802246,143.49812 c -2.178153,-3.42982 -6.424761,-4.06855 -6.424761,-4.06855 l -0.75099,1.69233 c 0,0 3.080756,0.76326 4.742105,2.49817 0.974241,1.0168 3.692405,6.65509 5.233103,9.55327 l 2.318152,-0.95876 c 0,0 -2.939457,-5.28601 -5.117609,-8.71646",
    style: {
      fill: "#5e3a22",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 75.25321,154.70112 c -1.416828,0.28518 -2.658798,0.1465 -2.449118,-1.63554 0.199366,-1.68652 -13.590196,1.72781 -13.590196,1.72781 0,0 2.178152,2.22782 4.465323,4.58405 2.285891,2.35621 4.67632,2.79946 8.384838,1.92588 1.169729,-0.2755 2.747206,-0.98198 3.536273,-1.36586 0.656145,-2.77947 0.202585,-4.29694 -0.34712,-5.23634",
    style: {
      fill: "#995d34",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 80.5089,165.43961 c 1.791692,1.6349 5.330526,1.52651 5.330526,1.52651 0,0 0,-2.83172 -1.143265,-4.1279 -0.487121,-0.55164 -1.960077,0.87294 -2.613644,0 -0.653584,-0.8723 -1.960077,-6.55059 -2.613661,-8.04483 -0.653567,-1.49425 -1.392944,-0.90584 -2.831079,-0.45938 -0.451622,0.13936 -1.805866,0.38648 -2.263304,0.47875 0.57487,1.26325 0.878737,3.22333 0.734878,5.37374 0.7697,-0.37485 2.344598,-1.7491 2.344598,-1.7491 0,0 0.90778,5.04083 3.054951,7.00221",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13.758591,132.57318 3.221415,4.18274 0.376145,-0.75099 -2.858164,-3.85951 -0.739396,0.42776",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.249468,132.88482 c 0,0 0.894868,1.90071 2.869795,1.58263 1.350368,-0.21744 2.869138,-1.74974 2.869138,-1.74974 L 16.4658,131.26796 c 0,0 -3.209161,0.72327 -5.216332,1.61686",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.906421,127.75106 c 0,0 -0.19355,3.91693 0.567115,6.07508 0.760043,2.15814 2.883348,0 2.883348,0 0,0 -1.511034,-4.50792 -3.450463,-6.07508",
    style: {
      fill: "#995d34",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.403785,150.89002 c 0,0 -7.22802,3.4711 -11.148156,4.8589 -2.414296,0.85551 -2.876252,1.6749 -3.26529,2.68848 0.532276,0.33099 1.357464,1.12134 1.923939,2.93044 0.270326,-0.48712 0.510987,-0.81809 0.687766,-0.88133 1.403277,-0.50131 7.273193,-0.20129 11.643031,-2.04847 0.714212,-0.30129 2.976236,-1.49618 5.263426,-3.93175 1.50006,-1.59748 -5.104716,-3.61627 -5.104716,-3.61627",
    style: {
      fill: "#916f6f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.990339,158.4374 c -0.112841,0.29549 -0.220013,0.60583 -0.367768,0.94004 -0.653566,1.48005 -3.662064,7.68288 -4.631787,9.24165 -0.969706,1.55941 -0.709695,4.29758 -0.709695,4.29758 l 3.114956,-1.35361 c 0,0 -0.624542,-1.87684 0.136068,-2.1633 0.760026,-0.28711 1.413592,-0.33227 2.067176,-2.35105 0.486463,-1.50264 1.528445,-4.2634 2.314916,-5.68087 -0.566457,-1.8091 -1.391663,-2.59945 -1.923939,-2.93044",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.591882,138.21726 c 0,0 -1.632965,3.97436 0.980697,6.09767 2.613644,2.12394 10.12748,2.39493 12.250784,2.09556 2.123304,-0.29873 1.743941,-4.04596 1.742003,-5.52602 -3.756928,-0.38066 -12.525006,-1.7762 -14.973484,-2.66721",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.546923,143.49812 c 0,0 -0.925849,5.6086 -1.251663,8.00417 -0.327112,2.39559 -1.128433,7.87449 -1.128433,7.87449 0,0 3.207223,6.6e-4 6.16217,-0.54646 -0.02524,-0.39292 0.410985,-1.51877 -0.678091,-2.02782 -1.089076,-0.50841 -2.551718,-1.17875 -2.364606,-2.9672 0.186454,-1.78846 1.329719,-10.33718 1.329719,-10.33718 h -2.069096",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 54.291116,138.21726 c -0.584526,-0.70324 -1.407154,0.871 -3.571095,0.62584 -0.534214,-0.0607 -1.143266,-0.12381 -1.763949,-0.20388 -0.319998,1.17553 -0.757447,2.69042 -1.115522,3.58013 -0.507768,1.262 -5.233743,0.70907 -5.233743,-0.93486 0,-1.38845 0.660023,-4.055 1.000028,-5.33699 -0.460016,-0.50841 -1.125836,-0.32001 -1.258758,-0.0207 -0.239363,0.54197 -0.487761,1.72587 -0.612271,2.29041 -0.27808,1.25942 -1.242628,4.20921 1.388445,5.32215 2.246533,0.94972 4.655654,1.26586 5.472465,0.28582 0.816154,-0.98004 1.24197,-3.44337 1.24197,-3.44337 l 4.45243,0.35808 c 0,0 0.402608,-2.03686 0,-2.52268",
    style: {
      fill: "#6c5353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 47.84055,142.21935 c 0.358075,-0.88971 0.795524,-2.4046 1.115522,-3.58013 -1.158756,-0.14905 -2.362027,-0.35871 -3.218178,-0.73552 -1.020694,-0.44904 -1.680717,-1.29166 -2.001373,-1.79683 -0.03932,-0.0633 -0.08449,-0.11028 -0.129667,-0.15929 -0.340006,1.28198 -1.000047,3.94853 -1.000047,5.33698 0,1.64392 4.725993,2.19686 5.233762,0.93486",
    style: {
      fill: "#483737",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.01273,136.94173 c 0,0 -0.04444,1.08198 0.47291,1.31425 0.774236,0.34712 1.471037,-0.80068 1.471037,-0.80068 l -1.943947,-0.51357",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7.8493355,140.76318 c 0,0 0.1212543,0.21742 0.7103528,1.59295 0.2690457,0.62906 0.9310065,2.78335 0.9310065,2.78335 l 0.9787402,-0.1026 c 0,0 -0.271624,-1.1607 -1.0006862,-2.99883 -0.21226,-0.53615 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67876",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9.7029538,142.75486 c -0.410326,0 -0.7445344,0.33421 -0.7445344,0.74456 0,0.41032 0.3342084,0.74453 0.7445344,0.74453 0.4103452,0 0.7445532,-0.33421 0.7445532,-0.74453 0,-0.41035 -0.334208,-0.74456 -0.7445532,-0.74456 z m 0,1.88782 c -0.6303395,0 -1.1432655,-0.51292 -1.1432655,-1.14326 0,-0.63036 0.512926,-1.14329 1.1432655,-1.14329 0.6303582,0 1.1432662,0.51293 1.1432662,1.14329 0,0.63034 -0.512908,1.14326 -1.1432662,1.14326",
    style: {
      fill: "#f4ab94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.133288,142.89229 c 0,0 3.696282,-1.88523 5.364727,-4.25371 1.25682,-1.78394 3.194969,-6.55381 3.194969,-6.55381 l 0.847775,-0.0613 c 0,0 -1.429082,4.2705 -3.656925,7.45256 -1.660709,2.37364 -5.4473,4.14014 -5.4473,4.14014 l -0.303246,-0.7239",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.307507,143.93363 c 0,0 10.446197,-4.20727 14.56248,-5.61185 6.002821,-2.04846 7.514495,-2.37428 8.697758,-2.13877 0,0 0.780033,-0.10516 0.638734,-0.23551 -1.251023,-1.16197 -7.288665,0.8781 -10.433304,2.10332 -1.336175,0.52066 -13.349553,5.26148 -13.349553,5.26148 l -0.116134,0.62133",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.211071,127.43106 c 1.174887,0.31162 2.494291,1.00648 2.494291,1.00648 l 0.822609,-1.76458 -1.41553,-1.24069 c 0,0 -2.045888,1.28844 -1.90137,1.99879",
    style: {
      fill: "#ee9d8f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.834361,125.85099 c -0.238723,1.50264 -1.501341,2.03749 -2.16396,2.22266 -0.386459,0.10845 -0.800022,-0.26517 -1.092295,-0.87873 -0.324533,-0.68067 -0.641953,-1.62975 -0.265808,-2.84979 0.448403,-1.45361 0.919375,-1.69749 2.000074,-1.52587 1.079383,0.17228 1.761352,1.52975 1.521989,3.03173",
    style: {
      fill: "#f9b2a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.44729,125.72582 c 0,0 -0.346462,1.1123 -0.256134,1.60136 0.08907,0.4884 0.622604,0.76518 0.622604,0.76518 l 0.714211,-2.15041 -1.080681,-0.21613",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.605971,125.21613 c -0.06072,-0.27227 -0.27744,-0.57163 -0.489059,-0.53809 -0.211619,0.0342 -0.526478,0.49292 -0.526478,0.49292 0,0 -0.486462,-0.23419 -0.954215,-0.68195 -0.469051,-0.44713 -1.331676,0.0128 -1.357481,-0.35744 -0.0406,-0.57615 -0.66518,-1.52523 1.744581,-1.99686 1.100689,-0.21549 2.261384,0.16131 2.56527,0.9452 0.593561,1.52975 0.101868,2.35236 0.250976,2.96528 -0.822609,0.22582 -1.171668,-0.55744 -1.233594,-0.82906",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.726426,124.18834 0.0018,0.3826 c 0,0 1.571661,0.18197 2.907196,-0.0819 0.782612,-0.15418 1.445231,-0.0146 2.245912,0.26388 0.801303,0.27743 1.319405,0.12327 1.319405,0.12327 0,0 -0.08193,-2.07299 -0.898105,-2.80205 -0.817423,-0.72971 -2.756852,-0.42324 -3.431067,-0.0962 -0.839398,0.40646 -1.100689,2.17169 -1.100689,2.17169 l -1.045201,0.0388",
    style: {
      fill: "#800000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.036871,123.71801 c 0,0 -0.163319,1.43038 0,2.25814 0.163135,0.82713 1.365858,0.95876 1.976848,0.15546 0.326472,-0.42906 0.800041,-1.52005 0.800041,-1.52005 l -0.633577,-0.26519 c 0,0 -0.16972,0.90392 -0.712932,1.42201 -0.662601,0.63098 -1.044561,0.007 -1.000046,-0.84972 0.03219,-0.62132 0.05944,-1.04198 0.05944,-1.04198 l -0.489701,-0.15875",
    style: {
      fill: "#550000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.322047,126.0981 c 0,0 0.02067,0.6781 0,1.08648 -0.01993,0.40777 -0.111012,0.69423 -0.111012,0.69423 l 0.578088,-0.33098 c 0,0 0.346462,-1.01423 0.166428,-1.28262 -0.09163,-0.13552 -0.633577,-0.16716 -0.633577,-0.16716",
    style: {
      fill: "#550000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.080646,129.71307 c 0,0 1.686515,0.45486 2.678807,1.47296 1.265855,1.29941 0.985196,3.04206 0,4.49243 -1.471018,2.1646 -5.227306,4.14274 -5.227306,4.14274 l -3.022049,1.38587 c 0,0 -1.452949,-1.22522 -0.898105,-2.59108 0.321315,-0.79228 2.902057,-3.34658 4.818259,-5.87829 0.70002,-0.92391 1.650394,-3.02463 1.650394,-3.02463",
    style: {
      fill: "#ffd5f6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.201517,126.08583 -0.310981,0.58713 c 0,0 0.800662,3.08399 1.127775,3.98209 0.326472,0.89873 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.17942 2.777529,0.68971 0.898105,0.51033 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.44394 1.93877,-2.4472 1.740064,-1.07035 2.504625,-2.62526 2.504625,-2.62526 0,0 -3.269167,-0.9452 -4.249846,-1.27553 -0.979398,-0.32905 -2.647203,-1.10842 -4.345331,-1.93685 -1.698127,-0.82712 -3.413026,-0.41486 -3.413026,-0.41486",
    style: {
      fill: "#5599ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.038763,135.94105 c 0,0 -1.633605,-0.24516 -2.1646,0 -0.530977,0.24518 -0.203865,0.69422 0,1.10262 0.204523,0.40841 0.612929,0.83553 1.06199,0.98908 0.449044,0.15417 1.891037,-0.72649 1.891037,-0.72649 l -0.788427,-1.36521",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.760313,131.77121 c -0.01097,-0.88583 -0.410984,-3.79174 -0.682609,-4.30145 -0.488401,-0.91488 -1.500042,-1.18456 -2.187168,-0.7968 -0.687126,0.38775 -0.467113,2.02975 -0.193568,3.4111 0.08523,0.4284 0.48648,2.60461 0.663259,3.08205 l -4.713081,2.85301 c -0.134788,0.81551 0.217417,1.37877 0.773577,1.72587 0.432913,-0.1549 1.780702,-0.6568 2.905276,-1.30133 1.180684,-0.67681 2.300083,-1.28071 2.998823,-1.67748 0.347742,-0.19743 0.457438,-1.17037 0.435491,-2.99497",
    style: {
      fill: "#0066ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.108835,141.35481 c 0,0 1.974269,6.04345 2.940756,7.15706 1.136809,1.31036 0.449701,-0.1059 0.449701,-0.1059 0,0 -1.947183,-3.43045 -2.615582,-6.64929 -0.142652,-0.1646 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#916f6f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.057149,139.8212 c 0,0 1.97555,2.29105 3.255597,3.87177 0.882614,1.09101 2.410419,3.47884 2.560094,3.70787 0.352918,0.53745 0.06383,1.37361 -0.361934,1.99686 -0.425835,0.6239 -0.896167,1.13295 -1.118119,1.56652 -0.220654,0.43419 0.130399,0.92197 0.130399,0.92197 0,0 1.508455,-0.39293 2.243955,-1.16715 0.734878,-0.77487 1.279407,-1.59748 1.439415,-1.5265 0.160575,0.0717 1.183281,-0.94456 1.183281,-0.94456 0,0 -0.736158,-1.23875 -1.317484,-2.02912 -0.581307,-0.79099 -2.120067,-3.78853 -2.723321,-5.01179 -0.603894,-1.22392 -0.625841,-1.78266 -2.088464,-2.27364 -0.591001,-0.19872 -0.525179,0.47485 -1.423925,0.47485 -1.080041,0 -1.779439,0.41292 -1.779439,0.41292",
    style: {
      fill: "#553133",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.20638,147.72474 -0.686486,0.57227 c 0,0 0.687126,0.74649 1.155519,1.30651 0.423256,0.50581 0.980057,1.39876 0.980057,1.39876 l 1.021956,-0.88325 c 0,0 -0.860028,-2.02139 -2.471046,-2.39429",
    style: {
      fill: "#6c5353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.44729,125.72582 c 0,0 1.041964,-1.01036 2.226526,-0.80712 1.184561,0.20322 1.989119,0.97164 2.383333,1.1794 0.393556,0.20775 1.047122,-0.11485 1.047122,-0.11485 0,0 -0.544529,1.07487 -1.497464,1.00519 -0.952953,-0.0697 -1.789754,-0.94778 -2.783344,-0.89035 -1.374234,0.0794 -1.376173,-0.37227 -1.376173,-0.37227",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer7",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5729",
    transform: "matrix(1.8112516,0,0,1.8112516,-15.73451,-315.04073)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4306-0-3-0-4-8",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,109.54101,175.29268)",
    style: {
      display: "inline",
      fill: "#666666",
      fillOpacity: 0.876992,
      filter: "url(#filter1510-3-2-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 71.092807,26.707917 c 0.662619,-0.268406 7.458348,-4.020158 12.034008,0 4.575019,4.020138 6.738979,6.587987 10.202976,6.298293 2.567848,-0.214837 3.216897,-2.158784 3.216897,-2.158784 0,0 0.649067,5.9028 -2.827201,7.388668 -7.132535,3.049154 -9.494562,-2.416216 -11.508188,-4.693731 -2.013627,-2.278155 -6.074422,-6.47767 -10.053283,-5.543444 -2.218789,0.52068 -1.065209,-1.291002 -1.065209,-1.291002",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-30-6-3-9-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,14.577765 c 0,0 3.701421,-1.119398 7.512538,-0.160027 3.811117,0.958751 7.991923,2.993026 10.25007,4.24403 3.021409,1.674261 4.39952,3.131087 4.39952,3.131087 0,0 -9.62165,-0.795505 -12.281107,-1.41617 -6.533798,-1.524586 -9.881021,-5.798938 -9.881021,-5.798938",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-4-7-6-5-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.030657,11.964122 c 0,0 0.255493,3.103982 0.827126,4.3292 0.571633,1.225199 1.878144,0 1.878144,0 0,0 -0.83746,-3.185295 -2.70527,-4.3292",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-44-5-1-0-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.830904,35.077904 c 0,0 1.027132,2.722681 3.291095,1.960077 2.263304,-0.761964 2.916249,-2.776889 4.223381,-1.224559 1.306511,1.551031 4.247267,6.846718 5.335703,7.13963 1.089076,0.292273 1.361341,-0.435509 1.905869,-0.469691 0.544548,-0.03475 2.558814,3.431735 2.558814,3.431735 0,0 -2.123304,1.522648 -5.227305,-0.111012 -2.929142,-1.541338 -5.934421,-5.662157 -5.934421,-5.662157 0,0 -6.370571,1.073586 -6.806702,0.781972 -0.43487,-0.292273 0.653566,-5.846032 0.653566,-5.846032",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-4-3-0-4-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.974429,33.934638 c 0,0 -9.96749,1.419407 -11.493996,1.652973 -0.418721,0.06383 -0.841977,0.405809 -1.263916,0.900025 0.370328,0.874879 0.825187,2.042669 1.140686,3.17626 0.200646,-0.257432 0.403231,-0.467771 0.607113,-0.592939 0.418081,-0.257414 4.753737,1.549751 10.307496,0.335507 1.396839,-0.305184 0.702617,-5.471826 0.702617,-5.471826",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-7-5-6-8-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.957683,41.587835 c -1.249724,1.697487 -2.245253,2.669131 -3.3891773,4.629849 -1.1426071,1.960077 -1.1426071,3.389817 -1.1426071,3.389817 l 3.2543164,-0.945838 c 0,0 0.17612,-1.57168 0.829065,-2.117507 0.652926,-0.546468 1.714898,-0.408406 2.450416,-1.86653 0.326454,-0.648409 1.312309,-3.618189 2.397507,-5.01373 -0.315499,-1.133591 -0.770358,-2.301381 -1.140686,-3.17626 -1.118119,1.305853 -2.234281,3.710474 -3.258834,5.100199",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-6-6-3-7-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.408427,29.259616 C 71.468951,24.126516 65.678408,24.635565 60.778215,24.853 46.417679,25.489155 41.765883,22.275476 37.950889,21.082539 c -2.343958,-0.73294 -9.873285,-4.420827 -12.496603,-5.050527 -5.261487,-1.263276 -9.953938,0.445185 -9.953938,0.445185 0,0 -5.123407,6.096368 -6.0924905,7.058977 -0.9690654,0.963268 -2.6304143,2.463968 -3.0465563,2.752364 -0.4148617,0.287755 -0.4916378,1.122617 0,1.846522 0.4735686,0.696161 1.523269,0.855511 1.523269,0.855511 0,0 -0.061999,0.900683 0.4916379,1.007142 0.5542219,0.105892 1.4207057,-0.201944 1.5929673,-1.25682 1.1000496,0.05102 4.9479266,-1.004564 6.3292746,-1.755555 1.761352,-0.956171 2.075571,-2.287829 2.075571,-2.287829 l 0.75099,-1.69233 c 0,0 4.246608,0.638734 6.424761,4.068549 2.178152,3.430455 5.117609,8.716467 5.117609,8.716467 l -2.318152,0.958751 c 0.314859,0.59228 0.581325,1.072287 0.772937,1.372954 1.163273,1.260039 2.484616,2.251051 3.914338,3.02011 l 2.504624,-2.003293 c 0,0 4.22854,0.754867 8.373225,0.691625 8.20612,-0.125827 10.73911,-1.947165 13.106953,-1.730389 2.939457,0.269046 5.069876,2.452355 5.071156,2.453654 1.249724,0.112293 2.694955,0.227749 4.402758,0.227749 0.787769,0 3.05559,0.03804 5.227287,-1.817498 2.171056,-1.855557 4.645997,-7.273175 2.68592,-9.704242",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-3-2-2-1-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.914353,39.830342 c -4.144685,0.06328 -8.373225,-0.691625 -8.373225,-0.691625 l -2.504624,2.003293 c 0.661321,0.355497 1.34329,0.668417 2.047187,0.931007 3.584647,0.920673 6.450565,0.879377 8.830662,0.879377 6.573155,6.58e-4 10.991385,-1.811024 13.495351,-2.440083 1.223919,-0.307105 2.70591,-0.1368 4.682758,0.04133 -0.0013,-0.0013 -2.131699,-2.184608 -5.071156,-2.453635 -2.367843,-0.216795 -4.900833,1.604562 -13.106953,1.730389",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-1-9-0-7-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.549772,27.073728 c -2.178153,-3.429815 -6.424761,-4.068549 -6.424761,-4.068549 l -0.75099,1.69233 c 0,0 3.080756,0.763262 4.742105,2.498168 0.974241,1.016799 3.692405,6.655089 5.233103,9.553269 l 2.318152,-0.958751 c 0,0 -2.939457,-5.286012 -5.117609,-8.716467",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-7-1-6-2-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.000736,38.276732 c -1.416828,0.285176 -2.658798,0.146493 -2.449118,-1.635544 0.199366,-1.686514 -13.590196,1.727811 -13.590196,1.727811 0,0 2.178152,2.227824 4.465323,4.584053 2.285891,2.356212 4.67632,2.799458 8.384838,1.925878 1.169729,-0.275502 2.747206,-0.981977 3.536273,-1.365858 0.656145,-2.779468 0.202585,-4.296939 -0.34712,-5.23634",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-5-2-1-7-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.256426,49.01522 c 1.791692,1.634904 5.330526,1.526506 5.330526,1.526506 0,0 0,-2.831718 -1.143265,-4.127896 -0.487121,-0.551643 -1.960077,0.87294 -2.613644,0 -0.653584,-0.872299 -1.960077,-6.550587 -2.613661,-8.044831 -0.653567,-1.494245 -1.392944,-0.905842 -2.831079,-0.459377 -0.451622,0.13936 -1.805866,0.386478 -2.263304,0.478744 0.57487,1.263258 0.878737,3.223336 0.734878,5.373744 0.7697,-0.374846 2.344598,-1.749099 2.344598,-1.749099 0,0 0.90778,5.040834 3.054951,7.002209",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-9-7-5-2-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.506117,16.148786 3.221415,4.182744 0.376145,-0.750991 -2.858164,-3.859508 -0.739396,0.427755",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-6-0-5-2-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.996994,16.460426 c 0,0 0.894868,1.900712 2.869795,1.582634 1.350368,-0.217435 2.869138,-1.749738 2.869138,-1.749738 l -0.522601,-1.449749 c 0,0 -3.209161,0.723265 -5.216332,1.616853",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-2-9-4-6-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.653947,11.326668 c 0,0 -0.19355,3.916935 0.567115,6.075079 0.760043,2.158144 2.883348,0 2.883348,0 0,0 -1.511034,-4.507917 -3.450463,-6.075079",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-1-3-7-1-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.151311,34.465633 c 0,0 -7.22802,3.471093 -11.148156,4.858897 -2.414296,0.855511 -2.876252,1.674901 -3.26529,2.688481 0.532276,0.33099 1.357464,1.121338 1.923939,2.930441 0.270326,-0.48712 0.510987,-0.818091 0.687766,-0.881334 1.403277,-0.501312 7.273193,-0.201286 11.643031,-2.048467 0.714212,-0.301288 2.976236,-1.496183 5.263426,-3.931749 1.50006,-1.597485 -5.104716,-3.616269 -5.104716,-3.616269",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-7-6-6-0-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,42.013011 c -0.112841,0.295492 -0.220013,0.605833 -0.367768,0.940041 -0.653566,1.480053 -3.662064,7.68288 -4.631787,9.241647 -0.969706,1.559408 -0.709695,4.297579 -0.709695,4.297579 l 3.114956,-1.353604 c 0,0 -0.624542,-1.876845 0.136068,-2.163302 0.760026,-0.287115 1.413592,-0.33227 2.067176,-2.351054 0.486463,-1.502639 1.528445,-4.263397 2.314916,-5.680866 -0.566457,-1.809103 -1.391663,-2.599451 -1.923939,-2.930441",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-8-0-5-6-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.339408,21.792873 c 0,0 -1.632965,3.974362 0.980697,6.097667 2.613644,2.123944 10.12748,2.394928 12.250784,2.09556 2.123304,-0.298729 1.743941,-4.045963 1.742003,-5.526016 -3.756928,-0.380661 -12.525006,-1.776202 -14.973484,-2.667211",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-5-6-6-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 46.294449,27.073728 c 0,0 -0.925849,5.608607 -1.251663,8.004176 -0.327112,2.395587 -1.128433,7.87449 -1.128433,7.87449 0,0 3.207223,6.58e-4 6.16217,-0.546467 -0.02524,-0.392916 0.410985,-1.51877 -0.678091,-2.027819 -1.089076,-0.508409 -2.551718,-1.178746 -2.364606,-2.967201 0.186454,-1.788456 1.329719,-10.337179 1.329719,-10.337179 h -2.069096",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-7-2-9-5-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.038642,21.792873 c -0.584526,-0.703238 -1.407154,0.871001 -3.571095,0.625841 -0.534214,-0.06072 -1.143266,-0.123815 -1.763949,-0.203883 -0.319998,1.175527 -0.757447,2.69042 -1.115522,3.58013 -0.507768,1.261996 -5.233743,0.709073 -5.233743,-0.934865 0,-1.388445 0.660023,-4.054998 1.000028,-5.336983 -0.460016,-0.508409 -1.125836,-0.320017 -1.258758,-0.02067 -0.239363,0.541968 -0.487761,1.725871 -0.612271,2.290408 -0.27808,1.259417 -1.242628,4.209208 1.388445,5.322151 2.246533,0.949715 4.655654,1.265855 5.472465,0.285816 0.816154,-0.980039 1.24197,-3.443367 1.24197,-3.443367 l 4.45243,0.358075 c 0,0 0.402608,-2.036853 0,-2.522675",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-4-6-3-9-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.588076,25.794961 c 0.358075,-0.88971 0.795524,-2.404603 1.115522,-3.58013 -1.158756,-0.149053 -2.362027,-0.358715 -3.218178,-0.735518 -1.020694,-0.449044 -1.680717,-1.291661 -2.001373,-1.796832 -0.03932,-0.06328 -0.08449,-0.110281 -0.129667,-0.159295 -0.340006,1.281986 -1.000047,3.948538 -1.000047,5.336983 0,1.64392 4.725993,2.196861 5.233762,0.934865",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-1-1-7-4-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.760256,20.517343 c 0,0 -0.04444,1.08198 0.47291,1.314247 0.774236,0.347121 1.471037,-0.800681 1.471037,-0.800681 l -1.943947,-0.513566",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-8-8-4-9-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.5968617,24.338793 c 0,0 0.1212543,0.217417 0.7103528,1.59295 0.2690457,0.629059 0.9310065,2.783344 0.9310065,2.783344 l 0.97874,-0.1026 c 0,0 -0.271624,-1.160694 -1.000686,-2.998822 -0.21226,-0.536153 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67875",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-5-7-5-0-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.45048,26.330474 c -0.410326,0 -0.7445344,0.334208 -0.7445344,0.744552 0,0.410327 0.3342084,0.744535 0.7445344,0.744535 0.410345,0 0.744553,-0.334208 0.744553,-0.744535 0,-0.410344 -0.334208,-0.744552 -0.744553,-0.744552 z m 0,1.887818 c -0.6303395,0 -1.1432655,-0.512926 -1.1432655,-1.143266 0,-0.630358 0.512926,-1.143283 1.1432655,-1.143283 0.630358,0 1.143266,0.512925 1.143266,1.143283 0,0.63034 -0.512908,1.143266 -1.143266,1.143266",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-9-9-2-9-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.880814,26.467895 c 0,0 3.696282,-1.885221 5.364727,-4.253704 1.25682,-1.783939 3.194969,-6.553806 3.194969,-6.553806 l 0.847775,-0.06127 c 0,0 -1.429082,4.270493 -3.656925,7.452551 -1.660709,2.37364 -5.4473,4.140149 -5.4473,4.140149 L 10.880814,26.46791",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-7-2-5-1-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.055033,27.509238 c 0,0 10.446197,-4.20727 14.56248,-5.611845 6.002821,-2.048466 7.514495,-2.37428 8.697758,-2.138776 0,0 0.780033,-0.10516 0.638734,-0.235504 -1.251023,-1.161975 -7.288665,0.878097 -10.433304,2.103314 -1.336175,0.520662 -13.349553,5.261487 -13.349553,5.261487 l -0.116134,0.621324",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-5-0-4-7-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.958597,11.00667 c 1.174887,0.311622 2.494291,1.006484 2.494291,1.006484 l 0.822609,-1.764589 -1.41553,-1.2406896 c 0,0 -2.045888,1.2884416 -1.90137,1.9987946",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-3-2-7-7-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.581887,9.426596 c -0.238723,1.502639 -1.501341,2.037493 -2.16396,2.222667 -0.386459,0.108452 -0.800022,-0.265169 -1.092295,-0.878737 -0.324533,-0.680671 -0.641953,-1.6297464 -0.265808,-2.8497881 0.448403,-1.4536072 0.919375,-1.6974875 2.000074,-1.525866 1.079383,0.17228 1.761352,1.5297432 1.521989,3.0317241",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-8-3-4-1-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 -0.346462,1.1123031 -0.256134,1.6013621 0.08907,0.488401 0.622604,0.765182 0.622604,0.765182 L 40.275497,9.5175642 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-8-7-4-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.353497,8.791739 c -0.06072,-0.2722644 -0.27744,-0.5716327 -0.489059,-0.5380912 -0.211619,0.0342 -0.526478,0.4929181 -0.526478,0.4929181 0,0 -0.486462,-0.2341873 -0.954215,-0.6819505 -0.469051,-0.447123 -1.331676,0.012802 -1.357481,-0.3574351 -0.0406,-0.5761501 -0.66518,-1.5252258 1.744581,-1.9968558 1.100689,-0.2154962 2.261384,0.1613067 2.56527,0.9451985 0.593561,1.5297432 0.101868,2.3523524 0.250976,2.9652811 C 38.764482,9.8466152 38.415423,9.0633634 38.353497,8.791739",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-3-5-3-5-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.473952,7.7639486 0.0018,0.3826004 c 0,0 1.571661,0.1819729 2.907196,-0.081934 0.782612,-0.154174 1.445231,-0.014631 2.245912,0.2638882 0.801303,0.2774219 1.319405,0.1232661 1.319405,0.1232661 0,0 -0.08193,-2.0729918 -0.898105,-2.8020541 C 38.232737,4.9200133 36.293308,5.2264776 35.619093,5.5535169 34.779695,5.959984 34.518404,7.725213 34.518404,7.725213 l -1.045201,0.038772",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-1-9-0-9-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.784397,7.2936171 c 0,0 -0.163319,1.4303805 0,2.258147 0.163135,0.8271269 1.365858,0.9587509 1.976848,0.1554543 0.326472,-0.4290538 0.800041,-1.5200502 0.800041,-1.5200502 L 38.927709,7.9219815 c 0,0 -0.16972,0.9039209 -0.712932,1.4220043 -0.662601,0.6309797 -1.044561,0.00732 -1.000046,-0.8497131 0.03219,-0.6213233 0.05944,-1.0419825 0.05944,-1.0419825 L 36.78447,7.2935439",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-8-2-7-7-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.069573,9.6737134 c 0,0 0.02067,0.6780916 0,1.0864786 -0.01993,0.407766 -0.111012,0.694223 -0.111012,0.694223 l 0.578088,-0.330972 c 0,0 0.346462,-1.014238 0.166428,-1.2826254 C 37.61145,9.7052981 37.0695,9.6736586 37.0695,9.6736586",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-9-2-8-7-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.828172,13.288684 c 0,0 1.686515,0.454859 2.678807,1.472956 1.265855,1.299415 0.985196,3.042057 0,4.492427 -1.471018,2.1646 -5.227306,4.142747 -5.227306,4.142747 l -3.022049,1.385865 c 0,0 -1.452949,-1.225217 -0.898105,-2.591075 0.321315,-0.792286 2.902057,-3.346583 4.818259,-5.878293 0.70002,-0.92391 1.650394,-3.024627 1.650394,-3.024627",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-6-8-6-6-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.949043,9.6614417 -0.310981,0.5871233 c 0,0 0.800662,3.083993 1.127775,3.982098 0.326472,0.898727 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.179413 2.777529,0.689705 0.898105,0.510329 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.443933 1.93877,-2.447198 1.740064,-1.070348 2.504625,-2.625256 2.504625,-2.625256 0,0 -3.269167,-0.945199 -4.249846,-1.27553 C 46.728002,11.684103 45.060197,10.904728 43.362069,10.076303 41.663942,9.249177 39.949043,9.6614417 39.949043,9.6614417",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-43-9-8-7-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.786289,19.516657 c 0,0 -1.633605,-0.245161 -2.1646,0 -0.530977,0.245179 -0.203865,0.694222 0,1.102628 0.204523,0.408406 0.612929,0.835521 1.06199,0.989073 0.449044,0.154174 1.891037,-0.726483 1.891037,-0.726483 l -0.788427,-1.365218",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-3-7-8-3-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.507839,15.346825 c -0.01097,-0.885834 -0.410984,-3.791749 -0.682609,-4.301456 -0.488401,-0.914876 -1.500042,-1.1845618 -2.187168,-0.796804 -0.687126,0.387758 -0.467113,2.029757 -0.193568,3.411106 0.08523,0.428395 0.48648,2.604608 0.663259,3.082054 l -4.713081,2.853006 c -0.134788,0.815514 0.217417,1.37877 0.773577,1.725872 0.432913,-0.154906 1.780702,-0.656803 2.905276,-1.301335 1.180684,-0.676811 2.300083,-1.280705 2.998823,-1.67748 0.347742,-0.197427 0.457438,-1.170369 0.435491,-2.994963",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-38-3-4-6-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.856361,24.930416 c 0,0 1.974269,6.043458 2.940756,7.15706 1.136809,1.310369 0.449701,-0.105892 0.449701,-0.105892 0,0 -1.947183,-3.430455 -2.615582,-6.649291 -0.142652,-0.164599 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-6-6-3-5-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.804675,23.396814 c 0,0 1.97555,2.291048 3.255597,3.871762 0.882614,1.091015 2.410419,3.478847 2.560094,3.707877 0.352918,0.537451 0.06383,1.373612 -0.361934,1.996856 -0.425835,0.623902 -0.896167,1.132951 -1.118119,1.566522 -0.220654,0.434193 0.130399,0.921972 0.130399,0.921972 0,0 1.508455,-0.392934 2.243955,-1.167151 0.734878,-0.774876 1.279407,-1.597485 1.439415,-1.526506 0.160575,0.07169 1.183281,-0.944559 1.183281,-0.944559 0,0 -0.736158,-1.238751 -1.317484,-2.029117 -0.581307,-0.790988 -2.120067,-3.78853 -2.723321,-5.011791 -0.603894,-1.223918 -0.625841,-1.782658 -2.088464,-2.273637 -0.591001,-0.198726 -0.525179,0.474849 -1.423925,0.474849 -1.080041,0 -1.779439,0.412923 -1.779439,0.412923",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-0-1-1-6-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.953906,31.300347 48.26742,31.87262 c 0,0 0.687126,0.746491 1.155519,1.30651 0.423256,0.505812 0.980057,1.39876 0.980057,1.39876 l 1.021956,-0.883255 c 0,0 -0.860028,-2.021381 -2.471046,-2.394288",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-4-2-4-3-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 1.041964,-1.0103613 2.226526,-0.8071186 1.184561,0.2032245 1.989119,0.9716441 2.383333,1.1794041 0.393556,0.2077418 1.047122,-0.1148532 1.047122,-0.1148532 0,0 -0.544529,1.0748658 -1.497464,1.0051858 C 42.40138,10.494366 41.564579,9.6162685 40.570989,9.6736951 39.196755,9.7530683 39.194816,9.3014279 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.876992,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-8-9-9-9-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5230-0",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,76.408491,-0.14033987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 70.170555,207.54384 c 0.662619,-0.26841 7.458348,-4.02016 12.034008,0 4.575019,4.02013 6.738979,6.58798 10.202976,6.29829 2.567848,-0.21484 3.216897,-2.15878 3.216897,-2.15878 0,0 0.649067,5.9028 -2.827201,7.38866 -7.132535,3.04916 -9.494562,-2.41621 -11.508188,-4.69373 -2.013627,-2.27815 -6.074422,-6.47767 -10.053283,-5.54344 -2.218789,0.52068 -1.065209,-1.291 -1.065209,-1.291",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-31-8-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.815613,195.41369 c 0,0 3.701421,-1.1194 7.512538,-0.16003 3.811117,0.95875 7.991923,2.99302 10.25007,4.24403 3.021409,1.67426 4.39952,3.13108 4.39952,3.13108 0,0 -9.62165,-0.7955 -12.281107,-1.41617 -6.533798,-1.52458 -9.881021,-5.79893 -9.881021,-5.79893",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-9-4-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.108405,192.80004 c 0,0 0.255493,3.10398 0.827126,4.3292 0.571633,1.2252 1.878144,0 1.878144,0 0,0 -0.83746,-3.18529 -2.70527,-4.3292",
    style: {
      fill: "#3e4837",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-4-3-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 70.908652,215.91382 c 0,0 1.027132,2.72268 3.291095,1.96008 2.263304,-0.76196 2.916249,-2.77689 4.223381,-1.22456 1.306511,1.55103 4.247267,6.84672 5.335703,7.13963 1.089076,0.29227 1.361341,-0.43551 1.905869,-0.46969 0.544548,-0.0348 2.558814,3.43174 2.558814,3.43174 0,0 -2.123304,1.52264 -5.227305,-0.11102 -2.929142,-1.54133 -5.934421,-5.66215 -5.934421,-5.66215 0,0 -6.370571,1.07358 -6.806702,0.78197 -0.43487,-0.29227 0.653566,-5.84603 0.653566,-5.84603",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-7-1-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.052177,214.77056 c 0,0 -9.96749,1.4194 -11.493996,1.65297 -0.418721,0.0638 -0.841977,0.40581 -1.263916,0.90003 0.370328,0.87487 0.825187,2.04267 1.140686,3.17626 0.200646,-0.25744 0.403231,-0.46778 0.607113,-0.59294 0.418081,-0.25742 4.753737,1.54975 10.307496,0.3355 1.396839,-0.30518 0.702617,-5.47182 0.702617,-5.47182",
    style: {
      fill: "#3e4837",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-8-4-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.035431,222.42375 c -1.249724,1.69749 -2.2452533,2.66914 -3.3891776,4.62985 -1.1426071,1.96008 -1.1426071,3.38982 -1.1426071,3.38982 l 3.2543167,-0.94584 c 0,0 0.17612,-1.57168 0.829065,-2.1175 0.652926,-0.54647 1.714898,-0.40841 2.450416,-1.86653 0.326454,-0.64841 1.312309,-3.61819 2.397507,-5.01373 -0.315499,-1.13359 -0.770358,-2.30139 -1.140686,-3.17626 -1.118119,1.30585 -2.234281,3.71047 -3.258834,5.10019",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-4-9-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 73.486175,210.09554 c -2.939476,-5.1331 -8.730019,-4.62406 -13.630212,-4.40662 -14.360536,0.63615 -19.012332,-2.57752 -22.827326,-3.77046 -2.343958,-0.73294 -9.873285,-4.42083 -12.496603,-5.05053 -5.261487,-1.26327 -9.953938,0.44519 -9.953938,0.44519 0,0 -5.1234073,6.09636 -6.0924908,7.05897 -0.9690654,0.96327 -2.6304143,2.46397 -3.0465563,2.75237 -0.4148617,0.28775 -0.4916378,1.12261 0,1.84652 0.4735686,0.69616 1.523269,0.85551 1.523269,0.85551 0,0 -0.061999,0.90068 0.4916379,1.00714 0.5542219,0.10589 1.4207057,-0.20194 1.5929673,-1.25682 1.1000499,0.051 4.9479269,-1.00456 6.3292749,-1.75555 1.761352,-0.95617 2.075571,-2.28783 2.075571,-2.28783 l 0.75099,-1.69233 c 0,0 4.246608,0.63873 6.424761,4.06855 2.178152,3.43045 5.117609,8.71646 5.117609,8.71646 l -2.318152,0.95876 c 0.314859,0.59228 0.581325,1.07228 0.772937,1.37295 1.163273,1.26004 2.484616,2.25105 3.914338,3.02011 l 2.504624,-2.00329 c 0,0 4.22854,0.75486 8.373225,0.69162 8.20612,-0.12583 10.73911,-1.94716 13.106953,-1.73039 2.939457,0.26905 5.069876,2.45236 5.071156,2.45366 1.249724,0.11229 2.694955,0.22775 4.402758,0.22775 0.787769,0 3.05559,0.038 5.227287,-1.8175 2.171056,-1.85556 4.645997,-7.27318 2.68592,-9.70424",
    style: {
      fill: "#5d6c53",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-5-2-62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.992101,220.66626 c -4.144685,0.0633 -8.373225,-0.69162 -8.373225,-0.69162 l -2.504624,2.00329 c 0.661321,0.3555 1.34329,0.66842 2.047187,0.93101 3.584647,0.92067 6.450565,0.87937 8.830662,0.87937 6.573155,6.6e-4 10.991385,-1.81102 13.495351,-2.44008 1.223919,-0.3071 2.70591,-0.1368 4.682758,0.0413 -0.0013,-0.001 -2.131699,-2.18461 -5.071156,-2.45363 -2.367843,-0.2168 -4.900833,1.60456 -13.106953,1.73038",
    style: {
      fill: "#3e4837",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-0-0-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.62752,207.90965 c -2.178153,-3.42982 -6.424761,-4.06855 -6.424761,-4.06855 l -0.75099,1.69233 c 0,0 3.080756,0.76326 4.742105,2.49817 0.974241,1.0168 3.692405,6.65509 5.233103,9.55327 l 2.318152,-0.95876 c 0,0 -2.939457,-5.28601 -5.117609,-8.71646",
    style: {
      fill: "#3e4837",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-3-6-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 75.078484,219.11265 c -1.416828,0.28518 -2.658798,0.1465 -2.449118,-1.63554 0.199366,-1.68652 -13.590196,1.72781 -13.590196,1.72781 0,0 2.178152,2.22782 4.465323,4.58405 2.285891,2.35621 4.67632,2.79946 8.384838,1.92588 1.169729,-0.2755 2.747206,-0.98198 3.536273,-1.36586 0.656145,-2.77947 0.202585,-4.29694 -0.34712,-5.23634",
    style: {
      fill: "#5d6c53",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-6-8-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 80.334174,229.85114 c 1.791692,1.6349 5.330526,1.52651 5.330526,1.52651 0,0 0,-2.83172 -1.143265,-4.1279 -0.487121,-0.55164 -1.960077,0.87294 -2.613644,0 -0.653584,-0.8723 -1.960077,-6.55059 -2.613661,-8.04483 -0.653567,-1.49425 -1.392944,-0.90584 -2.831079,-0.45938 -0.451622,0.13936 -1.805866,0.38648 -2.263304,0.47875 0.57487,1.26325 0.878737,3.22333 0.734878,5.37374 0.7697,-0.37485 2.344598,-1.7491 2.344598,-1.7491 0,0 0.90778,5.04083 3.054951,7.00221",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-1-9-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13.583865,196.98471 3.221415,4.18274 0.376145,-0.75099 -2.858164,-3.85951 -0.739396,0.42776",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-0-2-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.074742,197.29635 c 0,0 0.894868,1.90071 2.869795,1.58263 1.350368,-0.21744 2.869138,-1.74974 2.869138,-1.74974 l -0.522601,-1.44975 c 0,0 -3.209161,0.72327 -5.216332,1.61686",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-6-6-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.731695,192.16259 c 0,0 -0.19355,3.91693 0.567115,6.07508 0.760043,2.15814 2.883348,0 2.883348,0 0,0 -1.511034,-4.50792 -3.450463,-6.07508",
    style: {
      fill: "#5d6c53",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-3-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.229059,215.30155 c 0,0 -7.22802,3.4711 -11.148156,4.8589 -2.414296,0.85551 -2.876252,1.6749 -3.26529,2.68848 0.532276,0.33099 1.357464,1.12134 1.923939,2.93044 0.270326,-0.48712 0.510987,-0.81809 0.687766,-0.88133 1.403277,-0.50131 7.273193,-0.20129 11.643031,-2.04847 0.714212,-0.30129 2.976236,-1.49618 5.263426,-3.93175 1.50006,-1.59748 -5.104716,-3.61627 -5.104716,-3.61627",
    style: {
      fill: "#5d6c53",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-2-4-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.815613,222.84893 c -0.112841,0.29549 -0.220013,0.60583 -0.367768,0.94004 -0.653566,1.48005 -3.662064,7.68288 -4.631787,9.24165 -0.969706,1.55941 -0.709695,4.29758 -0.709695,4.29758 l 3.114956,-1.35361 c 0,0 -0.624542,-1.87684 0.136068,-2.1633 0.760026,-0.28711 1.413592,-0.33227 2.067176,-2.35105 0.486463,-1.50264 1.528445,-4.2634 2.314916,-5.68087 -0.566457,-1.8091 -1.391663,-2.59945 -1.923939,-2.93044",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-0-9-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.417156,202.62879 c 0,0 -1.632965,3.97436 0.980697,6.09767 2.613644,2.12394 10.12748,2.39493 12.250784,2.09556 2.123304,-0.29873 1.743941,-4.04596 1.742003,-5.52602 -3.756928,-0.38066 -12.525006,-1.7762 -14.973484,-2.66721",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-6-5-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.372197,207.90965 c 0,0 -0.925849,5.6086 -1.251663,8.00417 -0.327112,2.39559 -1.128433,7.87449 -1.128433,7.87449 0,0 3.207223,6.6e-4 6.16217,-0.54646 -0.02524,-0.39292 0.410985,-1.51877 -0.678091,-2.02782 -1.089076,-0.50841 -2.551718,-1.17875 -2.364606,-2.9672 0.186454,-1.78846 1.329719,-10.33718 1.329719,-10.33718 h -2.069096",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-1-0-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 54.11639,202.62879 c -0.584526,-0.70324 -1.407154,0.871 -3.571095,0.62584 -0.534214,-0.0607 -1.143266,-0.12381 -1.763949,-0.20388 -0.319998,1.17553 -0.757447,2.69042 -1.115522,3.58013 -0.507768,1.262 -5.233743,0.70907 -5.233743,-0.93486 0,-1.38845 0.660023,-4.055 1.000028,-5.33699 -0.460016,-0.50841 -1.125836,-0.32001 -1.258758,-0.0207 -0.239363,0.54197 -0.487761,1.72587 -0.612271,2.29041 -0.27808,1.25942 -1.242628,4.20921 1.388445,5.32215 2.246533,0.94972 4.655654,1.26586 5.472465,0.28582 0.816154,-0.98004 1.24197,-3.44337 1.24197,-3.44337 l 4.45243,0.35808 c 0,0 0.402608,-2.03686 0,-2.52268",
    style: {
      fill: "#6c5353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-5-4-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 47.665824,206.63088 c 0.358075,-0.88971 0.795524,-2.4046 1.115522,-3.58013 -1.158756,-0.14905 -2.362027,-0.35871 -3.218178,-0.73552 -1.020694,-0.44904 -1.680717,-1.29166 -2.001373,-1.79683 -0.03932,-0.0633 -0.08449,-0.11028 -0.129667,-0.15929 -0.340006,1.28198 -1.000047,3.94853 -1.000047,5.33698 0,1.64392 4.725993,2.19686 5.233762,0.93486",
    style: {
      fill: "#483737",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-5-8-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.838004,201.35326 c 0,0 -0.04444,1.08198 0.47291,1.31425 0.774236,0.34712 1.471037,-0.80068 1.471037,-0.80068 l -1.943947,-0.51357",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-4-7-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7.6746094,205.17471 c 0,0 0.1212543,0.21742 0.7103528,1.59295 0.2690457,0.62906 0.9310065,2.78335 0.9310065,2.78335 l 0.9787403,-0.1026 c 0,0 -0.271624,-1.1607 -1.0006863,-2.99883 -0.21226,-0.53615 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67876",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-7-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9.5282277,207.16639 c -0.410326,0 -0.7445344,0.33421 -0.7445344,0.74456 0,0.41032 0.3342084,0.74453 0.7445344,0.74453 0.4103452,0 0.7445533,-0.33421 0.7445533,-0.74453 0,-0.41035 -0.3342081,-0.74456 -0.7445533,-0.74456 z m 0,1.88782 c -0.6303395,0 -1.1432655,-0.51292 -1.1432655,-1.14326 0,-0.63036 0.512926,-1.14329 1.1432655,-1.14329 0.6303583,0 1.1432663,0.51293 1.1432663,1.14329 0,0.63034 -0.512908,1.14326 -1.1432663,1.14326",
    style: {
      fill: "#f4ab94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-6-7-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9.9585619,207.30382 c 0,0 3.6962821,-1.88523 5.3647271,-4.25371 1.25682,-1.78394 3.194969,-6.55381 3.194969,-6.55381 l 0.847775,-0.0613 c 0,0 -1.429082,4.2705 -3.656925,7.45256 -1.660709,2.37364 -5.4473,4.14014 -5.4473,4.14014 l -0.3032461,-0.7239",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-5-2-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.132781,208.34516 c 0,0 10.446197,-4.20727 14.56248,-5.61185 6.002821,-2.04846 7.514495,-2.37428 8.697758,-2.13877 0,0 0.780033,-0.10516 0.638734,-0.23551 -1.251023,-1.16197 -7.288665,0.8781 -10.433304,2.10332 -1.336175,0.52066 -13.349553,5.26148 -13.349553,5.26148 l -0.116134,0.62133",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-6-7-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.036345,191.84259 c 1.174887,0.31162 2.494291,1.00648 2.494291,1.00648 l 0.822609,-1.76458 -1.41553,-1.24069 c 0,0 -2.045888,1.28844 -1.90137,1.99879",
    style: {
      fill: "#ee9d8f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-9-2-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.659635,190.26252 c -0.238723,1.50264 -1.501341,2.03749 -2.16396,2.22266 -0.386459,0.10845 -0.800022,-0.26517 -1.092295,-0.87873 -0.324533,-0.68067 -0.641953,-1.62975 -0.265808,-2.84979 0.448403,-1.45361 0.919375,-1.69749 2.000074,-1.52587 1.079383,0.17228 1.761352,1.52975 1.521989,3.03173",
    style: {
      fill: "#f9b2a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-3-2-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.272564,190.13735 c 0,0 -0.346462,1.1123 -0.256134,1.60136 0.08907,0.4884 0.622604,0.76518 0.622604,0.76518 l 0.714211,-2.15041 -1.080681,-0.21613",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-7-6-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.431245,189.62766 c -0.06072,-0.27227 -0.27744,-0.57163 -0.489059,-0.53809 -0.211619,0.0342 -0.526478,0.49292 -0.526478,0.49292 0,0 -0.486462,-0.23419 -0.954215,-0.68195 -0.469051,-0.44713 -1.331676,0.0128 -1.357481,-0.35744 -0.0406,-0.57615 -0.66518,-1.52523 1.744581,-1.99686 1.100689,-0.21549 2.261384,0.16131 2.56527,0.9452 0.593561,1.52975 0.101868,2.35236 0.250976,2.96528 -0.822609,0.22582 -1.171668,-0.55744 -1.233594,-0.82906",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-4-1-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.5517,188.59987 0.0018,0.3826 c 0,0 1.571661,0.18197 2.907196,-0.0819 0.782612,-0.15418 1.445231,-0.0146 2.245912,0.26388 0.801303,0.27743 1.319405,0.12327 1.319405,0.12327 0,0 -0.08193,-2.07299 -0.898105,-2.80205 -0.817423,-0.72971 -2.756852,-0.42324 -3.431067,-0.0962 -0.839398,0.40646 -1.100689,2.17169 -1.100689,2.17169 l -1.045201,0.0388",
    style: {
      fill: "#944496",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-52-0-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.862145,188.12954 c 0,0 -0.163319,1.43038 0,2.25814 0.163135,0.82713 1.365858,0.95876 1.976848,0.15546 0.326472,-0.42906 0.800041,-1.52005 0.800041,-1.52005 l -0.633577,-0.26519 c 0,0 -0.16972,0.90392 -0.712932,1.42201 -0.662601,0.63098 -1.044561,0.007 -1.000046,-0.84972 0.03219,-0.62132 0.05944,-1.04198 0.05944,-1.04198 l -0.489701,-0.15875",
    style: {
      fill: "#944496",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-5-6-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.147321,190.50963 c 0,0 0.02067,0.6781 0,1.08648 -0.01993,0.40777 -0.111012,0.69423 -0.111012,0.69423 l 0.578088,-0.33098 c 0,0 0.346462,-1.01423 0.166428,-1.28262 -0.09163,-0.13552 -0.633577,-0.16716 -0.633577,-0.16716",
    style: {
      fill: "#944496",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-4-1-69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 49.90592,194.1246 c 0,0 1.686515,0.45486 2.678807,1.47296 1.265855,1.29941 0.985196,3.04206 0,4.49243 -1.471018,2.1646 -5.227306,4.14274 -5.227306,4.14274 l -3.022049,1.38587 c 0,0 -1.452949,-1.22522 -0.898105,-2.59108 0.321315,-0.79228 2.902057,-3.34658 4.818259,-5.87829 0.70002,-0.92391 1.650394,-3.02463 1.650394,-3.02463",
    style: {
      fill: "#f6d5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-7-5-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.026791,190.49736 -0.310981,0.58713 c 0,0 0.800662,3.08399 1.127775,3.98209 0.326472,0.89873 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.17942 2.777529,0.68971 0.898105,0.51033 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.44394 1.93877,-2.4472 1.740064,-1.07035 2.504625,-2.62526 2.504625,-2.62526 0,0 -3.269167,-0.9452 -4.249846,-1.27553 -0.979398,-0.32905 -2.647203,-1.10842 -4.345331,-1.93685 -1.698127,-0.82712 -3.413026,-0.41486 -3.413026,-0.41486",
    style: {
      fill: "#5555ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-4-9-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34.864037,200.35258 c 0,0 -1.633605,-0.24516 -2.1646,0 -0.530977,0.24518 -0.203865,0.69422 0,1.10262 0.204523,0.40841 0.612929,0.83553 1.06199,0.98908 0.449044,0.15417 1.891037,-0.72649 1.891037,-0.72649 l -0.788427,-1.36521",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-4-4-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.585587,196.18274 c -0.01097,-0.88583 -0.410984,-3.79174 -0.682609,-4.30145 -0.488401,-0.91488 -1.500042,-1.18456 -2.187168,-0.7968 -0.687126,0.38775 -0.467113,2.02975 -0.193568,3.4111 0.08523,0.4284 0.48648,2.60461 0.663259,3.08205 l -4.713081,2.85301 c -0.134788,0.81551 0.217417,1.37877 0.773577,1.72587 0.432913,-0.1549 1.780702,-0.6568 2.905276,-1.30133 1.180684,-0.67681 2.300083,-1.28071 2.998823,-1.67748 0.347742,-0.19743 0.457438,-1.17037 0.435491,-2.99497",
    style: {
      fill: "#2a2aff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-3-9-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 44.934109,205.76634 c 0,0 1.974269,6.04345 2.940756,7.15706 1.136809,1.31036 0.449701,-0.1059 0.449701,-0.1059 0,0 -1.947183,-3.43045 -2.615582,-6.64929 -0.142652,-0.1646 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#916f6f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-0-0-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.882423,204.23273 c 0,0 1.97555,2.29105 3.255597,3.87177 0.882614,1.09101 2.410419,3.47884 2.560094,3.70787 0.352918,0.53745 0.06383,1.37361 -0.361934,1.99686 -0.425835,0.6239 -0.896167,1.13295 -1.118119,1.56652 -0.220654,0.43419 0.130399,0.92197 0.130399,0.92197 0,0 1.508455,-0.39293 2.243955,-1.16715 0.734878,-0.77487 1.279407,-1.59748 1.439415,-1.5265 0.160575,0.0717 1.183281,-0.94456 1.183281,-0.94456 0,0 -0.736158,-1.23875 -1.317484,-2.02912 -0.581307,-0.79099 -2.120067,-3.78853 -2.723321,-5.01179 -0.603894,-1.22392 -0.625841,-1.78266 -2.088464,-2.27364 -0.591001,-0.19872 -0.525179,0.47485 -1.423925,0.47485 -1.080041,0 -1.779439,0.41292 -1.779439,0.41292",
    style: {
      fill: "#553133",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-7-9-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.031654,212.13627 -0.686486,0.57227 c 0,0 0.687126,0.74649 1.155519,1.30651 0.423256,0.50581 0.980057,1.39876 0.980057,1.39876 l 1.021956,-0.88325 c 0,0 -0.860028,-2.02139 -2.471046,-2.39429",
    style: {
      fill: "#6c5353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-8-1-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.272564,190.13735 c 0,0 1.041964,-1.01036 2.226526,-0.80712 1.184561,0.20322 1.989119,0.97164 2.383333,1.1794 0.393556,0.20775 1.047122,-0.11485 1.047122,-0.11485 0,0 -0.544529,1.07487 -1.497464,1.00519 -0.952953,-0.0697 -1.789754,-0.94778 -2.783344,-0.89035 -1.374234,0.0794 -1.376173,-0.37227 -1.376173,-0.37227",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-6-7-4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer8",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4793",
    transform: "matrix(1.8093414,0,0,1.8093414,-204.34199,-304.05654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4306-0-3-0-4-1-1-4",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,216.60984,169.4289)",
    style: {
      display: "inline",
      fill: "#666666",
      fillOpacity: 0.809464,
      filter: "url(#filter1510-3-2-8-6-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 71.092807,26.707917 c 0.662619,-0.268406 7.458348,-4.020158 12.034008,0 4.575019,4.020138 6.738979,6.587987 10.202976,6.298293 2.567848,-0.214837 3.216897,-2.158784 3.216897,-2.158784 0,0 0.649067,5.9028 -2.827201,7.388668 -7.132535,3.049154 -9.494562,-2.416216 -11.508188,-4.693731 -2.013627,-2.278155 -6.074422,-6.47767 -10.053283,-5.543444 -2.218789,0.52068 -1.065209,-1.291002 -1.065209,-1.291002",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-30-6-3-9-89-0-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,14.577765 c 0,0 3.701421,-1.119398 7.512538,-0.160027 3.811117,0.958751 7.991923,2.993026 10.25007,4.24403 3.021409,1.674261 4.39952,3.131087 4.39952,3.131087 0,0 -9.62165,-0.795505 -12.281107,-1.41617 -6.533798,-1.524586 -9.881021,-5.798938 -9.881021,-5.798938",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-4-7-6-5-6-8-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.030657,11.964122 c 0,0 0.255493,3.103982 0.827126,4.3292 0.571633,1.225199 1.878144,0 1.878144,0 0,0 -0.83746,-3.185295 -2.70527,-4.3292",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-44-5-1-0-4-5-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.830904,35.077904 c 0,0 1.027132,2.722681 3.291095,1.960077 2.263304,-0.761964 2.916249,-2.776889 4.223381,-1.224559 1.306511,1.551031 4.247267,6.846718 5.335703,7.13963 1.089076,0.292273 1.361341,-0.435509 1.905869,-0.469691 0.544548,-0.03475 2.558814,3.431735 2.558814,3.431735 0,0 -2.123304,1.522648 -5.227305,-0.111012 -2.929142,-1.541338 -5.934421,-5.662157 -5.934421,-5.662157 0,0 -6.370571,1.073586 -6.806702,0.781972 -0.43487,-0.292273 0.653566,-5.846032 0.653566,-5.846032",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-4-3-0-4-3-0-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.974429,33.934638 c 0,0 -9.96749,1.419407 -11.493996,1.652973 -0.418721,0.06383 -0.841977,0.405809 -1.263916,0.900025 0.370328,0.874879 0.825187,2.042669 1.140686,3.17626 0.200646,-0.257432 0.403231,-0.467771 0.607113,-0.592939 0.418081,-0.257414 4.753737,1.549751 10.307496,0.335507 1.396839,-0.305184 0.702617,-5.471826 0.702617,-5.471826",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-7-5-6-8-3-6-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.957683,41.587835 c -1.249724,1.697487 -2.245253,2.669131 -3.3891773,4.629849 -1.1426071,1.960077 -1.1426071,3.389817 -1.1426071,3.389817 l 3.2543164,-0.945838 c 0,0 0.17612,-1.57168 0.829065,-2.117507 0.652926,-0.546468 1.714898,-0.408406 2.450416,-1.86653 0.326454,-0.648409 1.312309,-3.618189 2.397507,-5.01373 -0.315499,-1.133591 -0.770358,-2.301381 -1.140686,-3.17626 -1.118119,1.305853 -2.234281,3.710474 -3.258834,5.100199",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-6-6-3-7-38-4-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.408427,29.259616 C 71.468951,24.126516 65.678408,24.635565 60.778215,24.853 46.417679,25.489155 41.765883,22.275476 37.950889,21.082539 c -2.343958,-0.73294 -9.873285,-4.420827 -12.496603,-5.050527 -5.261487,-1.263276 -9.953938,0.445185 -9.953938,0.445185 0,0 -5.123407,6.096368 -6.0924905,7.058977 -0.9690654,0.963268 -2.6304143,2.463968 -3.0465563,2.752364 -0.4148617,0.287755 -0.4916378,1.122617 0,1.846522 0.4735686,0.696161 1.523269,0.855511 1.523269,0.855511 0,0 -0.061999,0.900683 0.4916379,1.007142 0.5542219,0.105892 1.4207057,-0.201944 1.5929673,-1.25682 1.1000496,0.05102 4.9479266,-1.004564 6.3292746,-1.755555 1.761352,-0.956171 2.075571,-2.287829 2.075571,-2.287829 l 0.75099,-1.69233 c 0,0 4.246608,0.638734 6.424761,4.068549 2.178152,3.430455 5.117609,8.716467 5.117609,8.716467 l -2.318152,0.958751 c 0.314859,0.59228 0.581325,1.072287 0.772937,1.372954 1.163273,1.260039 2.484616,2.251051 3.914338,3.02011 l 2.504624,-2.003293 c 0,0 4.22854,0.754867 8.373225,0.691625 8.20612,-0.125827 10.73911,-1.947165 13.106953,-1.730389 2.939457,0.269046 5.069876,2.452355 5.071156,2.453654 1.249724,0.112293 2.694955,0.227749 4.402758,0.227749 0.787769,0 3.05559,0.03804 5.227287,-1.817498 2.171056,-1.855557 4.645997,-7.273175 2.68592,-9.704242",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-3-2-2-1-6-6-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.914353,39.830342 c -4.144685,0.06328 -8.373225,-0.691625 -8.373225,-0.691625 l -2.504624,2.003293 c 0.661321,0.355497 1.34329,0.668417 2.047187,0.931007 3.584647,0.920673 6.450565,0.879377 8.830662,0.879377 6.573155,6.58e-4 10.991385,-1.811024 13.495351,-2.440083 1.223919,-0.307105 2.70591,-0.1368 4.682758,0.04133 -0.0013,-0.0013 -2.131699,-2.184608 -5.071156,-2.453635 -2.367843,-0.216795 -4.900833,1.604562 -13.106953,1.730389",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-1-9-0-7-0-2-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.549772,27.073728 c -2.178153,-3.429815 -6.424761,-4.068549 -6.424761,-4.068549 l -0.75099,1.69233 c 0,0 3.080756,0.763262 4.742105,2.498168 0.974241,1.016799 3.692405,6.655089 5.233103,9.553269 l 2.318152,-0.958751 c 0,0 -2.939457,-5.286012 -5.117609,-8.716467",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-7-1-6-2-4-5-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.000736,38.276732 c -1.416828,0.285176 -2.658798,0.146493 -2.449118,-1.635544 0.199366,-1.686514 -13.590196,1.727811 -13.590196,1.727811 0,0 2.178152,2.227824 4.465323,4.584053 2.285891,2.356212 4.67632,2.799458 8.384838,1.925878 1.169729,-0.275502 2.747206,-0.981977 3.536273,-1.365858 0.656145,-2.779468 0.202585,-4.296939 -0.34712,-5.23634",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-5-2-1-7-8-8-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.256426,49.01522 c 1.791692,1.634904 5.330526,1.526506 5.330526,1.526506 0,0 0,-2.831718 -1.143265,-4.127896 -0.487121,-0.551643 -1.960077,0.87294 -2.613644,0 -0.653584,-0.872299 -1.960077,-6.550587 -2.613661,-8.044831 -0.653567,-1.494245 -1.392944,-0.905842 -2.831079,-0.459377 -0.451622,0.13936 -1.805866,0.386478 -2.263304,0.478744 0.57487,1.263258 0.878737,3.223336 0.734878,5.373744 0.7697,-0.374846 2.344598,-1.749099 2.344598,-1.749099 0,0 0.90778,5.040834 3.054951,7.002209",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-9-7-5-2-8-6-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.506117,16.148786 3.221415,4.182744 0.376145,-0.750991 -2.858164,-3.859508 -0.739396,0.427755",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-6-0-5-2-8-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.996994,16.460426 c 0,0 0.894868,1.900712 2.869795,1.582634 1.350368,-0.217435 2.869138,-1.749738 2.869138,-1.749738 l -0.522601,-1.449749 c 0,0 -3.209161,0.723265 -5.216332,1.616853",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-2-9-4-6-97-8-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.653947,11.326668 c 0,0 -0.19355,3.916935 0.567115,6.075079 0.760043,2.158144 2.883348,0 2.883348,0 0,0 -1.511034,-4.507917 -3.450463,-6.075079",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-1-3-7-1-7-4-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.151311,34.465633 c 0,0 -7.22802,3.471093 -11.148156,4.858897 -2.414296,0.855511 -2.876252,1.674901 -3.26529,2.688481 0.532276,0.33099 1.357464,1.121338 1.923939,2.930441 0.270326,-0.48712 0.510987,-0.818091 0.687766,-0.881334 1.403277,-0.501312 7.273193,-0.201286 11.643031,-2.048467 0.714212,-0.301288 2.976236,-1.496183 5.263426,-3.931749 1.50006,-1.597485 -5.104716,-3.616269 -5.104716,-3.616269",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-7-6-6-0-6-7-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,42.013011 c -0.112841,0.295492 -0.220013,0.605833 -0.367768,0.940041 -0.653566,1.480053 -3.662064,7.68288 -4.631787,9.241647 -0.969706,1.559408 -0.709695,4.297579 -0.709695,4.297579 l 3.114956,-1.353604 c 0,0 -0.624542,-1.876845 0.136068,-2.163302 0.760026,-0.287115 1.413592,-0.33227 2.067176,-2.351054 0.486463,-1.502639 1.528445,-4.263397 2.314916,-5.680866 -0.566457,-1.809103 -1.391663,-2.599451 -1.923939,-2.930441",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-8-0-5-6-4-2-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.339408,21.792873 c 0,0 -1.632965,3.974362 0.980697,6.097667 2.613644,2.123944 10.12748,2.394928 12.250784,2.09556 2.123304,-0.298729 1.743941,-4.045963 1.742003,-5.526016 -3.756928,-0.380661 -12.525006,-1.776202 -14.973484,-2.667211",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-5-6-6-1-3-4-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 46.294449,27.073728 c 0,0 -0.925849,5.608607 -1.251663,8.004176 -0.327112,2.395587 -1.128433,7.87449 -1.128433,7.87449 0,0 3.207223,6.58e-4 6.16217,-0.546467 -0.02524,-0.392916 0.410985,-1.51877 -0.678091,-2.027819 -1.089076,-0.508409 -2.551718,-1.178746 -2.364606,-2.967201 0.186454,-1.788456 1.329719,-10.337179 1.329719,-10.337179 h -2.069096",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-7-2-9-5-03-0-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.038642,21.792873 c -0.584526,-0.703238 -1.407154,0.871001 -3.571095,0.625841 -0.534214,-0.06072 -1.143266,-0.123815 -1.763949,-0.203883 -0.319998,1.175527 -0.757447,2.69042 -1.115522,3.58013 -0.507768,1.261996 -5.233743,0.709073 -5.233743,-0.934865 0,-1.388445 0.660023,-4.054998 1.000028,-5.336983 -0.460016,-0.508409 -1.125836,-0.320017 -1.258758,-0.02067 -0.239363,0.541968 -0.487761,1.725871 -0.612271,2.290408 -0.27808,1.259417 -1.242628,4.209208 1.388445,5.322151 2.246533,0.949715 4.655654,1.265855 5.472465,0.285816 0.816154,-0.980039 1.24197,-3.443367 1.24197,-3.443367 l 4.45243,0.358075 c 0,0 0.402608,-2.036853 0,-2.522675",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-4-6-3-9-0-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.588076,25.794961 c 0.358075,-0.88971 0.795524,-2.404603 1.115522,-3.58013 -1.158756,-0.149053 -2.362027,-0.358715 -3.218178,-0.735518 -1.020694,-0.449044 -1.680717,-1.291661 -2.001373,-1.796832 -0.03932,-0.06328 -0.08449,-0.110281 -0.129667,-0.159295 -0.340006,1.281986 -1.000047,3.948538 -1.000047,5.336983 0,1.64392 4.725993,2.196861 5.233762,0.934865",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-1-1-7-4-9-2-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.760256,20.517343 c 0,0 -0.04444,1.08198 0.47291,1.314247 0.774236,0.347121 1.471037,-0.800681 1.471037,-0.800681 l -1.943947,-0.513566",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-8-8-4-9-2-9-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.5968617,24.338793 c 0,0 0.1212543,0.217417 0.7103528,1.59295 0.2690457,0.629059 0.9310065,2.783344 0.9310065,2.783344 l 0.97874,-0.1026 c 0,0 -0.271624,-1.160694 -1.000686,-2.998822 -0.21226,-0.536153 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67875",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-5-7-5-0-5-9-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.45048,26.330474 c -0.410326,0 -0.7445344,0.334208 -0.7445344,0.744552 0,0.410327 0.3342084,0.744535 0.7445344,0.744535 0.410345,0 0.744553,-0.334208 0.744553,-0.744535 0,-0.410344 -0.334208,-0.744552 -0.744553,-0.744552 z m 0,1.887818 c -0.6303395,0 -1.1432655,-0.512926 -1.1432655,-1.143266 0,-0.630358 0.512926,-1.143283 1.1432655,-1.143283 0.630358,0 1.143266,0.512925 1.143266,1.143283 0,0.63034 -0.512908,1.143266 -1.143266,1.143266",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-9-9-2-9-40-0-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.880814,26.467895 c 0,0 3.696282,-1.885221 5.364727,-4.253704 1.25682,-1.783939 3.194969,-6.553806 3.194969,-6.553806 l 0.847775,-0.06127 c 0,0 -1.429082,4.270493 -3.656925,7.452551 -1.660709,2.37364 -5.4473,4.140149 -5.4473,4.140149 L 10.880814,26.46791",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-7-2-5-1-5-8-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.055033,27.509238 c 0,0 10.446197,-4.20727 14.56248,-5.611845 6.002821,-2.048466 7.514495,-2.37428 8.697758,-2.138776 0,0 0.780033,-0.10516 0.638734,-0.235504 -1.251023,-1.161975 -7.288665,0.878097 -10.433304,2.103314 -1.336175,0.520662 -13.349553,5.261487 -13.349553,5.261487 l -0.116134,0.621324",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-5-0-4-7-9-1-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.958597,11.00667 c 1.174887,0.311622 2.494291,1.006484 2.494291,1.006484 l 0.822609,-1.764589 -1.41553,-1.2406896 c 0,0 -2.045888,1.2884416 -1.90137,1.9987946",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-3-2-7-7-4-3-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.581887,9.426596 c -0.238723,1.502639 -1.501341,2.037493 -2.16396,2.222667 -0.386459,0.108452 -0.800022,-0.265169 -1.092295,-0.878737 -0.324533,-0.680671 -0.641953,-1.6297464 -0.265808,-2.8497881 0.448403,-1.4536072 0.919375,-1.6974875 2.000074,-1.525866 1.079383,0.17228 1.761352,1.5297432 1.521989,3.0317241",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-8-3-4-1-6-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 -0.346462,1.1123031 -0.256134,1.6013621 0.08907,0.488401 0.622604,0.765182 0.622604,0.765182 L 40.275497,9.5175642 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-8-7-4-1-9-1-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.353497,8.791739 c -0.06072,-0.2722644 -0.27744,-0.5716327 -0.489059,-0.5380912 -0.211619,0.0342 -0.526478,0.4929181 -0.526478,0.4929181 0,0 -0.486462,-0.2341873 -0.954215,-0.6819505 -0.469051,-0.447123 -1.331676,0.012802 -1.357481,-0.3574351 -0.0406,-0.5761501 -0.66518,-1.5252258 1.744581,-1.9968558 1.100689,-0.2154962 2.261384,0.1613067 2.56527,0.9451985 0.593561,1.5297432 0.101868,2.3523524 0.250976,2.9652811 C 38.764482,9.8466152 38.415423,9.0633634 38.353497,8.791739",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-3-5-3-5-2-0-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.473952,7.7639486 0.0018,0.3826004 c 0,0 1.571661,0.1819729 2.907196,-0.081934 0.782612,-0.154174 1.445231,-0.014631 2.245912,0.2638882 0.801303,0.2774219 1.319405,0.1232661 1.319405,0.1232661 0,0 -0.08193,-2.0729918 -0.898105,-2.8020541 C 38.232737,4.9200133 36.293308,5.2264776 35.619093,5.5535169 34.779695,5.959984 34.518404,7.725213 34.518404,7.725213 l -1.045201,0.038772",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-1-9-0-9-2-3-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.784397,7.2936171 c 0,0 -0.163319,1.4303805 0,2.258147 0.163135,0.8271269 1.365858,0.9587509 1.976848,0.1554543 0.326472,-0.4290538 0.800041,-1.5200502 0.800041,-1.5200502 L 38.927709,7.9219815 c 0,0 -0.16972,0.9039209 -0.712932,1.4220043 -0.662601,0.6309797 -1.044561,0.00732 -1.000046,-0.8497131 0.03219,-0.6213233 0.05944,-1.0419825 0.05944,-1.0419825 L 36.78447,7.2935439",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-8-2-7-7-4-4-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.069573,9.6737134 c 0,0 0.02067,0.6780916 0,1.0864786 -0.01993,0.407766 -0.111012,0.694223 -0.111012,0.694223 l 0.578088,-0.330972 c 0,0 0.346462,-1.014238 0.166428,-1.2826254 C 37.61145,9.7052981 37.0695,9.6736586 37.0695,9.6736586",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-9-2-8-7-7-0-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.828172,13.288684 c 0,0 1.686515,0.454859 2.678807,1.472956 1.265855,1.299415 0.985196,3.042057 0,4.492427 -1.471018,2.1646 -5.227306,4.142747 -5.227306,4.142747 l -3.022049,1.385865 c 0,0 -1.452949,-1.225217 -0.898105,-2.591075 0.321315,-0.792286 2.902057,-3.346583 4.818259,-5.878293 0.70002,-0.92391 1.650394,-3.024627 1.650394,-3.024627",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-6-8-6-6-7-3-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.949043,9.6614417 -0.310981,0.5871233 c 0,0 0.800662,3.083993 1.127775,3.982098 0.326472,0.898727 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.179413 2.777529,0.689705 0.898105,0.510329 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.443933 1.93877,-2.447198 1.740064,-1.070348 2.504625,-2.625256 2.504625,-2.625256 0,0 -3.269167,-0.945199 -4.249846,-1.27553 C 46.728002,11.684103 45.060197,10.904728 43.362069,10.076303 41.663942,9.249177 39.949043,9.6614417 39.949043,9.6614417",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-43-9-8-7-5-9-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.786289,19.516657 c 0,0 -1.633605,-0.245161 -2.1646,0 -0.530977,0.245179 -0.203865,0.694222 0,1.102628 0.204523,0.408406 0.612929,0.835521 1.06199,0.989073 0.449044,0.154174 1.891037,-0.726483 1.891037,-0.726483 l -0.788427,-1.365218",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-3-7-8-3-4-1-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.507839,15.346825 c -0.01097,-0.885834 -0.410984,-3.791749 -0.682609,-4.301456 -0.488401,-0.914876 -1.500042,-1.1845618 -2.187168,-0.796804 -0.687126,0.387758 -0.467113,2.029757 -0.193568,3.411106 0.08523,0.428395 0.48648,2.604608 0.663259,3.082054 l -4.713081,2.853006 c -0.134788,0.815514 0.217417,1.37877 0.773577,1.725872 0.432913,-0.154906 1.780702,-0.656803 2.905276,-1.301335 1.180684,-0.676811 2.300083,-1.280705 2.998823,-1.67748 0.347742,-0.197427 0.457438,-1.170369 0.435491,-2.994963",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-38-3-4-6-81-9-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.856361,24.930416 c 0,0 1.974269,6.043458 2.940756,7.15706 1.136809,1.310369 0.449701,-0.105892 0.449701,-0.105892 0,0 -1.947183,-3.430455 -2.615582,-6.649291 -0.142652,-0.164599 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-6-6-3-5-2-6-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.804675,23.396814 c 0,0 1.97555,2.291048 3.255597,3.871762 0.882614,1.091015 2.410419,3.478847 2.560094,3.707877 0.352918,0.537451 0.06383,1.373612 -0.361934,1.996856 -0.425835,0.623902 -0.896167,1.132951 -1.118119,1.566522 -0.220654,0.434193 0.130399,0.921972 0.130399,0.921972 0,0 1.508455,-0.392934 2.243955,-1.167151 0.734878,-0.774876 1.279407,-1.597485 1.439415,-1.526506 0.160575,0.07169 1.183281,-0.944559 1.183281,-0.944559 0,0 -0.736158,-1.238751 -1.317484,-2.029117 -0.581307,-0.790988 -2.120067,-3.78853 -2.723321,-5.011791 -0.603894,-1.223918 -0.625841,-1.782658 -2.088464,-2.273637 -0.591001,-0.198726 -0.525179,0.474849 -1.423925,0.474849 -1.080041,0 -1.779439,0.412923 -1.779439,0.412923",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-0-1-1-6-8-9-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.953906,31.300347 48.26742,31.87262 c 0,0 0.687126,0.746491 1.155519,1.30651 0.423256,0.505812 0.980057,1.39876 0.980057,1.39876 l 1.021956,-0.883255 c 0,0 -0.860028,-2.021381 -2.471046,-2.394288",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-4-2-4-3-9-3-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 1.041964,-1.0103613 2.226526,-0.8071186 1.184561,0.2032245 1.989119,0.9716441 2.383333,1.1794041 0.393556,0.2077418 1.047122,-0.1148532 1.047122,-0.1148532 0,0 -0.544529,1.0748658 -1.497464,1.0051858 C 42.40138,10.494366 41.564579,9.6162685 40.570989,9.6736951 39.196755,9.7530683 39.194816,9.3014279 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.809464,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-8-9-9-9-3-3-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5230",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,181.00178,-9.5718692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 70.170555,207.54384 c 0.662619,-0.26841 7.458348,-4.02016 12.034008,0 4.575019,4.02013 6.738979,6.58798 10.202976,6.29829 2.567848,-0.21484 3.216897,-2.15878 3.216897,-2.15878 0,0 0.649067,5.9028 -2.827201,7.38866 -7.132535,3.04916 -9.494562,-2.41621 -11.508188,-4.69373 -2.013627,-2.27815 -6.074422,-6.47767 -10.053283,-5.54344 -2.218789,0.52068 -1.065209,-1.291 -1.065209,-1.291",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-31-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.815613,195.41369 c 0,0 3.701421,-1.1194 7.512538,-0.16003 3.811117,0.95875 7.991923,2.99302 10.25007,4.24403 3.021409,1.67426 4.39952,3.13108 4.39952,3.13108 0,0 -9.62165,-0.7955 -12.281107,-1.41617 -6.533798,-1.52458 -9.881021,-5.79893 -9.881021,-5.79893",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-9-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.108405,192.80004 c 0,0 0.255493,3.10398 0.827126,4.3292 0.571633,1.2252 1.878144,0 1.878144,0 0,0 -0.83746,-3.18529 -2.70527,-4.3292",
    style: {
      fill: "#241c1f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-4-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 70.908652,215.91382 c 0,0 1.027132,2.72268 3.291095,1.96008 2.263304,-0.76196 2.916249,-2.77689 4.223381,-1.22456 1.306511,1.55103 4.247267,6.84672 5.335703,7.13963 1.089076,0.29227 1.361341,-0.43551 1.905869,-0.46969 0.544548,-0.0348 2.558814,3.43174 2.558814,3.43174 0,0 -2.123304,1.52264 -5.227305,-0.11102 -2.929142,-1.54133 -5.934421,-5.66215 -5.934421,-5.66215 0,0 -6.370571,1.07358 -6.806702,0.78197 -0.43487,-0.29227 0.653566,-5.84603 0.653566,-5.84603",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-7-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.052177,214.77056 c 0,0 -9.96749,1.4194 -11.493996,1.65297 -0.418721,0.0638 -0.841977,0.40581 -1.263916,0.90003 0.370328,0.87487 0.825187,2.04267 1.140686,3.17626 0.200646,-0.25744 0.403231,-0.46778 0.607113,-0.59294 0.418081,-0.25742 4.753737,1.54975 10.307496,0.3355 1.396839,-0.30518 0.702617,-5.47182 0.702617,-5.47182",
    style: {
      fill: "#241c1f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-8-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.035431,222.42375 c -1.249724,1.69749 -2.2452533,2.66914 -3.3891776,4.62985 -1.1426071,1.96008 -1.1426071,3.38982 -1.1426071,3.38982 l 3.2543167,-0.94584 c 0,0 0.17612,-1.57168 0.829065,-2.1175 0.652926,-0.54647 1.714898,-0.40841 2.450416,-1.86653 0.326454,-0.64841 1.312309,-3.61819 2.397507,-5.01373 -0.315499,-1.13359 -0.770358,-2.30139 -1.140686,-3.17626 -1.118119,1.30585 -2.234281,3.71047 -3.258834,5.10019",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-4-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 73.486175,210.09554 c -2.939476,-5.1331 -8.730019,-4.62406 -13.630212,-4.40662 -14.360536,0.63615 -19.012332,-2.57752 -22.827326,-3.77046 -2.343958,-0.73294 -9.873285,-4.42083 -12.496603,-5.05053 -5.261487,-1.26327 -9.953938,0.44519 -9.953938,0.44519 0,0 -5.1234073,6.09636 -6.0924908,7.05897 -0.9690654,0.96327 -2.6304143,2.46397 -3.0465563,2.75237 -0.4148617,0.28775 -0.4916378,1.12261 0,1.84652 0.4735686,0.69616 1.523269,0.85551 1.523269,0.85551 0,0 -0.061999,0.90068 0.4916379,1.00714 0.5542219,0.10589 1.4207057,-0.20194 1.5929673,-1.25682 1.1000499,0.051 4.9479269,-1.00456 6.3292749,-1.75555 1.761352,-0.95617 2.075571,-2.28783 2.075571,-2.28783 l 0.75099,-1.69233 c 0,0 4.246608,0.63873 6.424761,4.06855 2.178152,3.43045 5.117609,8.71646 5.117609,8.71646 l -2.318152,0.95876 c 0.314859,0.59228 0.581325,1.07228 0.772937,1.37295 1.163273,1.26004 2.484616,2.25105 3.914338,3.02011 l 2.504624,-2.00329 c 0,0 4.22854,0.75486 8.373225,0.69162 8.20612,-0.12583 10.73911,-1.94716 13.106953,-1.73039 2.939457,0.26905 5.069876,2.45236 5.071156,2.45366 1.249724,0.11229 2.694955,0.22775 4.402758,0.22775 0.787769,0 3.05559,0.038 5.227287,-1.8175 2.171056,-1.85556 4.645997,-7.27318 2.68592,-9.70424",
    style: {
      fill: "#48373e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-5-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.992101,220.66626 c -4.144685,0.0633 -8.373225,-0.69162 -8.373225,-0.69162 l -2.504624,2.00329 c 0.661321,0.3555 1.34329,0.66842 2.047187,0.93101 3.584647,0.92067 6.450565,0.87937 8.830662,0.87937 6.573155,6.6e-4 10.991385,-1.81102 13.495351,-2.44008 1.223919,-0.3071 2.70591,-0.1368 4.682758,0.0413 -0.0013,-0.001 -2.131699,-2.18461 -5.071156,-2.45363 -2.367843,-0.2168 -4.900833,1.60456 -13.106953,1.73038",
    style: {
      fill: "#241c1f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-0-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.62752,207.90965 c -2.178153,-3.42982 -6.424761,-4.06855 -6.424761,-4.06855 l -0.75099,1.69233 c 0,0 3.080756,0.76326 4.742105,2.49817 0.974241,1.0168 3.692405,6.65509 5.233103,9.55327 l 2.318152,-0.95876 c 0,0 -2.939457,-5.28601 -5.117609,-8.71646",
    style: {
      fill: "#241c1f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-3-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 75.078484,219.11265 c -1.416828,0.28518 -2.658798,0.1465 -2.449118,-1.63554 0.199366,-1.68652 -13.590196,1.72781 -13.590196,1.72781 0,0 2.178152,2.22782 4.465323,4.58405 2.285891,2.35621 4.67632,2.79946 8.384838,1.92588 1.169729,-0.2755 2.747206,-0.98198 3.536273,-1.36586 0.656145,-2.77947 0.202585,-4.29694 -0.34712,-5.23634",
    style: {
      fill: "#48373e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-6-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 80.334174,229.85114 c 1.791692,1.6349 5.330526,1.52651 5.330526,1.52651 0,0 0,-2.83172 -1.143265,-4.1279 -0.487121,-0.55164 -1.960077,0.87294 -2.613644,0 -0.653584,-0.8723 -1.960077,-6.55059 -2.613661,-8.04483 -0.653567,-1.49425 -1.392944,-0.90584 -2.831079,-0.45938 -0.451622,0.13936 -1.805866,0.38648 -2.263304,0.47875 0.57487,1.26325 0.878737,3.22333 0.734878,5.37374 0.7697,-0.37485 2.344598,-1.7491 2.344598,-1.7491 0,0 0.90778,5.04083 3.054951,7.00221",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-1-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13.583865,196.98471 3.221415,4.18274 0.376145,-0.75099 -2.858164,-3.85951 -0.739396,0.42776",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-0-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.074742,197.29635 c 0,0 0.894868,1.90071 2.869795,1.58263 1.350368,-0.21744 2.869138,-1.74974 2.869138,-1.74974 l -0.522601,-1.44975 c 0,0 -3.209161,0.72327 -5.216332,1.61686",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.731695,192.16259 c 0,0 -0.19355,3.91693 0.567115,6.07508 0.760043,2.15814 2.883348,0 2.883348,0 0,0 -1.511034,-4.50792 -3.450463,-6.07508",
    style: {
      fill: "#48373e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-3-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.229059,215.30155 c 0,0 -7.22802,3.4711 -11.148156,4.8589 -2.414296,0.85551 -2.876252,1.6749 -3.26529,2.68848 0.532276,0.33099 1.357464,1.12134 1.923939,2.93044 0.270326,-0.48712 0.510987,-0.81809 0.687766,-0.88133 1.403277,-0.50131 7.273193,-0.20129 11.643031,-2.04847 0.714212,-0.30129 2.976236,-1.49618 5.263426,-3.93175 1.50006,-1.59748 -5.104716,-3.61627 -5.104716,-3.61627",
    style: {
      fill: "#48373e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-2-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.815613,222.84893 c -0.112841,0.29549 -0.220013,0.60583 -0.367768,0.94004 -0.653566,1.48005 -3.662064,7.68288 -4.631787,9.24165 -0.969706,1.55941 -0.709695,4.29758 -0.709695,4.29758 l 3.114956,-1.35361 c 0,0 -0.624542,-1.87684 0.136068,-2.1633 0.760026,-0.28711 1.413592,-0.33227 2.067176,-2.35105 0.486463,-1.50264 1.528445,-4.2634 2.314916,-5.68087 -0.566457,-1.8091 -1.391663,-2.59945 -1.923939,-2.93044",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-0-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.417156,202.62879 c 0,0 -1.632965,3.97436 0.980697,6.09767 2.613644,2.12394 10.12748,2.39493 12.250784,2.09556 2.123304,-0.29873 1.743941,-4.04596 1.742003,-5.52602 -3.756928,-0.38066 -12.525006,-1.7762 -14.973484,-2.66721",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-6-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.372197,207.90965 c 0,0 -0.925849,5.6086 -1.251663,8.00417 -0.327112,2.39559 -1.128433,7.87449 -1.128433,7.87449 0,0 3.207223,6.6e-4 6.16217,-0.54646 -0.02524,-0.39292 0.410985,-1.51877 -0.678091,-2.02782 -1.089076,-0.50841 -2.551718,-1.17875 -2.364606,-2.9672 0.186454,-1.78846 1.329719,-10.33718 1.329719,-10.33718 h -2.069096",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-1-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 54.11639,202.62879 c -0.584526,-0.70324 -1.407154,0.871 -3.571095,0.62584 -0.534214,-0.0607 -1.143266,-0.12381 -1.763949,-0.20388 -0.319998,1.17553 -0.757447,2.69042 -1.115522,3.58013 -0.507768,1.262 -5.233743,0.70907 -5.233743,-0.93486 0,-1.38845 0.660023,-4.055 1.000028,-5.33699 -0.460016,-0.50841 -1.125836,-0.32001 -1.258758,-0.0207 -0.239363,0.54197 -0.487761,1.72587 -0.612271,2.29041 -0.27808,1.25942 -1.242628,4.20921 1.388445,5.32215 2.246533,0.94972 4.655654,1.26586 5.472465,0.28582 0.816154,-0.98004 1.24197,-3.44337 1.24197,-3.44337 l 4.45243,0.35808 c 0,0 0.402608,-2.03686 0,-2.52268",
    style: {
      fill: "#6c5353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-5-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 47.665824,206.63088 c 0.358075,-0.88971 0.795524,-2.4046 1.115522,-3.58013 -1.158756,-0.14905 -2.362027,-0.35871 -3.218178,-0.73552 -1.020694,-0.44904 -1.680717,-1.29166 -2.001373,-1.79683 -0.03932,-0.0633 -0.08449,-0.11028 -0.129667,-0.15929 -0.340006,1.28198 -1.000047,3.94853 -1.000047,5.33698 0,1.64392 4.725993,2.19686 5.233762,0.93486",
    style: {
      fill: "#483737",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-5-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.838004,201.35326 c 0,0 -0.04444,1.08198 0.47291,1.31425 0.774236,0.34712 1.471037,-0.80068 1.471037,-0.80068 l -1.943947,-0.51357",
    style: {
      fill: "#916f7c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-4-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7.6746094,205.17471 c 0,0 0.1212543,0.21742 0.7103528,1.59295 0.2690457,0.62906 0.9310065,2.78335 0.9310065,2.78335 l 0.9787403,-0.1026 c 0,0 -0.271624,-1.1607 -1.0006863,-2.99883 -0.21226,-0.53615 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67876",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-7-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9.5282277,207.16639 c -0.410326,0 -0.7445344,0.33421 -0.7445344,0.74456 0,0.41032 0.3342084,0.74453 0.7445344,0.74453 0.4103452,0 0.7445533,-0.33421 0.7445533,-0.74453 0,-0.41035 -0.3342081,-0.74456 -0.7445533,-0.74456 z m 0,1.88782 c -0.6303395,0 -1.1432655,-0.51292 -1.1432655,-1.14326 0,-0.63036 0.512926,-1.14329 1.1432655,-1.14329 0.6303583,0 1.1432663,0.51293 1.1432663,1.14329 0,0.63034 -0.512908,1.14326 -1.1432663,1.14326",
    style: {
      fill: "#f4ab94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-6-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9.9585619,207.30382 c 0,0 3.6962821,-1.88523 5.3647271,-4.25371 1.25682,-1.78394 3.194969,-6.55381 3.194969,-6.55381 l 0.847775,-0.0613 c 0,0 -1.429082,4.2705 -3.656925,7.45256 -1.660709,2.37364 -5.4473,4.14014 -5.4473,4.14014 l -0.3032461,-0.7239",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-5-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.132781,208.34516 c 0,0 10.446197,-4.20727 14.56248,-5.61185 6.002821,-2.04846 7.514495,-2.37428 8.697758,-2.13877 0,0 0.780033,-0.10516 0.638734,-0.23551 -1.251023,-1.16197 -7.288665,0.8781 -10.433304,2.10332 -1.336175,0.52066 -13.349553,5.26148 -13.349553,5.26148 l -0.116134,0.62133",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-6-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.036345,191.84259 c 1.174887,0.31162 2.494291,1.00648 2.494291,1.00648 l 0.822609,-1.76458 -1.41553,-1.24069 c 0,0 -2.045888,1.28844 -1.90137,1.99879",
    style: {
      fill: "#ee9d8f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-9-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.659635,190.26252 c -0.238723,1.50264 -1.501341,2.03749 -2.16396,2.22266 -0.386459,0.10845 -0.800022,-0.26517 -1.092295,-0.87873 -0.324533,-0.68067 -0.641953,-1.62975 -0.265808,-2.84979 0.448403,-1.45361 0.919375,-1.69749 2.000074,-1.52587 1.079383,0.17228 1.761352,1.52975 1.521989,3.03173",
    style: {
      fill: "#f9b2a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-3-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.272564,190.13735 c 0,0 -0.346462,1.1123 -0.256134,1.60136 0.08907,0.4884 0.622604,0.76518 0.622604,0.76518 l 0.714211,-2.15041 -1.080681,-0.21613",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-7-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.431245,189.62766 c -0.06072,-0.27227 -0.27744,-0.57163 -0.489059,-0.53809 -0.211619,0.0342 -0.526478,0.49292 -0.526478,0.49292 0,0 -0.486462,-0.23419 -0.954215,-0.68195 -0.469051,-0.44713 -1.331676,0.0128 -1.357481,-0.35744 -0.0406,-0.57615 -0.66518,-1.52523 1.744581,-1.99686 1.100689,-0.21549 2.261384,0.16131 2.56527,0.9452 0.593561,1.52975 0.101868,2.35236 0.250976,2.96528 -0.822609,0.22582 -1.171668,-0.55744 -1.233594,-0.82906",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-4-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.5517,188.59987 0.0018,0.3826 c 0,0 1.571661,0.18197 2.907196,-0.0819 0.782612,-0.15418 1.445231,-0.0146 2.245912,0.26388 0.801303,0.27743 1.319405,0.12327 1.319405,0.12327 0,0 -0.08193,-2.07299 -0.898105,-2.80205 -0.817423,-0.72971 -2.756852,-0.42324 -3.431067,-0.0962 -0.839398,0.40646 -1.100689,2.17169 -1.100689,2.17169 l -1.045201,0.0388",
    style: {
      fill: "#6600ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-52-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.862145,188.12954 c 0,0 -0.163319,1.43038 0,2.25814 0.163135,0.82713 1.365858,0.95876 1.976848,0.15546 0.326472,-0.42906 0.800041,-1.52005 0.800041,-1.52005 l -0.633577,-0.26519 c 0,0 -0.16972,0.90392 -0.712932,1.42201 -0.662601,0.63098 -1.044561,0.007 -1.000046,-0.84972 0.03219,-0.62132 0.05944,-1.04198 0.05944,-1.04198 l -0.489701,-0.15875",
    style: {
      fill: "#6600ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-5-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.147321,190.50963 c 0,0 0.02067,0.6781 0,1.08648 -0.01993,0.40777 -0.111012,0.69423 -0.111012,0.69423 l 0.578088,-0.33098 c 0,0 0.346462,-1.01423 0.166428,-1.28262 -0.09163,-0.13552 -0.633577,-0.16716 -0.633577,-0.16716",
    style: {
      fill: "#6600ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-4-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 49.90592,194.1246 c 0,0 1.686515,0.45486 2.678807,1.47296 1.265855,1.29941 0.985196,3.04206 0,4.49243 -1.471018,2.1646 -5.227306,4.14274 -5.227306,4.14274 l -3.022049,1.38587 c 0,0 -1.452949,-1.22522 -0.898105,-2.59108 0.321315,-0.79228 2.902057,-3.34658 4.818259,-5.87829 0.70002,-0.92391 1.650394,-3.02463 1.650394,-3.02463",
    style: {
      fill: "#f6d5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-7-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.026791,190.49736 -0.310981,0.58713 c 0,0 0.800662,3.08399 1.127775,3.98209 0.326472,0.89873 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.17942 2.777529,0.68971 0.898105,0.51033 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.44394 1.93877,-2.4472 1.740064,-1.07035 2.504625,-2.62526 2.504625,-2.62526 0,0 -3.269167,-0.9452 -4.249846,-1.27553 -0.979398,-0.32905 -2.647203,-1.10842 -4.345331,-1.93685 -1.698127,-0.82712 -3.413026,-0.41486 -3.413026,-0.41486",
    style: {
      fill: "#bc5fd3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-4-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34.864037,200.35258 c 0,0 -1.633605,-0.24516 -2.1646,0 -0.530977,0.24518 -0.203865,0.69422 0,1.10262 0.204523,0.40841 0.612929,0.83553 1.06199,0.98908 0.449044,0.15417 1.891037,-0.72649 1.891037,-0.72649 l -0.788427,-1.36521",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-4-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.585587,196.18274 c -0.01097,-0.88583 -0.410984,-3.79174 -0.682609,-4.30145 -0.488401,-0.91488 -1.500042,-1.18456 -2.187168,-0.7968 -0.687126,0.38775 -0.467113,2.02975 -0.193568,3.4111 0.08523,0.4284 0.48648,2.60461 0.663259,3.08205 l -4.713081,2.85301 c -0.134788,0.81551 0.217417,1.37877 0.773577,1.72587 0.432913,-0.1549 1.780702,-0.6568 2.905276,-1.30133 1.180684,-0.67681 2.300083,-1.28071 2.998823,-1.67748 0.347742,-0.19743 0.457438,-1.17037 0.435491,-2.99497",
    style: {
      fill: "#672178",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-3-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 44.934109,205.76634 c 0,0 1.974269,6.04345 2.940756,7.15706 1.136809,1.31036 0.449701,-0.1059 0.449701,-0.1059 0,0 -1.947183,-3.43045 -2.615582,-6.64929 -0.142652,-0.1646 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#916f6f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-0-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.882423,204.23273 c 0,0 1.97555,2.29105 3.255597,3.87177 0.882614,1.09101 2.410419,3.47884 2.560094,3.70787 0.352918,0.53745 0.06383,1.37361 -0.361934,1.99686 -0.425835,0.6239 -0.896167,1.13295 -1.118119,1.56652 -0.220654,0.43419 0.130399,0.92197 0.130399,0.92197 0,0 1.508455,-0.39293 2.243955,-1.16715 0.734878,-0.77487 1.279407,-1.59748 1.439415,-1.5265 0.160575,0.0717 1.183281,-0.94456 1.183281,-0.94456 0,0 -0.736158,-1.23875 -1.317484,-2.02912 -0.581307,-0.79099 -2.120067,-3.78853 -2.723321,-5.01179 -0.603894,-1.22392 -0.625841,-1.78266 -2.088464,-2.27364 -0.591001,-0.19872 -0.525179,0.47485 -1.423925,0.47485 -1.080041,0 -1.779439,0.41292 -1.779439,0.41292",
    style: {
      fill: "#280b17",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-7-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.031654,212.13627 -0.686486,0.57227 c 0,0 0.687126,0.74649 1.155519,1.30651 0.423256,0.50581 0.980057,1.39876 0.980057,1.39876 l 1.021956,-0.88325 c 0,0 -0.860028,-2.02139 -2.471046,-2.39429",
    style: {
      fill: "#6c5353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-8-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.272564,190.13735 c 0,0 1.041964,-1.01036 2.226526,-0.80712 1.184561,0.20322 1.989119,0.97164 2.383333,1.1794 0.393556,0.20775 1.047122,-0.11485 1.047122,-0.11485 0,0 -0.544529,1.07487 -1.497464,1.00519 -0.952953,-0.0697 -1.789754,-0.94778 -2.783344,-0.89035 -1.374234,0.0794 -1.376173,-0.37227 -1.376173,-0.37227",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-6-7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer9",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4543",
    style: {
      display: "inline"
    },
    transform: "matrix(1.7698454,0,0,1.7698454,-5.4866127,-404.73866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5937",
    transform: "translate(-1.8593424,1.6824454)",
    style: {
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4306-0-3-0-4-1",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,112.91751,228.38835)",
    style: {
      display: "inline",
      fill: "#666666",
      fillOpacity: 0.84454,
      filter: "url(#filter1510-3-2-8)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 71.092807,26.707917 c 0.662619,-0.268406 7.458348,-4.020158 12.034008,0 4.575019,4.020138 6.738979,6.587987 10.202976,6.298293 2.567848,-0.214837 3.216897,-2.158784 3.216897,-2.158784 0,0 0.649067,5.9028 -2.827201,7.388668 -7.132535,3.049154 -9.494562,-2.416216 -11.508188,-4.693731 -2.013627,-2.278155 -6.074422,-6.47767 -10.053283,-5.543444 -2.218789,0.52068 -1.065209,-1.291002 -1.065209,-1.291002",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-30-6-3-9-89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,14.577765 c 0,0 3.701421,-1.119398 7.512538,-0.160027 3.811117,0.958751 7.991923,2.993026 10.25007,4.24403 3.021409,1.674261 4.39952,3.131087 4.39952,3.131087 0,0 -9.62165,-0.795505 -12.281107,-1.41617 -6.533798,-1.524586 -9.881021,-5.798938 -9.881021,-5.798938",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-4-7-6-5-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.030657,11.964122 c 0,0 0.255493,3.103982 0.827126,4.3292 0.571633,1.225199 1.878144,0 1.878144,0 0,0 -0.83746,-3.185295 -2.70527,-4.3292",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-44-5-1-0-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.830904,35.077904 c 0,0 1.027132,2.722681 3.291095,1.960077 2.263304,-0.761964 2.916249,-2.776889 4.223381,-1.224559 1.306511,1.551031 4.247267,6.846718 5.335703,7.13963 1.089076,0.292273 1.361341,-0.435509 1.905869,-0.469691 0.544548,-0.03475 2.558814,3.431735 2.558814,3.431735 0,0 -2.123304,1.522648 -5.227305,-0.111012 -2.929142,-1.541338 -5.934421,-5.662157 -5.934421,-5.662157 0,0 -6.370571,1.073586 -6.806702,0.781972 -0.43487,-0.292273 0.653566,-5.846032 0.653566,-5.846032",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-4-3-0-4-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.974429,33.934638 c 0,0 -9.96749,1.419407 -11.493996,1.652973 -0.418721,0.06383 -0.841977,0.405809 -1.263916,0.900025 0.370328,0.874879 0.825187,2.042669 1.140686,3.17626 0.200646,-0.257432 0.403231,-0.467771 0.607113,-0.592939 0.418081,-0.257414 4.753737,1.549751 10.307496,0.335507 1.396839,-0.305184 0.702617,-5.471826 0.702617,-5.471826",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-7-5-6-8-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.957683,41.587835 c -1.249724,1.697487 -2.245253,2.669131 -3.3891773,4.629849 -1.1426071,1.960077 -1.1426071,3.389817 -1.1426071,3.389817 l 3.2543164,-0.945838 c 0,0 0.17612,-1.57168 0.829065,-2.117507 0.652926,-0.546468 1.714898,-0.408406 2.450416,-1.86653 0.326454,-0.648409 1.312309,-3.618189 2.397507,-5.01373 -0.315499,-1.133591 -0.770358,-2.301381 -1.140686,-3.17626 -1.118119,1.305853 -2.234281,3.710474 -3.258834,5.100199",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-6-6-3-7-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.408427,29.259616 C 71.468951,24.126516 65.678408,24.635565 60.778215,24.853 46.417679,25.489155 41.765883,22.275476 37.950889,21.082539 c -2.343958,-0.73294 -9.873285,-4.420827 -12.496603,-5.050527 -5.261487,-1.263276 -9.953938,0.445185 -9.953938,0.445185 0,0 -5.123407,6.096368 -6.0924905,7.058977 -0.9690654,0.963268 -2.6304143,2.463968 -3.0465563,2.752364 -0.4148617,0.287755 -0.4916378,1.122617 0,1.846522 0.4735686,0.696161 1.523269,0.855511 1.523269,0.855511 0,0 -0.061999,0.900683 0.4916379,1.007142 0.5542219,0.105892 1.4207057,-0.201944 1.5929673,-1.25682 1.1000496,0.05102 4.9479266,-1.004564 6.3292746,-1.755555 1.761352,-0.956171 2.075571,-2.287829 2.075571,-2.287829 l 0.75099,-1.69233 c 0,0 4.246608,0.638734 6.424761,4.068549 2.178152,3.430455 5.117609,8.716467 5.117609,8.716467 l -2.318152,0.958751 c 0.314859,0.59228 0.581325,1.072287 0.772937,1.372954 1.163273,1.260039 2.484616,2.251051 3.914338,3.02011 l 2.504624,-2.003293 c 0,0 4.22854,0.754867 8.373225,0.691625 8.20612,-0.125827 10.73911,-1.947165 13.106953,-1.730389 2.939457,0.269046 5.069876,2.452355 5.071156,2.453654 1.249724,0.112293 2.694955,0.227749 4.402758,0.227749 0.787769,0 3.05559,0.03804 5.227287,-1.817498 2.171056,-1.855557 4.645997,-7.273175 2.68592,-9.704242",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-3-2-2-1-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.914353,39.830342 c -4.144685,0.06328 -8.373225,-0.691625 -8.373225,-0.691625 l -2.504624,2.003293 c 0.661321,0.355497 1.34329,0.668417 2.047187,0.931007 3.584647,0.920673 6.450565,0.879377 8.830662,0.879377 6.573155,6.58e-4 10.991385,-1.811024 13.495351,-2.440083 1.223919,-0.307105 2.70591,-0.1368 4.682758,0.04133 -0.0013,-0.0013 -2.131699,-2.184608 -5.071156,-2.453635 -2.367843,-0.216795 -4.900833,1.604562 -13.106953,1.730389",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-1-9-0-7-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.549772,27.073728 c -2.178153,-3.429815 -6.424761,-4.068549 -6.424761,-4.068549 l -0.75099,1.69233 c 0,0 3.080756,0.763262 4.742105,2.498168 0.974241,1.016799 3.692405,6.655089 5.233103,9.553269 l 2.318152,-0.958751 c 0,0 -2.939457,-5.286012 -5.117609,-8.716467",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-7-1-6-2-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.000736,38.276732 c -1.416828,0.285176 -2.658798,0.146493 -2.449118,-1.635544 0.199366,-1.686514 -13.590196,1.727811 -13.590196,1.727811 0,0 2.178152,2.227824 4.465323,4.584053 2.285891,2.356212 4.67632,2.799458 8.384838,1.925878 1.169729,-0.275502 2.747206,-0.981977 3.536273,-1.365858 0.656145,-2.779468 0.202585,-4.296939 -0.34712,-5.23634",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-5-2-1-7-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.256426,49.01522 c 1.791692,1.634904 5.330526,1.526506 5.330526,1.526506 0,0 0,-2.831718 -1.143265,-4.127896 -0.487121,-0.551643 -1.960077,0.87294 -2.613644,0 -0.653584,-0.872299 -1.960077,-6.550587 -2.613661,-8.044831 -0.653567,-1.494245 -1.392944,-0.905842 -2.831079,-0.459377 -0.451622,0.13936 -1.805866,0.386478 -2.263304,0.478744 0.57487,1.263258 0.878737,3.223336 0.734878,5.373744 0.7697,-0.374846 2.344598,-1.749099 2.344598,-1.749099 0,0 0.90778,5.040834 3.054951,7.002209",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-9-7-5-2-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.506117,16.148786 3.221415,4.182744 0.376145,-0.750991 -2.858164,-3.859508 -0.739396,0.427755",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-6-0-5-2-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.996994,16.460426 c 0,0 0.894868,1.900712 2.869795,1.582634 1.350368,-0.217435 2.869138,-1.749738 2.869138,-1.749738 l -0.522601,-1.449749 c 0,0 -3.209161,0.723265 -5.216332,1.616853",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-2-9-4-6-97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.653947,11.326668 c 0,0 -0.19355,3.916935 0.567115,6.075079 0.760043,2.158144 2.883348,0 2.883348,0 0,0 -1.511034,-4.507917 -3.450463,-6.075079",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-1-3-7-1-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.151311,34.465633 c 0,0 -7.22802,3.471093 -11.148156,4.858897 -2.414296,0.855511 -2.876252,1.674901 -3.26529,2.688481 0.532276,0.33099 1.357464,1.121338 1.923939,2.930441 0.270326,-0.48712 0.510987,-0.818091 0.687766,-0.881334 1.403277,-0.501312 7.273193,-0.201286 11.643031,-2.048467 0.714212,-0.301288 2.976236,-1.496183 5.263426,-3.931749 1.50006,-1.597485 -5.104716,-3.616269 -5.104716,-3.616269",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-7-6-6-0-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,42.013011 c -0.112841,0.295492 -0.220013,0.605833 -0.367768,0.940041 -0.653566,1.480053 -3.662064,7.68288 -4.631787,9.241647 -0.969706,1.559408 -0.709695,4.297579 -0.709695,4.297579 l 3.114956,-1.353604 c 0,0 -0.624542,-1.876845 0.136068,-2.163302 0.760026,-0.287115 1.413592,-0.33227 2.067176,-2.351054 0.486463,-1.502639 1.528445,-4.263397 2.314916,-5.680866 -0.566457,-1.809103 -1.391663,-2.599451 -1.923939,-2.930441",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-8-0-5-6-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.339408,21.792873 c 0,0 -1.632965,3.974362 0.980697,6.097667 2.613644,2.123944 10.12748,2.394928 12.250784,2.09556 2.123304,-0.298729 1.743941,-4.045963 1.742003,-5.526016 -3.756928,-0.380661 -12.525006,-1.776202 -14.973484,-2.667211",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-5-6-6-1-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 46.294449,27.073728 c 0,0 -0.925849,5.608607 -1.251663,8.004176 -0.327112,2.395587 -1.128433,7.87449 -1.128433,7.87449 0,0 3.207223,6.58e-4 6.16217,-0.546467 -0.02524,-0.392916 0.410985,-1.51877 -0.678091,-2.027819 -1.089076,-0.508409 -2.551718,-1.178746 -2.364606,-2.967201 0.186454,-1.788456 1.329719,-10.337179 1.329719,-10.337179 h -2.069096",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-7-2-9-5-03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.038642,21.792873 c -0.584526,-0.703238 -1.407154,0.871001 -3.571095,0.625841 -0.534214,-0.06072 -1.143266,-0.123815 -1.763949,-0.203883 -0.319998,1.175527 -0.757447,2.69042 -1.115522,3.58013 -0.507768,1.261996 -5.233743,0.709073 -5.233743,-0.934865 0,-1.388445 0.660023,-4.054998 1.000028,-5.336983 -0.460016,-0.508409 -1.125836,-0.320017 -1.258758,-0.02067 -0.239363,0.541968 -0.487761,1.725871 -0.612271,2.290408 -0.27808,1.259417 -1.242628,4.209208 1.388445,5.322151 2.246533,0.949715 4.655654,1.265855 5.472465,0.285816 0.816154,-0.980039 1.24197,-3.443367 1.24197,-3.443367 l 4.45243,0.358075 c 0,0 0.402608,-2.036853 0,-2.522675",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-4-6-3-9-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.588076,25.794961 c 0.358075,-0.88971 0.795524,-2.404603 1.115522,-3.58013 -1.158756,-0.149053 -2.362027,-0.358715 -3.218178,-0.735518 -1.020694,-0.449044 -1.680717,-1.291661 -2.001373,-1.796832 -0.03932,-0.06328 -0.08449,-0.110281 -0.129667,-0.159295 -0.340006,1.281986 -1.000047,3.948538 -1.000047,5.336983 0,1.64392 4.725993,2.196861 5.233762,0.934865",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-1-1-7-4-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.760256,20.517343 c 0,0 -0.04444,1.08198 0.47291,1.314247 0.774236,0.347121 1.471037,-0.800681 1.471037,-0.800681 l -1.943947,-0.513566",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-8-8-4-9-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.5968617,24.338793 c 0,0 0.1212543,0.217417 0.7103528,1.59295 0.2690457,0.629059 0.9310065,2.783344 0.9310065,2.783344 l 0.97874,-0.1026 c 0,0 -0.271624,-1.160694 -1.000686,-2.998822 -0.21226,-0.536153 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67875",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-5-7-5-0-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.45048,26.330474 c -0.410326,0 -0.7445344,0.334208 -0.7445344,0.744552 0,0.410327 0.3342084,0.744535 0.7445344,0.744535 0.410345,0 0.744553,-0.334208 0.744553,-0.744535 0,-0.410344 -0.334208,-0.744552 -0.744553,-0.744552 z m 0,1.887818 c -0.6303395,0 -1.1432655,-0.512926 -1.1432655,-1.143266 0,-0.630358 0.512926,-1.143283 1.1432655,-1.143283 0.630358,0 1.143266,0.512925 1.143266,1.143283 0,0.63034 -0.512908,1.143266 -1.143266,1.143266",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-9-9-2-9-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.880814,26.467895 c 0,0 3.696282,-1.885221 5.364727,-4.253704 1.25682,-1.783939 3.194969,-6.553806 3.194969,-6.553806 l 0.847775,-0.06127 c 0,0 -1.429082,4.270493 -3.656925,7.452551 -1.660709,2.37364 -5.4473,4.140149 -5.4473,4.140149 L 10.880814,26.46791",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-7-2-5-1-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.055033,27.509238 c 0,0 10.446197,-4.20727 14.56248,-5.611845 6.002821,-2.048466 7.514495,-2.37428 8.697758,-2.138776 0,0 0.780033,-0.10516 0.638734,-0.235504 -1.251023,-1.161975 -7.288665,0.878097 -10.433304,2.103314 -1.336175,0.520662 -13.349553,5.261487 -13.349553,5.261487 l -0.116134,0.621324",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-5-0-4-7-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.958597,11.00667 c 1.174887,0.311622 2.494291,1.006484 2.494291,1.006484 l 0.822609,-1.764589 -1.41553,-1.2406896 c 0,0 -2.045888,1.2884416 -1.90137,1.9987946",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-3-2-7-7-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.581887,9.426596 c -0.238723,1.502639 -1.501341,2.037493 -2.16396,2.222667 -0.386459,0.108452 -0.800022,-0.265169 -1.092295,-0.878737 -0.324533,-0.680671 -0.641953,-1.6297464 -0.265808,-2.8497881 0.448403,-1.4536072 0.919375,-1.6974875 2.000074,-1.525866 1.079383,0.17228 1.761352,1.5297432 1.521989,3.0317241",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-8-3-4-1-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 -0.346462,1.1123031 -0.256134,1.6013621 0.08907,0.488401 0.622604,0.765182 0.622604,0.765182 L 40.275497,9.5175642 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-8-7-4-1-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.353497,8.791739 c -0.06072,-0.2722644 -0.27744,-0.5716327 -0.489059,-0.5380912 -0.211619,0.0342 -0.526478,0.4929181 -0.526478,0.4929181 0,0 -0.486462,-0.2341873 -0.954215,-0.6819505 -0.469051,-0.447123 -1.331676,0.012802 -1.357481,-0.3574351 -0.0406,-0.5761501 -0.66518,-1.5252258 1.744581,-1.9968558 1.100689,-0.2154962 2.261384,0.1613067 2.56527,0.9451985 0.593561,1.5297432 0.101868,2.3523524 0.250976,2.9652811 C 38.764482,9.8466152 38.415423,9.0633634 38.353497,8.791739",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-3-5-3-5-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.473952,7.7639486 0.0018,0.3826004 c 0,0 1.571661,0.1819729 2.907196,-0.081934 0.782612,-0.154174 1.445231,-0.014631 2.245912,0.2638882 0.801303,0.2774219 1.319405,0.1232661 1.319405,0.1232661 0,0 -0.08193,-2.0729918 -0.898105,-2.8020541 C 38.232737,4.9200133 36.293308,5.2264776 35.619093,5.5535169 34.779695,5.959984 34.518404,7.725213 34.518404,7.725213 l -1.045201,0.038772",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-1-9-0-9-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.784397,7.2936171 c 0,0 -0.163319,1.4303805 0,2.258147 0.163135,0.8271269 1.365858,0.9587509 1.976848,0.1554543 0.326472,-0.4290538 0.800041,-1.5200502 0.800041,-1.5200502 L 38.927709,7.9219815 c 0,0 -0.16972,0.9039209 -0.712932,1.4220043 -0.662601,0.6309797 -1.044561,0.00732 -1.000046,-0.8497131 0.03219,-0.6213233 0.05944,-1.0419825 0.05944,-1.0419825 L 36.78447,7.2935439",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-8-2-7-7-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.069573,9.6737134 c 0,0 0.02067,0.6780916 0,1.0864786 -0.01993,0.407766 -0.111012,0.694223 -0.111012,0.694223 l 0.578088,-0.330972 c 0,0 0.346462,-1.014238 0.166428,-1.2826254 C 37.61145,9.7052981 37.0695,9.6736586 37.0695,9.6736586",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-9-2-8-7-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.828172,13.288684 c 0,0 1.686515,0.454859 2.678807,1.472956 1.265855,1.299415 0.985196,3.042057 0,4.492427 -1.471018,2.1646 -5.227306,4.142747 -5.227306,4.142747 l -3.022049,1.385865 c 0,0 -1.452949,-1.225217 -0.898105,-2.591075 0.321315,-0.792286 2.902057,-3.346583 4.818259,-5.878293 0.70002,-0.92391 1.650394,-3.024627 1.650394,-3.024627",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-6-8-6-6-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.949043,9.6614417 -0.310981,0.5871233 c 0,0 0.800662,3.083993 1.127775,3.982098 0.326472,0.898727 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.179413 2.777529,0.689705 0.898105,0.510329 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.443933 1.93877,-2.447198 1.740064,-1.070348 2.504625,-2.625256 2.504625,-2.625256 0,0 -3.269167,-0.945199 -4.249846,-1.27553 C 46.728002,11.684103 45.060197,10.904728 43.362069,10.076303 41.663942,9.249177 39.949043,9.6614417 39.949043,9.6614417",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-43-9-8-7-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.786289,19.516657 c 0,0 -1.633605,-0.245161 -2.1646,0 -0.530977,0.245179 -0.203865,0.694222 0,1.102628 0.204523,0.408406 0.612929,0.835521 1.06199,0.989073 0.449044,0.154174 1.891037,-0.726483 1.891037,-0.726483 l -0.788427,-1.365218",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-3-7-8-3-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.507839,15.346825 c -0.01097,-0.885834 -0.410984,-3.791749 -0.682609,-4.301456 -0.488401,-0.914876 -1.500042,-1.1845618 -2.187168,-0.796804 -0.687126,0.387758 -0.467113,2.029757 -0.193568,3.411106 0.08523,0.428395 0.48648,2.604608 0.663259,3.082054 l -4.713081,2.853006 c -0.134788,0.815514 0.217417,1.37877 0.773577,1.725872 0.432913,-0.154906 1.780702,-0.656803 2.905276,-1.301335 1.180684,-0.676811 2.300083,-1.280705 2.998823,-1.67748 0.347742,-0.197427 0.457438,-1.170369 0.435491,-2.994963",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-38-3-4-6-81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.856361,24.930416 c 0,0 1.974269,6.043458 2.940756,7.15706 1.136809,1.310369 0.449701,-0.105892 0.449701,-0.105892 0,0 -1.947183,-3.430455 -2.615582,-6.649291 -0.142652,-0.164599 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-6-6-3-5-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.804675,23.396814 c 0,0 1.97555,2.291048 3.255597,3.871762 0.882614,1.091015 2.410419,3.478847 2.560094,3.707877 0.352918,0.537451 0.06383,1.373612 -0.361934,1.996856 -0.425835,0.623902 -0.896167,1.132951 -1.118119,1.566522 -0.220654,0.434193 0.130399,0.921972 0.130399,0.921972 0,0 1.508455,-0.392934 2.243955,-1.167151 0.734878,-0.774876 1.279407,-1.597485 1.439415,-1.526506 0.160575,0.07169 1.183281,-0.944559 1.183281,-0.944559 0,0 -0.736158,-1.238751 -1.317484,-2.029117 -0.581307,-0.790988 -2.120067,-3.78853 -2.723321,-5.011791 -0.603894,-1.223918 -0.625841,-1.782658 -2.088464,-2.273637 -0.591001,-0.198726 -0.525179,0.474849 -1.423925,0.474849 -1.080041,0 -1.779439,0.412923 -1.779439,0.412923",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-0-1-1-6-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.953906,31.300347 48.26742,31.87262 c 0,0 0.687126,0.746491 1.155519,1.30651 0.423256,0.505812 0.980057,1.39876 0.980057,1.39876 l 1.021956,-0.883255 c 0,0 -0.860028,-2.021381 -2.471046,-2.394288",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-4-2-4-3-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 1.041964,-1.0103613 2.226526,-0.8071186 1.184561,0.2032245 1.989119,0.9716441 2.383333,1.1794041 0.393556,0.2077418 1.047122,-0.1148532 1.047122,-0.1148532 0,0 -0.544529,1.0748658 -1.497464,1.0051858 C 42.40138,10.494366 41.564579,9.6162685 40.570989,9.6736951 39.196755,9.7530683 39.194816,9.3014279 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.84454,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-8-9-9-9-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6192-0",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,65.774399,-2.6783195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 70.174932,263.07646 c 0.662619,-0.2684 7.458348,-4.02016 12.034008,0 4.575019,4.02013 6.738979,6.58798 10.202976,6.29829 2.567848,-0.21484 3.216897,-2.15877 3.216897,-2.15877 0,0 0.649067,5.9028 -2.827201,7.38865 -7.132535,3.04916 -9.494562,-2.41621 -11.508188,-4.69372 -2.013627,-2.27816 -6.074422,-6.47767 -10.053283,-5.54345 -2.218789,0.52068 -1.065209,-1.291 -1.065209,-1.291",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-31-8-1-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.81999,250.94631 c 0,0 3.701421,-1.1194 7.512538,-0.16003 3.811117,0.95875 7.991923,2.99302 10.25007,4.24403 3.021409,1.67427 4.39952,3.13109 4.39952,3.13109 0,0 -9.62165,-0.7955 -12.281107,-1.41618 -6.533798,-1.52457 -9.881021,-5.79893 -9.881021,-5.79893",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-9-4-1-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.112782,248.33266 c 0,0 0.255493,3.10398 0.827126,4.3292 0.571633,1.2252 1.878144,0 1.878144,0 0,0 -0.83746,-3.18529 -2.70527,-4.3292",
    style: {
      fill: "#004455",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-4-3-5-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 70.913029,271.44644 c 0,0 1.027132,2.72268 3.291095,1.96008 2.263304,-0.76196 2.916249,-2.77689 4.223381,-1.22456 1.306511,1.55104 4.247267,6.84672 5.335703,7.13963 1.089076,0.29228 1.361341,-0.4355 1.905869,-0.46969 0.544548,-0.0348 2.558814,3.43174 2.558814,3.43174 0,0 -2.123304,1.52264 -5.227305,-0.11102 -2.929142,-1.54132 -5.934421,-5.66215 -5.934421,-5.66215 0,0 -6.370571,1.07358 -6.806702,0.78197 -0.43487,-0.29226 0.653566,-5.84603 0.653566,-5.84603",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-7-1-9-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.056554,270.30318 c 0,0 -9.96749,1.4194 -11.493996,1.65298 -0.418721,0.0638 -0.841977,0.4058 -1.263916,0.90002 0.370328,0.87487 0.825187,2.04267 1.140686,3.17626 0.200646,-0.25743 0.403231,-0.46778 0.607113,-0.59294 0.418081,-0.25741 4.753737,1.54976 10.307496,0.33551 1.396839,-0.30518 0.702617,-5.47183 0.702617,-5.47183",
    style: {
      fill: "#004455",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-8-4-7-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.039808,277.95638 c -1.249724,1.69748 -2.2452529,2.66913 -3.3891772,4.62985 -1.1426071,1.96008 -1.1426071,3.38981 -1.1426071,3.38981 l 3.2543163,-0.94583 c 0,0 0.17612,-1.57169 0.829065,-2.1175 0.652926,-0.54647 1.714898,-0.40841 2.450416,-1.86654 0.326454,-0.64841 1.312309,-3.61819 2.397507,-5.01373 -0.315499,-1.13359 -0.770358,-2.30139 -1.140686,-3.17626 -1.118119,1.30585 -2.234281,3.71047 -3.258834,5.10019",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-4-9-7-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 73.490552,265.62817 c -2.939476,-5.13311 -8.730019,-4.62407 -13.630212,-4.40663 -14.360536,0.63615 -19.012332,-2.57752 -22.827326,-3.77046 -2.343958,-0.73294 -9.873285,-4.42083 -12.496603,-5.05053 -5.261487,-1.26327 -9.953938,0.44519 -9.953938,0.44519 0,0 -5.1234069,6.09636 -6.0924904,7.05897 -0.9690654,0.96327 -2.6304143,2.46397 -3.0465563,2.75237 -0.4148617,0.28775 -0.4916378,1.12261 0,1.84652 0.4735686,0.69616 1.523269,0.85551 1.523269,0.85551 0,0 -0.061999,0.90068 0.4916379,1.00714 0.5542219,0.10589 1.4207057,-0.20194 1.5929673,-1.25682 1.1000495,0.051 4.9479265,-1.00456 6.3292745,-1.75555 1.761352,-0.95617 2.075571,-2.28783 2.075571,-2.28783 l 0.75099,-1.69233 c 0,0 4.246608,0.63873 6.424761,4.06855 2.178152,3.43045 5.117609,8.71646 5.117609,8.71646 l -2.318152,0.95876 c 0.314859,0.59228 0.581325,1.07228 0.772937,1.37295 1.163273,1.26004 2.484616,2.25105 3.914338,3.02011 l 2.504624,-2.00329 c 0,0 4.22854,0.75486 8.373225,0.69162 8.20612,-0.12583 10.73911,-1.94716 13.106953,-1.73039 2.939457,0.26905 5.069876,2.45236 5.071156,2.45366 1.249724,0.11229 2.694955,0.22775 4.402758,0.22775 0.787769,0 3.05559,0.038 5.227287,-1.8175 2.171056,-1.85556 4.645997,-7.27318 2.68592,-9.70424",
    style: {
      fill: "#0088aa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-5-2-6-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.996478,276.19889 c -4.144685,0.0633 -8.373225,-0.69162 -8.373225,-0.69162 l -2.504624,2.00328 c 0.661321,0.35551 1.34329,0.66842 2.047187,0.93101 3.584647,0.92067 6.450565,0.87937 8.830662,0.87937 6.573155,6.6e-4 10.991385,-1.81102 13.495351,-2.44008 1.223919,-0.3071 2.70591,-0.1368 4.682758,0.0413 -0.0013,-10e-4 -2.131699,-2.18461 -5.071156,-2.45363 -2.367843,-0.2168 -4.900833,1.60456 -13.106953,1.73038",
    style: {
      fill: "#004455",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-0-0-7-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.631897,263.44227 c -2.178153,-3.42982 -6.424761,-4.06854 -6.424761,-4.06854 l -0.75099,1.69232 c 0,0 3.080756,0.76326 4.742105,2.49818 0.974241,1.01679 3.692405,6.65508 5.233103,9.55327 l 2.318152,-0.95877 c 0,0 -2.939457,-5.28601 -5.117609,-8.71646",
    style: {
      fill: "#004455",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-3-6-3-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 75.082861,274.64528 c -1.416828,0.28517 -2.658798,0.1465 -2.449118,-1.63554 0.199366,-1.68653 -13.590196,1.7278 -13.590196,1.7278 0,0 2.178152,2.22783 4.465323,4.58405 2.285891,2.35622 4.67632,2.79946 8.384838,1.92588 1.169729,-0.27549 2.747206,-0.98197 3.536273,-1.36586 0.656145,-2.77947 0.202585,-4.29694 -0.34712,-5.23633",
    style: {
      fill: "#0088aa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-6-8-6-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 80.338551,285.38376 c 1.791692,1.6349 5.330526,1.52652 5.330526,1.52652 0,0 0,-2.83173 -1.143265,-4.12791 -0.487121,-0.55164 -1.960077,0.87294 -2.613644,0 -0.653584,-0.8723 -1.960077,-6.55059 -2.613661,-8.04483 -0.653567,-1.49425 -1.392944,-0.90584 -2.831079,-0.45938 -0.451622,0.13936 -1.805866,0.38648 -2.263304,0.47875 0.57487,1.26325 0.878737,3.22333 0.734878,5.37374 0.7697,-0.37485 2.344598,-1.7491 2.344598,-1.7491 0,0 0.90778,5.04083 3.054951,7.00221",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-1-9-5-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13.588242,252.51733 3.221415,4.18275 0.376145,-0.751 -2.858164,-3.85951 -0.739396,0.42776",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-0-2-6-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.079119,252.82897 c 0,0 0.894868,1.90071 2.869795,1.58263 1.350368,-0.21744 2.869138,-1.74974 2.869138,-1.74974 l -0.522601,-1.44975 c 0,0 -3.209161,0.72327 -5.216332,1.61686",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-6-6-3-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.736072,247.69521 c 0,0 -0.19355,3.91693 0.567115,6.07508 0.760043,2.15814 2.883348,0 2.883348,0 0,0 -1.511034,-4.50792 -3.450463,-6.07508",
    style: {
      fill: "#0088aa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-3-6-9-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.233436,270.83418 c 0,0 -7.22802,3.47109 -11.148156,4.8589 -2.414296,0.8555 -2.876252,1.67489 -3.26529,2.68847 0.532276,0.331 1.357464,1.12135 1.923939,2.93045 0.270326,-0.48712 0.510987,-0.8181 0.687766,-0.88133 1.403277,-0.50131 7.273193,-0.2013 11.643031,-2.04847 0.714212,-0.30129 2.976236,-1.49619 5.263426,-3.93176 1.50006,-1.59747 -5.104716,-3.61626 -5.104716,-3.61626",
    style: {
      fill: "#0088aa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-2-4-4-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.81999,278.38155 c -0.112841,0.2955 -0.220013,0.60584 -0.367768,0.94004 -0.653566,1.48005 -3.662064,7.68289 -4.631787,9.24165 -0.969706,1.55941 -0.709695,4.29759 -0.709695,4.29759 l 3.114956,-1.35361 c 0,0 -0.624542,-1.87684 0.136068,-2.1633 0.760026,-0.28712 1.413592,-0.33227 2.067176,-2.35105 0.486463,-1.50265 1.528445,-4.2634 2.314916,-5.68087 -0.566457,-1.8091 -1.391663,-2.59945 -1.923939,-2.93044",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-0-9-8-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.421533,258.16142 c 0,0 -1.632965,3.97436 0.980697,6.09767 2.613644,2.12394 10.12748,2.39493 12.250784,2.09555 2.123304,-0.29872 1.743941,-4.04595 1.742003,-5.52601 -3.756928,-0.38067 -12.525006,-1.7762 -14.973484,-2.66721",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-6-5-1-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.376574,263.44227 c 0,0 -0.925849,5.60861 -1.251663,8.00417 -0.327112,2.39559 -1.128433,7.8745 -1.128433,7.8745 0,0 3.207223,6.5e-4 6.16217,-0.54647 -0.02524,-0.39292 0.410985,-1.51876 -0.678091,-2.02781 -1.089076,-0.50842 -2.551718,-1.17876 -2.364606,-2.9672 0.186454,-1.78846 1.329719,-10.33718 1.329719,-10.33718 h -2.069096",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-1-0-2-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 54.120767,258.16142 c -0.584526,-0.70324 -1.407154,0.871 -3.571095,0.62584 -0.534214,-0.0607 -1.143266,-0.12381 -1.763949,-0.20388 -0.319998,1.17553 -0.757447,2.69041 -1.115522,3.58013 -0.507768,1.262 -5.233743,0.70907 -5.233743,-0.93486 0,-1.38845 0.660023,-4.055 1.000028,-5.33699 -0.460016,-0.50841 -1.125836,-0.32001 -1.258758,-0.0207 -0.239363,0.54198 -0.487761,1.72588 -0.612271,2.29042 -0.27808,1.25942 -1.242628,4.20921 1.388445,5.32214 2.246533,0.94973 4.655654,1.26587 5.472465,0.28582 0.816154,-0.98003 1.24197,-3.44336 1.24197,-3.44336 l 4.45243,0.35808 c 0,0 0.402608,-2.03686 0,-2.52268",
    style: {
      fill: "#6c5353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-5-4-9-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 47.670201,262.1635 c 0.358075,-0.88971 0.795524,-2.40459 1.115522,-3.58013 -1.158756,-0.14905 -2.362027,-0.3587 -3.218178,-0.73552 -1.020694,-0.44903 -1.680717,-1.29166 -2.001373,-1.79683 -0.03932,-0.0633 -0.08449,-0.11028 -0.129667,-0.15929 -0.340006,1.28199 -1.000047,3.94853 -1.000047,5.33699 0,1.64391 4.725993,2.19685 5.233762,0.93485",
    style: {
      fill: "#483737",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-5-8-3-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.842381,256.88589 c 0,0 -0.04444,1.08198 0.47291,1.31424 0.774236,0.34712 1.471037,-0.80068 1.471037,-0.80068 l -1.943947,-0.51356",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-4-7-9-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7.6789868,260.70733 c 0,0 0.1212543,0.21742 0.7103528,1.59296 0.2690457,0.62905 0.9310065,2.78335 0.9310065,2.78335 l 0.9787399,-0.1026 c 0,0 -0.271624,-1.1607 -1.0006859,-2.99883 -0.21226,-0.53615 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67876",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-7-1-0-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9.5326051,262.69902 c -0.410326,0 -0.7445344,0.33421 -0.7445344,0.74455 0,0.41033 0.3342084,0.74453 0.7445344,0.74453 0.4103452,0 0.7445529,-0.3342 0.7445529,-0.74453 0,-0.41034 -0.3342077,-0.74455 -0.7445529,-0.74455 z m 0,1.88781 c -0.6303395,0 -1.1432655,-0.51292 -1.1432655,-1.14326 0,-0.63035 0.512926,-1.14328 1.1432655,-1.14328 0.6303579,0 1.1432659,0.51293 1.1432659,1.14328 0,0.63034 -0.512908,1.14326 -1.1432659,1.14326",
    style: {
      fill: "#f4ab94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-6-7-8-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9.9629393,262.83645 c 0,0 3.6962817,-1.88524 5.3647267,-4.25371 1.25682,-1.78395 3.194969,-6.55382 3.194969,-6.55382 l 0.847775,-0.0613 c 0,0 -1.429082,4.27051 -3.656925,7.45256 -1.660709,2.37365 -5.4473,4.14015 -5.4473,4.14015 l -0.3032457,-0.7239",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-5-2-8-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.137158,263.87779 c 0,0 10.446197,-4.20727 14.56248,-5.61185 6.002821,-2.04847 7.514495,-2.37429 8.697758,-2.13878 0,0 0.780033,-0.10516 0.638734,-0.23551 -1.251023,-1.16197 -7.288665,0.8781 -10.433304,2.10332 -1.336175,0.52066 -13.349553,5.26149 -13.349553,5.26149 l -0.116134,0.62133",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-6-7-5-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.040722,247.37521 c 1.174887,0.31162 2.494291,1.00648 2.494291,1.00648 l 0.822609,-1.76458 -1.41553,-1.24069 c 0,0 -2.045888,1.28845 -1.90137,1.9988",
    style: {
      fill: "#ee9d8f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-9-2-0-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.664012,245.79514 c -0.238723,1.50264 -1.501341,2.03749 -2.16396,2.22266 -0.386459,0.10845 -0.800022,-0.26517 -1.092295,-0.87873 -0.324533,-0.68067 -0.641953,-1.62975 -0.265808,-2.84979 0.448403,-1.45361 0.919375,-1.69749 2.000074,-1.52587 1.079383,0.17228 1.761352,1.52975 1.521989,3.03173",
    style: {
      fill: "#f9b2a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-3-2-9-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.276941,245.66997 c 0,0 -0.346462,1.1123 -0.256134,1.60136 0.08907,0.4884 0.622604,0.76518 0.622604,0.76518 l 0.714211,-2.15041 -1.080681,-0.21613",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-7-6-6-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.435622,245.16028 c -0.06072,-0.27227 -0.27744,-0.57163 -0.489059,-0.53809 -0.211619,0.0342 -0.526478,0.49292 -0.526478,0.49292 0,0 -0.486462,-0.23419 -0.954215,-0.68195 -0.469051,-0.44713 -1.331676,0.0128 -1.357481,-0.35744 -0.0406,-0.57615 -0.66518,-1.52523 1.744581,-1.99686 1.100689,-0.21549 2.261384,0.16131 2.56527,0.9452 0.593561,1.52975 0.101868,2.35236 0.250976,2.96528 -0.822609,0.22582 -1.171668,-0.55744 -1.233594,-0.82906",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-4-1-3-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.556077,244.13249 0.0018,0.3826 c 0,0 1.571661,0.18197 2.907196,-0.0819 0.782612,-0.15417 1.445231,-0.0146 2.245912,0.26388 0.801303,0.27744 1.319405,0.12327 1.319405,0.12327 0,0 -0.08193,-2.07299 -0.898105,-2.80205 -0.817423,-0.72971 -2.756852,-0.42324 -3.431067,-0.0962 -0.839398,0.40646 -1.100689,2.17169 -1.100689,2.17169 l -1.045201,0.0388",
    style: {
      fill: "#dd7ea5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-52-0-8-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.866522,243.66216 c 0,0 -0.163319,1.43038 0,2.25814 0.163135,0.82713 1.365858,0.95876 1.976848,0.15546 0.326472,-0.42906 0.800041,-1.52005 0.800041,-1.52005 l -0.633577,-0.26519 c 0,0 -0.16972,0.90392 -0.712932,1.42201 -0.662601,0.63098 -1.044561,0.007 -1.000046,-0.84972 0.03219,-0.62131 0.05944,-1.04197 0.05944,-1.04197 l -0.489701,-0.15875",
    style: {
      fill: "#dd7ea5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-5-6-5-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.151698,246.04225 c 0,0 0.02067,0.6781 0,1.08648 -0.01993,0.40777 -0.111012,0.69423 -0.111012,0.69423 l 0.578088,-0.33098 c 0,0 0.346462,-1.01423 0.166428,-1.28262 -0.09163,-0.13552 -0.633577,-0.16716 -0.633577,-0.16716",
    style: {
      fill: "#dd7ea5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-4-1-6-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 49.910297,249.65722 c 0,0 1.686515,0.45486 2.678807,1.47296 1.265855,1.29941 0.985196,3.04206 0,4.49243 -1.471018,2.1646 -5.227306,4.14274 -5.227306,4.14274 l -3.022049,1.38587 c 0,0 -1.452949,-1.22521 -0.898105,-2.59107 0.321315,-0.79228 2.902057,-3.34658 4.818259,-5.87829 0.70002,-0.92392 1.650394,-3.02464 1.650394,-3.02464",
    style: {
      fill: "#e5d5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-7-5-1-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.031168,246.02998 -0.310981,0.58713 c 0,0 0.800662,3.08399 1.127775,3.98209 0.326472,0.89873 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.17942 2.777529,0.68971 0.898105,0.51033 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.44394 1.93877,-2.4472 1.740064,-1.07035 2.504625,-2.62526 2.504625,-2.62526 0,0 -3.269167,-0.9452 -4.249846,-1.27553 -0.979398,-0.32905 -2.647203,-1.10842 -4.345331,-1.93685 -1.698127,-0.82712 -3.413026,-0.41486 -3.413026,-0.41486",
    style: {
      fill: "#800033",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-4-9-1-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34.868414,255.8852 c 0,0 -1.633605,-0.24516 -2.1646,0 -0.530977,0.24518 -0.203865,0.69423 0,1.10262 0.204523,0.40841 0.612929,0.83553 1.06199,0.98908 0.449044,0.15417 1.891037,-0.72649 1.891037,-0.72649 l -0.788427,-1.36521",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-4-4-5-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.589964,251.71536 c -0.01097,-0.88583 -0.410984,-3.79174 -0.682609,-4.30145 -0.488401,-0.91488 -1.500042,-1.18456 -2.187168,-0.7968 -0.687126,0.38776 -0.467113,2.02976 -0.193568,3.41111 0.08523,0.4284 0.48648,2.60461 0.663259,3.08205 l -4.713081,2.85301 c -0.134788,0.81551 0.217417,1.37877 0.773577,1.72587 0.432913,-0.1549 1.780702,-0.6568 2.905276,-1.30133 1.180684,-0.67681 2.300083,-1.28071 2.998823,-1.67748 0.347742,-0.19743 0.457438,-1.17037 0.435491,-2.99497",
    style: {
      fill: "#550022",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-3-9-9-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 44.938486,261.29896 c 0,0 1.974269,6.04346 2.940756,7.15706 1.136809,1.31037 0.449701,-0.10589 0.449701,-0.10589 0,0 -1.947183,-3.43045 -2.615582,-6.64929 -0.142652,-0.1646 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#916f6f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-0-0-8-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.8868,259.76535 c 0,0 1.97555,2.29106 3.255597,3.87178 0.882614,1.091 2.410419,3.47884 2.560094,3.70787 0.352918,0.53745 0.06383,1.37361 -0.361934,1.99685 -0.425835,0.6239 -0.896167,1.13295 -1.118119,1.56653 -0.220654,0.43419 0.130399,0.92197 0.130399,0.92197 0,0 1.508455,-0.39294 2.243955,-1.16715 0.734878,-0.77488 1.279407,-1.59749 1.439415,-1.5265 0.160575,0.0717 1.183281,-0.94457 1.183281,-0.94457 0,0 -0.736158,-1.23874 -1.317484,-2.02911 -0.581307,-0.791 -2.120067,-3.78854 -2.723321,-5.0118 -0.603894,-1.22391 -0.625841,-1.78265 -2.088464,-2.27364 -0.591001,-0.19871 -0.525179,0.47486 -1.423925,0.47486 -1.080041,0 -1.779439,0.41292 -1.779439,0.41292",
    style: {
      fill: "#553133",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-7-9-4-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.036031,267.6689 -0.686486,0.57227 c 0,0 0.687126,0.74649 1.155519,1.30651 0.423256,0.50581 0.980057,1.39875 0.980057,1.39875 l 1.021956,-0.88324 c 0,0 -0.860028,-2.02139 -2.471046,-2.39429",
    style: {
      fill: "#6c5353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-8-1-8-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.276941,245.66997 c 0,0 1.041964,-1.01036 2.226526,-0.80712 1.184561,0.20322 1.989119,0.97164 2.383333,1.1794 0.393556,0.20775 1.047122,-0.11485 1.047122,-0.11485 0,0 -0.544529,1.07487 -1.497464,1.00519 -0.952953,-0.0697 -1.789754,-0.94778 -2.783344,-0.89035 -1.374234,0.0794 -1.376173,-0.37227 -1.376173,-0.37227",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-6-7-1-8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "layer10",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4668",
    transform: "matrix(1.8167632,0,0,1.8167632,-205.54501,-418.14033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4306-0-3-0-4-1-1",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,216.83012,231.62367)",
    style: {
      display: "inline",
      fill: "#666666",
      fillOpacity: 0.833502,
      filter: "url(#filter1510-3-2-8-6)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 71.092807,26.707917 c 0.662619,-0.268406 7.458348,-4.020158 12.034008,0 4.575019,4.020138 6.738979,6.587987 10.202976,6.298293 2.567848,-0.214837 3.216897,-2.158784 3.216897,-2.158784 0,0 0.649067,5.9028 -2.827201,7.388668 -7.132535,3.049154 -9.494562,-2.416216 -11.508188,-4.693731 -2.013627,-2.278155 -6.074422,-6.47767 -10.053283,-5.543444 -2.218789,0.52068 -1.065209,-1.291002 -1.065209,-1.291002",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-30-6-3-9-89-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,14.577765 c 0,0 3.701421,-1.119398 7.512538,-0.160027 3.811117,0.958751 7.991923,2.993026 10.25007,4.24403 3.021409,1.674261 4.39952,3.131087 4.39952,3.131087 0,0 -9.62165,-0.795505 -12.281107,-1.41617 -6.533798,-1.524586 -9.881021,-5.798938 -9.881021,-5.798938",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-4-7-6-5-6-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.030657,11.964122 c 0,0 0.255493,3.103982 0.827126,4.3292 0.571633,1.225199 1.878144,0 1.878144,0 0,0 -0.83746,-3.185295 -2.70527,-4.3292",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-44-5-1-0-4-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 71.830904,35.077904 c 0,0 1.027132,2.722681 3.291095,1.960077 2.263304,-0.761964 2.916249,-2.776889 4.223381,-1.224559 1.306511,1.551031 4.247267,6.846718 5.335703,7.13963 1.089076,0.292273 1.361341,-0.435509 1.905869,-0.469691 0.544548,-0.03475 2.558814,3.431735 2.558814,3.431735 0,0 -2.123304,1.522648 -5.227305,-0.111012 -2.929142,-1.541338 -5.934421,-5.662157 -5.934421,-5.662157 0,0 -6.370571,1.073586 -6.806702,0.781972 -0.43487,-0.292273 0.653566,-5.846032 0.653566,-5.846032",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-4-3-0-4-3-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.974429,33.934638 c 0,0 -9.96749,1.419407 -11.493996,1.652973 -0.418721,0.06383 -0.841977,0.405809 -1.263916,0.900025 0.370328,0.874879 0.825187,2.042669 1.140686,3.17626 0.200646,-0.257432 0.403231,-0.467771 0.607113,-0.592939 0.418081,-0.257414 4.753737,1.549751 10.307496,0.335507 1.396839,-0.305184 0.702617,-5.471826 0.702617,-5.471826",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-7-5-6-8-3-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.957683,41.587835 c -1.249724,1.697487 -2.245253,2.669131 -3.3891773,4.629849 -1.1426071,1.960077 -1.1426071,3.389817 -1.1426071,3.389817 l 3.2543164,-0.945838 c 0,0 0.17612,-1.57168 0.829065,-2.117507 0.652926,-0.546468 1.714898,-0.408406 2.450416,-1.86653 0.326454,-0.648409 1.312309,-3.618189 2.397507,-5.01373 -0.315499,-1.133591 -0.770358,-2.301381 -1.140686,-3.17626 -1.118119,1.305853 -2.234281,3.710474 -3.258834,5.100199",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-6-6-3-7-38-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.408427,29.259616 C 71.468951,24.126516 65.678408,24.635565 60.778215,24.853 46.417679,25.489155 41.765883,22.275476 37.950889,21.082539 c -2.343958,-0.73294 -9.873285,-4.420827 -12.496603,-5.050527 -5.261487,-1.263276 -9.953938,0.445185 -9.953938,0.445185 0,0 -5.123407,6.096368 -6.0924905,7.058977 -0.9690654,0.963268 -2.6304143,2.463968 -3.0465563,2.752364 -0.4148617,0.287755 -0.4916378,1.122617 0,1.846522 0.4735686,0.696161 1.523269,0.855511 1.523269,0.855511 0,0 -0.061999,0.900683 0.4916379,1.007142 0.5542219,0.105892 1.4207057,-0.201944 1.5929673,-1.25682 1.1000496,0.05102 4.9479266,-1.004564 6.3292746,-1.755555 1.761352,-0.956171 2.075571,-2.287829 2.075571,-2.287829 l 0.75099,-1.69233 c 0,0 4.246608,0.638734 6.424761,4.068549 2.178152,3.430455 5.117609,8.716467 5.117609,8.716467 l -2.318152,0.958751 c 0.314859,0.59228 0.581325,1.072287 0.772937,1.372954 1.163273,1.260039 2.484616,2.251051 3.914338,3.02011 l 2.504624,-2.003293 c 0,0 4.22854,0.754867 8.373225,0.691625 8.20612,-0.125827 10.73911,-1.947165 13.106953,-1.730389 2.939457,0.269046 5.069876,2.452355 5.071156,2.453654 1.249724,0.112293 2.694955,0.227749 4.402758,0.227749 0.787769,0 3.05559,0.03804 5.227287,-1.817498 2.171056,-1.855557 4.645997,-7.273175 2.68592,-9.704242",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-3-2-2-1-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.914353,39.830342 c -4.144685,0.06328 -8.373225,-0.691625 -8.373225,-0.691625 l -2.504624,2.003293 c 0.661321,0.355497 1.34329,0.668417 2.047187,0.931007 3.584647,0.920673 6.450565,0.879377 8.830662,0.879377 6.573155,6.58e-4 10.991385,-1.811024 13.495351,-2.440083 1.223919,-0.307105 2.70591,-0.1368 4.682758,0.04133 -0.0013,-0.0013 -2.131699,-2.184608 -5.071156,-2.453635 -2.367843,-0.216795 -4.900833,1.604562 -13.106953,1.730389",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-1-9-0-7-0-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.549772,27.073728 c -2.178153,-3.429815 -6.424761,-4.068549 -6.424761,-4.068549 l -0.75099,1.69233 c 0,0 3.080756,0.763262 4.742105,2.498168 0.974241,1.016799 3.692405,6.655089 5.233103,9.553269 l 2.318152,-0.958751 c 0,0 -2.939457,-5.286012 -5.117609,-8.716467",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-7-1-6-2-4-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 76.000736,38.276732 c -1.416828,0.285176 -2.658798,0.146493 -2.449118,-1.635544 0.199366,-1.686514 -13.590196,1.727811 -13.590196,1.727811 0,0 2.178152,2.227824 4.465323,4.584053 2.285891,2.356212 4.67632,2.799458 8.384838,1.925878 1.169729,-0.275502 2.747206,-0.981977 3.536273,-1.365858 0.656145,-2.779468 0.202585,-4.296939 -0.34712,-5.23634",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-5-2-1-7-8-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 81.256426,49.01522 c 1.791692,1.634904 5.330526,1.526506 5.330526,1.526506 0,0 0,-2.831718 -1.143265,-4.127896 -0.487121,-0.551643 -1.960077,0.87294 -2.613644,0 -0.653584,-0.872299 -1.960077,-6.550587 -2.613661,-8.044831 -0.653567,-1.494245 -1.392944,-0.905842 -2.831079,-0.459377 -0.451622,0.13936 -1.805866,0.386478 -2.263304,0.478744 0.57487,1.263258 0.878737,3.223336 0.734878,5.373744 0.7697,-0.374846 2.344598,-1.749099 2.344598,-1.749099 0,0 0.90778,5.040834 3.054951,7.002209",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-9-7-5-2-8-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.506117,16.148786 3.221415,4.182744 0.376145,-0.750991 -2.858164,-3.859508 -0.739396,0.427755",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-6-0-5-2-8-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.996994,16.460426 c 0,0 0.894868,1.900712 2.869795,1.582634 1.350368,-0.217435 2.869138,-1.749738 2.869138,-1.749738 l -0.522601,-1.449749 c 0,0 -3.209161,0.723265 -5.216332,1.616853",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-2-9-4-6-97-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.653947,11.326668 c 0,0 -0.19355,3.916935 0.567115,6.075079 0.760043,2.158144 2.883348,0 2.883348,0 0,0 -1.511034,-4.507917 -3.450463,-6.075079",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-1-3-7-1-7-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.151311,34.465633 c 0,0 -7.22802,3.471093 -11.148156,4.858897 -2.414296,0.855511 -2.876252,1.674901 -3.26529,2.688481 0.532276,0.33099 1.357464,1.121338 1.923939,2.930441 0.270326,-0.48712 0.510987,-0.818091 0.687766,-0.881334 1.403277,-0.501312 7.273193,-0.201286 11.643031,-2.048467 0.714212,-0.301288 2.976236,-1.496183 5.263426,-3.931749 1.50006,-1.597485 -5.104716,-3.616269 -5.104716,-3.616269",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-7-6-6-0-6-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.737865,42.013011 c -0.112841,0.295492 -0.220013,0.605833 -0.367768,0.940041 -0.653566,1.480053 -3.662064,7.68288 -4.631787,9.241647 -0.969706,1.559408 -0.709695,4.297579 -0.709695,4.297579 l 3.114956,-1.353604 c 0,0 -0.624542,-1.876845 0.136068,-2.163302 0.760026,-0.287115 1.413592,-0.33227 2.067176,-2.351054 0.486463,-1.502639 1.528445,-4.263397 2.314916,-5.680866 -0.566457,-1.809103 -1.391663,-2.599451 -1.923939,-2.930441",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-8-0-5-6-4-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.339408,21.792873 c 0,0 -1.632965,3.974362 0.980697,6.097667 2.613644,2.123944 10.12748,2.394928 12.250784,2.09556 2.123304,-0.298729 1.743941,-4.045963 1.742003,-5.526016 -3.756928,-0.380661 -12.525006,-1.776202 -14.973484,-2.667211",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-5-6-6-1-3-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 46.294449,27.073728 c 0,0 -0.925849,5.608607 -1.251663,8.004176 -0.327112,2.395587 -1.128433,7.87449 -1.128433,7.87449 0,0 3.207223,6.58e-4 6.16217,-0.546467 -0.02524,-0.392916 0.410985,-1.51877 -0.678091,-2.027819 -1.089076,-0.508409 -2.551718,-1.178746 -2.364606,-2.967201 0.186454,-1.788456 1.329719,-10.337179 1.329719,-10.337179 h -2.069096",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-7-2-9-5-03-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.038642,21.792873 c -0.584526,-0.703238 -1.407154,0.871001 -3.571095,0.625841 -0.534214,-0.06072 -1.143266,-0.123815 -1.763949,-0.203883 -0.319998,1.175527 -0.757447,2.69042 -1.115522,3.58013 -0.507768,1.261996 -5.233743,0.709073 -5.233743,-0.934865 0,-1.388445 0.660023,-4.054998 1.000028,-5.336983 -0.460016,-0.508409 -1.125836,-0.320017 -1.258758,-0.02067 -0.239363,0.541968 -0.487761,1.725871 -0.612271,2.290408 -0.27808,1.259417 -1.242628,4.209208 1.388445,5.322151 2.246533,0.949715 4.655654,1.265855 5.472465,0.285816 0.816154,-0.980039 1.24197,-3.443367 1.24197,-3.443367 l 4.45243,0.358075 c 0,0 0.402608,-2.036853 0,-2.522675",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-4-6-3-9-0-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.588076,25.794961 c 0.358075,-0.88971 0.795524,-2.404603 1.115522,-3.58013 -1.158756,-0.149053 -2.362027,-0.358715 -3.218178,-0.735518 -1.020694,-0.449044 -1.680717,-1.291661 -2.001373,-1.796832 -0.03932,-0.06328 -0.08449,-0.110281 -0.129667,-0.159295 -0.340006,1.281986 -1.000047,3.948538 -1.000047,5.336983 0,1.64392 4.725993,2.196861 5.233762,0.934865",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-1-1-7-4-9-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.760256,20.517343 c 0,0 -0.04444,1.08198 0.47291,1.314247 0.774236,0.347121 1.471037,-0.800681 1.471037,-0.800681 l -1.943947,-0.513566",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-8-8-4-9-2-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8.5968617,24.338793 c 0,0 0.1212543,0.217417 0.7103528,1.59295 0.2690457,0.629059 0.9310065,2.783344 0.9310065,2.783344 l 0.97874,-0.1026 c 0,0 -0.271624,-1.160694 -1.000686,-2.998822 -0.21226,-0.536153 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67875",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-5-7-5-0-5-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.45048,26.330474 c -0.410326,0 -0.7445344,0.334208 -0.7445344,0.744552 0,0.410327 0.3342084,0.744535 0.7445344,0.744535 0.410345,0 0.744553,-0.334208 0.744553,-0.744535 0,-0.410344 -0.334208,-0.744552 -0.744553,-0.744552 z m 0,1.887818 c -0.6303395,0 -1.1432655,-0.512926 -1.1432655,-1.143266 0,-0.630358 0.512926,-1.143283 1.1432655,-1.143283 0.630358,0 1.143266,0.512925 1.143266,1.143283 0,0.63034 -0.512908,1.143266 -1.143266,1.143266",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-9-9-2-9-40-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.880814,26.467895 c 0,0 3.696282,-1.885221 5.364727,-4.253704 1.25682,-1.783939 3.194969,-6.553806 3.194969,-6.553806 l 0.847775,-0.06127 c 0,0 -1.429082,4.270493 -3.656925,7.452551 -1.660709,2.37364 -5.4473,4.140149 -5.4473,4.140149 L 10.880814,26.46791",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-7-2-5-1-5-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.055033,27.509238 c 0,0 10.446197,-4.20727 14.56248,-5.611845 6.002821,-2.048466 7.514495,-2.37428 8.697758,-2.138776 0,0 0.780033,-0.10516 0.638734,-0.235504 -1.251023,-1.161975 -7.288665,0.878097 -10.433304,2.103314 -1.336175,0.520662 -13.349553,5.261487 -13.349553,5.261487 l -0.116134,0.621324",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-5-0-4-7-9-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.958597,11.00667 c 1.174887,0.311622 2.494291,1.006484 2.494291,1.006484 l 0.822609,-1.764589 -1.41553,-1.2406896 c 0,0 -2.045888,1.2884416 -1.90137,1.9987946",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-3-2-7-7-4-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.581887,9.426596 c -0.238723,1.502639 -1.501341,2.037493 -2.16396,2.222667 -0.386459,0.108452 -0.800022,-0.265169 -1.092295,-0.878737 -0.324533,-0.680671 -0.641953,-1.6297464 -0.265808,-2.8497881 0.448403,-1.4536072 0.919375,-1.6974875 2.000074,-1.525866 1.079383,0.17228 1.761352,1.5297432 1.521989,3.0317241",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-8-3-4-1-6-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 -0.346462,1.1123031 -0.256134,1.6013621 0.08907,0.488401 0.622604,0.765182 0.622604,0.765182 L 40.275497,9.5175642 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-8-7-4-1-9-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.353497,8.791739 c -0.06072,-0.2722644 -0.27744,-0.5716327 -0.489059,-0.5380912 -0.211619,0.0342 -0.526478,0.4929181 -0.526478,0.4929181 0,0 -0.486462,-0.2341873 -0.954215,-0.6819505 -0.469051,-0.447123 -1.331676,0.012802 -1.357481,-0.3574351 -0.0406,-0.5761501 -0.66518,-1.5252258 1.744581,-1.9968558 1.100689,-0.2154962 2.261384,0.1613067 2.56527,0.9451985 0.593561,1.5297432 0.101868,2.3523524 0.250976,2.9652811 C 38.764482,9.8466152 38.415423,9.0633634 38.353497,8.791739",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-3-5-3-5-2-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.473952,7.7639486 0.0018,0.3826004 c 0,0 1.571661,0.1819729 2.907196,-0.081934 0.782612,-0.154174 1.445231,-0.014631 2.245912,0.2638882 0.801303,0.2774219 1.319405,0.1232661 1.319405,0.1232661 0,0 -0.08193,-2.0729918 -0.898105,-2.8020541 C 38.232737,4.9200133 36.293308,5.2264776 35.619093,5.5535169 34.779695,5.959984 34.518404,7.725213 34.518404,7.725213 l -1.045201,0.038772",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-1-9-0-9-2-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.784397,7.2936171 c 0,0 -0.163319,1.4303805 0,2.258147 0.163135,0.8271269 1.365858,0.9587509 1.976848,0.1554543 0.326472,-0.4290538 0.800041,-1.5200502 0.800041,-1.5200502 L 38.927709,7.9219815 c 0,0 -0.16972,0.9039209 -0.712932,1.4220043 -0.662601,0.6309797 -1.044561,0.00732 -1.000046,-0.8497131 0.03219,-0.6213233 0.05944,-1.0419825 0.05944,-1.0419825 L 36.78447,7.2935439",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-8-2-7-7-4-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.069573,9.6737134 c 0,0 0.02067,0.6780916 0,1.0864786 -0.01993,0.407766 -0.111012,0.694223 -0.111012,0.694223 l 0.578088,-0.330972 c 0,0 0.346462,-1.014238 0.166428,-1.2826254 C 37.61145,9.7052981 37.0695,9.6736586 37.0695,9.6736586",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-9-2-8-7-7-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 50.828172,13.288684 c 0,0 1.686515,0.454859 2.678807,1.472956 1.265855,1.299415 0.985196,3.042057 0,4.492427 -1.471018,2.1646 -5.227306,4.142747 -5.227306,4.142747 l -3.022049,1.385865 c 0,0 -1.452949,-1.225217 -0.898105,-2.591075 0.321315,-0.792286 2.902057,-3.346583 4.818259,-5.878293 0.70002,-0.92391 1.650394,-3.024627 1.650394,-3.024627",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-6-8-6-6-7-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.949043,9.6614417 -0.310981,0.5871233 c 0,0 0.800662,3.083993 1.127775,3.982098 0.326472,0.898727 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.179413 2.777529,0.689705 0.898105,0.510329 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.443933 1.93877,-2.447198 1.740064,-1.070348 2.504625,-2.625256 2.504625,-2.625256 0,0 -3.269167,-0.945199 -4.249846,-1.27553 C 46.728002,11.684103 45.060197,10.904728 43.362069,10.076303 41.663942,9.249177 39.949043,9.6614417 39.949043,9.6614417",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-43-9-8-7-5-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.786289,19.516657 c 0,0 -1.633605,-0.245161 -2.1646,0 -0.530977,0.245179 -0.203865,0.694222 0,1.102628 0.204523,0.408406 0.612929,0.835521 1.06199,0.989073 0.449044,0.154174 1.891037,-0.726483 1.891037,-0.726483 l -0.788427,-1.365218",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-3-7-8-3-4-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.507839,15.346825 c -0.01097,-0.885834 -0.410984,-3.791749 -0.682609,-4.301456 -0.488401,-0.914876 -1.500042,-1.1845618 -2.187168,-0.796804 -0.687126,0.387758 -0.467113,2.029757 -0.193568,3.411106 0.08523,0.428395 0.48648,2.604608 0.663259,3.082054 l -4.713081,2.853006 c -0.134788,0.815514 0.217417,1.37877 0.773577,1.725872 0.432913,-0.154906 1.780702,-0.656803 2.905276,-1.301335 1.180684,-0.676811 2.300083,-1.280705 2.998823,-1.67748 0.347742,-0.197427 0.457438,-1.170369 0.435491,-2.994963",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-38-3-4-6-81-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.856361,24.930416 c 0,0 1.974269,6.043458 2.940756,7.15706 1.136809,1.310369 0.449701,-0.105892 0.449701,-0.105892 0,0 -1.947183,-3.430455 -2.615582,-6.649291 -0.142652,-0.164599 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-6-6-3-5-2-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.804675,23.396814 c 0,0 1.97555,2.291048 3.255597,3.871762 0.882614,1.091015 2.410419,3.478847 2.560094,3.707877 0.352918,0.537451 0.06383,1.373612 -0.361934,1.996856 -0.425835,0.623902 -0.896167,1.132951 -1.118119,1.566522 -0.220654,0.434193 0.130399,0.921972 0.130399,0.921972 0,0 1.508455,-0.392934 2.243955,-1.167151 0.734878,-0.774876 1.279407,-1.597485 1.439415,-1.526506 0.160575,0.07169 1.183281,-0.944559 1.183281,-0.944559 0,0 -0.736158,-1.238751 -1.317484,-2.029117 -0.581307,-0.790988 -2.120067,-3.78853 -2.723321,-5.011791 -0.603894,-1.223918 -0.625841,-1.782658 -2.088464,-2.273637 -0.591001,-0.198726 -0.525179,0.474849 -1.423925,0.474849 -1.080041,0 -1.779439,0.412923 -1.779439,0.412923",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-0-1-1-6-8-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48.953906,31.300347 48.26742,31.87262 c 0,0 0.687126,0.746491 1.155519,1.30651 0.423256,0.505812 0.980057,1.39876 0.980057,1.39876 l 1.021956,-0.883255 c 0,0 -0.860028,-2.021381 -2.471046,-2.394288",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-4-2-4-3-9-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.194816,9.3014279 c 0,0 1.041964,-1.0103613 2.226526,-0.8071186 1.184561,0.2032245 1.989119,0.9716441 2.383333,1.1794041 0.393556,0.2077418 1.047122,-0.1148532 1.047122,-0.1148532 0,0 -0.544529,1.0748658 -1.497464,1.0051858 C 42.40138,10.494366 41.564579,9.6162685 40.570989,9.6736951 39.196755,9.7530683 39.194816,9.3014279 39.194816,9.3014279",
    style: {
      fill: "#666666",
      fillOpacity: 0.833502,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-8-9-9-9-3-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6192",
    transform: "matrix(-0.99169114,0.12864163,0.12864163,0.99169114,173.82093,-2.6648517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 70.174932,263.07646 c 0.662619,-0.2684 7.458348,-4.02016 12.034008,0 4.575019,4.02013 6.738979,6.58798 10.202976,6.29829 2.567848,-0.21484 3.216897,-2.15877 3.216897,-2.15877 0,0 0.649067,5.9028 -2.827201,7.38865 -7.132535,3.04916 -9.494562,-2.41621 -11.508188,-4.69372 -2.013627,-2.27816 -6.074422,-6.47767 -10.053283,-5.54345 -2.218789,0.52068 -1.065209,-1.291 -1.065209,-1.291",
    style: {
      fill: "#000055",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path728-31-8-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.81999,250.94631 c 0,0 3.701421,-1.1194 7.512538,-0.16003 3.811117,0.95875 7.991923,2.99302 10.25007,4.24403 3.021409,1.67427 4.39952,3.13109 4.39952,3.13109 0,0 -9.62165,-0.7955 -12.281107,-1.41618 -6.533798,-1.52457 -9.881021,-5.79893 -9.881021,-5.79893",
    style: {
      fill: "#000055",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path730-9-4-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 14.112782,248.33266 c 0,0 0.255493,3.10398 0.827126,4.3292 0.571633,1.2252 1.878144,0 1.878144,0 0,0 -0.83746,-3.18529 -2.70527,-4.3292",
    style: {
      fill: "#eeaaff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path732-4-3-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 70.913029,271.44644 c 0,0 1.027132,2.72268 3.291095,1.96008 2.263304,-0.76196 2.916249,-2.77689 4.223381,-1.22456 1.306511,1.55104 4.247267,6.84672 5.335703,7.13963 1.089076,0.29228 1.361341,-0.4355 1.905869,-0.46969 0.544548,-0.0348 2.558814,3.43174 2.558814,3.43174 0,0 -2.123304,1.52264 -5.227305,-0.11102 -2.929142,-1.54132 -5.934421,-5.66215 -5.934421,-5.66215 0,0 -6.370571,1.07358 -6.806702,0.78197 -0.43487,-0.29226 0.653566,-5.84603 0.653566,-5.84603",
    style: {
      fill: "#eca1ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path734-7-1-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.056554,270.30318 c 0,0 -9.96749,1.4194 -11.493996,1.65298 -0.418721,0.0638 -0.841977,0.4058 -1.263916,0.90002 0.370328,0.87487 0.825187,2.04267 1.140686,3.17626 0.200646,-0.25743 0.403231,-0.46778 0.607113,-0.59294 0.418081,-0.25741 4.753737,1.54976 10.307496,0.33551 1.396839,-0.30518 0.702617,-5.47183 0.702617,-5.47183",
    style: {
      fill: "#eeaaff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path736-8-4-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 12.039808,277.95638 c -1.249724,1.69748 -2.2452529,2.66913 -3.3891772,4.62985 -1.1426071,1.96008 -1.1426071,3.38981 -1.1426071,3.38981 l 3.2543163,-0.94583 c 0,0 0.17612,-1.57169 0.829065,-2.1175 0.652926,-0.54647 1.714898,-0.40841 2.450416,-1.86654 0.326454,-0.64841 1.312309,-3.61819 2.397507,-5.01373 -0.315499,-1.13359 -0.770358,-2.30139 -1.140686,-3.17626 -1.118119,1.30585 -2.234281,3.71047 -3.258834,5.10019",
    style: {
      fill: "#eca1ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path738-4-9-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 73.490552,265.62817 c -2.939476,-5.13311 -8.730019,-4.62407 -13.630212,-4.40663 -14.360536,0.63615 -19.012332,-2.57752 -22.827326,-3.77046 -2.343958,-0.73294 -9.873285,-4.42083 -12.496603,-5.05053 -5.261487,-1.26327 -9.953938,0.44519 -9.953938,0.44519 0,0 -5.1234069,6.09636 -6.0924904,7.05897 -0.9690654,0.96327 -2.6304143,2.46397 -3.0465563,2.75237 -0.4148617,0.28775 -0.4916378,1.12261 0,1.84652 0.4735686,0.69616 1.523269,0.85551 1.523269,0.85551 0,0 -0.061999,0.90068 0.4916379,1.00714 0.5542219,0.10589 1.4207057,-0.20194 1.5929673,-1.25682 1.1000495,0.051 4.9479265,-1.00456 6.3292745,-1.75555 1.761352,-0.95617 2.075571,-2.28783 2.075571,-2.28783 l 0.75099,-1.69233 c 0,0 4.246608,0.63873 6.424761,4.06855 2.178152,3.43045 5.117609,8.71646 5.117609,8.71646 l -2.318152,0.95876 c 0.314859,0.59228 0.581325,1.07228 0.772937,1.37295 1.163273,1.26004 2.484616,2.25105 3.914338,3.02011 l 2.504624,-2.00329 c 0,0 4.22854,0.75486 8.373225,0.69162 8.20612,-0.12583 10.73911,-1.94716 13.106953,-1.73039 2.939457,0.26905 5.069876,2.45236 5.071156,2.45366 1.249724,0.11229 2.694955,0.22775 4.402758,0.22775 0.787769,0 3.05559,0.038 5.227287,-1.8175 2.171056,-1.85556 4.645997,-7.27318 2.68592,-9.70424",
    style: {
      fill: "#f6d5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path740-5-2-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.996478,276.19889 c -4.144685,0.0633 -8.373225,-0.69162 -8.373225,-0.69162 l -2.504624,2.00328 c 0.661321,0.35551 1.34329,0.66842 2.047187,0.93101 3.584647,0.92067 6.450565,0.87937 8.830662,0.87937 6.573155,6.6e-4 10.991385,-1.81102 13.495351,-2.44008 1.223919,-0.3071 2.70591,-0.1368 4.682758,0.0413 -0.0013,-10e-4 -2.131699,-2.18461 -5.071156,-2.45363 -2.367843,-0.2168 -4.900833,1.60456 -13.106953,1.73038",
    style: {
      fill: "#eeaaff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path742-0-0-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.631897,263.44227 c -2.178153,-3.42982 -6.424761,-4.06854 -6.424761,-4.06854 l -0.75099,1.69232 c 0,0 3.080756,0.76326 4.742105,2.49818 0.974241,1.01679 3.692405,6.65508 5.233103,9.55327 l 2.318152,-0.95877 c 0,0 -2.939457,-5.28601 -5.117609,-8.71646",
    style: {
      fill: "#eeaaff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path744-3-6-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 75.082861,274.64528 c -1.416828,0.28517 -2.658798,0.1465 -2.449118,-1.63554 0.199366,-1.68653 -13.590196,1.7278 -13.590196,1.7278 0,0 2.178152,2.22783 4.465323,4.58405 2.285891,2.35622 4.67632,2.79946 8.384838,1.92588 1.169729,-0.27549 2.747206,-0.98197 3.536273,-1.36586 0.656145,-2.77947 0.202585,-4.29694 -0.34712,-5.23633",
    style: {
      fill: "#f6d5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path746-6-8-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 80.338551,285.38376 c 1.791692,1.6349 5.330526,1.52652 5.330526,1.52652 0,0 0,-2.83173 -1.143265,-4.12791 -0.487121,-0.55164 -1.960077,0.87294 -2.613644,0 -0.653584,-0.8723 -1.960077,-6.55059 -2.613661,-8.04483 -0.653567,-1.49425 -1.392944,-0.90584 -2.831079,-0.45938 -0.451622,0.13936 -1.805866,0.38648 -2.263304,0.47875 0.57487,1.26325 0.878737,3.22333 0.734878,5.37374 0.7697,-0.37485 2.344598,-1.7491 2.344598,-1.7491 0,0 0.90778,5.04083 3.054951,7.00221",
    style: {
      fill: "#f6d5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path748-1-9-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 13.588242,252.51733 3.221415,4.18275 0.376145,-0.751 -2.858164,-3.85951 -0.739396,0.42776",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path750-0-2-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.079119,252.82897 c 0,0 0.894868,1.90071 2.869795,1.58263 1.350368,-0.21744 2.869138,-1.74974 2.869138,-1.74974 l -0.522601,-1.44975 c 0,0 -3.209161,0.72327 -5.216332,1.61686",
    style: {
      fill: "#000055",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path752-6-6-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 15.736072,247.69521 c 0,0 -0.19355,3.91693 0.567115,6.07508 0.760043,2.15814 2.883348,0 2.883348,0 0,0 -1.511034,-4.50792 -3.450463,-6.07508",
    style: {
      fill: "#f6d5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path754-3-6-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.233436,270.83418 c 0,0 -7.22802,3.47109 -11.148156,4.8589 -2.414296,0.8555 -2.876252,1.67489 -3.26529,2.68847 0.532276,0.331 1.357464,1.12135 1.923939,2.93045 0.270326,-0.48712 0.510987,-0.8181 0.687766,-0.88133 1.403277,-0.50131 7.273193,-0.2013 11.643031,-2.04847 0.714212,-0.30129 2.976236,-1.49619 5.263426,-3.93176 1.50006,-1.59747 -5.104716,-3.61626 -5.104716,-3.61626",
    style: {
      fill: "#f6d5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path756-2-4-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 16.81999,278.38155 c -0.112841,0.2955 -0.220013,0.60584 -0.367768,0.94004 -0.653566,1.48005 -3.662064,7.68289 -4.631787,9.24165 -0.969706,1.55941 -0.709695,4.29759 -0.709695,4.29759 l 3.114956,-1.35361 c 0,0 -0.624542,-1.87684 0.136068,-2.1633 0.760026,-0.28712 1.413592,-0.33227 2.067176,-2.35105 0.486463,-1.50265 1.528445,-4.2634 2.314916,-5.68087 -0.566457,-1.8091 -1.391663,-2.59945 -1.923939,-2.93044",
    style: {
      fill: "#f6d5ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path758-0-9-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 40.421533,258.16142 c 0,0 -1.632965,3.97436 0.980697,6.09767 2.613644,2.12394 10.12748,2.39493 12.250784,2.09555 2.123304,-0.29872 1.743941,-4.04595 1.742003,-5.52601 -3.756928,-0.38067 -12.525006,-1.7762 -14.973484,-2.66721",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path760-6-5-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 45.376574,263.44227 c 0,0 -0.925849,5.60861 -1.251663,8.00417 -0.327112,2.39559 -1.128433,7.8745 -1.128433,7.8745 0,0 3.207223,6.5e-4 6.16217,-0.54647 -0.02524,-0.39292 0.410985,-1.51876 -0.678091,-2.02781 -1.089076,-0.50842 -2.551718,-1.17876 -2.364606,-2.9672 0.186454,-1.78846 1.329719,-10.33718 1.329719,-10.33718 h -2.069096",
    style: {
      fill: "#492c2d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path762-1-0-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 54.120767,258.16142 c -0.584526,-0.70324 -1.407154,0.871 -3.571095,0.62584 -0.534214,-0.0607 -1.143266,-0.12381 -1.763949,-0.20388 -0.319998,1.17553 -0.757447,2.69041 -1.115522,3.58013 -0.507768,1.262 -5.233743,0.70907 -5.233743,-0.93486 0,-1.38845 0.660023,-4.055 1.000028,-5.33699 -0.460016,-0.50841 -1.125836,-0.32001 -1.258758,-0.0207 -0.239363,0.54198 -0.487761,1.72588 -0.612271,2.29042 -0.27808,1.25942 -1.242628,4.20921 1.388445,5.32214 2.246533,0.94973 4.655654,1.26587 5.472465,0.28582 0.816154,-0.98003 1.24197,-3.44336 1.24197,-3.44336 l 4.45243,0.35808 c 0,0 0.402608,-2.03686 0,-2.52268",
    style: {
      fill: "#6c5353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path764-5-4-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 47.670201,262.1635 c 0.358075,-0.88971 0.795524,-2.40459 1.115522,-3.58013 -1.158756,-0.14905 -2.362027,-0.3587 -3.218178,-0.73552 -1.020694,-0.44903 -1.680717,-1.29166 -2.001373,-1.79683 -0.03932,-0.0633 -0.08449,-0.11028 -0.129667,-0.15929 -0.340006,1.28199 -1.000047,3.94853 -1.000047,5.33699 0,1.64391 4.725993,2.19685 5.233762,0.93485",
    style: {
      fill: "#483737",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path766-5-8-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.842381,256.88589 c 0,0 -0.04444,1.08198 0.47291,1.31424 0.774236,0.34712 1.471037,-0.80068 1.471037,-0.80068 l -1.943947,-0.51356",
    style: {
      fill: "#000055",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path768-4-7-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7.6789868,260.70733 c 0,0 0.1212543,0.21742 0.7103528,1.59296 0.2690457,0.62905 0.9310065,2.78335 0.9310065,2.78335 l 0.9787399,-0.1026 c 0,0 -0.271624,-1.1607 -1.0006859,-2.99883 -0.21226,-0.53615 -0.9090605,-1.95364 -0.9090605,-1.95364 l -0.7103528,0.67876",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path770-7-1-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9.5326051,262.69902 c -0.410326,0 -0.7445344,0.33421 -0.7445344,0.74455 0,0.41033 0.3342084,0.74453 0.7445344,0.74453 0.4103452,0 0.7445529,-0.3342 0.7445529,-0.74453 0,-0.41034 -0.3342077,-0.74455 -0.7445529,-0.74455 z m 0,1.88781 c -0.6303395,0 -1.1432655,-0.51292 -1.1432655,-1.14326 0,-0.63035 0.512926,-1.14328 1.1432655,-1.14328 0.6303579,0 1.1432659,0.51293 1.1432659,1.14328 0,0.63034 -0.512908,1.14326 -1.1432659,1.14326",
    style: {
      fill: "#f4ab94",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path772-6-7-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9.9629393,262.83645 c 0,0 3.6962817,-1.88524 5.3647267,-4.25371 1.25682,-1.78395 3.194969,-6.55382 3.194969,-6.55382 l 0.847775,-0.0613 c 0,0 -1.429082,4.27051 -3.656925,7.45256 -1.660709,2.37365 -5.4473,4.14015 -5.4473,4.14015 l -0.3032457,-0.7239",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path774-5-2-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10.137158,263.87779 c 0,0 10.446197,-4.20727 14.56248,-5.61185 6.002821,-2.04847 7.514495,-2.37429 8.697758,-2.13878 0,0 0.780033,-0.10516 0.638734,-0.23551 -1.251023,-1.16197 -7.288665,0.8781 -10.433304,2.10332 -1.336175,0.52066 -13.349553,5.26149 -13.349553,5.26149 l -0.116134,0.62133",
    style: {
      fill: "#392526",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path776-6-7-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.040722,247.37521 c 1.174887,0.31162 2.494291,1.00648 2.494291,1.00648 l 0.822609,-1.76458 -1.41553,-1.24069 c 0,0 -2.045888,1.28845 -1.90137,1.9988",
    style: {
      fill: "#ee9d8f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path778-9-2-0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.664012,245.79514 c -0.238723,1.50264 -1.501341,2.03749 -2.16396,2.22266 -0.386459,0.10845 -0.800022,-0.26517 -1.092295,-0.87873 -0.324533,-0.68067 -0.641953,-1.62975 -0.265808,-2.84979 0.448403,-1.45361 0.919375,-1.69749 2.000074,-1.52587 1.079383,0.17228 1.761352,1.52975 1.521989,3.03173",
    style: {
      fill: "#f9b2a1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path780-3-2-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.276941,245.66997 c 0,0 -0.346462,1.1123 -0.256134,1.60136 0.08907,0.4884 0.622604,0.76518 0.622604,0.76518 l 0.714211,-2.15041 -1.080681,-0.21613",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path782-7-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 37.435622,245.16028 c -0.06072,-0.27227 -0.27744,-0.57163 -0.489059,-0.53809 -0.211619,0.0342 -0.526478,0.49292 -0.526478,0.49292 0,0 -0.486462,-0.23419 -0.954215,-0.68195 -0.469051,-0.44713 -1.331676,0.0128 -1.357481,-0.35744 -0.0406,-0.57615 -0.66518,-1.52523 1.744581,-1.99686 1.100689,-0.21549 2.261384,0.16131 2.56527,0.9452 0.593561,1.52975 0.101868,2.35236 0.250976,2.96528 -0.822609,0.22582 -1.171668,-0.55744 -1.233594,-0.82906",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path784-4-1-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 32.556077,244.13249 0.0018,0.3826 c 0,0 1.571661,0.18197 2.907196,-0.0819 0.782612,-0.15417 1.445231,-0.0146 2.245912,0.26388 0.801303,0.27744 1.319405,0.12327 1.319405,0.12327 0,0 -0.08193,-2.07299 -0.898105,-2.80205 -0.817423,-0.72971 -2.756852,-0.42324 -3.431067,-0.0962 -0.839398,0.40646 -1.100689,2.17169 -1.100689,2.17169 l -1.045201,0.0388",
    style: {
      fill: "#5d5d95",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path786-52-0-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 35.866522,243.66216 c 0,0 -0.163319,1.43038 0,2.25814 0.163135,0.82713 1.365858,0.95876 1.976848,0.15546 0.326472,-0.42906 0.800041,-1.52005 0.800041,-1.52005 l -0.633577,-0.26519 c 0,0 -0.16972,0.90392 -0.712932,1.42201 -0.662601,0.63098 -1.044561,0.007 -1.000046,-0.84972 0.03219,-0.62131 0.05944,-1.04197 0.05944,-1.04197 l -0.489701,-0.15875",
    style: {
      fill: "#5d5d95",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path788-5-6-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.151698,246.04225 c 0,0 0.02067,0.6781 0,1.08648 -0.01993,0.40777 -0.111012,0.69423 -0.111012,0.69423 l 0.578088,-0.33098 c 0,0 0.346462,-1.01423 0.166428,-1.28262 -0.09163,-0.13552 -0.633577,-0.16716 -0.633577,-0.16716",
    style: {
      fill: "#5d5d95",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path790-4-1-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 49.910297,249.65722 c 0,0 1.686515,0.45486 2.678807,1.47296 1.265855,1.29941 0.985196,3.04206 0,4.49243 -1.471018,2.1646 -5.227306,4.14274 -5.227306,4.14274 l -3.022049,1.38587 c 0,0 -1.452949,-1.22521 -0.898105,-2.59107 0.321315,-0.79228 2.902057,-3.34658 4.818259,-5.87829 0.70002,-0.92392 1.650394,-3.02464 1.650394,-3.02464",
    style: {
      fill: "#3a1c69",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path792-7-5-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.031168,246.02998 -0.310981,0.58713 c 0,0 0.800662,3.08399 1.127775,3.98209 0.326472,0.89873 1.632965,1.65877 1.632965,1.65877 0,0 1.878783,0.17942 2.777529,0.68971 0.898105,0.51033 2.33752,1.782 2.33752,1.782 0,0 1.266495,-1.44394 1.93877,-2.4472 1.740064,-1.07035 2.504625,-2.62526 2.504625,-2.62526 0,0 -3.269167,-0.9452 -4.249846,-1.27553 -0.979398,-0.32905 -2.647203,-1.10842 -4.345331,-1.93685 -1.698127,-0.82712 -3.413026,-0.41486 -3.413026,-0.41486",
    style: {
      fill: "#935e44",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path794-4-9-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 34.868414,255.8852 c 0,0 -1.633605,-0.24516 -2.1646,0 -0.530977,0.24518 -0.203865,0.69423 0,1.10262 0.204523,0.40841 0.612929,0.83553 1.06199,0.98908 0.449044,0.15417 1.891037,-0.72649 1.891037,-0.72649 l -0.788427,-1.36521",
    style: {
      fill: "#fcd1c9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path796-4-4-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 41.589964,251.71536 c -0.01097,-0.88583 -0.410984,-3.79174 -0.682609,-4.30145 -0.488401,-0.91488 -1.500042,-1.18456 -2.187168,-0.7968 -0.687126,0.38776 -0.467113,2.02976 -0.193568,3.41111 0.08523,0.4284 0.48648,2.60461 0.663259,3.08205 l -4.713081,2.85301 c -0.134788,0.81551 0.217417,1.37877 0.773577,1.72587 0.432913,-0.1549 1.780702,-0.6568 2.905276,-1.30133 1.180684,-0.67681 2.300083,-1.28071 2.998823,-1.67748 0.347742,-0.19743 0.457438,-1.17037 0.435491,-2.99497",
    style: {
      fill: "#673b26",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path798-3-9-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 44.938486,261.29896 c 0,0 1.974269,6.04346 2.940756,7.15706 1.136809,1.31037 0.449701,-0.10589 0.449701,-0.10589 0,0 -1.947183,-3.43045 -2.615582,-6.64929 -0.142652,-0.1646 -0.774875,-0.40195 -0.774875,-0.40195",
    style: {
      fill: "#916f6f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path800-0-0-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 42.8868,259.76535 c 0,0 1.97555,2.29106 3.255597,3.87178 0.882614,1.091 2.410419,3.47884 2.560094,3.70787 0.352918,0.53745 0.06383,1.37361 -0.361934,1.99685 -0.425835,0.6239 -0.896167,1.13295 -1.118119,1.56653 -0.220654,0.43419 0.130399,0.92197 0.130399,0.92197 0,0 1.508455,-0.39294 2.243955,-1.16715 0.734878,-0.77488 1.279407,-1.59749 1.439415,-1.5265 0.160575,0.0717 1.183281,-0.94457 1.183281,-0.94457 0,0 -0.736158,-1.23874 -1.317484,-2.02911 -0.581307,-0.791 -2.120067,-3.78854 -2.723321,-5.0118 -0.603894,-1.22391 -0.625841,-1.78265 -2.088464,-2.27364 -0.591001,-0.19871 -0.525179,0.47486 -1.423925,0.47486 -1.080041,0 -1.779439,0.41292 -1.779439,0.41292",
    style: {
      fill: "#553133",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path802-7-9-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 48.036031,267.6689 -0.686486,0.57227 c 0,0 0.687126,0.74649 1.155519,1.30651 0.423256,0.50581 0.980057,1.39875 0.980057,1.39875 l 1.021956,-0.88324 c 0,0 -0.860028,-2.02139 -2.471046,-2.39429",
    style: {
      fill: "#6c5353",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path804-8-1-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 38.276941,245.66997 c 0,0 1.041964,-1.01036 2.226526,-0.80712 1.184561,0.20322 1.989119,0.97164 2.383333,1.1794 0.393556,0.20775 1.047122,-0.11485 1.047122,-0.11485 0,0 -0.544529,1.07487 -1.497464,1.00519 -0.952953,-0.0697 -1.789754,-0.94778 -2.783344,-0.89035 -1.374234,0.0794 -1.376173,-0.37227 -1.376173,-0.37227",
    style: {
      fill: "#663337",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0645186
    },
    id: "path806-6-7-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.cb6da8023347a8cfd71ba2afb3d7ad77.svg";
export { ForwardRef as ReactComponent };